import dr, { createContext as Ls, useReducer as an, memo as we, useMemo as tr, useContext as ji, useState as Se, useEffect as Ge, useRef as be, useCallback as on, createElement as nn, forwardRef as ln, useImperativeHandle as pn, useId as cn } from "react";
var ys = { exports: {} }, Yr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var na;
function un() {
  if (na)
    return Yr;
  na = 1;
  var r = dr, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, a = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(l, p, g) {
    var w, k = {}, h = null, S = null;
    g !== void 0 && (h = "" + g), p.key !== void 0 && (h = "" + p.key), p.ref !== void 0 && (S = p.ref);
    for (w in p)
      s.call(p, w) && !i.hasOwnProperty(w) && (k[w] = p[w]);
    if (l && l.defaultProps)
      for (w in p = l.defaultProps, p)
        k[w] === void 0 && (k[w] = p[w]);
    return { $$typeof: e, type: l, key: h, ref: S, props: k, _owner: a.current };
  }
  return Yr.Fragment = t, Yr.jsx = o, Yr.jsxs = o, Yr;
}
var Wr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var la;
function fn() {
  return la || (la = 1, process.env.NODE_ENV !== "production" && function() {
    var r = dr, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), k = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), _ = Symbol.iterator, G = "@@iterator";
    function I(n) {
      if (n === null || typeof n != "object")
        return null;
      var y = _ && n[_] || n[G];
      return typeof y == "function" ? y : null;
    }
    var N = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(n) {
      {
        for (var y = arguments.length, D = new Array(y > 1 ? y - 1 : 0), M = 1; M < y; M++)
          D[M - 1] = arguments[M];
        re("error", n, D);
      }
    }
    function re(n, y, D) {
      {
        var M = N.ReactDebugCurrentFrame, q = M.getStackAddendum();
        q !== "" && (y += "%s", D = D.concat([q]));
        var Y = D.map(function(H) {
          return String(H);
        });
        Y.unshift("Warning: " + y), Function.prototype.apply.call(console[n], console, Y);
      }
    }
    var B = !1, R = !1, L = !1, Z = !1, c = !1, u;
    u = Symbol.for("react.module.reference");
    function m(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === s || n === i || c || n === a || n === g || n === w || Z || n === S || B || R || L || typeof n == "object" && n !== null && (n.$$typeof === h || n.$$typeof === k || n.$$typeof === o || n.$$typeof === l || n.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === u || n.getModuleId !== void 0));
    }
    function j(n, y, D) {
      var M = n.displayName;
      if (M)
        return M;
      var q = y.displayName || y.name || "";
      return q !== "" ? D + "(" + q + ")" : D;
    }
    function F(n) {
      return n.displayName || "Context";
    }
    function E(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case s:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case g:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case l:
            var y = n;
            return F(y) + ".Consumer";
          case o:
            var D = n;
            return F(D._context) + ".Provider";
          case p:
            return j(n, n.render, "ForwardRef");
          case k:
            var M = n.displayName || null;
            return M !== null ? M : E(n.type) || "Memo";
          case h: {
            var q = n, Y = q._payload, H = q._init;
            try {
              return E(H(Y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var b = Object.assign, f = 0, d, x, v, A, O, T, K;
    function V() {
    }
    V.__reactDisabledLog = !0;
    function te() {
      {
        if (f === 0) {
          d = console.log, x = console.info, v = console.warn, A = console.error, O = console.group, T = console.groupCollapsed, K = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: V,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        f++;
      }
    }
    function W() {
      {
        if (f--, f === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: b({}, n, {
              value: d
            }),
            info: b({}, n, {
              value: x
            }),
            warn: b({}, n, {
              value: v
            }),
            error: b({}, n, {
              value: A
            }),
            group: b({}, n, {
              value: O
            }),
            groupCollapsed: b({}, n, {
              value: T
            }),
            groupEnd: b({}, n, {
              value: K
            })
          });
        }
        f < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = N.ReactCurrentDispatcher, se;
    function de(n, y, D) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (q) {
            var M = q.stack.trim().match(/\n( *(at )?)/);
            se = M && M[1] || "";
          }
        return `
` + se + n;
      }
    }
    var me = !1, oe;
    {
      var ce = typeof WeakMap == "function" ? WeakMap : Map;
      oe = new ce();
    }
    function xe(n, y) {
      if (!n || me)
        return "";
      {
        var D = oe.get(n);
        if (D !== void 0)
          return D;
      }
      var M;
      me = !0;
      var q = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Y;
      Y = J.current, J.current = null, te();
      try {
        if (y) {
          var H = function() {
            throw Error();
          };
          if (Object.defineProperty(H.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(H, []);
            } catch (ve) {
              M = ve;
            }
            Reflect.construct(n, [], H);
          } else {
            try {
              H.call();
            } catch (ve) {
              M = ve;
            }
            n.call(H.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ve) {
            M = ve;
          }
          n();
        }
      } catch (ve) {
        if (ve && M && typeof ve.stack == "string") {
          for (var P = ve.stack.split(`
`), ie = M.stack.split(`
`), Q = P.length - 1, ee = ie.length - 1; Q >= 1 && ee >= 0 && P[Q] !== ie[ee]; )
            ee--;
          for (; Q >= 1 && ee >= 0; Q--, ee--)
            if (P[Q] !== ie[ee]) {
              if (Q !== 1 || ee !== 1)
                do
                  if (Q--, ee--, ee < 0 || P[Q] !== ie[ee]) {
                    var le = `
` + P[Q].replace(" at new ", " at ");
                    return n.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", n.displayName)), typeof n == "function" && oe.set(n, le), le;
                  }
                while (Q >= 1 && ee >= 0);
              break;
            }
        }
      } finally {
        me = !1, J.current = Y, W(), Error.prepareStackTrace = q;
      }
      var Ee = n ? n.displayName || n.name : "", Kr = Ee ? de(Ee) : "";
      return typeof n == "function" && oe.set(n, Kr), Kr;
    }
    function ke(n, y, D) {
      return xe(n, !1);
    }
    function ge(n) {
      var y = n.prototype;
      return !!(y && y.isReactComponent);
    }
    function ae(n, y, D) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return xe(n, ge(n));
      if (typeof n == "string")
        return de(n);
      switch (n) {
        case g:
          return de("Suspense");
        case w:
          return de("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case p:
            return ke(n.render);
          case k:
            return ae(n.type, y, D);
          case h: {
            var M = n, q = M._payload, Y = M._init;
            try {
              return ae(Y(q), y, D);
            } catch {
            }
          }
        }
      return "";
    }
    var qe = Object.prototype.hasOwnProperty, Mr = {}, Br = N.ReactDebugCurrentFrame;
    function Ke(n) {
      if (n) {
        var y = n._owner, D = ae(n.type, n._source, y ? y.type : null);
        Br.setExtraStackFrame(D);
      } else
        Br.setExtraStackFrame(null);
    }
    function Pt(n, y, D, M, q) {
      {
        var Y = Function.call.bind(qe);
        for (var H in n)
          if (Y(n, H)) {
            var P = void 0;
            try {
              if (typeof n[H] != "function") {
                var ie = Error((M || "React class") + ": " + D + " type `" + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[H] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ie.name = "Invariant Violation", ie;
              }
              P = n[H](y, H, M, D, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Q) {
              P = Q;
            }
            P && !(P instanceof Error) && (Ke(q), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", M || "React class", D, H, typeof P), Ke(null)), P instanceof Error && !(P.message in Mr) && (Mr[P.message] = !0, Ke(q), C("Failed %s type: %s", D, P.message), Ke(null));
          }
      }
    }
    var Ut = Array.isArray;
    function or(n) {
      return Ut(n);
    }
    function Gt(n) {
      {
        var y = typeof Symbol == "function" && Symbol.toStringTag, D = y && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return D;
      }
    }
    function Ht(n) {
      try {
        return Tr(n), !1;
      } catch {
        return !0;
      }
    }
    function Tr(n) {
      return "" + n;
    }
    function Ir(n) {
      if (Ht(n))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Gt(n)), Tr(n);
    }
    var Te = N.ReactCurrentOwner, qt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Rr, Lr, nr;
    nr = {};
    function Kt(n) {
      if (qe.call(n, "ref")) {
        var y = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function Yt(n) {
      if (qe.call(n, "key")) {
        var y = Object.getOwnPropertyDescriptor(n, "key").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function Wt(n, y) {
      if (typeof n.ref == "string" && Te.current && y && Te.current.stateNode !== y) {
        var D = E(Te.current.type);
        nr[D] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', E(Te.current.type), n.ref), nr[D] = !0);
      }
    }
    function Vt(n, y) {
      {
        var D = function() {
          Rr || (Rr = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        D.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: D,
          configurable: !0
        });
      }
    }
    function Zt(n, y) {
      {
        var D = function() {
          Lr || (Lr = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        D.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: D,
          configurable: !0
        });
      }
    }
    var Jt = function(n, y, D, M, q, Y, H) {
      var P = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: n,
        key: y,
        ref: D,
        props: H,
        // Record the component responsible for creating this element.
        _owner: Y
      };
      return P._store = {}, Object.defineProperty(P._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(P, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: M
      }), Object.defineProperty(P, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.freeze && (Object.freeze(P.props), Object.freeze(P)), P;
    };
    function Qt(n, y, D, M, q) {
      {
        var Y, H = {}, P = null, ie = null;
        D !== void 0 && (Ir(D), P = "" + D), Yt(y) && (Ir(y.key), P = "" + y.key), Kt(y) && (ie = y.ref, Wt(y, q));
        for (Y in y)
          qe.call(y, Y) && !qt.hasOwnProperty(Y) && (H[Y] = y[Y]);
        if (n && n.defaultProps) {
          var Q = n.defaultProps;
          for (Y in Q)
            H[Y] === void 0 && (H[Y] = Q[Y]);
        }
        if (P || ie) {
          var ee = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          P && Vt(H, ee), ie && Zt(H, ee);
        }
        return Jt(n, P, ie, q, M, Te.current, H);
      }
    }
    var lr = N.ReactCurrentOwner, Nr = N.ReactDebugCurrentFrame;
    function Fe(n) {
      if (n) {
        var y = n._owner, D = ae(n.type, n._source, y ? y.type : null);
        Nr.setExtraStackFrame(D);
      } else
        Nr.setExtraStackFrame(null);
    }
    var pr;
    pr = !1;
    function cr(n) {
      return typeof n == "object" && n !== null && n.$$typeof === e;
    }
    function Pr() {
      {
        if (lr.current) {
          var n = E(lr.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Xt(n) {
      {
        if (n !== void 0) {
          var y = n.fileName.replace(/^.*[\\\/]/, ""), D = n.lineNumber;
          return `

Check your code at ` + y + ":" + D + ".";
        }
        return "";
      }
    }
    var Ur = {};
    function es(n) {
      {
        var y = Pr();
        if (!y) {
          var D = typeof n == "string" ? n : n.displayName || n.name;
          D && (y = `

Check the top-level render call using <` + D + ">.");
        }
        return y;
      }
    }
    function Gr(n, y) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var D = es(y);
        if (Ur[D])
          return;
        Ur[D] = !0;
        var M = "";
        n && n._owner && n._owner !== lr.current && (M = " It was passed a child from " + E(n._owner.type) + "."), Fe(n), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', D, M), Fe(null);
      }
    }
    function Hr(n, y) {
      {
        if (typeof n != "object")
          return;
        if (or(n))
          for (var D = 0; D < n.length; D++) {
            var M = n[D];
            cr(M) && Gr(M, y);
          }
        else if (cr(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var q = I(n);
          if (typeof q == "function" && q !== n.entries)
            for (var Y = q.call(n), H; !(H = Y.next()).done; )
              cr(H.value) && Gr(H.value, y);
        }
      }
    }
    function rs(n) {
      {
        var y = n.type;
        if (y == null || typeof y == "string")
          return;
        var D;
        if (typeof y == "function")
          D = y.propTypes;
        else if (typeof y == "object" && (y.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        y.$$typeof === k))
          D = y.propTypes;
        else
          return;
        if (D) {
          var M = E(y);
          Pt(D, n.props, "prop", M, n);
        } else if (y.PropTypes !== void 0 && !pr) {
          pr = !0;
          var q = E(y);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", q || "Unknown");
        }
        typeof y.getDefaultProps == "function" && !y.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ts(n) {
      {
        for (var y = Object.keys(n.props), D = 0; D < y.length; D++) {
          var M = y[D];
          if (M !== "children" && M !== "key") {
            Fe(n), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", M), Fe(null);
            break;
          }
        }
        n.ref !== null && (Fe(n), C("Invalid attribute `ref` supplied to `React.Fragment`."), Fe(null));
      }
    }
    function qr(n, y, D, M, q, Y) {
      {
        var H = m(n);
        if (!H) {
          var P = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (P += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ie = Xt(q);
          ie ? P += ie : P += Pr();
          var Q;
          n === null ? Q = "null" : or(n) ? Q = "array" : n !== void 0 && n.$$typeof === e ? (Q = "<" + (E(n.type) || "Unknown") + " />", P = " Did you accidentally export a JSX literal instead of a component?") : Q = typeof n, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Q, P);
        }
        var ee = Qt(n, y, D, q, Y);
        if (ee == null)
          return ee;
        if (H) {
          var le = y.children;
          if (le !== void 0)
            if (M)
              if (or(le)) {
                for (var Ee = 0; Ee < le.length; Ee++)
                  Hr(le[Ee], n);
                Object.freeze && Object.freeze(le);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Hr(le, n);
        }
        return n === s ? ts(ee) : rs(ee), ee;
      }
    }
    function ss(n, y, D) {
      return qr(n, y, D, !0);
    }
    function as(n, y, D) {
      return qr(n, y, D, !1);
    }
    var is = as, os = ss;
    Wr.Fragment = s, Wr.jsx = is, Wr.jsxs = os;
  }()), Wr;
}
process.env.NODE_ENV === "production" ? ys.exports = un() : ys.exports = fn();
var z = ys.exports, gt = /* @__PURE__ */ ((r) => (r.UPDATE_MODE = "MODE_THREAD", r.SELECT_THREAD = "SELECT_THREAD", r.CREATOR_UPDATE_FILTERS = "CREATOR_UPDATE_FILTERS", r))(gt || {});
const pa = (r) => ({
  filters: r,
  type: "CREATOR_UPDATE_FILTERS"
  /* CREATOR_UPDATE_FILTERS */
}), Ct = (r) => ({
  thread: r,
  mode: "read-thread",
  type: "SELECT_THREAD"
  /* SELECT_THREAD */
}), jr = (r) => ({
  mode: r,
  type: "MODE_THREAD"
  /* UPDATE_MODE */
}), kn = (r, e) => {
  switch (e.type) {
    case gt.CREATOR_UPDATE_FILTERS:
      return { ...r, filters: e.filters };
    case gt.UPDATE_MODE:
      return { ...r, mode: e.mode };
    case gt.SELECT_THREAD:
      return { ...r, thread: e.thread, mode: e.mode };
    default:
      return r;
  }
};
function dn() {
  const r = [];
  function e(s) {
    return r.push(s), () => {
      const a = r.indexOf(s);
      a !== -1 && r.splice(a, 1);
    };
  }
  function t(s) {
    r.forEach((a) => {
      a(s);
    });
  }
  return {
    next: t,
    subscribe: e
  };
}
const Ci = (r = { id: "haou2" }, e = "creator", t = {
  baseUrl: "",
  tokenKey: "access-token",
  assetBaseUrl: "",
  becomeKey: "become-token"
}) => ({
  mode: "initial",
  type: e,
  user: r,
  settings: t,
  filters: {
    status: "unread"
  },
  thread: null,
  observer: dn()
}), Si = Ls({
  state: Ci(),
  dispatch: () => {
  }
}), mn = ({ type: r, user: e, settings: t, children: s, defaultContextState: a }) => {
  const [i, o] = an(
    kn,
    a || Ci(e, r, t)
  );
  return /* @__PURE__ */ z.jsx(Si.Provider, { value: { state: i, dispatch: o }, children: s });
};
function Ai(r) {
  var e, t, s = "";
  if (typeof r == "string" || typeof r == "number")
    s += r;
  else if (typeof r == "object")
    if (Array.isArray(r)) {
      var a = r.length;
      for (e = 0; e < a; e++)
        r[e] && (t = Ai(r[e])) && (s && (s += " "), s += t);
    } else
      for (t in r)
        r[t] && (s && (s += " "), s += t);
  return s;
}
function zr() {
  for (var r, e, t = 0, s = "", a = arguments.length; t < a; t++)
    (r = arguments[t]) && (e = Ai(r)) && (s && (s += " "), s += e);
  return s;
}
const Fr = we(
  ({ children: r, size: e = "xs", legend: t, src: s }) => {
    const a = tr(() => {
      const [i] = t;
      return i;
    }, [t]);
    return /* @__PURE__ */ z.jsxs(
      "figure",
      {
        "data-testid": "avatar",
        className: zr(
          "skp-relative skp-flex-shrink-0 skp-overflow-hidden skp-rounded-full skp-bg-slate-200",
          {
            "skp-h-8 skp-w-8": e === "xs",
            "skp-h-10 skp-w-10": e === "sm",
            "skp-h-20 skp-w-20": e === "lg"
          }
        ),
        children: [
          s ? /* @__PURE__ */ z.jsx(
            "img",
            {
              src: s,
              alt: t,
              className: "skp-h-full skp-w-full skp-object-contain",
              "data-testid": "avatar-picture"
            }
          ) : /* @__PURE__ */ z.jsx(
            "span",
            {
              "data-testid": "avatar-initial",
              className: zr(
                "skp-absolute skp-left-0 skp-top-0 skp-inline-flex skp-h-full skp-w-full skp-items-center skp-justify-center skp-font-semibold skp-uppercase skp-text-gray-600",
                {
                  "skp-text-xs": e === "xs",
                  "skp-text-sm": e === "sm",
                  "skp-text-2xl": e === "lg"
                }
              ),
              children: r || a
            }
          ),
          /* @__PURE__ */ z.jsx(
            "figcaption",
            {
              "data-testid": "avatar-legend",
              className: "skp-absolute skp-inline-flex skp-h-0 skp-w-0 skp-items-center skp-justify-center skp-overflow-hidden",
              children: t
            }
          )
        ]
      }
    );
  }
), St = (r) => {
  const e = Date.now(), t = new Date(r).getTime(), s = e - t, a = Math.floor(
    s % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)
  ), i = Math.floor(
    s % (1e3 * 60 * 60) / (1e3 * 60)
  ), o = Math.floor(s % (1e3 * 60) / 1e3), l = Math.floor(s / (1e3 * 60 * 60 * 24)), p = Math.floor(l / 30), g = Math.floor(p / 12);
  return {
    days: l,
    hours: a,
    minutes: i,
    seconds: o,
    months: p,
    years: g
  };
}, At = ({
  years: r,
  months: e,
  days: t,
  hours: s,
  minutes: a,
  seconds: i
}) => r !== 0 ? { key: "datetime.distance_in_words.x_years", count: r } : e !== 0 ? { key: "datetime.distance_in_words.x_months", count: e } : t !== 0 ? { key: "datetime.distance_in_words.x_days", count: t } : s !== 0 ? { key: "datetime.distance_in_words.x_hours", count: s } : a !== 0 ? { key: "datetime.distance_in_words.x_minutes", count: a } : { key: "js.time.less_than_a_minute", count: i };
function gn(r, e) {
  const t = be();
  return on(
    (...s) => {
      t.current && clearTimeout(t.current), t.current = setTimeout(() => {
        r(...s);
      }, e);
    },
    [e, r]
  );
}
const vn = (r) => {
  const e = be(null);
  return Ge(() => {
    const t = (s) => {
      e.current && !e.current.contains(s.target) && r();
    };
    return document.addEventListener("click", t), () => {
      document.removeEventListener("click", t);
    };
  }, [e]), e;
}, Je = () => {
  const r = ji(window.I18nContext), [e, t] = Se(r.i18n), { i18n: s, locale: a, setLocale: i } = r;
  return Ge(() => s.onChange((o) => {
    t(
      Object.assign(
        Object.create(Object.getPrototypeOf(o)),
        o
      )
    );
  }), []), { i18n: e, locale: a, setLocale: i };
};
var pt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Be(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var ws = { exports: {} }, Vr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ca;
function hn() {
  if (ca)
    return Vr;
  ca = 1;
  var r = dr, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, a = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(l, p, g) {
    var w, k = {}, h = null, S = null;
    g !== void 0 && (h = "" + g), p.key !== void 0 && (h = "" + p.key), p.ref !== void 0 && (S = p.ref);
    for (w in p)
      s.call(p, w) && !i.hasOwnProperty(w) && (k[w] = p[w]);
    if (l && l.defaultProps)
      for (w in p = l.defaultProps, p)
        k[w] === void 0 && (k[w] = p[w]);
    return { $$typeof: e, type: l, key: h, ref: S, props: k, _owner: a.current };
  }
  return Vr.Fragment = t, Vr.jsx = o, Vr.jsxs = o, Vr;
}
var ct = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ua;
function xn() {
  return ua || (ua = 1, process.env.NODE_ENV !== "production" && function() {
    var r = dr, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), k = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), _ = Symbol.iterator, G = "@@iterator";
    function I(n) {
      if (n === null || typeof n != "object")
        return null;
      var y = _ && n[_] || n[G];
      return typeof y == "function" ? y : null;
    }
    var N = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(n) {
      {
        for (var y = arguments.length, D = new Array(y > 1 ? y - 1 : 0), M = 1; M < y; M++)
          D[M - 1] = arguments[M];
        re("error", n, D);
      }
    }
    function re(n, y, D) {
      {
        var M = N.ReactDebugCurrentFrame, q = M.getStackAddendum();
        q !== "" && (y += "%s", D = D.concat([q]));
        var Y = D.map(function(H) {
          return String(H);
        });
        Y.unshift("Warning: " + y), Function.prototype.apply.call(console[n], console, Y);
      }
    }
    var B = !1, R = !1, L = !1, Z = !1, c = !1, u;
    u = Symbol.for("react.module.reference");
    function m(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === s || n === i || c || n === a || n === g || n === w || Z || n === S || B || R || L || typeof n == "object" && n !== null && (n.$$typeof === h || n.$$typeof === k || n.$$typeof === o || n.$$typeof === l || n.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === u || n.getModuleId !== void 0));
    }
    function j(n, y, D) {
      var M = n.displayName;
      if (M)
        return M;
      var q = y.displayName || y.name || "";
      return q !== "" ? D + "(" + q + ")" : D;
    }
    function F(n) {
      return n.displayName || "Context";
    }
    function E(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case s:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case g:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case l:
            var y = n;
            return F(y) + ".Consumer";
          case o:
            var D = n;
            return F(D._context) + ".Provider";
          case p:
            return j(n, n.render, "ForwardRef");
          case k:
            var M = n.displayName || null;
            return M !== null ? M : E(n.type) || "Memo";
          case h: {
            var q = n, Y = q._payload, H = q._init;
            try {
              return E(H(Y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var b = Object.assign, f = 0, d, x, v, A, O, T, K;
    function V() {
    }
    V.__reactDisabledLog = !0;
    function te() {
      {
        if (f === 0) {
          d = console.log, x = console.info, v = console.warn, A = console.error, O = console.group, T = console.groupCollapsed, K = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: V,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        f++;
      }
    }
    function W() {
      {
        if (f--, f === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: b({}, n, {
              value: d
            }),
            info: b({}, n, {
              value: x
            }),
            warn: b({}, n, {
              value: v
            }),
            error: b({}, n, {
              value: A
            }),
            group: b({}, n, {
              value: O
            }),
            groupCollapsed: b({}, n, {
              value: T
            }),
            groupEnd: b({}, n, {
              value: K
            })
          });
        }
        f < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = N.ReactCurrentDispatcher, se;
    function de(n, y, D) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (q) {
            var M = q.stack.trim().match(/\n( *(at )?)/);
            se = M && M[1] || "";
          }
        return `
` + se + n;
      }
    }
    var me = !1, oe;
    {
      var ce = typeof WeakMap == "function" ? WeakMap : Map;
      oe = new ce();
    }
    function xe(n, y) {
      if (!n || me)
        return "";
      {
        var D = oe.get(n);
        if (D !== void 0)
          return D;
      }
      var M;
      me = !0;
      var q = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Y;
      Y = J.current, J.current = null, te();
      try {
        if (y) {
          var H = function() {
            throw Error();
          };
          if (Object.defineProperty(H.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(H, []);
            } catch (ve) {
              M = ve;
            }
            Reflect.construct(n, [], H);
          } else {
            try {
              H.call();
            } catch (ve) {
              M = ve;
            }
            n.call(H.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ve) {
            M = ve;
          }
          n();
        }
      } catch (ve) {
        if (ve && M && typeof ve.stack == "string") {
          for (var P = ve.stack.split(`
`), ie = M.stack.split(`
`), Q = P.length - 1, ee = ie.length - 1; Q >= 1 && ee >= 0 && P[Q] !== ie[ee]; )
            ee--;
          for (; Q >= 1 && ee >= 0; Q--, ee--)
            if (P[Q] !== ie[ee]) {
              if (Q !== 1 || ee !== 1)
                do
                  if (Q--, ee--, ee < 0 || P[Q] !== ie[ee]) {
                    var le = `
` + P[Q].replace(" at new ", " at ");
                    return n.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", n.displayName)), typeof n == "function" && oe.set(n, le), le;
                  }
                while (Q >= 1 && ee >= 0);
              break;
            }
        }
      } finally {
        me = !1, J.current = Y, W(), Error.prepareStackTrace = q;
      }
      var Ee = n ? n.displayName || n.name : "", Kr = Ee ? de(Ee) : "";
      return typeof n == "function" && oe.set(n, Kr), Kr;
    }
    function ke(n, y, D) {
      return xe(n, !1);
    }
    function ge(n) {
      var y = n.prototype;
      return !!(y && y.isReactComponent);
    }
    function ae(n, y, D) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return xe(n, ge(n));
      if (typeof n == "string")
        return de(n);
      switch (n) {
        case g:
          return de("Suspense");
        case w:
          return de("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case p:
            return ke(n.render);
          case k:
            return ae(n.type, y, D);
          case h: {
            var M = n, q = M._payload, Y = M._init;
            try {
              return ae(Y(q), y, D);
            } catch {
            }
          }
        }
      return "";
    }
    var qe = Object.prototype.hasOwnProperty, Mr = {}, Br = N.ReactDebugCurrentFrame;
    function Ke(n) {
      if (n) {
        var y = n._owner, D = ae(n.type, n._source, y ? y.type : null);
        Br.setExtraStackFrame(D);
      } else
        Br.setExtraStackFrame(null);
    }
    function Pt(n, y, D, M, q) {
      {
        var Y = Function.call.bind(qe);
        for (var H in n)
          if (Y(n, H)) {
            var P = void 0;
            try {
              if (typeof n[H] != "function") {
                var ie = Error((M || "React class") + ": " + D + " type `" + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[H] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ie.name = "Invariant Violation", ie;
              }
              P = n[H](y, H, M, D, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Q) {
              P = Q;
            }
            P && !(P instanceof Error) && (Ke(q), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", M || "React class", D, H, typeof P), Ke(null)), P instanceof Error && !(P.message in Mr) && (Mr[P.message] = !0, Ke(q), C("Failed %s type: %s", D, P.message), Ke(null));
          }
      }
    }
    var Ut = Array.isArray;
    function or(n) {
      return Ut(n);
    }
    function Gt(n) {
      {
        var y = typeof Symbol == "function" && Symbol.toStringTag, D = y && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return D;
      }
    }
    function Ht(n) {
      try {
        return Tr(n), !1;
      } catch {
        return !0;
      }
    }
    function Tr(n) {
      return "" + n;
    }
    function Ir(n) {
      if (Ht(n))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Gt(n)), Tr(n);
    }
    var Te = N.ReactCurrentOwner, qt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Rr, Lr, nr;
    nr = {};
    function Kt(n) {
      if (qe.call(n, "ref")) {
        var y = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function Yt(n) {
      if (qe.call(n, "key")) {
        var y = Object.getOwnPropertyDescriptor(n, "key").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function Wt(n, y) {
      if (typeof n.ref == "string" && Te.current && y && Te.current.stateNode !== y) {
        var D = E(Te.current.type);
        nr[D] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', E(Te.current.type), n.ref), nr[D] = !0);
      }
    }
    function Vt(n, y) {
      {
        var D = function() {
          Rr || (Rr = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        D.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: D,
          configurable: !0
        });
      }
    }
    function Zt(n, y) {
      {
        var D = function() {
          Lr || (Lr = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        D.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: D,
          configurable: !0
        });
      }
    }
    var Jt = function(n, y, D, M, q, Y, H) {
      var P = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: n,
        key: y,
        ref: D,
        props: H,
        // Record the component responsible for creating this element.
        _owner: Y
      };
      return P._store = {}, Object.defineProperty(P._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(P, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: M
      }), Object.defineProperty(P, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.freeze && (Object.freeze(P.props), Object.freeze(P)), P;
    };
    function Qt(n, y, D, M, q) {
      {
        var Y, H = {}, P = null, ie = null;
        D !== void 0 && (Ir(D), P = "" + D), Yt(y) && (Ir(y.key), P = "" + y.key), Kt(y) && (ie = y.ref, Wt(y, q));
        for (Y in y)
          qe.call(y, Y) && !qt.hasOwnProperty(Y) && (H[Y] = y[Y]);
        if (n && n.defaultProps) {
          var Q = n.defaultProps;
          for (Y in Q)
            H[Y] === void 0 && (H[Y] = Q[Y]);
        }
        if (P || ie) {
          var ee = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          P && Vt(H, ee), ie && Zt(H, ee);
        }
        return Jt(n, P, ie, q, M, Te.current, H);
      }
    }
    var lr = N.ReactCurrentOwner, Nr = N.ReactDebugCurrentFrame;
    function Fe(n) {
      if (n) {
        var y = n._owner, D = ae(n.type, n._source, y ? y.type : null);
        Nr.setExtraStackFrame(D);
      } else
        Nr.setExtraStackFrame(null);
    }
    var pr;
    pr = !1;
    function cr(n) {
      return typeof n == "object" && n !== null && n.$$typeof === e;
    }
    function Pr() {
      {
        if (lr.current) {
          var n = E(lr.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Xt(n) {
      {
        if (n !== void 0) {
          var y = n.fileName.replace(/^.*[\\\/]/, ""), D = n.lineNumber;
          return `

Check your code at ` + y + ":" + D + ".";
        }
        return "";
      }
    }
    var Ur = {};
    function es(n) {
      {
        var y = Pr();
        if (!y) {
          var D = typeof n == "string" ? n : n.displayName || n.name;
          D && (y = `

Check the top-level render call using <` + D + ">.");
        }
        return y;
      }
    }
    function Gr(n, y) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var D = es(y);
        if (Ur[D])
          return;
        Ur[D] = !0;
        var M = "";
        n && n._owner && n._owner !== lr.current && (M = " It was passed a child from " + E(n._owner.type) + "."), Fe(n), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', D, M), Fe(null);
      }
    }
    function Hr(n, y) {
      {
        if (typeof n != "object")
          return;
        if (or(n))
          for (var D = 0; D < n.length; D++) {
            var M = n[D];
            cr(M) && Gr(M, y);
          }
        else if (cr(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var q = I(n);
          if (typeof q == "function" && q !== n.entries)
            for (var Y = q.call(n), H; !(H = Y.next()).done; )
              cr(H.value) && Gr(H.value, y);
        }
      }
    }
    function rs(n) {
      {
        var y = n.type;
        if (y == null || typeof y == "string")
          return;
        var D;
        if (typeof y == "function")
          D = y.propTypes;
        else if (typeof y == "object" && (y.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        y.$$typeof === k))
          D = y.propTypes;
        else
          return;
        if (D) {
          var M = E(y);
          Pt(D, n.props, "prop", M, n);
        } else if (y.PropTypes !== void 0 && !pr) {
          pr = !0;
          var q = E(y);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", q || "Unknown");
        }
        typeof y.getDefaultProps == "function" && !y.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ts(n) {
      {
        for (var y = Object.keys(n.props), D = 0; D < y.length; D++) {
          var M = y[D];
          if (M !== "children" && M !== "key") {
            Fe(n), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", M), Fe(null);
            break;
          }
        }
        n.ref !== null && (Fe(n), C("Invalid attribute `ref` supplied to `React.Fragment`."), Fe(null));
      }
    }
    function qr(n, y, D, M, q, Y) {
      {
        var H = m(n);
        if (!H) {
          var P = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (P += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ie = Xt(q);
          ie ? P += ie : P += Pr();
          var Q;
          n === null ? Q = "null" : or(n) ? Q = "array" : n !== void 0 && n.$$typeof === e ? (Q = "<" + (E(n.type) || "Unknown") + " />", P = " Did you accidentally export a JSX literal instead of a component?") : Q = typeof n, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Q, P);
        }
        var ee = Qt(n, y, D, q, Y);
        if (ee == null)
          return ee;
        if (H) {
          var le = y.children;
          if (le !== void 0)
            if (M)
              if (or(le)) {
                for (var Ee = 0; Ee < le.length; Ee++)
                  Hr(le[Ee], n);
                Object.freeze && Object.freeze(le);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Hr(le, n);
        }
        return n === s ? ts(ee) : rs(ee), ee;
      }
    }
    function ss(n, y, D) {
      return qr(n, y, D, !0);
    }
    function as(n, y, D) {
      return qr(n, y, D, !1);
    }
    var is = as, os = ss;
    ct.Fragment = s, ct.jsx = is, ct.jsxs = os;
  }()), ct;
}
process.env.NODE_ENV === "production" ? ws.exports = hn() : ws.exports = xn();
var $ = ws.exports, bn = Array.isArray, He = bn, yn = typeof pt == "object" && pt && pt.Object === Object && pt, Di = yn, wn = Di, zn = typeof self == "object" && self && self.Object === Object && self, Fn = wn || zn || Function("return this")(), Qe = Fn, En = Qe, jn = En.Symbol, et = jn, fa = et, _i = Object.prototype, Cn = _i.hasOwnProperty, Sn = _i.toString, Zr = fa ? fa.toStringTag : void 0;
function An(r) {
  var e = Cn.call(r, Zr), t = r[Zr];
  try {
    r[Zr] = void 0;
    var s = !0;
  } catch {
  }
  var a = Sn.call(r);
  return s && (e ? r[Zr] = t : delete r[Zr]), a;
}
var Dn = An, _n = Object.prototype, On = _n.toString;
function $n(r) {
  return On.call(r);
}
var Mn = $n, ka = et, Bn = Dn, Tn = Mn, In = "[object Null]", Rn = "[object Undefined]", da = ka ? ka.toStringTag : void 0;
function Ln(r) {
  return r == null ? r === void 0 ? Rn : In : da && da in Object(r) ? Bn(r) : Tn(r);
}
var rt = Ln;
function Nn(r) {
  return r != null && typeof r == "object";
}
var tt = Nn, Pn = rt, Un = tt, Gn = "[object Symbol]";
function Hn(r) {
  return typeof r == "symbol" || Un(r) && Pn(r) == Gn;
}
var st = Hn, qn = He, Kn = st, Yn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Wn = /^\w*$/;
function Vn(r, e) {
  if (qn(r))
    return !1;
  var t = typeof r;
  return t == "number" || t == "symbol" || t == "boolean" || r == null || Kn(r) ? !0 : Wn.test(r) || !Yn.test(r) || e != null && r in Object(e);
}
var Ns = Vn;
function Zn(r) {
  var e = typeof r;
  return r != null && (e == "object" || e == "function");
}
var gr = Zn;
const Jn = /* @__PURE__ */ Be(gr);
var Qn = rt, Xn = gr, el = "[object AsyncFunction]", rl = "[object Function]", tl = "[object GeneratorFunction]", sl = "[object Proxy]";
function al(r) {
  if (!Xn(r))
    return !1;
  var e = Qn(r);
  return e == rl || e == tl || e == el || e == sl;
}
var Oi = al, il = Qe, ol = il["__core-js_shared__"], nl = ol, ns = nl, ma = function() {
  var r = /[^.]+$/.exec(ns && ns.keys && ns.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function ll(r) {
  return !!ma && ma in r;
}
var pl = ll, cl = Function.prototype, ul = cl.toString;
function fl(r) {
  if (r != null) {
    try {
      return ul.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
var $i = fl, kl = Oi, dl = pl, ml = gr, gl = $i, vl = /[\\^$.*+?()[\]{}|]/g, hl = /^\[object .+?Constructor\]$/, xl = Function.prototype, bl = Object.prototype, yl = xl.toString, wl = bl.hasOwnProperty, zl = RegExp(
  "^" + yl.call(wl).replace(vl, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Fl(r) {
  if (!ml(r) || dl(r))
    return !1;
  var e = kl(r) ? zl : hl;
  return e.test(gl(r));
}
var El = Fl;
function jl(r, e) {
  return r == null ? void 0 : r[e];
}
var Cl = jl, Sl = El, Al = Cl;
function Dl(r, e) {
  var t = Al(r, e);
  return Sl(t) ? t : void 0;
}
var vr = Dl, _l = vr, Ol = _l(Object, "create"), Dt = Ol, ga = Dt;
function $l() {
  this.__data__ = ga ? ga(null) : {}, this.size = 0;
}
var Ml = $l;
function Bl(r) {
  var e = this.has(r) && delete this.__data__[r];
  return this.size -= e ? 1 : 0, e;
}
var Tl = Bl, Il = Dt, Rl = "__lodash_hash_undefined__", Ll = Object.prototype, Nl = Ll.hasOwnProperty;
function Pl(r) {
  var e = this.__data__;
  if (Il) {
    var t = e[r];
    return t === Rl ? void 0 : t;
  }
  return Nl.call(e, r) ? e[r] : void 0;
}
var Ul = Pl, Gl = Dt, Hl = Object.prototype, ql = Hl.hasOwnProperty;
function Kl(r) {
  var e = this.__data__;
  return Gl ? e[r] !== void 0 : ql.call(e, r);
}
var Yl = Kl, Wl = Dt, Vl = "__lodash_hash_undefined__";
function Zl(r, e) {
  var t = this.__data__;
  return this.size += this.has(r) ? 0 : 1, t[r] = Wl && e === void 0 ? Vl : e, this;
}
var Jl = Zl, Ql = Ml, Xl = Tl, ep = Ul, rp = Yl, tp = Jl;
function Cr(r) {
  var e = -1, t = r == null ? 0 : r.length;
  for (this.clear(); ++e < t; ) {
    var s = r[e];
    this.set(s[0], s[1]);
  }
}
Cr.prototype.clear = Ql;
Cr.prototype.delete = Xl;
Cr.prototype.get = ep;
Cr.prototype.has = rp;
Cr.prototype.set = tp;
var sp = Cr;
function ap() {
  this.__data__ = [], this.size = 0;
}
var ip = ap;
function op(r, e) {
  return r === e || r !== r && e !== e;
}
var _t = op, np = _t;
function lp(r, e) {
  for (var t = r.length; t--; )
    if (np(r[t][0], e))
      return t;
  return -1;
}
var Ot = lp, pp = Ot, cp = Array.prototype, up = cp.splice;
function fp(r) {
  var e = this.__data__, t = pp(e, r);
  if (t < 0)
    return !1;
  var s = e.length - 1;
  return t == s ? e.pop() : up.call(e, t, 1), --this.size, !0;
}
var kp = fp, dp = Ot;
function mp(r) {
  var e = this.__data__, t = dp(e, r);
  return t < 0 ? void 0 : e[t][1];
}
var gp = mp, vp = Ot;
function hp(r) {
  return vp(this.__data__, r) > -1;
}
var xp = hp, bp = Ot;
function yp(r, e) {
  var t = this.__data__, s = bp(t, r);
  return s < 0 ? (++this.size, t.push([r, e])) : t[s][1] = e, this;
}
var wp = yp, zp = ip, Fp = kp, Ep = gp, jp = xp, Cp = wp;
function Sr(r) {
  var e = -1, t = r == null ? 0 : r.length;
  for (this.clear(); ++e < t; ) {
    var s = r[e];
    this.set(s[0], s[1]);
  }
}
Sr.prototype.clear = zp;
Sr.prototype.delete = Fp;
Sr.prototype.get = Ep;
Sr.prototype.has = jp;
Sr.prototype.set = Cp;
var $t = Sr, Sp = vr, Ap = Qe, Dp = Sp(Ap, "Map"), Ps = Dp, va = sp, _p = $t, Op = Ps;
function $p() {
  this.size = 0, this.__data__ = {
    hash: new va(),
    map: new (Op || _p)(),
    string: new va()
  };
}
var Mp = $p;
function Bp(r) {
  var e = typeof r;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? r !== "__proto__" : r === null;
}
var Tp = Bp, Ip = Tp;
function Rp(r, e) {
  var t = r.__data__;
  return Ip(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
}
var Mt = Rp, Lp = Mt;
function Np(r) {
  var e = Lp(this, r).delete(r);
  return this.size -= e ? 1 : 0, e;
}
var Pp = Np, Up = Mt;
function Gp(r) {
  return Up(this, r).get(r);
}
var Hp = Gp, qp = Mt;
function Kp(r) {
  return qp(this, r).has(r);
}
var Yp = Kp, Wp = Mt;
function Vp(r, e) {
  var t = Wp(this, r), s = t.size;
  return t.set(r, e), this.size += t.size == s ? 0 : 1, this;
}
var Zp = Vp, Jp = Mp, Qp = Pp, Xp = Hp, ec = Yp, rc = Zp;
function Ar(r) {
  var e = -1, t = r == null ? 0 : r.length;
  for (this.clear(); ++e < t; ) {
    var s = r[e];
    this.set(s[0], s[1]);
  }
}
Ar.prototype.clear = Jp;
Ar.prototype.delete = Qp;
Ar.prototype.get = Xp;
Ar.prototype.has = ec;
Ar.prototype.set = rc;
var Us = Ar, Mi = Us, tc = "Expected a function";
function Gs(r, e) {
  if (typeof r != "function" || e != null && typeof e != "function")
    throw new TypeError(tc);
  var t = function() {
    var s = arguments, a = e ? e.apply(this, s) : s[0], i = t.cache;
    if (i.has(a))
      return i.get(a);
    var o = r.apply(this, s);
    return t.cache = i.set(a, o) || i, o;
  };
  return t.cache = new (Gs.Cache || Mi)(), t;
}
Gs.Cache = Mi;
var sc = Gs, ac = sc, ic = 500;
function oc(r) {
  var e = ac(r, function(s) {
    return t.size === ic && t.clear(), s;
  }), t = e.cache;
  return e;
}
var nc = oc, lc = nc, pc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, cc = /\\(\\)?/g, uc = lc(function(r) {
  var e = [];
  return r.charCodeAt(0) === 46 && e.push(""), r.replace(pc, function(t, s, a, i) {
    e.push(a ? i.replace(cc, "$1") : s || t);
  }), e;
}), fc = uc;
function kc(r, e) {
  for (var t = -1, s = r == null ? 0 : r.length, a = Array(s); ++t < s; )
    a[t] = e(r[t], t, r);
  return a;
}
var Bi = kc, ha = et, dc = Bi, mc = He, gc = st, vc = 1 / 0, xa = ha ? ha.prototype : void 0, ba = xa ? xa.toString : void 0;
function Ti(r) {
  if (typeof r == "string")
    return r;
  if (mc(r))
    return dc(r, Ti) + "";
  if (gc(r))
    return ba ? ba.call(r) : "";
  var e = r + "";
  return e == "0" && 1 / r == -vc ? "-0" : e;
}
var hc = Ti, xc = hc;
function bc(r) {
  return r == null ? "" : xc(r);
}
var Dr = bc, yc = He, wc = Ns, zc = fc, Fc = Dr;
function Ec(r, e) {
  return yc(r) ? r : wc(r, e) ? [r] : zc(Fc(r));
}
var Hs = Ec, jc = st, Cc = 1 / 0;
function Sc(r) {
  if (typeof r == "string" || jc(r))
    return r;
  var e = r + "";
  return e == "0" && 1 / r == -Cc ? "-0" : e;
}
var at = Sc, Ac = Hs, Dc = at;
function _c(r, e) {
  e = Ac(e, r);
  for (var t = 0, s = e.length; r != null && t < s; )
    r = r[Dc(e[t++])];
  return t && t == s ? r : void 0;
}
var qs = _c, Oc = qs;
function $c(r, e, t) {
  var s = r == null ? void 0 : Oc(r, e);
  return s === void 0 ? t : s;
}
var Ii = $c;
const zs = /* @__PURE__ */ Be(Ii);
var Mc = Object.prototype, Bc = Mc.hasOwnProperty;
function Tc(r, e) {
  return r != null && Bc.call(r, e);
}
var Ic = Tc, Rc = rt, Lc = tt, Nc = "[object Arguments]";
function Pc(r) {
  return Lc(r) && Rc(r) == Nc;
}
var Uc = Pc, ya = Uc, Gc = tt, Ri = Object.prototype, Hc = Ri.hasOwnProperty, qc = Ri.propertyIsEnumerable, Kc = ya(/* @__PURE__ */ function() {
  return arguments;
}()) ? ya : function(r) {
  return Gc(r) && Hc.call(r, "callee") && !qc.call(r, "callee");
}, Ks = Kc, Yc = 9007199254740991, Wc = /^(?:0|[1-9]\d*)$/;
function Vc(r, e) {
  var t = typeof r;
  return e = e ?? Yc, !!e && (t == "number" || t != "symbol" && Wc.test(r)) && r > -1 && r % 1 == 0 && r < e;
}
var Bt = Vc, Zc = 9007199254740991;
function Jc(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= Zc;
}
var Ys = Jc, Qc = Hs, Xc = Ks, e0 = He, r0 = Bt, t0 = Ys, s0 = at;
function a0(r, e, t) {
  e = Qc(e, r);
  for (var s = -1, a = e.length, i = !1; ++s < a; ) {
    var o = s0(e[s]);
    if (!(i = r != null && t(r, o)))
      break;
    r = r[o];
  }
  return i || ++s != a ? i : (a = r == null ? 0 : r.length, !!a && t0(a) && r0(o, a) && (e0(r) || Xc(r)));
}
var Li = a0, i0 = Ic, o0 = Li;
function n0(r, e) {
  return r != null && o0(r, e, i0);
}
var l0 = n0;
const p0 = /* @__PURE__ */ Be(l0);
var c0 = vr, u0 = function() {
  try {
    var r = c0(Object, "defineProperty");
    return r({}, "", {}), r;
  } catch {
  }
}(), Ni = u0, wa = Ni;
function f0(r, e, t) {
  e == "__proto__" && wa ? wa(r, e, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : r[e] = t;
}
var k0 = f0, d0 = k0, m0 = _t, g0 = Object.prototype, v0 = g0.hasOwnProperty;
function h0(r, e, t) {
  var s = r[e];
  (!(v0.call(r, e) && m0(s, t)) || t === void 0 && !(e in r)) && d0(r, e, t);
}
var Pi = h0, x0 = Pi, b0 = Hs, y0 = Bt, za = gr, w0 = at;
function z0(r, e, t, s) {
  if (!za(r))
    return r;
  e = b0(e, r);
  for (var a = -1, i = e.length, o = i - 1, l = r; l != null && ++a < i; ) {
    var p = w0(e[a]), g = t;
    if (p === "__proto__" || p === "constructor" || p === "prototype")
      return r;
    if (a != o) {
      var w = l[p];
      g = s ? s(w, p, l) : void 0, g === void 0 && (g = za(w) ? w : y0(e[a + 1]) ? [] : {});
    }
    x0(l, p, g), l = l[p];
  }
  return r;
}
var Ui = z0, F0 = Ui;
function E0(r, e, t) {
  return r == null ? r : F0(r, e, t);
}
var j0 = E0;
const C0 = /* @__PURE__ */ Be(j0);
var S0 = Ui;
function A0(r, e, t, s) {
  return s = typeof s == "function" ? s : void 0, r == null ? r : S0(r, e, t, s);
}
var D0 = A0;
const _0 = /* @__PURE__ */ Be(D0);
var O0 = "__lodash_hash_undefined__";
function $0(r) {
  return this.__data__.set(r, O0), this;
}
var M0 = $0;
function B0(r) {
  return this.__data__.has(r);
}
var T0 = B0, I0 = Us, R0 = M0, L0 = T0;
function ht(r) {
  var e = -1, t = r == null ? 0 : r.length;
  for (this.__data__ = new I0(); ++e < t; )
    this.add(r[e]);
}
ht.prototype.add = ht.prototype.push = R0;
ht.prototype.has = L0;
var Gi = ht;
function N0(r, e, t, s) {
  for (var a = r.length, i = t + (s ? 1 : -1); s ? i-- : ++i < a; )
    if (e(r[i], i, r))
      return i;
  return -1;
}
var P0 = N0;
function U0(r) {
  return r !== r;
}
var G0 = U0;
function H0(r, e, t) {
  for (var s = t - 1, a = r.length; ++s < a; )
    if (r[s] === e)
      return s;
  return -1;
}
var q0 = H0, K0 = P0, Y0 = G0, W0 = q0;
function V0(r, e, t) {
  return e === e ? W0(r, e, t) : K0(r, Y0, t);
}
var Z0 = V0, J0 = Z0;
function Q0(r, e) {
  var t = r == null ? 0 : r.length;
  return !!t && J0(r, e, 0) > -1;
}
var X0 = Q0;
function e1(r, e, t) {
  for (var s = -1, a = r == null ? 0 : r.length; ++s < a; )
    if (t(e, r[s]))
      return !0;
  return !1;
}
var r1 = e1;
function t1(r, e) {
  return r.has(e);
}
var Hi = t1, s1 = vr, a1 = Qe, i1 = s1(a1, "Set"), qi = i1;
function o1() {
}
var n1 = o1;
function l1(r) {
  var e = -1, t = Array(r.size);
  return r.forEach(function(s) {
    t[++e] = s;
  }), t;
}
var Ws = l1, ls = qi, p1 = n1, c1 = Ws, u1 = 1 / 0, f1 = ls && 1 / c1(new ls([, -0]))[1] == u1 ? function(r) {
  return new ls(r);
} : p1, k1 = f1, d1 = Gi, m1 = X0, g1 = r1, v1 = Hi, h1 = k1, x1 = Ws, b1 = 200;
function y1(r, e, t) {
  var s = -1, a = m1, i = r.length, o = !0, l = [], p = l;
  if (t)
    o = !1, a = g1;
  else if (i >= b1) {
    var g = e ? null : h1(r);
    if (g)
      return x1(g);
    o = !1, a = v1, p = new d1();
  } else
    p = e ? [] : l;
  e:
    for (; ++s < i; ) {
      var w = r[s], k = e ? e(w) : w;
      if (w = t || w !== 0 ? w : 0, o && k === k) {
        for (var h = p.length; h--; )
          if (p[h] === k)
            continue e;
        e && p.push(k), l.push(w);
      } else
        a(p, k, t) || (p !== l && p.push(k), l.push(w));
    }
  return l;
}
var w1 = y1, z1 = w1;
function F1(r) {
  return r && r.length ? z1(r) : [];
}
var E1 = F1;
const j1 = /* @__PURE__ */ Be(E1), C1 = (r, e) => {
  const t = [], s = [];
  return t.push(e), e || t.push(r.locale), r.enableFallback && t.push(r.defaultLocale), t.filter(Boolean).map((a) => a.toString()).forEach(function(a) {
    if (s.includes(a) || s.push(a), !r.enableFallback)
      return;
    const i = a.split("-");
    i.length === 3 && s.push(`${i[0]}-${i[1]}`), s.push(i[0]);
  }), j1(s);
};
class S1 {
  constructor(e) {
    this.i18n = e, this.registry = {}, this.register("default", C1);
  }
  register(e, t) {
    if (typeof t != "function") {
      const s = t;
      t = () => s;
    }
    this.registry[e] = t;
  }
  get(e) {
    let t = this.registry[e] || this.registry[this.i18n.locale] || this.registry.default;
    return typeof t == "function" && (t = t(this.i18n, e)), t instanceof Array || (t = [t]), t;
  }
}
const A1 = (r, e) => {
  const t = String(r).split("."), s = !t[1], a = Number(t[0]) == r, i = a && t[0].slice(-1), o = a && t[0].slice(-2);
  return e ? i == 1 && o != 11 ? "one" : i == 2 && o != 12 ? "two" : i == 3 && o != 13 ? "few" : "other" : r == 1 && s ? "one" : "other";
};
function D1({ pluralizer: r, includeZero: e = !0, ordinal: t = !1 }) {
  return function(s, a) {
    return [
      e && a === 0 ? "zero" : "",
      r(a, t)
    ].filter(Boolean);
  };
}
const _1 = D1({
  pluralizer: A1,
  includeZero: !0
});
class O1 {
  constructor(e) {
    this.i18n = e, this.registry = {}, this.register("default", _1);
  }
  register(e, t) {
    this.registry[e] = t;
  }
  get(e) {
    return this.registry[e] || this.registry[this.i18n.locale] || this.registry.default;
  }
}
function $1(r, e, t) {
  var s = -1, a = r.length;
  e < 0 && (e = -e > a ? 0 : a + e), t = t > a ? a : t, t < 0 && (t += a), a = e > t ? 0 : t - e >>> 0, e >>>= 0;
  for (var i = Array(a); ++s < a; )
    i[s] = r[s + e];
  return i;
}
var M1 = $1, B1 = M1;
function T1(r, e, t) {
  var s = r.length;
  return t = t === void 0 ? s : t, !e && t >= s ? r : B1(r, e, t);
}
var I1 = T1, R1 = "\\ud800-\\udfff", L1 = "\\u0300-\\u036f", N1 = "\\ufe20-\\ufe2f", P1 = "\\u20d0-\\u20ff", U1 = L1 + N1 + P1, G1 = "\\ufe0e\\ufe0f", H1 = "\\u200d", q1 = RegExp("[" + H1 + R1 + U1 + G1 + "]");
function K1(r) {
  return q1.test(r);
}
var Ki = K1;
function Y1(r) {
  return r.split("");
}
var W1 = Y1, Yi = "\\ud800-\\udfff", V1 = "\\u0300-\\u036f", Z1 = "\\ufe20-\\ufe2f", J1 = "\\u20d0-\\u20ff", Q1 = V1 + Z1 + J1, X1 = "\\ufe0e\\ufe0f", eu = "[" + Yi + "]", Fs = "[" + Q1 + "]", Es = "\\ud83c[\\udffb-\\udfff]", ru = "(?:" + Fs + "|" + Es + ")", Wi = "[^" + Yi + "]", Vi = "(?:\\ud83c[\\udde6-\\uddff]){2}", Zi = "[\\ud800-\\udbff][\\udc00-\\udfff]", tu = "\\u200d", Ji = ru + "?", Qi = "[" + X1 + "]?", su = "(?:" + tu + "(?:" + [Wi, Vi, Zi].join("|") + ")" + Qi + Ji + ")*", au = Qi + Ji + su, iu = "(?:" + [Wi + Fs + "?", Fs, Vi, Zi, eu].join("|") + ")", ou = RegExp(Es + "(?=" + Es + ")|" + iu + au, "g");
function nu(r) {
  return r.match(ou) || [];
}
var lu = nu, pu = W1, cu = Ki, uu = lu;
function fu(r) {
  return cu(r) ? uu(r) : pu(r);
}
var ku = fu, du = I1, mu = Ki, gu = ku, vu = Dr;
function hu(r) {
  return function(e) {
    e = vu(e);
    var t = mu(e) ? gu(e) : void 0, s = t ? t[0] : e.charAt(0), a = t ? du(t, 1).join("") : e.slice(1);
    return s[r]() + a;
  };
}
var xu = hu, bu = xu, yu = bu("toUpperCase"), wu = yu, zu = Dr, Fu = wu;
function Eu(r) {
  return Fu(zu(r).toLowerCase());
}
var ju = Eu;
function Cu(r, e, t, s) {
  var a = -1, i = r == null ? 0 : r.length;
  for (s && i && (t = r[++a]); ++a < i; )
    t = e(t, r[a], a, r);
  return t;
}
var Su = Cu;
function Au(r) {
  return function(e) {
    return r == null ? void 0 : r[e];
  };
}
var Du = Au, _u = Du, Ou = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, $u = _u(Ou), Mu = $u, Bu = Mu, Tu = Dr, Iu = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ru = "\\u0300-\\u036f", Lu = "\\ufe20-\\ufe2f", Nu = "\\u20d0-\\u20ff", Pu = Ru + Lu + Nu, Uu = "[" + Pu + "]", Gu = RegExp(Uu, "g");
function Hu(r) {
  return r = Tu(r), r && r.replace(Iu, Bu).replace(Gu, "");
}
var qu = Hu, Ku = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function Yu(r) {
  return r.match(Ku) || [];
}
var Wu = Yu, Vu = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Zu(r) {
  return Vu.test(r);
}
var Ju = Zu, Xi = "\\ud800-\\udfff", Qu = "\\u0300-\\u036f", Xu = "\\ufe20-\\ufe2f", ef = "\\u20d0-\\u20ff", rf = Qu + Xu + ef, eo = "\\u2700-\\u27bf", ro = "a-z\\xdf-\\xf6\\xf8-\\xff", tf = "\\xac\\xb1\\xd7\\xf7", sf = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", af = "\\u2000-\\u206f", of = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", to = "A-Z\\xc0-\\xd6\\xd8-\\xde", nf = "\\ufe0e\\ufe0f", so = tf + sf + af + of, ao = "['’]", Fa = "[" + so + "]", lf = "[" + rf + "]", io = "\\d+", pf = "[" + eo + "]", oo = "[" + ro + "]", no = "[^" + Xi + so + io + eo + ro + to + "]", cf = "\\ud83c[\\udffb-\\udfff]", uf = "(?:" + lf + "|" + cf + ")", ff = "[^" + Xi + "]", lo = "(?:\\ud83c[\\udde6-\\uddff]){2}", po = "[\\ud800-\\udbff][\\udc00-\\udfff]", hr = "[" + to + "]", kf = "\\u200d", Ea = "(?:" + oo + "|" + no + ")", df = "(?:" + hr + "|" + no + ")", ja = "(?:" + ao + "(?:d|ll|m|re|s|t|ve))?", Ca = "(?:" + ao + "(?:D|LL|M|RE|S|T|VE))?", co = uf + "?", uo = "[" + nf + "]?", mf = "(?:" + kf + "(?:" + [ff, lo, po].join("|") + ")" + uo + co + ")*", gf = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", vf = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", hf = uo + co + mf, xf = "(?:" + [pf, lo, po].join("|") + ")" + hf, bf = RegExp([
  hr + "?" + oo + "+" + ja + "(?=" + [Fa, hr, "$"].join("|") + ")",
  df + "+" + Ca + "(?=" + [Fa, hr + Ea, "$"].join("|") + ")",
  hr + "?" + Ea + "+" + ja,
  hr + "+" + Ca,
  vf,
  gf,
  io,
  xf
].join("|"), "g");
function yf(r) {
  return r.match(bf) || [];
}
var wf = yf, zf = Wu, Ff = Ju, Ef = Dr, jf = wf;
function Cf(r, e, t) {
  return r = Ef(r), e = t ? void 0 : e, e === void 0 ? Ff(r) ? jf(r) : zf(r) : r.match(e) || [];
}
var Sf = Cf, Af = Su, Df = qu, _f = Sf, Of = "['’]", $f = RegExp(Of, "g");
function Mf(r) {
  return function(e) {
    return Af(_f(Df(e).replace($f, "")), r, "");
  };
}
var Bf = Mf, Tf = ju, If = Bf, Rf = If(function(r, e, t) {
  return e = e.toLowerCase(), r + (t ? Tf(e) : e);
}), Lf = Rf;
const Nf = /* @__PURE__ */ Be(Lf);
function Pe(r) {
  return r ? Object.keys(r).reduce((e, t) => (e[Nf(t)] = r[t], e), {}) : {};
}
function Ze(r) {
  return r != null;
}
function Pf(r, e, t) {
  let s = [{ scope: e }];
  if (Ze(t.defaults) && (s = s.concat(t.defaults)), Ze(t.defaultValue)) {
    const a = typeof t.defaultValue == "function" ? t.defaultValue(r, e, t) : t.defaultValue;
    s.push({ message: a }), delete t.defaultValue;
  }
  return s;
}
var Uf = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, ps = Math.ceil, Oe = Math.floor, ze = "[BigNumber Error] ", Sa = ze + "Number primitive has more than 15 significant digits: ", Ie = 1e14, X = 14, cs = 9007199254740991, us = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], er = 1e7, he = 1e9;
function fo(r) {
  var e, t, s, a = C.prototype = { constructor: C, toString: null, valueOf: null }, i = new C(1), o = 20, l = 4, p = -7, g = 21, w = -1e7, k = 1e7, h = !1, S = 1, _ = 0, G = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, I = "0123456789abcdefghijklmnopqrstuvwxyz", N = !0;
  function C(c, u) {
    var m, j, F, E, b, f, d, x, v = this;
    if (!(v instanceof C))
      return new C(c, u);
    if (u == null) {
      if (c && c._isBigNumber === !0) {
        v.s = c.s, !c.c || c.e > k ? v.c = v.e = null : c.e < w ? v.c = [v.e = 0] : (v.e = c.e, v.c = c.c.slice());
        return;
      }
      if ((f = typeof c == "number") && c * 0 == 0) {
        if (v.s = 1 / c < 0 ? (c = -c, -1) : 1, c === ~~c) {
          for (E = 0, b = c; b >= 10; b /= 10, E++)
            ;
          E > k ? v.c = v.e = null : (v.e = E, v.c = [c]);
          return;
        }
        x = String(c);
      } else {
        if (!Uf.test(x = String(c)))
          return s(v, x, f);
        v.s = x.charCodeAt(0) == 45 ? (x = x.slice(1), -1) : 1;
      }
      (E = x.indexOf(".")) > -1 && (x = x.replace(".", "")), (b = x.search(/e/i)) > 0 ? (E < 0 && (E = b), E += +x.slice(b + 1), x = x.substring(0, b)) : E < 0 && (E = x.length);
    } else {
      if (ue(u, 2, I.length, "Base"), u == 10 && N)
        return v = new C(c), L(v, o + v.e + 1, l);
      if (x = String(c), f = typeof c == "number") {
        if (c * 0 != 0)
          return s(v, x, f, u);
        if (v.s = 1 / c < 0 ? (x = x.slice(1), -1) : 1, C.DEBUG && x.replace(/^0\.0*|\./, "").length > 15)
          throw Error(Sa + c);
      } else
        v.s = x.charCodeAt(0) === 45 ? (x = x.slice(1), -1) : 1;
      for (m = I.slice(0, u), E = b = 0, d = x.length; b < d; b++)
        if (m.indexOf(j = x.charAt(b)) < 0) {
          if (j == ".") {
            if (b > E) {
              E = d;
              continue;
            }
          } else if (!F && (x == x.toUpperCase() && (x = x.toLowerCase()) || x == x.toLowerCase() && (x = x.toUpperCase()))) {
            F = !0, b = -1, E = 0;
            continue;
          }
          return s(v, String(c), f, u);
        }
      f = !1, x = t(x, u, 10, v.s), (E = x.indexOf(".")) > -1 ? x = x.replace(".", "") : E = x.length;
    }
    for (b = 0; x.charCodeAt(b) === 48; b++)
      ;
    for (d = x.length; x.charCodeAt(--d) === 48; )
      ;
    if (x = x.slice(b, ++d)) {
      if (d -= b, f && C.DEBUG && d > 15 && (c > cs || c !== Oe(c)))
        throw Error(Sa + v.s * c);
      if ((E = E - b - 1) > k)
        v.c = v.e = null;
      else if (E < w)
        v.c = [v.e = 0];
      else {
        if (v.e = E, v.c = [], b = (E + 1) % X, E < 0 && (b += X), b < d) {
          for (b && v.c.push(+x.slice(0, b)), d -= X; b < d; )
            v.c.push(+x.slice(b, b += X));
          b = X - (x = x.slice(b)).length;
        } else
          b -= d;
        for (; b--; x += "0")
          ;
        v.c.push(+x);
      }
    } else
      v.c = [v.e = 0];
  }
  C.clone = fo, C.ROUND_UP = 0, C.ROUND_DOWN = 1, C.ROUND_CEIL = 2, C.ROUND_FLOOR = 3, C.ROUND_HALF_UP = 4, C.ROUND_HALF_DOWN = 5, C.ROUND_HALF_EVEN = 6, C.ROUND_HALF_CEIL = 7, C.ROUND_HALF_FLOOR = 8, C.EUCLID = 9, C.config = C.set = function(c) {
    var u, m;
    if (c != null)
      if (typeof c == "object") {
        if (c.hasOwnProperty(u = "DECIMAL_PLACES") && (m = c[u], ue(m, 0, he, u), o = m), c.hasOwnProperty(u = "ROUNDING_MODE") && (m = c[u], ue(m, 0, 8, u), l = m), c.hasOwnProperty(u = "EXPONENTIAL_AT") && (m = c[u], m && m.pop ? (ue(m[0], -he, 0, u), ue(m[1], 0, he, u), p = m[0], g = m[1]) : (ue(m, -he, he, u), p = -(g = m < 0 ? -m : m))), c.hasOwnProperty(u = "RANGE"))
          if (m = c[u], m && m.pop)
            ue(m[0], -he, -1, u), ue(m[1], 1, he, u), w = m[0], k = m[1];
          else if (ue(m, -he, he, u), m)
            w = -(k = m < 0 ? -m : m);
          else
            throw Error(ze + u + " cannot be zero: " + m);
        if (c.hasOwnProperty(u = "CRYPTO"))
          if (m = c[u], m === !!m)
            if (m)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                h = m;
              else
                throw h = !m, Error(ze + "crypto unavailable");
            else
              h = m;
          else
            throw Error(ze + u + " not true or false: " + m);
        if (c.hasOwnProperty(u = "MODULO_MODE") && (m = c[u], ue(m, 0, 9, u), S = m), c.hasOwnProperty(u = "POW_PRECISION") && (m = c[u], ue(m, 0, he, u), _ = m), c.hasOwnProperty(u = "FORMAT"))
          if (m = c[u], typeof m == "object")
            G = m;
          else
            throw Error(ze + u + " not an object: " + m);
        if (c.hasOwnProperty(u = "ALPHABET"))
          if (m = c[u], typeof m == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(m))
            N = m.slice(0, 10) == "0123456789", I = m;
          else
            throw Error(ze + u + " invalid: " + m);
      } else
        throw Error(ze + "Object expected: " + c);
    return {
      DECIMAL_PLACES: o,
      ROUNDING_MODE: l,
      EXPONENTIAL_AT: [p, g],
      RANGE: [w, k],
      CRYPTO: h,
      MODULO_MODE: S,
      POW_PRECISION: _,
      FORMAT: G,
      ALPHABET: I
    };
  }, C.isBigNumber = function(c) {
    if (!c || c._isBigNumber !== !0)
      return !1;
    if (!C.DEBUG)
      return !0;
    var u, m, j = c.c, F = c.e, E = c.s;
    e:
      if ({}.toString.call(j) == "[object Array]") {
        if ((E === 1 || E === -1) && F >= -he && F <= he && F === Oe(F)) {
          if (j[0] === 0) {
            if (F === 0 && j.length === 1)
              return !0;
            break e;
          }
          if (u = (F + 1) % X, u < 1 && (u += X), String(j[0]).length == u) {
            for (u = 0; u < j.length; u++)
              if (m = j[u], m < 0 || m >= Ie || m !== Oe(m))
                break e;
            if (m !== 0)
              return !0;
          }
        }
      } else if (j === null && F === null && (E === null || E === 1 || E === -1))
        return !0;
    throw Error(ze + "Invalid BigNumber: " + c);
  }, C.maximum = C.max = function() {
    return B(arguments, -1);
  }, C.minimum = C.min = function() {
    return B(arguments, 1);
  }, C.random = function() {
    var c = 9007199254740992, u = Math.random() * c & 2097151 ? function() {
      return Oe(Math.random() * c);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(m) {
      var j, F, E, b, f, d = 0, x = [], v = new C(i);
      if (m == null ? m = o : ue(m, 0, he), b = ps(m / X), h)
        if (crypto.getRandomValues) {
          for (j = crypto.getRandomValues(new Uint32Array(b *= 2)); d < b; )
            f = j[d] * 131072 + (j[d + 1] >>> 11), f >= 9e15 ? (F = crypto.getRandomValues(new Uint32Array(2)), j[d] = F[0], j[d + 1] = F[1]) : (x.push(f % 1e14), d += 2);
          d = b / 2;
        } else if (crypto.randomBytes) {
          for (j = crypto.randomBytes(b *= 7); d < b; )
            f = (j[d] & 31) * 281474976710656 + j[d + 1] * 1099511627776 + j[d + 2] * 4294967296 + j[d + 3] * 16777216 + (j[d + 4] << 16) + (j[d + 5] << 8) + j[d + 6], f >= 9e15 ? crypto.randomBytes(7).copy(j, d) : (x.push(f % 1e14), d += 7);
          d = b / 7;
        } else
          throw h = !1, Error(ze + "crypto unavailable");
      if (!h)
        for (; d < b; )
          f = u(), f < 9e15 && (x[d++] = f % 1e14);
      for (b = x[--d], m %= X, b && m && (f = us[X - m], x[d] = Oe(b / f) * f); x[d] === 0; x.pop(), d--)
        ;
      if (d < 0)
        x = [E = 0];
      else {
        for (E = -1; x[0] === 0; x.splice(0, 1), E -= X)
          ;
        for (d = 1, f = x[0]; f >= 10; f /= 10, d++)
          ;
        d < X && (E -= X - d);
      }
      return v.e = E, v.c = x, v;
    };
  }(), C.sum = function() {
    for (var c = 1, u = arguments, m = new C(u[0]); c < u.length; )
      m = m.plus(u[c++]);
    return m;
  }, t = /* @__PURE__ */ function() {
    var c = "0123456789";
    function u(m, j, F, E) {
      for (var b, f = [0], d, x = 0, v = m.length; x < v; ) {
        for (d = f.length; d--; f[d] *= j)
          ;
        for (f[0] += E.indexOf(m.charAt(x++)), b = 0; b < f.length; b++)
          f[b] > F - 1 && (f[b + 1] == null && (f[b + 1] = 0), f[b + 1] += f[b] / F | 0, f[b] %= F);
      }
      return f.reverse();
    }
    return function(m, j, F, E, b) {
      var f, d, x, v, A, O, T, K, V = m.indexOf("."), te = o, W = l;
      for (V >= 0 && (v = _, _ = 0, m = m.replace(".", ""), K = new C(j), O = K.pow(m.length - V), _ = v, K.c = u(
        Ye(_e(O.c), O.e, "0"),
        10,
        F,
        c
      ), K.e = K.c.length), T = u(m, j, F, b ? (f = I, c) : (f = c, I)), x = v = T.length; T[--v] == 0; T.pop())
        ;
      if (!T[0])
        return f.charAt(0);
      if (V < 0 ? --x : (O.c = T, O.e = x, O.s = E, O = e(O, K, te, W, F), T = O.c, A = O.r, x = O.e), d = x + te + 1, V = T[d], v = F / 2, A = A || d < 0 || T[d + 1] != null, A = W < 4 ? (V != null || A) && (W == 0 || W == (O.s < 0 ? 3 : 2)) : V > v || V == v && (W == 4 || A || W == 6 && T[d - 1] & 1 || W == (O.s < 0 ? 8 : 7)), d < 1 || !T[0])
        m = A ? Ye(f.charAt(1), -te, f.charAt(0)) : f.charAt(0);
      else {
        if (T.length = d, A)
          for (--F; ++T[--d] > F; )
            T[d] = 0, d || (++x, T = [1].concat(T));
        for (v = T.length; !T[--v]; )
          ;
        for (V = 0, m = ""; V <= v; m += f.charAt(T[V++]))
          ;
        m = Ye(m, x, f.charAt(0));
      }
      return m;
    };
  }(), e = /* @__PURE__ */ function() {
    function c(j, F, E) {
      var b, f, d, x, v = 0, A = j.length, O = F % er, T = F / er | 0;
      for (j = j.slice(); A--; )
        d = j[A] % er, x = j[A] / er | 0, b = T * d + x * O, f = O * d + b % er * er + v, v = (f / E | 0) + (b / er | 0) + T * x, j[A] = f % E;
      return v && (j = [v].concat(j)), j;
    }
    function u(j, F, E, b) {
      var f, d;
      if (E != b)
        d = E > b ? 1 : -1;
      else
        for (f = d = 0; f < E; f++)
          if (j[f] != F[f]) {
            d = j[f] > F[f] ? 1 : -1;
            break;
          }
      return d;
    }
    function m(j, F, E, b) {
      for (var f = 0; E--; )
        j[E] -= f, f = j[E] < F[E] ? 1 : 0, j[E] = f * b + j[E] - F[E];
      for (; !j[0] && j.length > 1; j.splice(0, 1))
        ;
    }
    return function(j, F, E, b, f) {
      var d, x, v, A, O, T, K, V, te, W, J, se, de, me, oe, ce, xe, ke = j.s == F.s ? 1 : -1, ge = j.c, ae = F.c;
      if (!ge || !ge[0] || !ae || !ae[0])
        return new C(
          // Return NaN if either NaN, or both Infinity or 0.
          !j.s || !F.s || (ge ? ae && ge[0] == ae[0] : !ae) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            ge && ge[0] == 0 || !ae ? ke * 0 : ke / 0
          )
        );
      for (V = new C(ke), te = V.c = [], x = j.e - F.e, ke = E + x + 1, f || (f = Ie, x = $e(j.e / X) - $e(F.e / X), ke = ke / X | 0), v = 0; ae[v] == (ge[v] || 0); v++)
        ;
      if (ae[v] > (ge[v] || 0) && x--, ke < 0)
        te.push(1), A = !0;
      else {
        for (me = ge.length, ce = ae.length, v = 0, ke += 2, O = Oe(f / (ae[0] + 1)), O > 1 && (ae = c(ae, O, f), ge = c(ge, O, f), ce = ae.length, me = ge.length), de = ce, W = ge.slice(0, ce), J = W.length; J < ce; W[J++] = 0)
          ;
        xe = ae.slice(), xe = [0].concat(xe), oe = ae[0], ae[1] >= f / 2 && oe++;
        do {
          if (O = 0, d = u(ae, W, ce, J), d < 0) {
            if (se = W[0], ce != J && (se = se * f + (W[1] || 0)), O = Oe(se / oe), O > 1)
              for (O >= f && (O = f - 1), T = c(ae, O, f), K = T.length, J = W.length; u(T, W, K, J) == 1; )
                O--, m(T, ce < K ? xe : ae, K, f), K = T.length, d = 1;
            else
              O == 0 && (d = O = 1), T = ae.slice(), K = T.length;
            if (K < J && (T = [0].concat(T)), m(W, T, J, f), J = W.length, d == -1)
              for (; u(ae, W, ce, J) < 1; )
                O++, m(W, ce < J ? xe : ae, J, f), J = W.length;
          } else
            d === 0 && (O++, W = [0]);
          te[v++] = O, W[0] ? W[J++] = ge[de] || 0 : (W = [ge[de]], J = 1);
        } while ((de++ < me || W[0] != null) && ke--);
        A = W[0] != null, te[0] || te.splice(0, 1);
      }
      if (f == Ie) {
        for (v = 1, ke = te[0]; ke >= 10; ke /= 10, v++)
          ;
        L(V, E + (V.e = v + x * X - 1) + 1, b, A);
      } else
        V.e = x, V.r = +A;
      return V;
    };
  }();
  function re(c, u, m, j) {
    var F, E, b, f, d;
    if (m == null ? m = l : ue(m, 0, 8), !c.c)
      return c.toString();
    if (F = c.c[0], b = c.e, u == null)
      d = _e(c.c), d = j == 1 || j == 2 && (b <= p || b >= g) ? ft(d, b) : Ye(d, b, "0");
    else if (c = L(new C(c), u, m), E = c.e, d = _e(c.c), f = d.length, j == 1 || j == 2 && (u <= E || E <= p)) {
      for (; f < u; d += "0", f++)
        ;
      d = ft(d, E);
    } else if (u -= b, d = Ye(d, E, "0"), E + 1 > f) {
      if (--u > 0)
        for (d += "."; u--; d += "0")
          ;
    } else if (u += E - f, u > 0)
      for (E + 1 == f && (d += "."); u--; d += "0")
        ;
    return c.s < 0 && F ? "-" + d : d;
  }
  function B(c, u) {
    for (var m, j, F = 1, E = new C(c[0]); F < c.length; F++)
      j = new C(c[F]), (!j.s || (m = ur(E, j)) === u || m === 0 && E.s === u) && (E = j);
    return E;
  }
  function R(c, u, m) {
    for (var j = 1, F = u.length; !u[--F]; u.pop())
      ;
    for (F = u[0]; F >= 10; F /= 10, j++)
      ;
    return (m = j + m * X - 1) > k ? c.c = c.e = null : m < w ? c.c = [c.e = 0] : (c.e = m, c.c = u), c;
  }
  s = /* @__PURE__ */ function() {
    var c = /^(-?)0([xbo])(?=\w[\w.]*$)/i, u = /^([^.]+)\.$/, m = /^\.([^.]+)$/, j = /^-?(Infinity|NaN)$/, F = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(E, b, f, d) {
      var x, v = f ? b : b.replace(F, "");
      if (j.test(v))
        E.s = isNaN(v) ? null : v < 0 ? -1 : 1;
      else {
        if (!f && (v = v.replace(c, function(A, O, T) {
          return x = (T = T.toLowerCase()) == "x" ? 16 : T == "b" ? 2 : 8, !d || d == x ? O : A;
        }), d && (x = d, v = v.replace(u, "$1").replace(m, "0.$1")), b != v))
          return new C(v, x);
        if (C.DEBUG)
          throw Error(ze + "Not a" + (d ? " base " + d : "") + " number: " + b);
        E.s = null;
      }
      E.c = E.e = null;
    };
  }();
  function L(c, u, m, j) {
    var F, E, b, f, d, x, v, A = c.c, O = us;
    if (A) {
      e: {
        for (F = 1, f = A[0]; f >= 10; f /= 10, F++)
          ;
        if (E = u - F, E < 0)
          E += X, b = u, d = A[x = 0], v = Oe(d / O[F - b - 1] % 10);
        else if (x = ps((E + 1) / X), x >= A.length)
          if (j) {
            for (; A.length <= x; A.push(0))
              ;
            d = v = 0, F = 1, E %= X, b = E - X + 1;
          } else
            break e;
        else {
          for (d = f = A[x], F = 1; f >= 10; f /= 10, F++)
            ;
          E %= X, b = E - X + F, v = b < 0 ? 0 : Oe(d / O[F - b - 1] % 10);
        }
        if (j = j || u < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        A[x + 1] != null || (b < 0 ? d : d % O[F - b - 1]), j = m < 4 ? (v || j) && (m == 0 || m == (c.s < 0 ? 3 : 2)) : v > 5 || v == 5 && (m == 4 || j || m == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (E > 0 ? b > 0 ? d / O[F - b] : 0 : A[x - 1]) % 10 & 1 || m == (c.s < 0 ? 8 : 7)), u < 1 || !A[0])
          return A.length = 0, j ? (u -= c.e + 1, A[0] = O[(X - u % X) % X], c.e = -u || 0) : A[0] = c.e = 0, c;
        if (E == 0 ? (A.length = x, f = 1, x--) : (A.length = x + 1, f = O[X - E], A[x] = b > 0 ? Oe(d / O[F - b] % O[b]) * f : 0), j)
          for (; ; )
            if (x == 0) {
              for (E = 1, b = A[0]; b >= 10; b /= 10, E++)
                ;
              for (b = A[0] += f, f = 1; b >= 10; b /= 10, f++)
                ;
              E != f && (c.e++, A[0] == Ie && (A[0] = 1));
              break;
            } else {
              if (A[x] += f, A[x] != Ie)
                break;
              A[x--] = 0, f = 1;
            }
        for (E = A.length; A[--E] === 0; A.pop())
          ;
      }
      c.e > k ? c.c = c.e = null : c.e < w && (c.c = [c.e = 0]);
    }
    return c;
  }
  function Z(c) {
    var u, m = c.e;
    return m === null ? c.toString() : (u = _e(c.c), u = m <= p || m >= g ? ft(u, m) : Ye(u, m, "0"), c.s < 0 ? "-" + u : u);
  }
  return a.absoluteValue = a.abs = function() {
    var c = new C(this);
    return c.s < 0 && (c.s = 1), c;
  }, a.comparedTo = function(c, u) {
    return ur(this, new C(c, u));
  }, a.decimalPlaces = a.dp = function(c, u) {
    var m, j, F, E = this;
    if (c != null)
      return ue(c, 0, he), u == null ? u = l : ue(u, 0, 8), L(new C(E), c + E.e + 1, u);
    if (!(m = E.c))
      return null;
    if (j = ((F = m.length - 1) - $e(this.e / X)) * X, F = m[F])
      for (; F % 10 == 0; F /= 10, j--)
        ;
    return j < 0 && (j = 0), j;
  }, a.dividedBy = a.div = function(c, u) {
    return e(this, new C(c, u), o, l);
  }, a.dividedToIntegerBy = a.idiv = function(c, u) {
    return e(this, new C(c, u), 0, 1);
  }, a.exponentiatedBy = a.pow = function(c, u) {
    var m, j, F, E, b, f, d, x, v, A = this;
    if (c = new C(c), c.c && !c.isInteger())
      throw Error(ze + "Exponent not an integer: " + Z(c));
    if (u != null && (u = new C(u)), f = c.e > 14, !A.c || !A.c[0] || A.c[0] == 1 && !A.e && A.c.length == 1 || !c.c || !c.c[0])
      return v = new C(Math.pow(+Z(A), f ? c.s * (2 - ut(c)) : +Z(c))), u ? v.mod(u) : v;
    if (d = c.s < 0, u) {
      if (u.c ? !u.c[0] : !u.s)
        return new C(NaN);
      j = !d && A.isInteger() && u.isInteger(), j && (A = A.mod(u));
    } else {
      if (c.e > 9 && (A.e > 0 || A.e < -1 || (A.e == 0 ? A.c[0] > 1 || f && A.c[1] >= 24e7 : A.c[0] < 8e13 || f && A.c[0] <= 9999975e7)))
        return E = A.s < 0 && ut(c) ? -0 : 0, A.e > -1 && (E = 1 / E), new C(d ? 1 / E : E);
      _ && (E = ps(_ / X + 2));
    }
    for (f ? (m = new C(0.5), d && (c.s = 1), x = ut(c)) : (F = Math.abs(+Z(c)), x = F % 2), v = new C(i); ; ) {
      if (x) {
        if (v = v.times(A), !v.c)
          break;
        E ? v.c.length > E && (v.c.length = E) : j && (v = v.mod(u));
      }
      if (F) {
        if (F = Oe(F / 2), F === 0)
          break;
        x = F % 2;
      } else if (c = c.times(m), L(c, c.e + 1, 1), c.e > 14)
        x = ut(c);
      else {
        if (F = +Z(c), F === 0)
          break;
        x = F % 2;
      }
      A = A.times(A), E ? A.c && A.c.length > E && (A.c.length = E) : j && (A = A.mod(u));
    }
    return j ? v : (d && (v = i.div(v)), u ? v.mod(u) : E ? L(v, _, l, b) : v);
  }, a.integerValue = function(c) {
    var u = new C(this);
    return c == null ? c = l : ue(c, 0, 8), L(u, u.e + 1, c);
  }, a.isEqualTo = a.eq = function(c, u) {
    return ur(this, new C(c, u)) === 0;
  }, a.isFinite = function() {
    return !!this.c;
  }, a.isGreaterThan = a.gt = function(c, u) {
    return ur(this, new C(c, u)) > 0;
  }, a.isGreaterThanOrEqualTo = a.gte = function(c, u) {
    return (u = ur(this, new C(c, u))) === 1 || u === 0;
  }, a.isInteger = function() {
    return !!this.c && $e(this.e / X) > this.c.length - 2;
  }, a.isLessThan = a.lt = function(c, u) {
    return ur(this, new C(c, u)) < 0;
  }, a.isLessThanOrEqualTo = a.lte = function(c, u) {
    return (u = ur(this, new C(c, u))) === -1 || u === 0;
  }, a.isNaN = function() {
    return !this.s;
  }, a.isNegative = function() {
    return this.s < 0;
  }, a.isPositive = function() {
    return this.s > 0;
  }, a.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, a.minus = function(c, u) {
    var m, j, F, E, b = this, f = b.s;
    if (c = new C(c, u), u = c.s, !f || !u)
      return new C(NaN);
    if (f != u)
      return c.s = -u, b.plus(c);
    var d = b.e / X, x = c.e / X, v = b.c, A = c.c;
    if (!d || !x) {
      if (!v || !A)
        return v ? (c.s = -u, c) : new C(A ? b : NaN);
      if (!v[0] || !A[0])
        return A[0] ? (c.s = -u, c) : new C(v[0] ? b : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          l == 3 ? -0 : 0
        ));
    }
    if (d = $e(d), x = $e(x), v = v.slice(), f = d - x) {
      for ((E = f < 0) ? (f = -f, F = v) : (x = d, F = A), F.reverse(), u = f; u--; F.push(0))
        ;
      F.reverse();
    } else
      for (j = (E = (f = v.length) < (u = A.length)) ? f : u, f = u = 0; u < j; u++)
        if (v[u] != A[u]) {
          E = v[u] < A[u];
          break;
        }
    if (E && (F = v, v = A, A = F, c.s = -c.s), u = (j = A.length) - (m = v.length), u > 0)
      for (; u--; v[m++] = 0)
        ;
    for (u = Ie - 1; j > f; ) {
      if (v[--j] < A[j]) {
        for (m = j; m && !v[--m]; v[m] = u)
          ;
        --v[m], v[j] += Ie;
      }
      v[j] -= A[j];
    }
    for (; v[0] == 0; v.splice(0, 1), --x)
      ;
    return v[0] ? R(c, v, x) : (c.s = l == 3 ? -1 : 1, c.c = [c.e = 0], c);
  }, a.modulo = a.mod = function(c, u) {
    var m, j, F = this;
    return c = new C(c, u), !F.c || !c.s || c.c && !c.c[0] ? new C(NaN) : !c.c || F.c && !F.c[0] ? new C(F) : (S == 9 ? (j = c.s, c.s = 1, m = e(F, c, 0, 3), c.s = j, m.s *= j) : m = e(F, c, 0, S), c = F.minus(m.times(c)), !c.c[0] && S == 1 && (c.s = F.s), c);
  }, a.multipliedBy = a.times = function(c, u) {
    var m, j, F, E, b, f, d, x, v, A, O, T, K, V, te, W = this, J = W.c, se = (c = new C(c, u)).c;
    if (!J || !se || !J[0] || !se[0])
      return !W.s || !c.s || J && !J[0] && !se || se && !se[0] && !J ? c.c = c.e = c.s = null : (c.s *= W.s, !J || !se ? c.c = c.e = null : (c.c = [0], c.e = 0)), c;
    for (j = $e(W.e / X) + $e(c.e / X), c.s *= W.s, d = J.length, A = se.length, d < A && (K = J, J = se, se = K, F = d, d = A, A = F), F = d + A, K = []; F--; K.push(0))
      ;
    for (V = Ie, te = er, F = A; --F >= 0; ) {
      for (m = 0, O = se[F] % te, T = se[F] / te | 0, b = d, E = F + b; E > F; )
        x = J[--b] % te, v = J[b] / te | 0, f = T * x + v * O, x = O * x + f % te * te + K[E] + m, m = (x / V | 0) + (f / te | 0) + T * v, K[E--] = x % V;
      K[E] = m;
    }
    return m ? ++j : K.splice(0, 1), R(c, K, j);
  }, a.negated = function() {
    var c = new C(this);
    return c.s = -c.s || null, c;
  }, a.plus = function(c, u) {
    var m, j = this, F = j.s;
    if (c = new C(c, u), u = c.s, !F || !u)
      return new C(NaN);
    if (F != u)
      return c.s = -u, j.minus(c);
    var E = j.e / X, b = c.e / X, f = j.c, d = c.c;
    if (!E || !b) {
      if (!f || !d)
        return new C(F / 0);
      if (!f[0] || !d[0])
        return d[0] ? c : new C(f[0] ? j : F * 0);
    }
    if (E = $e(E), b = $e(b), f = f.slice(), F = E - b) {
      for (F > 0 ? (b = E, m = d) : (F = -F, m = f), m.reverse(); F--; m.push(0))
        ;
      m.reverse();
    }
    for (F = f.length, u = d.length, F - u < 0 && (m = d, d = f, f = m, u = F), F = 0; u; )
      F = (f[--u] = f[u] + d[u] + F) / Ie | 0, f[u] = Ie === f[u] ? 0 : f[u] % Ie;
    return F && (f = [F].concat(f), ++b), R(c, f, b);
  }, a.precision = a.sd = function(c, u) {
    var m, j, F, E = this;
    if (c != null && c !== !!c)
      return ue(c, 1, he), u == null ? u = l : ue(u, 0, 8), L(new C(E), c, u);
    if (!(m = E.c))
      return null;
    if (F = m.length - 1, j = F * X + 1, F = m[F]) {
      for (; F % 10 == 0; F /= 10, j--)
        ;
      for (F = m[0]; F >= 10; F /= 10, j++)
        ;
    }
    return c && E.e + 1 > j && (j = E.e + 1), j;
  }, a.shiftedBy = function(c) {
    return ue(c, -cs, cs), this.times("1e" + c);
  }, a.squareRoot = a.sqrt = function() {
    var c, u, m, j, F, E = this, b = E.c, f = E.s, d = E.e, x = o + 4, v = new C("0.5");
    if (f !== 1 || !b || !b[0])
      return new C(!f || f < 0 && (!b || b[0]) ? NaN : b ? E : 1 / 0);
    if (f = Math.sqrt(+Z(E)), f == 0 || f == 1 / 0 ? (u = _e(b), (u.length + d) % 2 == 0 && (u += "0"), f = Math.sqrt(+u), d = $e((d + 1) / 2) - (d < 0 || d % 2), f == 1 / 0 ? u = "5e" + d : (u = f.toExponential(), u = u.slice(0, u.indexOf("e") + 1) + d), m = new C(u)) : m = new C(f + ""), m.c[0]) {
      for (d = m.e, f = d + x, f < 3 && (f = 0); ; )
        if (F = m, m = v.times(F.plus(e(E, F, x, 1))), _e(F.c).slice(0, f) === (u = _e(m.c)).slice(0, f))
          if (m.e < d && --f, u = u.slice(f - 3, f + 1), u == "9999" || !j && u == "4999") {
            if (!j && (L(F, F.e + o + 2, 0), F.times(F).eq(E))) {
              m = F;
              break;
            }
            x += 4, f += 4, j = 1;
          } else {
            (!+u || !+u.slice(1) && u.charAt(0) == "5") && (L(m, m.e + o + 2, 1), c = !m.times(m).eq(E));
            break;
          }
    }
    return L(m, m.e + o + 1, l, c);
  }, a.toExponential = function(c, u) {
    return c != null && (ue(c, 0, he), c++), re(this, c, u, 1);
  }, a.toFixed = function(c, u) {
    return c != null && (ue(c, 0, he), c = c + this.e + 1), re(this, c, u);
  }, a.toFormat = function(c, u, m) {
    var j, F = this;
    if (m == null)
      c != null && u && typeof u == "object" ? (m = u, u = null) : c && typeof c == "object" ? (m = c, c = u = null) : m = G;
    else if (typeof m != "object")
      throw Error(ze + "Argument not an object: " + m);
    if (j = F.toFixed(c, u), F.c) {
      var E, b = j.split("."), f = +m.groupSize, d = +m.secondaryGroupSize, x = m.groupSeparator || "", v = b[0], A = b[1], O = F.s < 0, T = O ? v.slice(1) : v, K = T.length;
      if (d && (E = f, f = d, d = E, K -= E), f > 0 && K > 0) {
        for (E = K % f || f, v = T.substr(0, E); E < K; E += f)
          v += x + T.substr(E, f);
        d > 0 && (v += x + T.slice(E)), O && (v = "-" + v);
      }
      j = A ? v + (m.decimalSeparator || "") + ((d = +m.fractionGroupSize) ? A.replace(
        new RegExp("\\d{" + d + "}\\B", "g"),
        "$&" + (m.fractionGroupSeparator || "")
      ) : A) : v;
    }
    return (m.prefix || "") + j + (m.suffix || "");
  }, a.toFraction = function(c) {
    var u, m, j, F, E, b, f, d, x, v, A, O, T = this, K = T.c;
    if (c != null && (f = new C(c), !f.isInteger() && (f.c || f.s !== 1) || f.lt(i)))
      throw Error(ze + "Argument " + (f.isInteger() ? "out of range: " : "not an integer: ") + Z(f));
    if (!K)
      return new C(T);
    for (u = new C(i), x = m = new C(i), j = d = new C(i), O = _e(K), E = u.e = O.length - T.e - 1, u.c[0] = us[(b = E % X) < 0 ? X + b : b], c = !c || f.comparedTo(u) > 0 ? E > 0 ? u : x : f, b = k, k = 1 / 0, f = new C(O), d.c[0] = 0; v = e(f, u, 0, 1), F = m.plus(v.times(j)), F.comparedTo(c) != 1; )
      m = j, j = F, x = d.plus(v.times(F = x)), d = F, u = f.minus(v.times(F = u)), f = F;
    return F = e(c.minus(m), j, 0, 1), d = d.plus(F.times(x)), m = m.plus(F.times(j)), d.s = x.s = T.s, E = E * 2, A = e(x, j, E, l).minus(T).abs().comparedTo(
      e(d, m, E, l).minus(T).abs()
    ) < 1 ? [x, j] : [d, m], k = b, A;
  }, a.toNumber = function() {
    return +Z(this);
  }, a.toPrecision = function(c, u) {
    return c != null && ue(c, 1, he), re(this, c, u, 2);
  }, a.toString = function(c) {
    var u, m = this, j = m.s, F = m.e;
    return F === null ? j ? (u = "Infinity", j < 0 && (u = "-" + u)) : u = "NaN" : (c == null ? u = F <= p || F >= g ? ft(_e(m.c), F) : Ye(_e(m.c), F, "0") : c === 10 && N ? (m = L(new C(m), o + F + 1, l), u = Ye(_e(m.c), m.e, "0")) : (ue(c, 2, I.length, "Base"), u = t(Ye(_e(m.c), F, "0"), 10, c, j, !0)), j < 0 && m.c[0] && (u = "-" + u)), u;
  }, a.valueOf = a.toJSON = function() {
    return Z(this);
  }, a._isBigNumber = !0, a[Symbol.toStringTag] = "BigNumber", a[Symbol.for("nodejs.util.inspect.custom")] = a.valueOf, r != null && C.set(r), C;
}
function $e(r) {
  var e = r | 0;
  return r > 0 || r === e ? e : e - 1;
}
function _e(r) {
  for (var e, t, s = 1, a = r.length, i = r[0] + ""; s < a; ) {
    for (e = r[s++] + "", t = X - e.length; t--; e = "0" + e)
      ;
    i += e;
  }
  for (a = i.length; i.charCodeAt(--a) === 48; )
    ;
  return i.slice(0, a + 1 || 1);
}
function ur(r, e) {
  var t, s, a = r.c, i = e.c, o = r.s, l = e.s, p = r.e, g = e.e;
  if (!o || !l)
    return null;
  if (t = a && !a[0], s = i && !i[0], t || s)
    return t ? s ? 0 : -l : o;
  if (o != l)
    return o;
  if (t = o < 0, s = p == g, !a || !i)
    return s ? 0 : !a ^ t ? 1 : -1;
  if (!s)
    return p > g ^ t ? 1 : -1;
  for (l = (p = a.length) < (g = i.length) ? p : g, o = 0; o < l; o++)
    if (a[o] != i[o])
      return a[o] > i[o] ^ t ? 1 : -1;
  return p == g ? 0 : p > g ^ t ? 1 : -1;
}
function ue(r, e, t, s) {
  if (r < e || r > t || r !== Oe(r))
    throw Error(ze + (s || "Argument") + (typeof r == "number" ? r < e || r > t ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(r));
}
function ut(r) {
  var e = r.c.length - 1;
  return $e(r.e / X) == e && r.c[e] % 2 != 0;
}
function ft(r, e) {
  return (r.length > 1 ? r.charAt(0) + "." + r.slice(1) : r) + (e < 0 ? "e" : "e+") + e;
}
function Ye(r, e, t) {
  var s, a;
  if (e < 0) {
    for (a = t + "."; ++e; a += t)
      ;
    r = a + r;
  } else if (s = r.length, ++e > s) {
    for (a = t, e -= s; --e; a += t)
      ;
    r += a;
  } else
    e < s && (r = r.slice(0, e) + "." + r.slice(e));
  return r;
}
var fe = fo(), xt;
(function(r) {
  r[r.up = fe.ROUND_UP] = "up", r[r.down = fe.ROUND_DOWN] = "down", r[r.truncate = fe.ROUND_DOWN] = "truncate", r[r.halfUp = fe.ROUND_HALF_UP] = "halfUp", r[r.default = fe.ROUND_HALF_UP] = "default", r[r.halfDown = fe.ROUND_HALF_DOWN] = "halfDown", r[r.halfEven = fe.ROUND_HALF_EVEN] = "halfEven", r[r.banker = fe.ROUND_HALF_EVEN] = "banker", r[r.ceiling = fe.ROUND_CEIL] = "ceiling", r[r.ceil = fe.ROUND_CEIL] = "ceil", r[r.floor = fe.ROUND_FLOOR] = "floor";
})(xt || (xt = {}));
function ko(r) {
  var e;
  return (e = xt[r]) !== null && e !== void 0 ? e : xt.default;
}
var Gf = 9007199254740991, Hf = Math.floor;
function qf(r, e) {
  var t = "";
  if (!r || e < 1 || e > Gf)
    return t;
  do
    e % 2 && (t += r), e = Hf(e / 2), e && (r += r);
  while (e);
  return t;
}
var Kf = qf, Yf = Oi, Wf = Ys;
function Vf(r) {
  return r != null && Wf(r.length) && !Yf(r);
}
var Tt = Vf, Zf = _t, Jf = Tt, Qf = Bt, Xf = gr;
function ek(r, e, t) {
  if (!Xf(t))
    return !1;
  var s = typeof e;
  return (s == "number" ? Jf(t) && Qf(e, t.length) : s == "string" && e in t) ? Zf(t[e], r) : !1;
}
var Vs = ek, rk = /\s/;
function tk(r) {
  for (var e = r.length; e-- && rk.test(r.charAt(e)); )
    ;
  return e;
}
var sk = tk, ak = sk, ik = /^\s+/;
function ok(r) {
  return r && r.slice(0, ak(r) + 1).replace(ik, "");
}
var nk = ok, lk = nk, Aa = gr, pk = st, Da = NaN, ck = /^[-+]0x[0-9a-f]+$/i, uk = /^0b[01]+$/i, fk = /^0o[0-7]+$/i, kk = parseInt;
function dk(r) {
  if (typeof r == "number")
    return r;
  if (pk(r))
    return Da;
  if (Aa(r)) {
    var e = typeof r.valueOf == "function" ? r.valueOf() : r;
    r = Aa(e) ? e + "" : e;
  }
  if (typeof r != "string")
    return r === 0 ? r : +r;
  r = lk(r);
  var t = uk.test(r);
  return t || fk.test(r) ? kk(r.slice(2), t ? 2 : 8) : ck.test(r) ? Da : +r;
}
var mk = dk, gk = mk, _a = 1 / 0, vk = 17976931348623157e292;
function hk(r) {
  if (!r)
    return r === 0 ? r : 0;
  if (r = gk(r), r === _a || r === -_a) {
    var e = r < 0 ? -1 : 1;
    return e * vk;
  }
  return r === r ? r : 0;
}
var mo = hk, xk = mo;
function bk(r) {
  var e = xk(r), t = e % 1;
  return e === e ? t ? e - t : e : 0;
}
var yk = bk, wk = Kf, zk = Vs, Fk = yk, Ek = Dr;
function jk(r, e, t) {
  return (t ? zk(r, e, t) : e === void 0) ? e = 1 : e = Fk(e), wk(Ek(r), e);
}
var Ck = jk;
const Sk = /* @__PURE__ */ Be(Ck);
function Ak(r) {
  return r.isZero() ? 1 : Math.floor(Math.log10(r.abs().toNumber()) + 1);
}
function Dk(r, { precision: e, significant: t }) {
  return t && e !== null && e > 0 ? e - Ak(r) : e;
}
function bt(r, e) {
  const t = Dk(r, e);
  if (t === null)
    return r.toString();
  const s = ko(e.roundMode);
  if (t >= 0)
    return r.toFixed(t, s);
  const a = Math.pow(10, Math.abs(t));
  return r = new fe(r.div(a).toFixed(0, s)).times(a), r.toString();
}
function _k(r, { formattedNumber: e, unit: t }) {
  return r.replace("%n", e).replace("%u", t);
}
function Ok({ significand: r, whole: e, precision: t }) {
  if (e === "0" || t === null)
    return r;
  const s = Math.max(0, t - e.length);
  return (r ?? "").substr(0, s);
}
function Jr(r, e) {
  var t, s, a;
  const i = new fe(r);
  if (e.raise && !i.isFinite())
    throw new Error(`"${r}" is not a valid numeric value`);
  const o = bt(i, e), l = new fe(o), p = l.lt(0), g = l.isZero();
  let [w, k] = o.split(".");
  const h = [];
  let S;
  const _ = (t = e.format) !== null && t !== void 0 ? t : "%n", G = (s = e.negativeFormat) !== null && s !== void 0 ? s : `-${_}`, I = p && !g ? G : _;
  for (w = w.replace("-", ""); w.length > 0; )
    h.unshift(w.substr(Math.max(0, w.length - 3), 3)), w = w.substr(0, w.length - 3);
  return w = h.join(""), S = h.join(e.delimiter), e.significant ? k = Ok({
    whole: w,
    significand: k,
    precision: e.precision
  }) : k = k ?? Sk("0", (a = e.precision) !== null && a !== void 0 ? a : 0), e.stripInsignificantZeros && k && (k = k.replace(/0+$/, "")), i.isNaN() && (S = r.toString()), k && i.isFinite() && (S += (e.separator || ".") + k), _k(I, {
    formattedNumber: S,
    unit: e.unit
  });
}
function Er(r, e, t) {
  let s = "";
  return (e instanceof String || typeof e == "string") && (s = e), e instanceof Array && (s = e.join(r.defaultSeparator)), t.scope && (s = [t.scope, s].join(r.defaultSeparator)), s;
}
function kr(r) {
  var e, t;
  if (r === null)
    return "null";
  const s = typeof r;
  return s !== "object" ? s : ((t = (e = r == null ? void 0 : r.constructor) === null || e === void 0 ? void 0 : e.name) === null || t === void 0 ? void 0 : t.toLowerCase()) || "object";
}
function fs(r, e, t) {
  t = Object.keys(t).reduce((a, i) => (a[r.transformKey(i)] = t[i], a), {});
  const s = e.match(r.placeholder);
  if (!s)
    return e;
  for (; s.length; ) {
    let a;
    const i = s.shift(), o = i.replace(r.placeholder, "$1");
    Ze(t[o]) ? a = t[o].toString().replace(/\$/gm, "_#$#_") : o in t ? a = r.nullPlaceholder(r, i, e, t) : a = r.missingPlaceholder(r, i, e, t);
    const l = new RegExp(i.replace(/\{/gm, "\\{").replace(/\}/gm, "\\}"));
    e = e.replace(l, a);
  }
  return e.replace(/_#\$#_/g, "$");
}
function Ue(r, e, t = {}) {
  t = Object.assign({}, t);
  const s = "locale" in t ? t.locale : r.locale, a = kr(s), i = r.locales.get(a === "string" ? s : typeof s).slice();
  e = Er(r, e, t).split(r.defaultSeparator).map((l) => r.transformKey(l)).join(".");
  const o = i.map((l) => zs(r.translations, [l, e].join(".")));
  return o.push(t.defaultValue), o.find((l) => Ze(l));
}
function $k(r, e) {
  const t = new fe(r);
  if (!t.isFinite())
    return r.toString();
  if (!e.delimiterPattern.global)
    throw new Error(`options.delimiterPattern must be a global regular expression; received ${e.delimiterPattern}`);
  let [s, a] = t.toString().split(".");
  return s = s.replace(e.delimiterPattern, (i) => `${i}${e.delimiter}`), [s, a].filter(Boolean).join(e.separator);
}
function Mk(r, e) {
  for (var t = -1, s = e.length, a = r.length; ++t < s; )
    r[a + t] = e[t];
  return r;
}
var go = Mk, Oa = et, Bk = Ks, Tk = He, $a = Oa ? Oa.isConcatSpreadable : void 0;
function Ik(r) {
  return Tk(r) || Bk(r) || !!($a && r && r[$a]);
}
var Rk = Ik, Lk = go, Nk = Rk;
function vo(r, e, t, s, a) {
  var i = -1, o = r.length;
  for (t || (t = Nk), a || (a = []); ++i < o; ) {
    var l = r[i];
    e > 0 && t(l) ? e > 1 ? vo(l, e - 1, t, s, a) : Lk(a, l) : s || (a[a.length] = l);
  }
  return a;
}
var ho = vo, Pk = $t;
function Uk() {
  this.__data__ = new Pk(), this.size = 0;
}
var Gk = Uk;
function Hk(r) {
  var e = this.__data__, t = e.delete(r);
  return this.size = e.size, t;
}
var qk = Hk;
function Kk(r) {
  return this.__data__.get(r);
}
var Yk = Kk;
function Wk(r) {
  return this.__data__.has(r);
}
var Vk = Wk, Zk = $t, Jk = Ps, Qk = Us, Xk = 200;
function ed(r, e) {
  var t = this.__data__;
  if (t instanceof Zk) {
    var s = t.__data__;
    if (!Jk || s.length < Xk - 1)
      return s.push([r, e]), this.size = ++t.size, this;
    t = this.__data__ = new Qk(s);
  }
  return t.set(r, e), this.size = t.size, this;
}
var rd = ed, td = $t, sd = Gk, ad = qk, id = Yk, od = Vk, nd = rd;
function _r(r) {
  var e = this.__data__ = new td(r);
  this.size = e.size;
}
_r.prototype.clear = sd;
_r.prototype.delete = ad;
_r.prototype.get = id;
_r.prototype.has = od;
_r.prototype.set = nd;
var xo = _r;
function ld(r, e) {
  for (var t = -1, s = r == null ? 0 : r.length; ++t < s; )
    if (e(r[t], t, r))
      return !0;
  return !1;
}
var pd = ld, cd = Gi, ud = pd, fd = Hi, kd = 1, dd = 2;
function md(r, e, t, s, a, i) {
  var o = t & kd, l = r.length, p = e.length;
  if (l != p && !(o && p > l))
    return !1;
  var g = i.get(r), w = i.get(e);
  if (g && w)
    return g == e && w == r;
  var k = -1, h = !0, S = t & dd ? new cd() : void 0;
  for (i.set(r, e), i.set(e, r); ++k < l; ) {
    var _ = r[k], G = e[k];
    if (s)
      var I = o ? s(G, _, k, e, r, i) : s(_, G, k, r, e, i);
    if (I !== void 0) {
      if (I)
        continue;
      h = !1;
      break;
    }
    if (S) {
      if (!ud(e, function(N, C) {
        if (!fd(S, C) && (_ === N || a(_, N, t, s, i)))
          return S.push(C);
      })) {
        h = !1;
        break;
      }
    } else if (!(_ === G || a(_, G, t, s, i))) {
      h = !1;
      break;
    }
  }
  return i.delete(r), i.delete(e), h;
}
var bo = md, gd = Qe, vd = gd.Uint8Array, hd = vd;
function xd(r) {
  var e = -1, t = Array(r.size);
  return r.forEach(function(s, a) {
    t[++e] = [a, s];
  }), t;
}
var bd = xd, Ma = et, Ba = hd, yd = _t, wd = bo, zd = bd, Fd = Ws, Ed = 1, jd = 2, Cd = "[object Boolean]", Sd = "[object Date]", Ad = "[object Error]", Dd = "[object Map]", _d = "[object Number]", Od = "[object RegExp]", $d = "[object Set]", Md = "[object String]", Bd = "[object Symbol]", Td = "[object ArrayBuffer]", Id = "[object DataView]", Ta = Ma ? Ma.prototype : void 0, ks = Ta ? Ta.valueOf : void 0;
function Rd(r, e, t, s, a, i, o) {
  switch (t) {
    case Id:
      if (r.byteLength != e.byteLength || r.byteOffset != e.byteOffset)
        return !1;
      r = r.buffer, e = e.buffer;
    case Td:
      return !(r.byteLength != e.byteLength || !i(new Ba(r), new Ba(e)));
    case Cd:
    case Sd:
    case _d:
      return yd(+r, +e);
    case Ad:
      return r.name == e.name && r.message == e.message;
    case Od:
    case Md:
      return r == e + "";
    case Dd:
      var l = zd;
    case $d:
      var p = s & Ed;
      if (l || (l = Fd), r.size != e.size && !p)
        return !1;
      var g = o.get(r);
      if (g)
        return g == e;
      s |= jd, o.set(r, e);
      var w = wd(l(r), l(e), s, a, i, o);
      return o.delete(r), w;
    case Bd:
      if (ks)
        return ks.call(r) == ks.call(e);
  }
  return !1;
}
var Ld = Rd, Nd = go, Pd = He;
function Ud(r, e, t) {
  var s = e(r);
  return Pd(r) ? s : Nd(s, t(r));
}
var Gd = Ud;
function Hd(r, e) {
  for (var t = -1, s = r == null ? 0 : r.length, a = 0, i = []; ++t < s; ) {
    var o = r[t];
    e(o, t, r) && (i[a++] = o);
  }
  return i;
}
var qd = Hd;
function Kd() {
  return [];
}
var Yd = Kd, Wd = qd, Vd = Yd, Zd = Object.prototype, Jd = Zd.propertyIsEnumerable, Ia = Object.getOwnPropertySymbols, Qd = Ia ? function(r) {
  return r == null ? [] : (r = Object(r), Wd(Ia(r), function(e) {
    return Jd.call(r, e);
  }));
} : Vd, Xd = Qd;
function em(r, e) {
  for (var t = -1, s = Array(r); ++t < r; )
    s[t] = e(t);
  return s;
}
var rm = em, yt = { exports: {} };
function tm() {
  return !1;
}
var sm = tm;
yt.exports;
(function(r, e) {
  var t = Qe, s = sm, a = e && !e.nodeType && e, i = a && !0 && r && !r.nodeType && r, o = i && i.exports === a, l = o ? t.Buffer : void 0, p = l ? l.isBuffer : void 0, g = p || s;
  r.exports = g;
})(yt, yt.exports);
var yo = yt.exports, am = rt, im = Ys, om = tt, nm = "[object Arguments]", lm = "[object Array]", pm = "[object Boolean]", cm = "[object Date]", um = "[object Error]", fm = "[object Function]", km = "[object Map]", dm = "[object Number]", mm = "[object Object]", gm = "[object RegExp]", vm = "[object Set]", hm = "[object String]", xm = "[object WeakMap]", bm = "[object ArrayBuffer]", ym = "[object DataView]", wm = "[object Float32Array]", zm = "[object Float64Array]", Fm = "[object Int8Array]", Em = "[object Int16Array]", jm = "[object Int32Array]", Cm = "[object Uint8Array]", Sm = "[object Uint8ClampedArray]", Am = "[object Uint16Array]", Dm = "[object Uint32Array]", pe = {};
pe[wm] = pe[zm] = pe[Fm] = pe[Em] = pe[jm] = pe[Cm] = pe[Sm] = pe[Am] = pe[Dm] = !0;
pe[nm] = pe[lm] = pe[bm] = pe[pm] = pe[ym] = pe[cm] = pe[um] = pe[fm] = pe[km] = pe[dm] = pe[mm] = pe[gm] = pe[vm] = pe[hm] = pe[xm] = !1;
function _m(r) {
  return om(r) && im(r.length) && !!pe[am(r)];
}
var Om = _m;
function $m(r) {
  return function(e) {
    return r(e);
  };
}
var wo = $m, wt = { exports: {} };
wt.exports;
(function(r, e) {
  var t = Di, s = e && !e.nodeType && e, a = s && !0 && r && !r.nodeType && r, i = a && a.exports === s, o = i && t.process, l = function() {
    try {
      var p = a && a.require && a.require("util").types;
      return p || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  r.exports = l;
})(wt, wt.exports);
var Mm = wt.exports, Bm = Om, Tm = wo, Ra = Mm, La = Ra && Ra.isTypedArray, Im = La ? Tm(La) : Bm, zo = Im, Rm = rm, Lm = Ks, Nm = He, Pm = yo, Um = Bt, Gm = zo, Hm = Object.prototype, qm = Hm.hasOwnProperty;
function Km(r, e) {
  var t = Nm(r), s = !t && Lm(r), a = !t && !s && Pm(r), i = !t && !s && !a && Gm(r), o = t || s || a || i, l = o ? Rm(r.length, String) : [], p = l.length;
  for (var g in r)
    (e || qm.call(r, g)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
    Um(g, p))) && l.push(g);
  return l;
}
var Ym = Km, Wm = Object.prototype;
function Vm(r) {
  var e = r && r.constructor, t = typeof e == "function" && e.prototype || Wm;
  return r === t;
}
var Zm = Vm;
function Jm(r, e) {
  return function(t) {
    return r(e(t));
  };
}
var Qm = Jm, Xm = Qm, eg = Xm(Object.keys, Object), rg = eg, tg = Zm, sg = rg, ag = Object.prototype, ig = ag.hasOwnProperty;
function og(r) {
  if (!tg(r))
    return sg(r);
  var e = [];
  for (var t in Object(r))
    ig.call(r, t) && t != "constructor" && e.push(t);
  return e;
}
var ng = og, lg = Ym, pg = ng, cg = Tt;
function ug(r) {
  return cg(r) ? lg(r) : pg(r);
}
var Zs = ug, fg = Gd, kg = Xd, dg = Zs;
function mg(r) {
  return fg(r, dg, kg);
}
var gg = mg, Na = gg, vg = 1, hg = Object.prototype, xg = hg.hasOwnProperty;
function bg(r, e, t, s, a, i) {
  var o = t & vg, l = Na(r), p = l.length, g = Na(e), w = g.length;
  if (p != w && !o)
    return !1;
  for (var k = p; k--; ) {
    var h = l[k];
    if (!(o ? h in e : xg.call(e, h)))
      return !1;
  }
  var S = i.get(r), _ = i.get(e);
  if (S && _)
    return S == e && _ == r;
  var G = !0;
  i.set(r, e), i.set(e, r);
  for (var I = o; ++k < p; ) {
    h = l[k];
    var N = r[h], C = e[h];
    if (s)
      var re = o ? s(C, N, h, e, r, i) : s(N, C, h, r, e, i);
    if (!(re === void 0 ? N === C || a(N, C, t, s, i) : re)) {
      G = !1;
      break;
    }
    I || (I = h == "constructor");
  }
  if (G && !I) {
    var B = r.constructor, R = e.constructor;
    B != R && "constructor" in r && "constructor" in e && !(typeof B == "function" && B instanceof B && typeof R == "function" && R instanceof R) && (G = !1);
  }
  return i.delete(r), i.delete(e), G;
}
var yg = bg, wg = vr, zg = Qe, Fg = wg(zg, "DataView"), Eg = Fg, jg = vr, Cg = Qe, Sg = jg(Cg, "Promise"), Ag = Sg, Dg = vr, _g = Qe, Og = Dg(_g, "WeakMap"), $g = Og, js = Eg, Cs = Ps, Ss = Ag, As = qi, Ds = $g, Fo = rt, Or = $i, Pa = "[object Map]", Mg = "[object Object]", Ua = "[object Promise]", Ga = "[object Set]", Ha = "[object WeakMap]", qa = "[object DataView]", Bg = Or(js), Tg = Or(Cs), Ig = Or(Ss), Rg = Or(As), Lg = Or(Ds), fr = Fo;
(js && fr(new js(new ArrayBuffer(1))) != qa || Cs && fr(new Cs()) != Pa || Ss && fr(Ss.resolve()) != Ua || As && fr(new As()) != Ga || Ds && fr(new Ds()) != Ha) && (fr = function(r) {
  var e = Fo(r), t = e == Mg ? r.constructor : void 0, s = t ? Or(t) : "";
  if (s)
    switch (s) {
      case Bg:
        return qa;
      case Tg:
        return Pa;
      case Ig:
        return Ua;
      case Rg:
        return Ga;
      case Lg:
        return Ha;
    }
  return e;
});
var Ng = fr, ds = xo, Pg = bo, Ug = Ld, Gg = yg, Ka = Ng, Ya = He, Wa = yo, Hg = zo, qg = 1, Va = "[object Arguments]", Za = "[object Array]", kt = "[object Object]", Kg = Object.prototype, Ja = Kg.hasOwnProperty;
function Yg(r, e, t, s, a, i) {
  var o = Ya(r), l = Ya(e), p = o ? Za : Ka(r), g = l ? Za : Ka(e);
  p = p == Va ? kt : p, g = g == Va ? kt : g;
  var w = p == kt, k = g == kt, h = p == g;
  if (h && Wa(r)) {
    if (!Wa(e))
      return !1;
    o = !0, w = !1;
  }
  if (h && !w)
    return i || (i = new ds()), o || Hg(r) ? Pg(r, e, t, s, a, i) : Ug(r, e, p, t, s, a, i);
  if (!(t & qg)) {
    var S = w && Ja.call(r, "__wrapped__"), _ = k && Ja.call(e, "__wrapped__");
    if (S || _) {
      var G = S ? r.value() : r, I = _ ? e.value() : e;
      return i || (i = new ds()), a(G, I, t, s, i);
    }
  }
  return h ? (i || (i = new ds()), Gg(r, e, t, s, a, i)) : !1;
}
var Wg = Yg, Vg = Wg, Qa = tt;
function Eo(r, e, t, s, a) {
  return r === e ? !0 : r == null || e == null || !Qa(r) && !Qa(e) ? r !== r && e !== e : Vg(r, e, t, s, Eo, a);
}
var jo = Eo, Zg = xo, Jg = jo, Qg = 1, Xg = 2;
function e2(r, e, t, s) {
  var a = t.length, i = a, o = !s;
  if (r == null)
    return !i;
  for (r = Object(r); a--; ) {
    var l = t[a];
    if (o && l[2] ? l[1] !== r[l[0]] : !(l[0] in r))
      return !1;
  }
  for (; ++a < i; ) {
    l = t[a];
    var p = l[0], g = r[p], w = l[1];
    if (o && l[2]) {
      if (g === void 0 && !(p in r))
        return !1;
    } else {
      var k = new Zg();
      if (s)
        var h = s(g, w, p, r, e, k);
      if (!(h === void 0 ? Jg(w, g, Qg | Xg, s, k) : h))
        return !1;
    }
  }
  return !0;
}
var r2 = e2, t2 = gr;
function s2(r) {
  return r === r && !t2(r);
}
var Co = s2, a2 = Co, i2 = Zs;
function o2(r) {
  for (var e = i2(r), t = e.length; t--; ) {
    var s = e[t], a = r[s];
    e[t] = [s, a, a2(a)];
  }
  return e;
}
var n2 = o2;
function l2(r, e) {
  return function(t) {
    return t == null ? !1 : t[r] === e && (e !== void 0 || r in Object(t));
  };
}
var So = l2, p2 = r2, c2 = n2, u2 = So;
function f2(r) {
  var e = c2(r);
  return e.length == 1 && e[0][2] ? u2(e[0][0], e[0][1]) : function(t) {
    return t === r || p2(t, r, e);
  };
}
var k2 = f2;
function d2(r, e) {
  return r != null && e in Object(r);
}
var m2 = d2, g2 = m2, v2 = Li;
function h2(r, e) {
  return r != null && v2(r, e, g2);
}
var x2 = h2, b2 = jo, y2 = Ii, w2 = x2, z2 = Ns, F2 = Co, E2 = So, j2 = at, C2 = 1, S2 = 2;
function A2(r, e) {
  return z2(r) && F2(e) ? E2(j2(r), e) : function(t) {
    var s = y2(t, r);
    return s === void 0 && s === e ? w2(t, r) : b2(e, s, C2 | S2);
  };
}
var D2 = A2;
function _2(r) {
  return r;
}
var It = _2;
function O2(r) {
  return function(e) {
    return e == null ? void 0 : e[r];
  };
}
var $2 = O2, M2 = qs;
function B2(r) {
  return function(e) {
    return M2(e, r);
  };
}
var T2 = B2, I2 = $2, R2 = T2, L2 = Ns, N2 = at;
function P2(r) {
  return L2(r) ? I2(N2(r)) : R2(r);
}
var U2 = P2, G2 = k2, H2 = D2, q2 = It, K2 = He, Y2 = U2;
function W2(r) {
  return typeof r == "function" ? r : r == null ? q2 : typeof r == "object" ? K2(r) ? H2(r[0], r[1]) : G2(r) : Y2(r);
}
var V2 = W2;
function Z2(r) {
  return function(e, t, s) {
    for (var a = -1, i = Object(e), o = s(e), l = o.length; l--; ) {
      var p = o[r ? l : ++a];
      if (t(i[p], p, i) === !1)
        break;
    }
    return e;
  };
}
var J2 = Z2, Q2 = J2, X2 = Q2(), ev = X2, rv = ev, tv = Zs;
function sv(r, e) {
  return r && rv(r, e, tv);
}
var av = sv, iv = Tt;
function ov(r, e) {
  return function(t, s) {
    if (t == null)
      return t;
    if (!iv(t))
      return r(t, s);
    for (var a = t.length, i = e ? a : -1, o = Object(t); (e ? i-- : ++i < a) && s(o[i], i, o) !== !1; )
      ;
    return t;
  };
}
var nv = ov, lv = av, pv = nv, cv = pv(lv), uv = cv, fv = uv, kv = Tt;
function dv(r, e) {
  var t = -1, s = kv(r) ? Array(r.length) : [];
  return fv(r, function(a, i, o) {
    s[++t] = e(a, i, o);
  }), s;
}
var mv = dv;
function gv(r, e) {
  var t = r.length;
  for (r.sort(e); t--; )
    r[t] = r[t].value;
  return r;
}
var vv = gv, Xa = st;
function hv(r, e) {
  if (r !== e) {
    var t = r !== void 0, s = r === null, a = r === r, i = Xa(r), o = e !== void 0, l = e === null, p = e === e, g = Xa(e);
    if (!l && !g && !i && r > e || i && o && p && !l && !g || s && o && p || !t && p || !a)
      return 1;
    if (!s && !i && !g && r < e || g && t && a && !s && !i || l && t && a || !o && a || !p)
      return -1;
  }
  return 0;
}
var xv = hv, bv = xv;
function yv(r, e, t) {
  for (var s = -1, a = r.criteria, i = e.criteria, o = a.length, l = t.length; ++s < o; ) {
    var p = bv(a[s], i[s]);
    if (p) {
      if (s >= l)
        return p;
      var g = t[s];
      return p * (g == "desc" ? -1 : 1);
    }
  }
  return r.index - e.index;
}
var wv = yv, ms = Bi, zv = qs, Fv = V2, Ev = mv, jv = vv, Cv = wo, Sv = wv, Av = It, Dv = He;
function _v(r, e, t) {
  e.length ? e = ms(e, function(i) {
    return Dv(i) ? function(o) {
      return zv(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : e = [Av];
  var s = -1;
  e = ms(e, Cv(Fv));
  var a = Ev(r, function(i, o, l) {
    var p = ms(e, function(g) {
      return g(i);
    });
    return { criteria: p, index: ++s, value: i };
  });
  return jv(a, function(i, o) {
    return Sv(i, o, t);
  });
}
var Ov = _v;
function $v(r, e, t) {
  switch (t.length) {
    case 0:
      return r.call(e);
    case 1:
      return r.call(e, t[0]);
    case 2:
      return r.call(e, t[0], t[1]);
    case 3:
      return r.call(e, t[0], t[1], t[2]);
  }
  return r.apply(e, t);
}
var Mv = $v, Bv = Mv, ei = Math.max;
function Tv(r, e, t) {
  return e = ei(e === void 0 ? r.length - 1 : e, 0), function() {
    for (var s = arguments, a = -1, i = ei(s.length - e, 0), o = Array(i); ++a < i; )
      o[a] = s[e + a];
    a = -1;
    for (var l = Array(e + 1); ++a < e; )
      l[a] = s[a];
    return l[e] = t(o), Bv(r, this, l);
  };
}
var Iv = Tv;
function Rv(r) {
  return function() {
    return r;
  };
}
var Lv = Rv, Nv = Lv, ri = Ni, Pv = It, Uv = ri ? function(r, e) {
  return ri(r, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Nv(e),
    writable: !0
  });
} : Pv, Gv = Uv, Hv = 800, qv = 16, Kv = Date.now;
function Yv(r) {
  var e = 0, t = 0;
  return function() {
    var s = Kv(), a = qv - (s - t);
    if (t = s, a > 0) {
      if (++e >= Hv)
        return arguments[0];
    } else
      e = 0;
    return r.apply(void 0, arguments);
  };
}
var Wv = Yv, Vv = Gv, Zv = Wv, Jv = Zv(Vv), Qv = Jv, Xv = It, eh = Iv, rh = Qv;
function th(r, e) {
  return rh(eh(r, e, Xv), r + "");
}
var sh = th, ah = ho, ih = Ov, oh = sh, ti = Vs, nh = oh(function(r, e) {
  if (r == null)
    return [];
  var t = e.length;
  return t > 1 && ti(r, e[0], e[1]) ? e = [] : t > 2 && ti(e[0], e[1], e[2]) && (e = [e[0]]), ih(r, ah(e, 1), []);
}), lh = nh;
const ph = /* @__PURE__ */ Be(lh);
function ch(r, e, t) {
  for (var s = -1, a = r.length, i = e.length, o = {}; ++s < a; ) {
    var l = s < i ? e[s] : void 0;
    t(o, r[s], l);
  }
  return o;
}
var uh = ch, fh = Pi, kh = uh;
function dh(r, e) {
  return kh(r || [], e || [], fh);
}
var mh = dh;
const gh = /* @__PURE__ */ Be(mh), _s = {
  0: "unit",
  1: "ten",
  2: "hundred",
  3: "thousand",
  6: "million",
  9: "billion",
  12: "trillion",
  15: "quadrillion",
  "-1": "deci",
  "-2": "centi",
  "-3": "mili",
  "-6": "micro",
  "-9": "nano",
  "-12": "pico",
  "-15": "femto"
}, vh = gh(Object.values(_s), Object.keys(_s).map((r) => parseInt(r, 10)));
function hh(r, e, t) {
  const s = {
    roundMode: t.roundMode,
    precision: t.precision,
    significant: t.significant
  };
  let a;
  if (kr(t.units) === "string") {
    const k = t.units;
    if (a = Ue(r, k), !a)
      throw new Error(`The scope "${r.locale}${r.defaultSeparator}${Er(r, k, {})}" couldn't be found`);
  } else
    a = t.units;
  let i = bt(new fe(e), s);
  const o = (k) => ph(Object.keys(k).map((h) => vh[h]), (h) => h * -1), l = (k, h) => {
    const S = k.isZero() ? 0 : Math.floor(Math.log10(k.abs().toNumber()));
    return o(h).find((_) => S >= _) || 0;
  }, p = (k, h) => {
    const S = _s[h.toString()];
    return k[S] || "";
  }, g = l(new fe(i), a), w = p(a, g);
  if (i = bt(new fe(i).div(Math.pow(10, g)), s), t.stripInsignificantZeros) {
    let [k, h] = i.split(".");
    h = (h || "").replace(/0+$/, ""), i = k, h && (i += `${t.separator}${h}`);
  }
  return t.format.replace("%n", i || "0").replace("%u", w).trim();
}
const si = ["byte", "kb", "mb", "gb", "tb", "pb", "eb"];
function xh(r, e, t) {
  const s = ko(t.roundMode), a = 1024, i = new fe(e).abs(), o = i.lt(a);
  let l;
  const p = (_, G) => {
    const I = G.length - 1, N = new fe(Math.log(_.toNumber())).div(Math.log(a)).integerValue(fe.ROUND_DOWN).toNumber();
    return Math.min(I, N);
  }, g = (_) => `number.human.storage_units.units.${o ? "byte" : _[w]}`, w = p(i, si);
  o ? l = i.integerValue() : l = new fe(bt(i.div(Math.pow(a, w)), {
    significant: t.significant,
    precision: t.precision,
    roundMode: t.roundMode
  }));
  const k = r.translate("number.human.storage_units.format", {
    defaultValue: "%n %u"
  }), h = r.translate(g(si), {
    count: i.integerValue().toNumber()
  });
  let S = l.toFixed(t.precision, s);
  return t.stripInsignificantZeros && (S = S.replace(/(\..*?)0+$/, "$1").replace(/\.$/, "")), k.replace("%n", S).replace("%u", h);
}
function Os(r) {
  if (r instanceof Date)
    return r;
  if (typeof r == "number") {
    const s = /* @__PURE__ */ new Date();
    return s.setTime(r), s;
  }
  const e = new String(r).match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})(?:[.,](\d{1,3}))?)?(Z|\+00:?00)?/);
  if (e) {
    const s = e.slice(1, 8).map((k) => parseInt(k, 10) || 0);
    s[1] -= 1;
    const [a, i, o, l, p, g, w] = s;
    return e[8] ? new Date(Date.UTC(a, i, o, l, p, g, w)) : new Date(a, i, o, l, p, g, w);
  }
  r.match(/([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/) && (/* @__PURE__ */ new Date()).setTime(Date.parse([RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$6, RegExp.$4, RegExp.$5].join(" ")));
  const t = /* @__PURE__ */ new Date();
  return t.setTime(Date.parse(r)), t;
}
function ai({ i18n: r, count: e, scope: t, options: s, baseScope: a }) {
  s = Object.assign({}, s);
  let i, o;
  if (typeof t == "object" && t ? i = t : i = Ue(r, t, s), !i)
    return r.missingTranslation.get(t, s);
  const l = r.pluralization.get(s.locale)(r, e), p = [];
  for (; l.length; ) {
    const g = l.shift();
    if (Ze(i[g])) {
      o = i[g];
      break;
    }
    p.push(g);
  }
  return Ze(o) ? (s.count = e, r.interpolate(r, o, s)) : r.missingTranslation.get(a.split(r.defaultSeparator).concat([p[0]]), s);
}
var bh = ho, yh = 1 / 0;
function wh(r) {
  var e = r == null ? 0 : r.length;
  return e ? bh(r, yh) : [];
}
var zh = wh;
const Fh = /* @__PURE__ */ Be(zh);
class Eh {
  constructor(e) {
    this.target = e;
  }
  call() {
    const e = Fh(Object.keys(this.target).map((t) => this.compute(this.target[t], t)));
    return e.sort(), e;
  }
  compute(e, t) {
    return !Array.isArray(e) && Jn(e) ? Object.keys(e).map((s) => this.compute(e[s], `${t}.${s}`)) : t;
  }
}
function jh(r) {
  return new Eh(r).call();
}
const Ch = {
  meridian: { am: "AM", pm: "PM" },
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  abbrDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  monthNames: [
    null,
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  abbrMonthNames: [
    null,
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
};
function Sh(r, e, t = {}) {
  const { abbrDayNames: s, dayNames: a, abbrMonthNames: i, monthNames: o, meridian: l } = Object.assign(Object.assign({}, Ch), t);
  if (isNaN(r.getTime()))
    throw new Error("strftime() requires a valid date object, but received an invalid date.");
  const p = r.getDay(), g = r.getDate(), w = r.getFullYear(), k = r.getMonth() + 1, h = r.getHours();
  let S = h;
  const _ = h > 11 ? "pm" : "am", G = r.getSeconds(), I = r.getMinutes(), N = r.getTimezoneOffset(), C = Math.floor(Math.abs(N / 60)), re = Math.abs(N) - C * 60, B = (N > 0 ? "-" : "+") + (C.toString().length < 2 ? "0" + C : C) + (re.toString().length < 2 ? "0" + re : re);
  return S > 12 ? S = S - 12 : S === 0 && (S = 12), e = e.replace("%a", s[p]), e = e.replace("%A", a[p]), e = e.replace("%b", i[k]), e = e.replace("%B", o[k]), e = e.replace("%d", g.toString().padStart(2, "0")), e = e.replace("%e", g.toString()), e = e.replace("%-d", g.toString()), e = e.replace("%H", h.toString().padStart(2, "0")), e = e.replace("%-H", h.toString()), e = e.replace("%k", h.toString()), e = e.replace("%I", S.toString().padStart(2, "0")), e = e.replace("%-I", S.toString()), e = e.replace("%l", S.toString()), e = e.replace("%m", k.toString().padStart(2, "0")), e = e.replace("%-m", k.toString()), e = e.replace("%M", I.toString().padStart(2, "0")), e = e.replace("%-M", I.toString()), e = e.replace("%p", l[_]), e = e.replace("%P", l[_].toLowerCase()), e = e.replace("%S", G.toString().padStart(2, "0")), e = e.replace("%-S", G.toString()), e = e.replace("%w", p.toString()), e = e.replace("%y", w.toString().padStart(2, "0").substr(-2)), e = e.replace("%-y", w.toString().padStart(2, "0").substr(-2).replace(/^0+/, "")), e = e.replace("%Y", w.toString()), e = e.replace(/%z/i, B), e;
}
var Ah = Math.ceil, Dh = Math.max;
function _h(r, e, t, s) {
  for (var a = -1, i = Dh(Ah((e - r) / (t || 1)), 0), o = Array(i); i--; )
    o[s ? i : ++a] = r, r += t;
  return o;
}
var Oh = _h, $h = Oh, Mh = Vs, gs = mo;
function Bh(r) {
  return function(e, t, s) {
    return s && typeof s != "number" && Mh(e, t, s) && (t = s = void 0), e = gs(e), t === void 0 ? (t = e, e = 0) : t = gs(t), s = s === void 0 ? e < t ? 1 : -1 : gs(s), $h(e, t, s, r);
  };
}
var Th = Bh, Ih = Th, Rh = Ih(), Lh = Rh;
const Nh = /* @__PURE__ */ Be(Lh), je = (r, e, t) => t >= r && t <= e;
function Ph(r, e, t, s = {}) {
  const a = s.scope || "datetime.distance_in_words", i = (L, Z = 0) => r.t(L, { count: Z, scope: a });
  e = Os(e), t = Os(t);
  let o = e.getTime() / 1e3, l = t.getTime() / 1e3;
  o > l && ([e, t, o, l] = [
    t,
    e,
    l,
    o
  ]);
  const p = Math.round(l - o), g = Math.round((l - o) / 60), w = g / 60 / 24, k = Math.round(g / 60), h = Math.round(w), S = Math.round(h / 30);
  if (je(0, 1, g))
    return s.includeSeconds ? je(0, 4, p) ? i("less_than_x_seconds", 5) : je(5, 9, p) ? i("less_than_x_seconds", 10) : je(10, 19, p) ? i("less_than_x_seconds", 20) : je(20, 39, p) ? i("half_a_minute") : je(40, 59, p) ? i("less_than_x_minutes", 1) : i("x_minutes", 1) : g === 0 ? i("less_than_x_minutes", 1) : i("x_minutes", g);
  if (je(2, 44, g))
    return i("x_minutes", g);
  if (je(45, 89, g))
    return i("about_x_hours", 1);
  if (je(90, 1439, g))
    return i("about_x_hours", k);
  if (je(1440, 2519, g))
    return i("x_days", 1);
  if (je(2520, 43199, g))
    return i("x_days", h);
  if (je(43200, 86399, g))
    return i("about_x_months", Math.round(g / 43200));
  if (je(86400, 525599, g))
    return i("x_months", S);
  let _ = e.getFullYear();
  e.getMonth() + 1 >= 3 && (_ += 1);
  let G = t.getFullYear();
  t.getMonth() + 1 < 3 && (G -= 1);
  const I = _ > G ? 0 : Nh(_, G).filter((L) => new Date(L, 1, 29).getMonth() == 1).length, N = 525600, C = I * 1440, re = g - C, B = Math.trunc(re / N), R = parseFloat((re / N - B).toPrecision(3));
  return R < 0.25 ? i("about_x_years", B) : R < 0.75 ? i("over_x_years", B) : i("almost_x_years", B + 1);
}
const Uh = function(r, e) {
  e instanceof Array && (e = e.join(r.defaultSeparator));
  const t = e.split(r.defaultSeparator).slice(-1)[0];
  return r.missingTranslationPrefix + t.replace("_", " ").replace(/([a-z])([A-Z])/g, (s, a, i) => `${a} ${i.toLowerCase()}`);
}, Gh = (r, e, t) => {
  const s = Er(r, e, t), a = "locale" in t ? t.locale : r.locale, i = kr(a);
  return `[missing "${[
    i == "string" ? a : i,
    s
  ].join(r.defaultSeparator)}" translation]`;
}, Hh = (r, e, t) => {
  const s = Er(r, e, t), a = [r.locale, s].join(r.defaultSeparator);
  throw new Error(`Missing translation: ${a}`);
};
class qh {
  constructor(e) {
    this.i18n = e, this.registry = {}, this.register("guess", Uh), this.register("message", Gh), this.register("error", Hh);
  }
  register(e, t) {
    this.registry[e] = t;
  }
  get(e, t) {
    var s;
    return this.registry[(s = t.missingBehavior) !== null && s !== void 0 ? s : this.i18n.missingBehavior](this.i18n, e, t);
  }
}
var Kh = function(r, e, t, s) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(w) {
      try {
        g(s.next(w));
      } catch (k) {
        o(k);
      }
    }
    function p(w) {
      try {
        g(s.throw(w));
      } catch (k) {
        o(k);
      }
    }
    function g(w) {
      w.done ? i(w.value) : a(w.value).then(l, p);
    }
    g((s = s.apply(r, e || [])).next());
  });
};
const vs = {
  defaultLocale: "en",
  availableLocales: ["en"],
  locale: "en",
  defaultSeparator: ".",
  placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm,
  enableFallback: !1,
  missingBehavior: "message",
  missingTranslationPrefix: "",
  missingPlaceholder: (r, e) => `[missing "${e}" value]`,
  nullPlaceholder: (r, e, t, s) => r.missingPlaceholder(r, e, t, s),
  transformKey: (r) => r
};
class Yh {
  constructor(e = {}, t = {}) {
    this._locale = vs.locale, this._defaultLocale = vs.defaultLocale, this._version = 0, this.onChangeHandlers = [], this.translations = {}, this.availableLocales = [], this.t = this.translate, this.p = this.pluralize, this.l = this.localize, this.distanceOfTimeInWords = this.timeAgoInWords;
    const { locale: s, enableFallback: a, missingBehavior: i, missingTranslationPrefix: o, missingPlaceholder: l, nullPlaceholder: p, defaultLocale: g, defaultSeparator: w, placeholder: k, transformKey: h } = Object.assign(Object.assign({}, vs), t);
    this.locale = s, this.defaultLocale = g, this.defaultSeparator = w, this.enableFallback = a, this.locale = s, this.missingBehavior = i, this.missingTranslationPrefix = o, this.missingPlaceholder = l, this.nullPlaceholder = p, this.placeholder = k, this.pluralization = new O1(this), this.locales = new S1(this), this.missingTranslation = new qh(this), this.transformKey = h, this.interpolate = fs, this.store(e);
  }
  store(e) {
    jh(e).forEach((t) => _0(this.translations, t, zs(e, t), Object)), this.hasChanged();
  }
  get locale() {
    return this._locale || this.defaultLocale || "en";
  }
  set locale(e) {
    if (typeof e != "string")
      throw new Error(`Expected newLocale to be a string; got ${kr(e)}`);
    const t = this._locale !== e;
    this._locale = e, t && this.hasChanged();
  }
  get defaultLocale() {
    return this._defaultLocale || "en";
  }
  set defaultLocale(e) {
    if (typeof e != "string")
      throw new Error(`Expected newLocale to be a string; got ${kr(e)}`);
    const t = this._defaultLocale !== e;
    this._defaultLocale = e, t && this.hasChanged();
  }
  translate(e, t) {
    t = Object.assign({}, t);
    const s = Pf(this, e, t);
    let a;
    return s.some((i) => (Ze(i.scope) ? a = Ue(this, i.scope, t) : Ze(i.message) && (a = i.message), a != null)) ? (typeof a == "string" ? a = this.interpolate(this, a, t) : typeof a == "object" && a && Ze(t.count) && (a = ai({
      i18n: this,
      count: t.count || 0,
      scope: a,
      options: t,
      baseScope: Er(this, e, t)
    })), t && a instanceof Array && (a = a.map((i) => typeof i == "string" ? fs(this, i, t) : i)), a) : this.missingTranslation.get(e, t);
  }
  pluralize(e, t, s) {
    return ai({
      i18n: this,
      count: e,
      scope: t,
      options: Object.assign({}, s),
      baseScope: Er(this, t, s ?? {})
    });
  }
  localize(e, t, s) {
    if (s = Object.assign({}, s), t == null)
      return "";
    switch (e) {
      case "currency":
        return this.numberToCurrency(t);
      case "number":
        return Jr(t, Object.assign({ delimiter: ",", precision: 3, separator: ".", significant: !1, stripInsignificantZeros: !1 }, Ue(this, "number.format")));
      case "percentage":
        return this.numberToPercentage(t);
      default: {
        let a;
        return e.match(/^(date|time)/) ? a = this.toTime(e, t) : a = t.toString(), fs(this, a, s);
      }
    }
  }
  toTime(e, t) {
    const s = Os(t), a = Ue(this, e);
    return s.toString().match(/invalid/i) || !a ? s.toString() : this.strftime(s, a);
  }
  numberToCurrency(e, t = {}) {
    return Jr(e, Object.assign(Object.assign(Object.assign({ delimiter: ",", format: "%u%n", precision: 2, separator: ".", significant: !1, stripInsignificantZeros: !1, unit: "$" }, Pe(this.get("number.format"))), Pe(this.get("number.currency.format"))), t));
  }
  numberToPercentage(e, t = {}) {
    return Jr(e, Object.assign(Object.assign(Object.assign({ delimiter: "", format: "%n%", precision: 3, stripInsignificantZeros: !1, separator: ".", significant: !1 }, Pe(this.get("number.format"))), Pe(this.get("number.percentage.format"))), t));
  }
  numberToHumanSize(e, t = {}) {
    return xh(this, e, Object.assign(Object.assign(Object.assign({ delimiter: "", precision: 3, significant: !0, stripInsignificantZeros: !0, units: {
      billion: "Billion",
      million: "Million",
      quadrillion: "Quadrillion",
      thousand: "Thousand",
      trillion: "Trillion",
      unit: ""
    } }, Pe(this.get("number.human.format"))), Pe(this.get("number.human.storage_units"))), t));
  }
  numberToHuman(e, t = {}) {
    return hh(this, e, Object.assign(Object.assign(Object.assign({ delimiter: "", separator: ".", precision: 3, significant: !0, stripInsignificantZeros: !0, format: "%n %u", roundMode: "default", units: {
      billion: "Billion",
      million: "Million",
      quadrillion: "Quadrillion",
      thousand: "Thousand",
      trillion: "Trillion",
      unit: ""
    } }, Pe(this.get("number.human.format"))), Pe(this.get("number.human.decimal_units"))), t));
  }
  numberToRounded(e, t) {
    return Jr(e, Object.assign({ unit: "", precision: 3, significant: !1, separator: ".", delimiter: "", stripInsignificantZeros: !1 }, t));
  }
  numberToDelimited(e, t = {}) {
    return $k(e, Object.assign({ delimiterPattern: /(\d)(?=(\d\d\d)+(?!\d))/g, delimiter: ",", separator: "." }, t));
  }
  withLocale(e, t) {
    return Kh(this, void 0, void 0, function* () {
      const s = this.locale;
      try {
        this.locale = e, yield t();
      } finally {
        this.locale = s;
      }
    });
  }
  strftime(e, t, s = {}) {
    return Sh(e, t, Object.assign(Object.assign(Object.assign({}, Pe(Ue(this, "date"))), { meridian: {
      am: Ue(this, "time.am") || "AM",
      pm: Ue(this, "time.pm") || "PM"
    } }), s));
  }
  update(e, t, s = { strict: !1 }) {
    if (s.strict && !p0(this.translations, e))
      throw new Error(`The path "${e}" is not currently defined`);
    const a = zs(this.translations, e), i = kr(a), o = kr(t);
    if (s.strict && i !== o)
      throw new Error(`The current type for "${e}" is "${i}", but you're trying to override it with "${o}"`);
    let l;
    o === "object" ? l = Object.assign(Object.assign({}, a), t) : l = t, C0(this.translations, e, l), this.hasChanged();
  }
  toSentence(e, t = {}) {
    const { wordsConnector: s, twoWordsConnector: a, lastWordConnector: i } = Object.assign(Object.assign({ wordsConnector: ", ", twoWordsConnector: " and ", lastWordConnector: ", and " }, Pe(Ue(this, "support.array"))), t), o = e.length;
    switch (o) {
      case 0:
        return "";
      case 1:
        return `${e[0]}`;
      case 2:
        return e.join(a);
      default:
        return [
          e.slice(0, o - 1).join(s),
          i,
          e[o - 1]
        ].join("");
    }
  }
  timeAgoInWords(e, t, s = {}) {
    return Ph(this, e, t, s);
  }
  onChange(e) {
    return this.onChangeHandlers.push(e), () => {
      this.onChangeHandlers.splice(this.onChangeHandlers.indexOf(e), 1);
    };
  }
  get version() {
    return this._version;
  }
  formatNumber(e, t) {
    return Jr(e, t);
  }
  get(e) {
    return Ue(this, e);
  }
  runCallbacks() {
    this.onChangeHandlers.forEach((e) => e(this));
  }
  hasChanged() {
    this._version += 1, this.runCallbacks();
  }
}
const Wh = Ls({
  i18n: new Yh(),
  setLocale: (r) => new Promise((e) => e)
});
Wh.displayName = "I18nContext";
const ii = we(({ height: r, width: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    fill: "none",
    width: e,
    height: r,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#00CD82",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M68.443 124.457c2.32 2.321 5.374 3.543 8.672 3.543 3.297 0 6.35-1.344 8.671-3.543L138.427 71.8a12.168 12.168 0 000-17.226 12.16 12.16 0 00-17.221 0L76.992 98.556 58.794 80.352a12.16 12.16 0 00-17.221 0 12.17 12.17 0 000 17.227l26.87 26.878z"
        }
      )
    ]
  }
)), Vh = we(({ height: r, width: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    fill: "none",
    width: e,
    height: r,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#A0A0A0",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M127.2 117.152l-25.9-27.1 26-27.1c3.1-3.3 2.9-8.5-.3-11.7-3.3-3.1-8.6-3-11.7.3l-25.5 26.6-25.4-26.6c-3.1-3.3-8.4-3.4-11.7-.3-3.3 3.1-3.4 8.4-.3 11.7l25.9 27.1-26 27.1c-1.5 1.6-2.3 3.7-2.3 5.9s1 4.3 2.5 5.7c1.5 1.5 3.5 2.3 5.8 2.3 2.2 0 4.4-.9 6-2.5l25.4-26.6 25.4 26.6c1.6 1.6 3.7 2.5 6 2.5 2.1 0 4.1-.8 5.7-2.3 1.6-1.5 2.5-3.6 2.6-5.8.1-2.1-.7-4.2-2.2-5.8z"
        }
      )
    ]
  }
)), Zh = we(({ height: r, width: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    height: r,
    width: e,
    fill: "none",
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "url(#paint0_linear_352_4279)",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M33 57.364C33 46.666 41.657 38 52.326 38h74.348C137.343 38 146 46.661 146 57.364v45.478c0 10.698-8.657 19.364-19.326 19.364h-38.57L61.217 151v-28.794h-8.89c-10.67 0-19.327-8.661-19.327-19.364V57.364zm19.326-13.633c-7.521 0-13.613 6.108-13.613 13.633v45.478c0 7.529 6.09 13.633 13.613 13.633H66.93v20.024l18.697-20.024h41.047c7.521 0 13.613-6.107 13.613-13.633V57.364c0-7.529-6.091-13.633-13.613-13.633H52.326z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M33 57.364C33 46.666 41.657 38 52.326 38h74.348C137.343 38 146 46.661 146 57.364v45.478c0 10.698-8.657 19.364-19.326 19.364h-38.57L61.217 151v-28.794h-8.89c-10.67 0-19.327-8.661-19.327-19.364V57.364zm19.326-13.633c-7.521 0-13.613 6.108-13.613 13.633v45.478c0 7.529 6.09 13.633 13.613 13.633H66.93v20.024l18.697-20.024h41.047c7.521 0 13.613-6.107 13.613-13.633V57.364c0-7.529-6.091-13.633-13.613-13.633H52.326z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M89.5 93.442l-11.934 6.2c-1.647.857-2.723.106-2.405-1.666l2.345-13.062-9.714-9.191c-1.34-1.269-.943-2.502.916-2.76l13.38-1.848 5.93-11.88c.818-1.64 2.14-1.652 2.964 0l5.93 11.88 13.379 1.849c1.847.255 2.267 1.481.916 2.759l-9.713 9.191 2.345 13.062c.319 1.776-.747 2.529-2.406 1.667l-11.933-6.2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ $.jsx("defs", { children: /* @__PURE__ */ $.jsxs(
        "linearGradient",
        {
          id: "paint0_linear_352_4279",
          x1: "159.5",
          x2: "46.5",
          y1: "32",
          y2: "160.5",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ $.jsx("stop", { stopColor: "#14D7A7" }),
            /* @__PURE__ */ $.jsx(
              "stop",
              {
                offset: "0.45",
                stopColor: "#19B393"
              }
            ),
            /* @__PURE__ */ $.jsx(
              "stop",
              {
                offset: "1",
                stopColor: "#274C5C"
              }
            )
          ]
        }
      ) })
    ]
  }
)), Jh = we(({ width: r, height: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    height: e,
    width: r,
    fill: "none",
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#DA0000",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M127.2 117.152l-25.9-27.1 26-27.1c3.1-3.3 2.9-8.5-.3-11.7-3.3-3.1-8.6-3-11.7.3l-25.5 26.6-25.4-26.6c-3.1-3.3-8.4-3.4-11.7-.3-3.3 3.1-3.4 8.4-.3 11.7l25.9 27.1-26 27.1c-1.5 1.6-2.3 3.7-2.3 5.9s1 4.3 2.5 5.7c1.5 1.5 3.5 2.3 5.8 2.3 2.2 0 4.4-.9 6-2.5l25.4-26.6 25.4 26.6c1.6 1.6 3.7 2.5 6 2.5 2.1 0 4.1-.8 5.7-2.3 1.6-1.5 2.5-3.6 2.6-5.8.1-2.1-.7-4.2-2.2-5.8z"
        }
      )
    ]
  }
)), Qh = we(({ width: r, height: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    height: e,
    width: r,
    fill: "none",
    viewBox: "0 0 180 180",
    children: [
      /* @__PURE__ */ $.jsx(
        "rect",
        {
          width: "180",
          height: "180",
          fill: "url(#paint0_radial_354_4353)",
          rx: "90"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "rect",
        {
          width: "180",
          height: "180",
          fill: "url(#paint1_radial_354_4353)",
          rx: "90"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M89.667 33c-15.39 0-17.32.065-23.363.341-6.032.275-10.152 1.232-13.756 2.633-3.727 1.449-6.887 3.386-10.037 6.537-3.15 3.15-5.088 6.31-6.536 10.037-1.4 3.604-2.359 7.723-2.634 13.755-.276 6.044-.341 7.973-.341 23.364 0 15.389.065 17.32.341 23.364.275 6.03 1.234 10.15 2.634 13.754 1.448 3.727 3.386 6.887 6.536 10.038 3.15 3.149 6.31 5.086 10.037 6.536 3.604 1.4 7.724 2.358 13.756 2.633 6.043.276 7.973.341 23.363.341 15.389 0 17.318-.065 23.362-.341 6.034-.275 10.152-1.233 13.756-2.633 3.727-1.45 6.887-3.387 10.038-6.536 3.149-3.151 5.088-6.311 6.536-10.038 1.4-3.604 2.358-7.724 2.633-13.754.276-6.044.341-7.975.341-23.364 0-15.39-.065-17.32-.341-23.364-.275-6.032-1.233-10.151-2.633-13.755-1.448-3.727-3.387-6.887-6.536-10.037-3.151-3.151-6.311-5.089-10.038-6.537-3.604-1.4-7.722-2.358-13.756-2.633-6.044-.276-7.973-.341-23.362-.341zm0 10.21c15.13 0 16.922.058 22.898.33 5.524.253 8.524 1.176 10.522 1.952 2.645 1.027 4.533 2.256 6.516 4.239 1.982 1.982 3.21 3.87 4.238 6.515.776 1.996 1.699 4.997 1.952 10.522.272 5.976.331 7.768.331 22.899 0 15.13-.059 16.922-.331 22.898-.253 5.524-1.176 8.526-1.952 10.522-1.028 2.645-2.256 4.533-4.238 6.516-1.983 1.982-3.871 3.21-6.516 4.238-1.998.776-4.998 1.7-10.522 1.952-5.976.272-7.766.33-22.898.33s-16.924-.058-22.899-.33c-5.524-.252-8.525-1.176-10.521-1.952-2.646-1.028-4.534-2.256-6.516-4.238-1.983-1.983-3.211-3.871-4.239-6.516-.776-1.996-1.699-4.998-1.952-10.522-.272-5.976-.33-7.768-.33-22.898 0-15.131.058-16.923.33-22.9.253-5.524 1.176-8.524 1.952-10.52 1.028-2.646 2.256-4.534 4.239-6.516 1.982-1.983 3.87-3.212 6.516-4.239 1.996-.776 4.997-1.699 10.521-1.952 5.976-.272 7.768-.33 22.899-.33z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M89.667 108.556c-10.432 0-18.89-8.457-18.89-18.89 0-10.431 8.458-18.889 18.89-18.889s18.889 8.458 18.889 18.89-8.457 18.889-18.89 18.889zm0-47.988c-16.071 0-29.1 13.028-29.1 29.099 0 16.07 13.029 29.098 29.1 29.098 16.072 0 29.098-13.028 29.098-29.098 0-16.071-13.026-29.099-29.098-29.099zM126.714 59.417a6.799 6.799 0 11-13.598 0 6.8 6.8 0 0113.598 0z"
        }
      ),
      /* @__PURE__ */ $.jsxs("defs", { children: [
        /* @__PURE__ */ $.jsxs(
          "radialGradient",
          {
            id: "paint0_radial_354_4353",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(-106.74055 -221.03968 328.77111 -158.7643 152.1 204.3)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ $.jsx(
                "stop",
                {
                  offset: "0.244",
                  stopColor: "#FF1B90"
                }
              ),
              /* @__PURE__ */ $.jsx(
                "stop",
                {
                  offset: "0.437",
                  stopColor: "#F80261"
                }
              ),
              /* @__PURE__ */ $.jsx(
                "stop",
                {
                  offset: "0.688",
                  stopColor: "#ED00C0"
                }
              ),
              /* @__PURE__ */ $.jsx(
                "stop",
                {
                  offset: "0.777",
                  stopColor: "#C500E9"
                }
              ),
              /* @__PURE__ */ $.jsx(
                "stop",
                {
                  offset: "0.893",
                  stopColor: "#7017FF"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ $.jsxs(
          "radialGradient",
          {
            id: "paint1_radial_354_4353",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(61.37989 -85.67985 93.71724 67.13776 60.3 180)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ $.jsx(
                "stop",
                {
                  offset: "0.094",
                  stopColor: "#FFD000"
                }
              ),
              /* @__PURE__ */ $.jsx(
                "stop",
                {
                  offset: "0.443",
                  stopColor: "#FF6930"
                }
              ),
              /* @__PURE__ */ $.jsx(
                "stop",
                {
                  offset: "0.693",
                  stopColor: "#FE3B36"
                }
              ),
              /* @__PURE__ */ $.jsx(
                "stop",
                {
                  offset: "1",
                  stopColor: "#FF6930",
                  stopOpacity: "0"
                }
              )
            ]
          }
        )
      ] })
    ]
  }
)), Xh = we(
  ({ height: r, width: e }) => /* @__PURE__ */ $.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: r,
      width: e,
      fill: "none",
      viewBox: "0 0 180 180",
      children: [
        /* @__PURE__ */ $.jsx(
          "rect",
          {
            width: "180",
            height: "180",
            fill: "url(#paint0_radial_354_4349)",
            rx: "90"
          }
        ),
        /* @__PURE__ */ $.jsx(
          "rect",
          {
            width: "180",
            height: "180",
            fill: "url(#paint1_radial_354_4349)",
            rx: "90"
          }
        ),
        /* @__PURE__ */ $.jsx(
          "path",
          {
            fill: "#fff",
            d: "M89.98 151.516c-10.045 0-20.008-2.485-28.815-7.186a4.227 4.227 0 113.983-7.458c7.585 4.05 16.172 6.19 24.831 6.19 4.069 0 8.123-.464 12.046-1.379a4.225 4.225 0 015.078 3.156 4.227 4.227 0 01-3.157 5.078 61.628 61.628 0 01-13.967 1.599zM50.762 135.893a4.207 4.207 0 01-2.906-1.159c-8.61-8.156-14.63-18.525-17.41-29.987a4.228 4.228 0 118.217-1.992c2.394 9.874 7.585 18.809 15.008 25.841a4.227 4.227 0 01-2.909 7.297zM33.233 88.806a4.226 4.226 0 01-4.212-4.644 60.82 60.82 0 015.395-19.73 4.228 4.228 0 017.665 3.57 52.35 52.35 0 00-4.646 16.993 4.228 4.228 0 01-4.202 3.811zM50.966 53.002a4.227 4.227 0 01-3.264-6.91c.377-.46.76-.913 1.15-1.361a4.225 4.225 0 015.965-.41 4.226 4.226 0 01.41 5.964 54.11 54.11 0 00-.991 1.173 4.221 4.221 0 01-3.27 1.544zM119.235 143.453a4.228 4.228 0 01-2.176-7.855c15.865-9.499 25.722-26.872 25.722-45.339 0-29.115-23.688-52.803-52.803-52.803a4.228 4.228 0 110-8.456c33.778 0 61.258 27.48 61.258 61.258 0 21.424-11.432 41.577-29.835 52.593a4.183 4.183 0 01-2.166.602z"
          }
        ),
        /* @__PURE__ */ $.jsx(
          "path",
          {
            fill: "#fff",
            d: "M118.553 86.25H94.332V62.03h-8.456v24.22h-24.22v8.455h24.22v24.222h8.456V94.705h24.221V86.25z"
          }
        ),
        /* @__PURE__ */ $.jsxs("defs", { children: [
          /* @__PURE__ */ $.jsxs(
            "radialGradient",
            {
              id: "paint0_radial_354_4349",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-106.74055 -221.03968 328.77111 -158.7643 152.1 204.3)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.244",
                    stopColor: "#FF1B90"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.437",
                    stopColor: "#F80261"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.688",
                    stopColor: "#ED00C0"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.777",
                    stopColor: "#C500E9"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.893",
                    stopColor: "#7017FF"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ $.jsxs(
            "radialGradient",
            {
              id: "paint1_radial_354_4349",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(61.37989 -85.67985 93.71724 67.13776 60.3 180)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.094",
                    stopColor: "#FFD000"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.443",
                    stopColor: "#FF6930"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.693",
                    stopColor: "#FE3B36"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "1",
                    stopColor: "#FF6930",
                    stopOpacity: "0"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  )
), ex = we(
  ({ width: r, height: e }) => /* @__PURE__ */ $.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: e,
      width: r,
      fill: "none",
      viewBox: "0 0 180 180",
      children: [
        /* @__PURE__ */ $.jsx(
          "rect",
          {
            width: "180",
            height: "180",
            fill: "url(#paint0_radial_357_4364)",
            rx: "90"
          }
        ),
        /* @__PURE__ */ $.jsx(
          "rect",
          {
            width: "180",
            height: "180",
            fill: "url(#paint1_radial_357_4364)",
            rx: "90"
          }
        ),
        /* @__PURE__ */ $.jsx("g", { clipPath: "url(#clip0_357_4364)", children: /* @__PURE__ */ $.jsx(
          "path",
          {
            fill: "#fff",
            d: "M64.14 29H116c9.65 0 18.43 3.96 24.8 10.32 6.38 6.37 10.34 15.16 10.34 24.82v52.61c0 9.64-3.96 18.42-10.32 24.79l-.02.02c-6.38 6.37-15.16 10.32-24.79 10.32H64.14c-9.66 0-18.45-3.96-24.82-10.32l-.24-.27C32.86 134.95 29 126.27 29 116.74v-52.6c0-9.67 3.95-18.45 10.32-24.82C45.69 32.95 54.47 29 64.14 29zm56.37 31.02l.07.11h21.6c-.87-5.68-3.58-10.78-7.48-14.69-4.8-4.8-11.42-7.78-18.7-7.78h-8.87l13.38 22.36zm-9.99.11L97.07 37.66h-29.5l13.61 22.47h29.34zm-39.41 0L57.95 38.39a26.446 26.446 0 00-12.51 7.05c-3.9 3.9-6.6 9.01-7.48 14.69h33.15zm71.37 8.66H37.66v47.96c0 7.17 2.89 13.7 7.56 18.48l.22.21c4.8 4.8 11.43 7.79 18.7 7.79H116c7.28 0 13.9-2.98 18.69-7.77l.02-.02c4.79-4.79 7.77-11.41 7.77-18.69V68.79zM79.95 83.95l26.83 17.45c.43.28.82.64 1.13 1.08a3.9 3.9 0 01-1 5.42l-26.72 15.77c-.67.55-1.53.88-2.48.88a3.91 3.91 0 01-3.91-3.91V87.15h.02a3.902 3.902 0 016.13-3.2z"
          }
        ) }),
        /* @__PURE__ */ $.jsxs("defs", { children: [
          /* @__PURE__ */ $.jsxs(
            "radialGradient",
            {
              id: "paint0_radial_357_4364",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-106.74055 -221.03968 328.77111 -158.7643 152.1 204.3)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.244",
                    stopColor: "#FF1B90"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.437",
                    stopColor: "#F80261"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.688",
                    stopColor: "#ED00C0"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.777",
                    stopColor: "#C500E9"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.893",
                    stopColor: "#7017FF"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ $.jsxs(
            "radialGradient",
            {
              id: "paint1_radial_357_4364",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(61.37989 -85.67985 93.71724 67.13776 60.3 180)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.094",
                    stopColor: "#FFD000"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.443",
                    stopColor: "#FF6930"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "0.693",
                    stopColor: "#FE3B36"
                  }
                ),
                /* @__PURE__ */ $.jsx(
                  "stop",
                  {
                    offset: "1",
                    stopColor: "#FF6930",
                    stopOpacity: "0"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ $.jsx("clipPath", { id: "clip0_357_4364", children: /* @__PURE__ */ $.jsx(
            "path",
            {
              fill: "#fff",
              d: "M0 0H122.14V122.88H0z",
              transform: "translate(29 29)"
            }
          ) })
        ] })
      ]
    }
  )
), rx = we(({ height: r, width: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: r,
    width: e,
    viewBox: "0 0 180 180",
    children: [
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#4A90E2",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M133.381 125.5h-14.504V79.127h-17.978v-10.93c2.52.069 4.937-.101 7.253-.51 2.383-.477 4.494-1.26 6.332-2.35a15.91 15.91 0 004.801-4.493c1.294-1.839 2.145-4.12 2.554-6.844h11.542v71.5zM68.256 94.244h20.326v10.929H68.256v20.326h-10.93v-20.326H37v-10.93h20.326V73.918h10.93v20.327z"
        }
      )
    ]
  }
)), tx = we(({ width: r, height: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    width: r,
    height: e,
    fill: "none",
    viewBox: "0 0 181 181",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ $.jsx(
        "mask",
        {
          id: "mask0_352_4285",
          style: { maskType: "luminance" },
          width: "181",
          height: "181",
          x: "0",
          y: "0",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ $.jsx(
            "path",
            {
              fill: "#fff",
              d: "M180.113 90.547c0-49.707-40.294-90.007-90-90.007-49.705 0-90 40.3-90 90.007 0 49.693 40.295 90 90 90 49.706 0 90-40.307 90-90z"
            }
          )
        }
      ),
      /* @__PURE__ */ $.jsx("g", { mask: "url(#mask0_352_4285)", children: /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "url(#paint0_linear_352_4285)",
          d: "M180.113 90.547c0-49.707-40.294-90.007-90-90.007-49.705 0-90 40.3-90 90.007 0 49.693 40.295 90 90 90 49.706 0 90-40.307 90-90z"
        }
      ) }),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#C8DAEA",
          d: "M61.035 97.12l10.678 29.56s1.335 2.76 2.764 2.76c1.431 0 22.691-22.12 22.691-22.12l23.644-45.667-59.396 27.84-.381 7.627z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#A9C6D8",
          d: "M75.193 104.693l-2.05 21.787s-.86 6.68 5.815 0c6.674-6.667 13.062-11.813 13.062-11.813l-16.827-9.974z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M61.228 98.173l-21.962-7.16s-2.622-1.066-1.78-3.48c.174-.493.525-.92 1.573-1.653 4.868-3.387 90.08-34.013 90.08-34.013s2.406-.814 3.828-.267c.649.24 1.064.52 1.414 1.533.127.374.2 1.16.191 1.934-.008.573-.077 1.093-.128 1.92-.519 8.373-16.047 70.866-16.047 70.866s-.929 3.654-4.258 3.774c-1.214.053-2.688-.2-4.45-1.707-6.532-5.627-29.113-20.8-34.104-24.133-.28-.187-.36-.44-.409-.68-.07-.347.313-.787.313-.787s39.319-34.947 40.366-38.613c.081-.28-.223-.427-.635-.307-2.612.96-47.884 29.547-52.88 32.707-.292.186-1.112.066-1.112.066z"
        }
      ),
      /* @__PURE__ */ $.jsx("defs", { children: /* @__PURE__ */ $.jsxs(
        "linearGradient",
        {
          id: "paint0_linear_352_4285",
          x1: "90.113",
          x2: "90.113",
          y1: "180.547",
          y2: "0.547",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ $.jsx("stop", { stopColor: "#1D93D2" }),
            /* @__PURE__ */ $.jsx(
              "stop",
              {
                offset: "1",
                stopColor: "#38B0E3"
              }
            )
          ]
        }
      ) })
    ]
  }
)), sx = we(({ height: r, width: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    fill: "none",
    width: e,
    height: r,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#010201",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M65.98 126.121l.323.295c.996.713 1.716 1.716 2.67 2.481 2.96 2.376 6.288 3.668 10.105 3.904 9.043.559 16.924-6.246 17.945-15.189.05-.437.032-.876.032-1.313.002-26.923.002-53.846.002-80.77 0-1.816 0-1.816 1.808-1.816 4.092 0 8.182-.002 12.273.003.384 0 .785-.072 1.135.17l.073.055c.196.203.253.463.311.727 1.568 7.256 5.386 13.047 11.377 17.417.373.274.687.615 1.045.906.262.22.523.442.783.664.967.548 1.649 1.43 2.488 2.13 3.312 2.76 7.051 4.662 11.221 5.735.368.095.787.09 1.055.437l.067.059c.245.259.204.588.204.899.004 4.746.006 9.493 0 14.24-.002 1.086-.147 1.141-1.244 1.142-3.478.004-6.891-.465-10.271-1.237-5.809-1.33-11.172-3.69-16.144-6.957-.26-.17-.535-.535-.811-.41-.352.16-.166.612-.166.932-.01 13.364.049 26.727-.028 40.09-.054 9.342-3.024 17.7-9.14 24.818-6.498 7.563-14.75 11.954-24.657 13.163-7.635.933-14.88-.448-21.755-3.844a19.94 19.94 0 01-3.17-1.94l-.94-.833c-2.37-1.956-4.02-4.49-5.558-7.087-2.37-4-3.908-8.317-4.659-12.909-.43-2.624-.648-5.27-.502-7.924.466-8.556 3.345-16.192 8.864-22.792 4.629-5.538 10.407-9.406 17.22-11.731a34.638 34.638 0 018.78-1.783c.558-.04 1.108-.172 1.672-.137.266.017.54-.01.767.175l.083.056c.157.269.119.568.119.856.004 4.817.002 9.633.002 14.45 0 .17-.005.34-.013.511-.023.483-.27.644-.727.515-1.317-.375-2.67-.548-4.03-.62a15.343 15.343 0 00-6.168.917c-6.62 2.443-10.64 7.184-11.479 14.169-.828 6.887 1.89 12.394 7.617 16.359.48.333.972.643 1.42 1.017z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#CB1C54",
          d: "M53.51 142.912c.257-.069.402.134.58.242a38.164 38.164 0 0013.927 5.142c2.503.403 5.032.572 7.564.441 8.472-.441 16.052-3.258 22.608-8.674 6.31-5.214 10.503-11.802 12.602-19.712.661-2.498 1.026-5.042 1.157-7.626.076-1.485.069-2.969.071-4.453.004-12.735.002-25.47.002-38.203v-.868c.332-.09.482.158.666.283 4.534 3.104 9.442 5.403 14.742 6.861a49.737 49.737 0 008.878 1.6c1.265.11 2.53.095 3.793.187.552.04.56.018.565-.559.008-.61.003-1.218.003-1.826v-12.93c.001-.268.017-.535.025-.801 1.136.128 2.254.372 3.395.457.705.053 1.409.119 2.116.098.349-.011.496.111.457.462-.017.144-.002.292-.002.438v18.698c0 .123.002.244-.002.365-.014.543-.014.555-.588.554a45.497 45.497 0 01-5.826-.39 49.391 49.391 0 01-11.494-2.934 49.164 49.164 0 01-10.037-5.31c-.195-.134-.397-.257-.697-.45v.873c0 13.61.01 27.22-.004 40.831-.008 7.253-1.887 13.993-5.756 20.141-4.674 7.424-11.162 12.646-19.406 15.643-5.005 1.819-10.182 2.516-15.502 2.124-8.974-.663-16.738-4.089-23.344-10.171-.178-.162-.328-.354-.492-.533z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#6ABAC5",
          d: "M112.274 33.887c-.267.013-.532.037-.799.037l-13.153.001c-1.017 0-1.017 0-1.017.984 0 26.782-.003 53.564.006 80.347.002 1.861-.137 3.696-.72 5.469-2.058 6.27-6.26 10.4-12.688 11.867-6.894 1.573-12.748-.529-17.406-5.873l-.192-.303c1.332.529 2.66 1.063 4.076 1.343 4.493.888 8.728.202 12.625-2.202 4.503-2.776 7.161-6.84 8.095-12.032.176-.98.204-1.98.204-2.98-.006-26.833-.004-53.666-.002-80.498 0-1.251-.174-1.095 1.071-1.095 6.187-.005 12.375-.003 18.561-.003.147 0 .294-.002.439 0 .633.01.645.01.641.652-.006 1.435-.024 2.868.259 4.286z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#6ABAC5",
          d: "M79.156 77.89c-3.78.127-7.477.726-11.073 1.92-5.192 1.727-9.804 4.431-13.828 8.14-5.279 4.866-8.879 10.766-10.847 17.656-.701 2.456-1.108 4.97-1.287 7.523a37.452 37.452 0 00-.058 4.592c.226 4.248 1.106 8.361 2.722 12.311 1.806 4.412 4.332 8.356 7.622 11.81l.164.235c-.747-.32-1.348-.863-1.97-1.359-6.14-4.865-10.466-11-12.848-18.476a37.578 37.578 0 01-1.594-7.988 37.343 37.343 0 01-.078-5.906 37.308 37.308 0 013.238-13.022c1.954-4.328 4.621-8.17 8.012-11.492 3.948-3.869 8.522-6.766 13.733-8.64a37.845 37.845 0 0110.097-2.14 39.17 39.17 0 017.502.167c.337.04.536.108.528.51-.027 1.386-.026 2.773-.035 4.16z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#CB1C54",
          d: "M65.98 126.121c-1.525-.687-2.842-1.681-4.037-2.831-3.002-2.89-4.79-6.414-5.253-10.556-.972-8.689 4.507-16.189 12.115-18.513 3.247-.992 6.5-1.028 9.771-.15.183.05.363.129.565.076.108-.262.054-.533.054-.795.004-4.868.002-9.737.004-14.607 0-.265.027-.532.04-.799 1.879-.127 3.743.042 5.607.25.293.032.372.17.364.424-.005.146 0 .292 0 .438 0 6.451.001 12.902-.003 19.351-.001.236.066.485-.09.741-.848-.16-1.683-.416-2.548-.537-4.982-.697-9.478.468-13.425 3.576-3.469 2.732-5.602 6.323-6.318 10.673-.761 4.612.193 8.892 2.848 12.77.108.158.204.326.307.489zM125.08 52.99c-1.876-1.108-3.519-2.509-5.029-4.064-4.055-4.172-6.616-9.125-7.702-14.84l-.002-.145c1.749-.1 3.5-.012 5.25-.047.311-.006.448.118.419.43-.012.121 0 .244-.001.365-.091 4.905 1.366 9.386 3.756 13.605.853 1.506 1.876 2.897 2.989 4.222.123.145.297.26.32.474z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#6ABAC5",
          d: "M140.627 61.957c-4.989-1.065-9.377-3.314-13.182-6.701-.56-.499-1.138-.985-1.582-1.601.186-.02.32.094.467.178a28.908 28.908 0 009.689 3.432c1.339.222 2.691.366 4.055.352.568-.005.583.016.583.558-.002 1.261-.019 2.52-.03 3.782z"
        }
      )
    ]
  }
)), ax = we(({ height: r, width: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    fill: "none",
    width: e,
    height: r,
    viewBox: "0 0 181 181",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#9146FF",
          fillRule: "evenodd",
          d: "M180.113 90.85c0 49.705-40.294 89.999-90 89.999-49.705 0-90-40.294-90-90s40.295-90 90-90c49.706 0 90 40.294 90 90z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M134.557 93.072l-17.777 17.777H99.001l-15.554 15.556v-15.556h-20V44.183h71.11v48.889z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#000",
          d: "M134.558 93.072L116.78 110.85H99.002l-15.555 15.556v-15.556h-20V44.183h71.111v48.89zM59.002 35.295L36.78 57.516v80h26.667v22.223l22.221-22.223h17.779l40-40V35.295H59.002z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#000",
          d: "M112.334 59.739h8.89v26.666h-8.89V59.74zM87.89 59.739h8.89v26.666h-8.89V59.74z"
        }
      )
    ]
  }
)), ix = we(({ height: r, width: e }) => /* @__PURE__ */ $.jsxs(
  "svg",
  {
    fill: "none",
    viewBox: "0 0 180 181",
    width: e,
    height: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#DA0000",
          d: "M180 90.952c0 49.705-40.295 90-90 90s-90-40.295-90-90 40.295-90 90-90 90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ $.jsx(
        "path",
        {
          fill: "#fff",
          d: "M78 108.952v-36l31.176 18-31.176 18zm69.492-46.883a15.028 15.028 0 00-10.609-10.609C127.525 48.952 90 48.952 90 48.952s-37.525 0-46.884 2.508a15.029 15.029 0 00-10.608 10.61C30 71.426 30 90.951 30 90.951s0 19.525 2.508 28.883a15.026 15.026 0 0010.608 10.609C52.475 132.952 90 132.952 90 132.952s37.525 0 46.883-2.508a15.025 15.025 0 0010.609-10.609C150 110.477 150 90.952 150 90.952s0-19.525-2.508-28.883z"
        }
      )
    ]
  }
));
Ls({
  addEvent: () => new Promise((r) => r)
});
const Ne = () => ji(Si), ox = we(({ type: r, thread: e, onClick: t }) => {
  const { i18n: s } = Je(), { state: a } = Ne(), { store: i, last_message: o } = e, [l, p] = Se(
    r === "creator" ? e.is_read_by_creator : e.is_read_by_store
  ), g = tr(() => {
    const k = St(o.sent_at);
    return At(k);
  }, [e]), w = () => {
    l || p(!0), t(e);
  };
  return /* @__PURE__ */ z.jsxs(
    "ul",
    {
      "data-testid": "thread",
      onClick: w,
      className: "skp-mb-0 skp-min-h-24 skp-pb-3 skp-pr-3 skp-pt-3",
      children: [
        /* @__PURE__ */ z.jsxs("li", { className: "skp-relative skp-mb-1 skp-flex skp-items-center skp-justify-between skp-pl-8", children: [
          !l && /* @__PURE__ */ z.jsx(
            "span",
            {
              "data-testid": "thread-unread",
              className: "skp-absolute skp-left-2 skp-top-2 skp-h-3 skp-w-3 skp-rounded-full skp-bg-blue-500"
            }
          ),
          /* @__PURE__ */ z.jsxs("div", { className: "skp-flex skp-items-center", children: [
            /* @__PURE__ */ z.jsx(
              Fr,
              {
                src: `${a.settings.assetBaseUrl}/${i.logo}`,
                legend: i.title
              }
            ),
            /* @__PURE__ */ z.jsx(
              "h5",
              {
                "data-testid": "thread-sender",
                className: "skp-ml-2 skp-line-clamp-2 skp-text-sm skp-font-semibold skp-text-gray-500",
                children: i.title
              }
            )
          ] }),
          /* @__PURE__ */ z.jsx("span", { className: "skp-pl-2 skp-text-xs skp-text-gray-400", children: s.t(g.key, { count: g.count }) })
        ] }),
        /* @__PURE__ */ z.jsx("li", { className: "skp-pl-8", children: /* @__PURE__ */ z.jsx("p", { className: "skp-line-clamp-1 skp-whitespace-nowrap skp-text-sm skp-text-gray-400", children: o.text }) })
      ]
    }
  );
}), nx = (r) => r.toLowerCase().split("-").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(""), Ao = (r) => r.replace(/([A-Z])/g, (e) => `-${e[0].toLowerCase()}`), lx = (r, e, t = {}) => {
  if (r instanceof Element) {
    const s = px(r.classList, e, t);
    s !== "" && (r.className = s), Object.keys(e).forEach((a) => {
      if (!(a === "children" || a === "style" || a === "ref" || a === "class" || a === "className" || a === "forwardedRef"))
        if (a.indexOf("on") === 0 && a[2] === a[2].toUpperCase()) {
          const i = a.substring(2), o = i[0].toLowerCase() + i.substring(1);
          Do(o) || ux(r, o, e[a]);
        } else
          r[a] = e[a], typeof e[a] === "string" && r.setAttribute(Ao(a), e[a]);
    });
  }
}, px = (r, e, t) => {
  const s = e.className || e.class, a = t.className || t.class, i = hs(r), o = hs(s ? s.split(" ") : []), l = hs(a ? a.split(" ") : []), p = [];
  return i.forEach((g) => {
    o.has(g) ? (p.push(g), o.delete(g)) : l.has(g) || p.push(g);
  }), o.forEach((g) => p.push(g)), p.join(" ");
}, cx = (r) => {
  switch (r) {
    case "doubleclick":
      return "dblclick";
  }
  return r;
};
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
const Do = (r) => {
  if (typeof document > "u")
    return !0;
  {
    const e = "on" + cx(r);
    let t = e in document;
    if (!t) {
      const s = document.createElement("div");
      s.setAttribute(e, "return;"), t = typeof s[e] == "function";
    }
    return t;
  }
}, ux = (r, e, t) => {
  const s = r.__events || (r.__events = {}), a = s[e];
  a && r.removeEventListener(e, a), r.addEventListener(e, s[e] = function(o) {
    t && t.call(this, o);
  });
}, hs = (r) => {
  const e = /* @__PURE__ */ new Map();
  return r.forEach((t) => e.set(t, t)), e;
}, fx = (r, e) => {
  typeof r == "function" ? r(e) : r != null && (r.current = e);
}, kx = (...r) => (e) => {
  r.forEach((t) => {
    fx(t, e);
  });
}, dx = (r, e) => {
  const t = (s, a) => dr.createElement(r, Object.assign({}, s, { forwardedRef: a }));
  return t.displayName = e, dr.forwardRef(t);
};
var mx = function(r, e) {
  var t = {};
  for (var s in r)
    Object.prototype.hasOwnProperty.call(r, s) && e.indexOf(s) < 0 && (t[s] = r[s]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, s = Object.getOwnPropertySymbols(r); a < s.length; a++)
      e.indexOf(s[a]) < 0 && Object.prototype.propertyIsEnumerable.call(r, s[a]) && (t[s[a]] = r[s[a]]);
  return t;
};
const Rt = (r, e, t, s) => {
  s !== void 0 && s();
  const a = nx(r), i = class extends dr.Component {
    constructor(o) {
      super(o), this.setComponentElRef = (l) => {
        this.componentEl = l;
      };
    }
    componentDidMount() {
      this.componentDidUpdate(this.props);
    }
    componentDidUpdate(o) {
      lx(this.componentEl, this.props, o);
    }
    render() {
      const o = this.props, { children: l, forwardedRef: p, style: g, className: w, ref: k } = o, h = mx(o, ["children", "forwardedRef", "style", "className", "ref"]);
      let S = Object.keys(h).reduce((G, I) => {
        const N = h[I];
        if (I.indexOf("on") === 0 && I[2] === I[2].toUpperCase()) {
          const C = I.substring(2).toLowerCase();
          typeof document < "u" && Do(C) && (G[I] = N);
        } else {
          const C = typeof N;
          (C === "string" || C === "boolean" || C === "number") && (G[Ao(I)] = N);
        }
        return G;
      }, {});
      t && (S = t(this.props, S));
      const _ = Object.assign(Object.assign({}, S), { ref: kx(p, this.setComponentElRef), style: g });
      return nn(r, _, l);
    }
    static get displayName() {
      return a;
    }
  };
  return e && (i.contextType = e), dx(i, a);
}, rr = {
  allRenderFn: !1,
  cmpDidLoad: !0,
  cmpDidUnload: !1,
  cmpDidUpdate: !0,
  cmpDidRender: !0,
  cmpWillLoad: !0,
  cmpWillUpdate: !0,
  cmpWillRender: !0,
  connectedCallback: !0,
  disconnectedCallback: !0,
  element: !0,
  event: !0,
  hasRenderFn: !0,
  lifecycle: !0,
  hostListener: !0,
  hostListenerTargetWindow: !0,
  hostListenerTargetDocument: !0,
  hostListenerTargetBody: !0,
  hostListenerTargetParent: !1,
  hostListenerTarget: !0,
  member: !0,
  method: !0,
  mode: !0,
  observeAttribute: !0,
  prop: !0,
  propMutable: !0,
  reflect: !0,
  scoped: !0,
  shadowDom: !0,
  slot: !0,
  cssAnnotations: !0,
  state: !0,
  style: !0,
  formAssociated: !1,
  svg: !0,
  updatable: !0,
  vdomAttribute: !0,
  vdomXlink: !0,
  vdomClass: !0,
  vdomFunctional: !0,
  vdomKey: !0,
  vdomListener: !0,
  vdomRef: !0,
  vdomPropOrAttr: !0,
  vdomRender: !0,
  vdomStyle: !0,
  vdomText: !0,
  watchCallback: !0,
  taskQueue: !0,
  hotModuleReplacement: !1,
  isDebug: !1,
  isDev: !1,
  isTesting: !1,
  hydrateServerSide: !1,
  hydrateClientSide: !1,
  lifecycleDOMEvents: !1,
  lazyLoad: !1,
  profile: !1,
  slotRelocation: !0,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  appendChildSlotFix: !1,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  cloneNodeFix: !1,
  hydratedAttribute: !1,
  hydratedClass: !0,
  scriptDataOpts: !1,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  scopedSlotTextContentFix: !1,
  // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
  shadowDomShim: !1,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  slotChildNodesFix: !1,
  invisiblePrehydration: !0,
  propBoolean: !0,
  propNumber: !0,
  propString: !0,
  constructableCSS: !0,
  cmpShouldUpdate: !0,
  devTools: !1,
  shadowDelegatesFocus: !0,
  initializeNextTick: !1,
  asyncLoading: !1,
  asyncQueue: !1,
  transformTagName: !1,
  attachStyles: !0,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  experimentalSlotFixes: !1
};
let xr, $s, Qr, Js = !1, zt = !1, Qs = !1, Ce = !1, oi = null, Ms = !1;
const gx = (r) => {
  const e = new URL(r, ye.$resourcesUrl$);
  return e.origin !== lt.location.origin ? e.href : e.pathname;
}, mr = (r, e = "") => () => {
}, vx = "slot-fb{display:contents}slot-fb[hidden]{display:none}", ni = "http://www.w3.org/1999/xlink", li = {}, hx = "http://www.w3.org/2000/svg", xx = "http://www.w3.org/1999/xhtml", bx = (r) => r != null, Xs = (r) => (r = typeof r, r === "object" || r === "function");
function yx(r) {
  var e, t, s;
  return (s = (t = (e = r.head) === null || e === void 0 ? void 0 : e.querySelector('meta[name="csp-nonce"]')) === null || t === void 0 ? void 0 : t.getAttribute("content")) !== null && s !== void 0 ? s : void 0;
}
const U = (r, e, ...t) => {
  let s = null, a = null, i = null, o = !1, l = !1;
  const p = [], g = (k) => {
    for (let h = 0; h < k.length; h++)
      s = k[h], Array.isArray(s) ? g(s) : s != null && typeof s != "boolean" && ((o = typeof r != "function" && !Xs(s)) && (s = String(s)), o && l ? p[p.length - 1].$text$ += s : p.push(o ? Ft(null, s) : s), l = o);
  };
  if (g(t), e) {
    e.key && (a = e.key), e.name && (i = e.name);
    {
      const k = e.className || e.class;
      k && (e.class = typeof k != "object" ? k : Object.keys(k).filter((h) => k[h]).join(" "));
    }
  }
  if (typeof r == "function")
    return r(e === null ? {} : e, p, zx);
  const w = Ft(r, null);
  return w.$attrs$ = e, p.length > 0 && (w.$children$ = p), w.$key$ = a, w.$name$ = i, w;
}, Ft = (r, e) => {
  const t = {
    $flags$: 0,
    $tag$: r,
    $text$: e,
    $elm$: null,
    $children$: null
  };
  return t.$attrs$ = null, t.$key$ = null, t.$name$ = null, t;
}, it = {}, wx = (r) => r && r.$tag$ === it, zx = {
  forEach: (r, e) => r.map(pi).forEach(e),
  map: (r, e) => r.map(pi).map(e).map(Fx)
}, pi = (r) => ({
  vattrs: r.$attrs$,
  vchildren: r.$children$,
  vkey: r.$key$,
  vname: r.$name$,
  vtag: r.$tag$,
  vtext: r.$text$
}), Fx = (r) => {
  if (typeof r.vtag == "function") {
    const t = Object.assign({}, r.vattrs);
    return r.vkey && (t.key = r.vkey), r.vname && (t.name = r.vname), U(r.vtag, t, ...r.vchildren || []);
  }
  const e = Ft(r.vtag, r.vtext);
  return e.$attrs$ = r.vattrs, e.$children$ = r.vchildren, e.$key$ = r.vkey, e.$name$ = r.vname, e;
}, Ex = (r) => Xx.map((e) => e(r)).find((e) => !!e), jx = (r, e) => r != null && !Xs(r) ? e & 4 ? r === "false" ? !1 : r === "" || !!r : e & 2 ? parseFloat(r) : e & 1 ? String(r) : r : r, Cx = (r) => r, sr = (r, e, t) => {
  const s = Cx(r);
  return {
    emit: (a) => Sx(s, e, {
      bubbles: !!(t & 4),
      composed: !!(t & 2),
      cancelable: !!(t & 1),
      detail: a
    })
  };
}, Sx = (r, e, t) => {
  const s = ye.ce(e, t);
  return r.dispatchEvent(s), s;
}, ci = /* @__PURE__ */ new WeakMap(), Ax = (r, e, t) => {
  let s = jt.get(r);
  t3 && t ? (s = s || new CSSStyleSheet(), typeof s == "string" ? s = e : s.replaceSync(e)) : s = e, jt.set(r, s);
}, Dx = (r, e, t) => {
  var s;
  const a = _o(e, t), i = jt.get(a);
  if (r = r.nodeType === 11 ? r : Re, i)
    if (typeof i == "string") {
      r = r.head || r;
      let o = ci.get(r), l;
      if (o || ci.set(r, o = /* @__PURE__ */ new Set()), !o.has(a)) {
        {
          l = Re.createElement("style"), l.innerHTML = i;
          const p = (s = ye.$nonce$) !== null && s !== void 0 ? s : yx(Re);
          p != null && l.setAttribute("nonce", p), r.insertBefore(l, r.querySelector("link"));
        }
        e.$flags$ & 4 && (l.innerHTML += vx), o && o.add(a);
      }
    } else
      r.adoptedStyleSheets.includes(i) || (r.adoptedStyleSheets = [...r.adoptedStyleSheets, i]);
  return a;
}, _x = (r) => {
  const e = r.$cmpMeta$, t = r.$hostElement$, s = e.$flags$, a = mr("attachStyles", e.$tagName$), i = Dx(t.shadowRoot ? t.shadowRoot : t.getRootNode(), e, r.$modeName$);
  s & 10 && (t["s-sc"] = i, t.classList.add(i + "-h"), s & 2 && t.classList.add(i + "-s")), a();
}, _o = (r, e) => "sc-" + (e && r.$flags$ & 32 ? r.$tagName$ + "-" + e : r.$tagName$), ui = (r, e, t, s, a, i) => {
  if (t !== s) {
    let o = gi(r, e), l = e.toLowerCase();
    if (e === "class") {
      const p = r.classList, g = fi(t), w = fi(s);
      p.remove(...g.filter((k) => k && !w.includes(k))), p.add(...w.filter((k) => k && !g.includes(k)));
    } else if (e === "style") {
      for (const p in t)
        (!s || s[p] == null) && (p.includes("-") ? r.style.removeProperty(p) : r.style[p] = "");
      for (const p in s)
        (!t || s[p] !== t[p]) && (p.includes("-") ? r.style.setProperty(p, s[p]) : r.style[p] = s[p]);
    } else if (e !== "key")
      if (e === "ref")
        s && s(r);
      else if (!r.__lookupSetter__(e) && e[0] === "o" && e[1] === "n") {
        if (e[2] === "-" ? e = e.slice(3) : gi(lt, l) ? e = l.slice(2) : e = l[2] + e.slice(3), t || s) {
          const p = e.endsWith(Oo);
          e = e.replace($x, ""), t && ye.rel(r, e, t, p), s && ye.ael(r, e, s, p);
        }
      } else {
        const p = Xs(s);
        if ((o || p && s !== null) && !a)
          try {
            if (r.tagName.includes("-"))
              r[e] = s;
            else {
              const w = s ?? "";
              e === "list" ? o = !1 : (t == null || r[e] != w) && (r[e] = w);
            }
          } catch {
          }
        let g = !1;
        l !== (l = l.replace(/^xlink\:?/, "")) && (e = l, g = !0), s == null || s === !1 ? (s !== !1 || r.getAttribute(e) === "") && (g ? r.removeAttributeNS(ni, e) : r.removeAttribute(e)) : (!o || i & 4 || a) && !p && (s = s === !0 ? "" : s, g ? r.setAttributeNS(ni, e, s) : r.setAttribute(e, s));
      }
  }
}, Ox = /\s/, fi = (r) => r ? r.split(Ox) : [], Oo = "Capture", $x = new RegExp(Oo + "$"), $o = (r, e, t, s) => {
  const a = e.$elm$.nodeType === 11 && e.$elm$.host ? e.$elm$.host : e.$elm$, i = r && r.$attrs$ || li, o = e.$attrs$ || li;
  for (s in i)
    s in o || ui(a, s, i[s], void 0, t, e.$flags$);
  for (s in o)
    ui(a, s, i[s], o[s], t, e.$flags$);
}, Et = (r, e, t, s) => {
  const a = e.$children$[t];
  let i = 0, o, l, p;
  if (Js || (Qs = !0, a.$tag$ === "slot" && (xr && s.classList.add(xr + "-s"), a.$flags$ |= a.$children$ ? (
    // slot element has fallback content
    2
  ) : (
    // slot element does not have fallback content
    1
  ))), a.$text$ !== null)
    o = a.$elm$ = Re.createTextNode(a.$text$);
  else if (a.$flags$ & 1)
    o = a.$elm$ = Re.createTextNode("");
  else {
    if (Ce || (Ce = a.$tag$ === "svg"), o = a.$elm$ = Re.createElementNS(Ce ? hx : xx, a.$flags$ & 2 ? "slot-fb" : a.$tag$), Ce && a.$tag$ === "foreignObject" && (Ce = !1), $o(null, a, Ce), bx(xr) && o["s-si"] !== xr && o.classList.add(o["s-si"] = xr), a.$children$)
      for (i = 0; i < a.$children$.length; ++i)
        l = Et(r, a, i, o), l && o.appendChild(l);
    a.$tag$ === "svg" ? Ce = !1 : o.tagName === "foreignObject" && (Ce = !0);
  }
  return o["s-hn"] = Qr, a.$flags$ & 3 && (o["s-sr"] = !0, o["s-cr"] = $s, o["s-sn"] = a.$name$ || "", p = r && r.$children$ && r.$children$[t], p && p.$tag$ === a.$tag$ && r.$elm$ && Xr(r.$elm$, !1)), o;
}, Xr = (r, e) => {
  ye.$flags$ |= 1;
  const t = r.childNodes;
  for (let s = t.length - 1; s >= 0; s--) {
    const a = t[s];
    a["s-hn"] !== Qr && a["s-ol"] && (To(a).insertBefore(a, ea(a)), a["s-ol"].remove(), a["s-ol"] = void 0, a["s-sh"] = void 0, Qs = !0), e && Xr(a, e);
  }
  ye.$flags$ &= -2;
}, Mo = (r, e, t, s, a, i) => {
  let o = r["s-cr"] && r["s-cr"].parentNode || r, l;
  for (o.shadowRoot && o.tagName === Qr && (o = o.shadowRoot); a <= i; ++a)
    s[a] && (l = Et(null, t, a, r), l && (s[a].$elm$ = l, o.insertBefore(l, ea(e))));
}, Bo = (r, e, t) => {
  for (let s = e; s <= t; ++s) {
    const a = r[s];
    if (a) {
      const i = a.$elm$;
      Lo(a), i && (zt = !0, i["s-ol"] ? i["s-ol"].remove() : Xr(i, !0), i.remove());
    }
  }
}, Mx = (r, e, t, s, a = !1) => {
  let i = 0, o = 0, l = 0, p = 0, g = e.length - 1, w = e[0], k = e[g], h = s.length - 1, S = s[0], _ = s[h], G, I;
  for (; i <= g && o <= h; )
    if (w == null)
      w = e[++i];
    else if (k == null)
      k = e[--g];
    else if (S == null)
      S = s[++o];
    else if (_ == null)
      _ = s[--h];
    else if (dt(w, S, a))
      br(w, S, a), w = e[++i], S = s[++o];
    else if (dt(k, _, a))
      br(k, _, a), k = e[--g], _ = s[--h];
    else if (dt(w, _, a))
      (w.$tag$ === "slot" || _.$tag$ === "slot") && Xr(w.$elm$.parentNode, !1), br(w, _, a), r.insertBefore(w.$elm$, k.$elm$.nextSibling), w = e[++i], _ = s[--h];
    else if (dt(k, S, a))
      (w.$tag$ === "slot" || _.$tag$ === "slot") && Xr(k.$elm$.parentNode, !1), br(k, S, a), r.insertBefore(k.$elm$, w.$elm$), k = e[--g], S = s[++o];
    else {
      for (l = -1, p = i; p <= g; ++p)
        if (e[p] && e[p].$key$ !== null && e[p].$key$ === S.$key$) {
          l = p;
          break;
        }
      l >= 0 ? (I = e[l], I.$tag$ !== S.$tag$ ? G = Et(e && e[o], t, l, r) : (br(I, S, a), e[l] = void 0, G = I.$elm$), S = s[++o]) : (G = Et(e && e[o], t, o, r), S = s[++o]), G && To(w.$elm$).insertBefore(G, ea(w.$elm$));
    }
  i > g ? Mo(r, s[h + 1] == null ? null : s[h + 1].$elm$, t, s, o, h) : o > h && Bo(e, i, g);
}, dt = (r, e, t = !1) => r.$tag$ === e.$tag$ ? r.$tag$ === "slot" ? r.$name$ === e.$name$ : t ? !0 : r.$key$ === e.$key$ : !1, ea = (r) => r && r["s-ol"] || r, To = (r) => (r["s-ol"] ? r["s-ol"] : r).parentNode, br = (r, e, t = !1) => {
  const s = e.$elm$ = r.$elm$, a = r.$children$, i = e.$children$, o = e.$tag$, l = e.$text$;
  let p;
  l === null ? (Ce = o === "svg" ? !0 : o === "foreignObject" ? !1 : Ce, o === "slot" && !Js || $o(r, e, Ce), a !== null && i !== null ? Mx(s, a, e, i, t) : i !== null ? (r.$text$ !== null && (s.textContent = ""), Mo(s, null, e, i, 0, i.length - 1)) : a !== null && Bo(a, 0, a.length - 1), Ce && o === "svg" && (Ce = !1)) : (p = s["s-cr"]) ? p.parentNode.textContent = l : r.$text$ !== l && (s.data = l);
}, Io = (r) => {
  const e = r.childNodes;
  for (const t of e)
    if (t.nodeType === 1) {
      if (t["s-sr"]) {
        const s = t["s-sn"];
        t.hidden = !1;
        for (const a of e)
          if (a !== t) {
            if (a["s-hn"] !== t["s-hn"] || s !== "") {
              if (a.nodeType === 1 && (s === a.getAttribute("slot") || s === a["s-sn"])) {
                t.hidden = !0;
                break;
              }
            } else if (a.nodeType === 1 || a.nodeType === 3 && a.textContent.trim() !== "") {
              t.hidden = !0;
              break;
            }
          }
      }
      Io(t);
    }
}, We = [], Ro = (r) => {
  let e, t, s;
  for (const a of r.childNodes) {
    if (a["s-sr"] && (e = a["s-cr"]) && e.parentNode) {
      t = e.parentNode.childNodes;
      const i = a["s-sn"];
      for (s = t.length - 1; s >= 0; s--)
        if (e = t[s], !e["s-cn"] && !e["s-nr"] && e["s-hn"] !== a["s-hn"] && !rr.experimentalSlotFixes)
          if (ki(e, i)) {
            let o = We.find((l) => l.$nodeToRelocate$ === e);
            zt = !0, e["s-sn"] = e["s-sn"] || i, o ? (o.$nodeToRelocate$["s-sh"] = a["s-hn"], o.$slotRefNode$ = a) : (e["s-sh"] = a["s-hn"], We.push({
              $slotRefNode$: a,
              $nodeToRelocate$: e
            })), e["s-sr"] && We.map((l) => {
              ki(l.$nodeToRelocate$, e["s-sn"]) && (o = We.find((p) => p.$nodeToRelocate$ === e), o && !l.$slotRefNode$ && (l.$slotRefNode$ = o.$slotRefNode$));
            });
          } else
            We.some((o) => o.$nodeToRelocate$ === e) || We.push({
              $nodeToRelocate$: e
            });
    }
    a.nodeType === 1 && Ro(a);
  }
}, ki = (r, e) => r.nodeType === 1 ? r.getAttribute("slot") === null && e === "" || r.getAttribute("slot") === e : r["s-sn"] === e ? !0 : e === "", Lo = (r) => {
  r.$attrs$ && r.$attrs$.ref && r.$attrs$.ref(null), r.$children$ && r.$children$.map(Lo);
}, Bx = (r, e, t = !1) => {
  var s, a, i, o, l;
  const p = r.$hostElement$, g = r.$cmpMeta$, w = r.$vnode$ || Ft(null, null), k = wx(e) ? e : U(null, null, e);
  if (Qr = p.tagName, g.$attrsToReflect$ && (k.$attrs$ = k.$attrs$ || {}, g.$attrsToReflect$.map(([h, S]) => k.$attrs$[S] = p[h])), t && k.$attrs$)
    for (const h of Object.keys(k.$attrs$))
      p.hasAttribute(h) && !["key", "ref", "style", "class"].includes(h) && (k.$attrs$[h] = p[h]);
  k.$tag$ = null, k.$flags$ |= 4, r.$vnode$ = k, k.$elm$ = w.$elm$ = p.shadowRoot || p, xr = p["s-sc"], Js = (g.$flags$ & 1) !== 0, $s = p["s-cr"], zt = !1, br(w, k, t);
  {
    if (ye.$flags$ |= 1, Qs) {
      Ro(k.$elm$);
      for (const h of We) {
        const S = h.$nodeToRelocate$;
        if (!S["s-ol"]) {
          const _ = Re.createTextNode("");
          _["s-nr"] = S, S.parentNode.insertBefore(S["s-ol"] = _, S);
        }
      }
      for (const h of We) {
        const S = h.$nodeToRelocate$, _ = h.$slotRefNode$;
        if (_) {
          const G = _.parentNode;
          let I = _.nextSibling;
          {
            let N = (s = S["s-ol"]) === null || s === void 0 ? void 0 : s.previousSibling;
            for (; N; ) {
              let C = (a = N["s-nr"]) !== null && a !== void 0 ? a : null;
              if (C && C["s-sn"] === S["s-sn"] && G === C.parentNode && (C = C.nextSibling, !C || !C["s-nr"])) {
                I = C;
                break;
              }
              N = N.previousSibling;
            }
          }
          (!I && G !== S.parentNode || S.nextSibling !== I) && S !== I && (!S["s-hn"] && S["s-ol"] && (S["s-hn"] = S["s-ol"].parentNode.nodeName), G.insertBefore(S, I), S.nodeType === 1 && (S.hidden = (i = S["s-ih"]) !== null && i !== void 0 ? i : !1));
        } else
          S.nodeType === 1 && (t && (S["s-ih"] = (o = S.hidden) !== null && o !== void 0 ? o : !1), S.hidden = !0);
      }
    }
    zt && Io(k.$elm$), ye.$flags$ &= -2, We.length = 0;
  }
  if (rr.experimentalScopedSlotChanges && g.$flags$ & 2)
    for (const h of k.$elm$.childNodes)
      h["s-hn"] !== Qr && !h["s-sh"] && (t && h["s-ih"] == null && (h["s-ih"] = (l = h.hidden) !== null && l !== void 0 ? l : !1), h.hidden = !0);
  $s = void 0;
}, Tx = (r, e) => {
}, No = (r, e) => (r.$flags$ |= 16, Tx(r, r.$ancestorComponent$), i3(() => Ix(r, e))), Ix = (r, e) => {
  const t = r.$hostElement$, s = mr("scheduleUpdate", r.$cmpMeta$.$tagName$), a = t;
  let i;
  return e ? i = wr(a, "componentWillLoad") : i = wr(a, "componentWillUpdate"), i = di(i, () => wr(a, "componentWillRender")), s(), di(i, () => Lx(r, a, e));
}, di = (r, e) => Rx(r) ? r.then(e) : e(), Rx = (r) => r instanceof Promise || r && r.then && typeof r.then == "function", Lx = async (r, e, t) => {
  const s = r.$hostElement$, a = mr("update", r.$cmpMeta$.$tagName$);
  s["s-rc"], t && _x(r);
  const i = mr("render", r.$cmpMeta$.$tagName$);
  Nx(r, e, s, t), i(), a(), Px(r);
}, Nx = (r, e, t, s) => {
  try {
    oi = e, e = e.render && e.render(), r.$flags$ &= -17, r.$flags$ |= 2, (rr.hasRenderFn || rr.reflect) && (rr.vdomRender || rr.reflect) && (rr.hydrateServerSide || Bx(r, e, s));
  } catch (p) {
    nt(p, r.$hostElement$);
  }
  return oi = null, null;
}, Px = (r) => {
  const e = r.$cmpMeta$.$tagName$, t = r.$hostElement$, s = mr("postUpdate", e), a = t;
  r.$ancestorComponent$, wr(a, "componentDidRender"), r.$flags$ & 64 ? (wr(a, "componentDidUpdate"), s()) : (r.$flags$ |= 64, wr(a, "componentDidLoad"), s());
}, wr = (r, e, t) => {
  if (r && r[e])
    try {
      return r[e](t);
    } catch (s) {
      nt(s);
    }
}, Ux = (r, e) => ot(r).$instanceValues$.get(e), Gx = (r, e, t, s) => {
  const a = ot(r), i = r, o = a.$instanceValues$.get(e), l = a.$flags$, p = i;
  t = jx(t, s.$members$[e][0]);
  const g = Number.isNaN(o) && Number.isNaN(t);
  if (t !== o && !g) {
    a.$instanceValues$.set(e, t);
    {
      if (s.$watchers$ && l & 128) {
        const k = s.$watchers$[e];
        k && k.map((h) => {
          try {
            p[h](t, o, e);
          } catch (S) {
            nt(S, i);
          }
        });
      }
      if ((l & 18) === 2) {
        if (p.componentShouldUpdate && p.componentShouldUpdate(t, o, e) === !1)
          return;
        No(a, !1);
      }
    }
  }
}, Hx = (r, e, t) => {
  var s;
  const a = r.prototype;
  if (e.$members$) {
    r.watchers && (e.$watchers$ = r.watchers);
    const i = Object.entries(e.$members$);
    i.map(([o, [l]]) => {
      (l & 31 || l & 32) && Object.defineProperty(a, o, {
        get() {
          return Ux(this, o);
        },
        set(p) {
          Gx(this, o, p, e);
        },
        configurable: !0,
        enumerable: !0
      });
    });
    {
      const o = /* @__PURE__ */ new Map();
      a.attributeChangedCallback = function(l, p, g) {
        ye.jmp(() => {
          var w;
          const k = o.get(l);
          if (this.hasOwnProperty(k))
            g = this[k], delete this[k];
          else {
            if (a.hasOwnProperty(k) && typeof this[k] == "number" && this[k] == g)
              return;
            if (k == null) {
              const h = ot(this), S = h == null ? void 0 : h.$flags$;
              if (S && !(S & 8) && S & 128 && g !== p) {
                const G = this, I = (w = e.$watchers$) === null || w === void 0 ? void 0 : w[l];
                I == null || I.forEach((N) => {
                  G[N] != null && G[N].call(G, g, p, l);
                });
              }
              return;
            }
          }
          this[k] = g === null && typeof this[k] == "boolean" ? !1 : g;
        });
      }, r.observedAttributes = Array.from(/* @__PURE__ */ new Set([
        ...Object.keys((s = e.$watchers$) !== null && s !== void 0 ? s : {}),
        ...i.filter(
          ([l, p]) => p[0] & 15
          /* MEMBER_FLAGS.HasAttribute */
        ).map(([l, p]) => {
          var g;
          const w = p[1] || l;
          return o.set(w, l), p[0] & 512 && ((g = e.$attrsToReflect$) === null || g === void 0 || g.push([l, w])), w;
        })
      ]));
    }
  }
  return r;
}, qx = async (r, e, t, s) => {
  let a;
  if (!(e.$flags$ & 32) && (e.$flags$ |= 32, a = r.constructor, customElements.whenDefined(t.$tagName$).then(() => e.$flags$ |= 128), a.style)) {
    let o = a.style;
    typeof o != "string" && (o = o[e.$modeName$ = Ex(r)]);
    const l = _o(t, e.$modeName$);
    if (!jt.has(l)) {
      const p = mr("registerStyles", t.$tagName$);
      Ax(l, o, !!(t.$flags$ & 1)), p();
    }
  }
  e.$ancestorComponent$, No(e, !0);
}, mi = (r) => {
}, Kx = (r) => {
  if (!(ye.$flags$ & 1)) {
    const e = ot(r), t = e.$cmpMeta$, s = mr("connectedCallback", t.$tagName$);
    e.$flags$ & 1 ? (Po(r, e, t.$listeners$), e != null && e.$lazyInstance$ ? mi(e.$lazyInstance$) : e != null && e.$onReadyPromise$ && e.$onReadyPromise$.then(() => mi(e.$lazyInstance$))) : (e.$flags$ |= 1, // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
    t.$flags$ & 12 && Yx(r), t.$members$ && Object.entries(t.$members$).map(([a, [i]]) => {
      if (i & 31 && r.hasOwnProperty(a)) {
        const o = r[a];
        delete r[a], r[a] = o;
      }
    }), qx(r, e, t)), s();
  }
}, Yx = (r) => {
  const e = r["s-cr"] = Re.createComment("");
  e["s-cn"] = !0, r.insertBefore(e, r.firstChild);
}, Wx = async (r) => {
  if (!(ye.$flags$ & 1)) {
    const e = ot(r);
    e.$rmListeners$ && (e.$rmListeners$.map((t) => t()), e.$rmListeners$ = void 0);
  }
}, Ae = (r, e) => {
  const t = {
    $flags$: e[0],
    $tagName$: e[1]
  };
  t.$members$ = e[2], t.$listeners$ = e[3], t.$watchers$ = r.$watchers$, t.$attrsToReflect$ = [];
  const s = r.prototype.connectedCallback, a = r.prototype.disconnectedCallback;
  return Object.assign(r.prototype, {
    __registerHost() {
      Qx(this, t);
    },
    connectedCallback() {
      Kx(this), s && s.call(this);
    },
    disconnectedCallback() {
      Wx(this), a && a.call(this);
    },
    __attachShadow() {
      this.attachShadow({
        mode: "open",
        delegatesFocus: !!(t.$flags$ & 16)
      });
    }
  }), r.is = t.$tagName$, Hx(r, t);
}, Po = (r, e, t, s) => {
  t && t.map(([a, i, o]) => {
    const l = Zx(r, a), p = Vx(e, o), g = Jx(a);
    ye.ael(l, i, p, g), (e.$rmListeners$ = e.$rmListeners$ || []).push(() => ye.rel(l, i, p, g));
  });
}, Vx = (r, e) => (t) => {
  try {
    rr.lazyLoad || r.$hostElement$[e](t);
  } catch (s) {
    nt(s);
  }
}, Zx = (r, e) => e & 4 ? Re : e & 8 ? lt : e & 16 ? Re.body : r, Jx = (r) => e3 ? {
  passive: (r & 1) !== 0,
  capture: (r & 2) !== 0
} : (r & 2) !== 0, Uo = /* @__PURE__ */ new WeakMap(), ot = (r) => Uo.get(r), Qx = (r, e) => {
  const t = {
    $flags$: 0,
    $hostElement$: r,
    $cmpMeta$: e,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  return Po(r, t, e.$listeners$), Uo.set(r, t);
}, gi = (r, e) => e in r, nt = (r, e) => (0, console.error)(r, e), jt = /* @__PURE__ */ new Map(), Xx = [], lt = typeof window < "u" ? window : {}, Re = lt.document || { head: {} }, De = lt.HTMLElement || class {
}, ye = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (r) => r(),
  raf: (r) => requestAnimationFrame(r),
  ael: (r, e, t, s) => r.addEventListener(e, t, s),
  rel: (r, e, t, s) => r.removeEventListener(e, t, s),
  ce: (r, e) => new CustomEvent(r, e)
}, e3 = /* @__PURE__ */ (() => {
  let r = !1;
  try {
    Re.addEventListener("e", null, Object.defineProperty({}, "passive", {
      get() {
        r = !0;
      }
    }));
  } catch {
  }
  return r;
})(), r3 = (r) => Promise.resolve(r), t3 = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), vi = [], Go = [], s3 = (r, e) => (t) => {
  r.push(t), Ms || (Ms = !0, e && ye.$flags$ & 4 ? a3(Bs) : ye.raf(Bs));
}, hi = (r) => {
  for (let e = 0; e < r.length; e++)
    try {
      r[e](performance.now());
    } catch (t) {
      nt(t);
    }
  r.length = 0;
}, Bs = () => {
  hi(vi), hi(Go), (Ms = vi.length > 0) && ye.raf(Bs);
}, a3 = (r) => r3().then(r), i3 = /* @__PURE__ */ s3(Go, !0);
var Ve = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ne(r, e, t) {
  return t = {
    path: e,
    exports: {},
    require: function(s, a) {
      return o3();
    }
  }, r(t, t.exports), t.exports;
}
function o3() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "circle-check", a = 512, i = 512, o = [61533, "check-circle"], l = "f058", p = "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faCircleCheck = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "triangle-exclamation", a = 512, i = 512, o = [9888, "exclamation-triangle", "warning"], l = "f071", p = "M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faTriangleExclamation = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "circle-xmark", a = 512, i = 512, o = [61532, "times-circle", "xmark-circle"], l = "f057", p = "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM175 208.1L222.1 255.1L175 303C165.7 312.4 165.7 327.6 175 336.1C184.4 346.3 199.6 346.3 208.1 336.1L255.1 289.9L303 336.1C312.4 346.3 327.6 346.3 336.1 336.1C346.3 327.6 346.3 312.4 336.1 303L289.9 255.1L336.1 208.1C346.3 199.6 346.3 184.4 336.1 175C327.6 165.7 312.4 165.7 303 175L255.1 222.1L208.1 175C199.6 165.7 184.4 165.7 175 175C165.7 184.4 165.7 199.6 175 208.1V208.1z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faCircleXmark = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "circle-info", a = 512, i = 512, o = ["info-circle"], l = "f05a", p = "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faCircleInfo = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
var Ho = ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "xmark", a = 320, i = 512, o = [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], l = "f00d", p = "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faXmark = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
}), n3 = ne(function(r) {
  /*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  */
  (function() {
    var e = {}.hasOwnProperty;
    function t() {
      for (var s = [], a = 0; a < arguments.length; a++) {
        var i = arguments[a];
        if (i) {
          var o = typeof i;
          if (o === "string" || o === "number")
            s.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var l = t.apply(null, i);
              l && s.push(l);
            }
          } else if (o === "object") {
            if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
              s.push(i.toString());
              continue;
            }
            for (var p in i)
              e.call(i, p) && i[p] && s.push(p);
          }
        }
      }
      return s.join(" ");
    }
    r.exports ? (t.default = t, r.exports = t) : window.classNames = t;
  })();
});
const ra = (r) => r.includes("--color") || r.includes("--skp") ? `var(${r})` : r, l3 = () => String(Math.ceil(Date.now() * Math.random())), p3 = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i, Me = (r, e) => (...t) => (n3(t).split(" ").map((s) => s === "" ? r : r + "-" + s).join(" ") + " " + (e || "")).trim(), Lt = (r) => (e) => (...t) => Me(r, e)(t), c3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-icon,.skp-icon-solution{}.skp-icon-root,.skp-icon-solution-root{display:flex;transform-origin:center center}.skp-icon-small,.skp-icon-solution-small{height:var(--skp-icon-small-height)}.skp-icon-medium,.skp-icon-solution-medium{height:var(--skp-icon-medium-height)}.skp-icon-large,.skp-icon-solution-large{height:var(--skp-icon-large-height)}.skp-icon-xlarge,.skp-icon-solution-xlarge{height:var(--skp-icon-xlarge-height)}.skp-icon-xxlarge,.skp-icon-solution-xxlarge{height:var(--skp-icon-xxlarge-height)}.skp-icon-rotate-0,.skp-icon-solution-rotate-0{transform:rotate(0deg)}.skp-icon-rotate-90,.skp-icon-solution-rotate-90{transform:rotate(90deg)}.skp-icon-rotate-180,.skp-icon-solution-rotate-180{transform:rotate(180deg)}.skp-icon-rotate-270,.skp-icon-solution-rotate-270{transform:rotate(270deg)}.skp-icon-flip-horizontal,.skp-icon-solution-flip-horizontal{transform:scale(-1, 1)}.skp-icon-flip-vertical,.skp-icon-solution-flip-vertical{transform:scale(1, -1)}.skp-icon-flip-both,.skp-icon-solution-flip-both{transform:scale(-1, -1)}', u3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.color = "--skp-color-black", this.cursor = "auto", this.flip = void 0, this.icon = void 0, this.rotate = 0, this.size = "medium", this.skpClass = "", this.skpTitle = null;
  }
  render() {
    var e;
    const t = {
      class: Me("skp-icon", this.skpClass)("root", `rotate-${this.rotate}`, this.size, {
        [`flip-${this.flip}`]: this.flip
      }),
      style: { cursor: this.cursor }
    };
    return U("svg", Object.assign({ role: "img", viewBox: `0 0 ${this.icon.icon[0]} ${this.icon.icon[1]}` }, t), U("title", null, (e = this.skpTitle) !== null && e !== void 0 ? e : `${this.icon.prefix}-${this.icon.iconName}`), [this.icon.icon[4]].flat(1 / 0).map((s) => U("path", { fill: ra(this.color), d: s })));
  }
  static get style() {
    return c3;
  }
}, [0, "skp-icon", {
  color: [1],
  cursor: [1],
  flip: [1],
  icon: [16],
  rotate: [2],
  size: [1],
  skpClass: [1, "skp-class"],
  skpTitle: [1, "skp-title"]
}]);
function ar() {
  if (typeof customElements > "u")
    return;
  ["skp-icon"].forEach((e) => {
    switch (e) {
      case "skp-icon":
        customElements.get(e) || customElements.define(e, u3);
        break;
    }
  });
}
const f3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-text-root{margin:0}.skp-text-root.skp-text-strong{font-weight:var(--skp-font-weight-bold)}.skp-text-root.skp-text-xxsmall{font-size:var(--skp-xxsmall-size);line-height:12px}.skp-text-root.skp-text-xsmall{font-size:var(--skp-xsmall-size);line-height:14px}.skp-text-root.skp-text-small{font-size:var(--skp-small-size);line-height:17px}.skp-text-root.skp-text-medium{font-size:var(--skp-medium-size);line-height:19px}.skp-text-root.skp-text-large{font-size:var(--skp-large-size);line-height:22px}.skp-text-root.skp-text-xlarge{font-size:var(--skp-xlarge-size);line-height:24px}', k3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.bold = !1, this.color = "--skp-color-neutral-900", this.italic = !1, this.skpClass = "", this.size = "medium", this.text = void 0, this.textTransform = "none", this.underlined = !1, this.userSelect = "unset";
  }
  render() {
    const e = Object.assign({ textDecoration: this.underlined ? "underline" : "unset", textTransform: this.textTransform || "unset", userSelect: this.userSelect, display: "block" }, this.color && { color: ra(this.color) }), t = Me("skp-text", this.skpClass)("root", this.size);
    return ((i, o) => o ? U("i", null, i) : i)(((i, o) => o ? U("strong", { class: `${t} skp-text-strong`, style: e }, i) : U("p", { class: t, style: e }, i))(this.text, this.bold), this.italic);
  }
  static get style() {
    return f3;
  }
}, [0, "skp-text", {
  bold: [4],
  color: [1],
  italic: [4],
  skpClass: [1, "skp-class"],
  size: [1],
  text: [1],
  textTransform: [1, "text-transform"],
  underlined: [4],
  userSelect: [1, "user-select"]
}]);
function $r() {
  if (typeof customElements > "u")
    return;
  ["skp-text"].forEach((e) => {
    switch (e) {
      case "skp-text":
        customElements.get(e) || customElements.define(e, k3);
        break;
    }
  });
}
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "image-user", a = 512, i = 512, o = [], l = "e1b8", p = "M448 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V96C512 60.65 483.3 32 448 32zM256 128c35.35 0 64 28.66 64 64s-28.65 64-64 64s-64-28.66-64-64S220.7 128 256 128zM352 384H160c-8.836 0-16-7.164-16-16c0-44.18 35.82-80 80-80h64c44.18 0 80 35.82 80 80C368 376.8 360.8 384 352 384z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faImageUser = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "angle-right", a = 256, i = 512, o = [8250], l = "f105", p = "M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faAngleRight = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
var ta = ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "check", a = 448, i = 512, o = [10004, 10003], l = "f00c", p = "M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faCheck = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
const d3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-loader-root{display:inline-block;position:relative;width:18px;height:18px}.skp-loader-root div{box-sizing:border-box;display:block;position:absolute;width:18px;height:18px;border:2px solid gold;border-radius:50%;animation:skp-loader-animation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;border-color:gold transparent transparent}.skp-loader-root div:nth-child(1){animation-delay:-0.45s}.skp-loader-root div:nth-child(2){animation-delay:-0.3s}.skp-loader-root div:nth-child(3){animation-delay:-0.15s}.skp-loader-root.skp-loader-primary div{border:2px solid var(--skp-color-primary-500);border-color:var(--skp-color-primary-500) transparent transparent}.skp-loader-root.skp-loader-secondary div{border:2px solid var(--skp-color-neutral-700);border-color:var(--skp-color-neutral-700) transparent transparent}.skp-loader-root.skp-loader-tertiary div{border:2px solid var(--skp-color-white);border-color:var(--skp-color-white) transparent transparent}.skp-loader-root.skp-loader-small{width:14px;height:14px}.skp-loader-root.skp-loader-small div{width:14px;height:14px}.skp-loader-root.skp-loader-large{width:22px;height:22px}.skp-loader-root.skp-loader-large div{width:22px;height:22px}@keyframes skp-loader-animation{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}', m3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.size = "medium", this.type = "primary";
  }
  render() {
    return U(it, { class: Me("skp-loader")("root", this.type, this.size) }, U("div", null), U("div", null), U("div", null), U("div", null));
  }
  static get style() {
    return d3;
  }
}, [0, "skp-loader", {
  size: [1],
  type: [1]
}]);
function qo() {
  if (typeof customElements > "u")
    return;
  ["skp-loader"].forEach((e) => {
    switch (e) {
      case "skp-loader":
        customElements.get(e) || customElements.define(e, m3);
        break;
    }
  });
}
const g3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-button-root{position:relative;border-radius:var(--skp-small-radius);border:none;padding:12px 18px;height:var(--skp-button-medium-height);outline:none;transition:var(--skp-transition);cursor:pointer;display:flex;align-items:center;justify-content:center;}.skp-button-root.skp-button-small{padding:8px 12px;height:var(--skp-button-small-height)}.skp-button-root.skp-button-small.skp-button-squared{width:var(--skp-button-small-height)}.skp-button-root.skp-button-medium.skp-button-squared{width:var(--skp-button-medium-height)}.skp-button-root.skp-button-large{padding:14px 20px;height:var(--skp-button-large-height)}.skp-button-root.skp-button-large.skp-button-squared{width:var(--skp-button-large-height)}.skp-button-root.skp-button-primary{background-color:var(--skp-color-primary-500)}.skp-button-root.skp-button-primary:hover{background-color:var(--skp-color-primary-400)}.skp-button-root.skp-button-primary:focus-visible{background-color:var(--skp-color-primary-400);outline:solid 4px var(--skp-color-primary-100)}.skp-button-root.skp-button-primary:active,.skp-button-root.skp-button-primary.skp-button-loading{background-color:var(--skp-color-primary-500)}.skp-button-root.skp-button-primary.skp-button-disabled{background-color:var(--skp-color-neutral-100)}.skp-button-root.skp-button-secondary{background-color:var(--skp-color-white);border:1px solid var(--skp-color-neutral-300)}.skp-button-root.skp-button-secondary:hover{background-color:var(--skp-color-neutral-50);border:1px solid var(--skp-color-neutral-500)}.skp-button-root.skp-button-secondary:focus-visible{outline:solid 4px var(--skp-color-neutral-100)}.skp-button-root.skp-button-secondary:active,.skp-button-root.skp-button-secondary.skp-button-loading{background-color:var(--skp-color-neutral-50);border:1px solid var(--skp-color-neutral-300)}.skp-button-root.skp-button-secondary.skp-button-disabled{background-color:var(--skp-color-neutral-100)}.skp-button-root.skp-button-tertiary{background-color:var(--skp-color-neutral-900)}.skp-button-root.skp-button-tertiary .skp-text-root{color:var(--skp-color-white)}.skp-button-root.skp-button-tertiary:hover{background-color:var(--skp-color-neutral-700)}.skp-button-root.skp-button-tertiary:focus-visible{outline:solid 4px var(--skp-color-neutral-200)}.skp-button-root.skp-button-tertiary:active,.skp-button-root.skp-button-tertiary.skp-button-loading{background-color:var(--skp-color-neutral-900)}.skp-button-root.skp-button-tertiary.skp-button-disabled{background-color:var(--skp-color-neutral-100)}.skp-button-root.skp-button-outline{background-color:var(--skp-color-white);border:1px solid var(--skp-color-primary-500)}.skp-button-root.skp-button-outline:hover{background-color:var(--skp-color-primary-50)}.skp-button-root.skp-button-outline:focus-visible{outline:solid 4px var(--skp-color-primary-100)}.skp-button-root.skp-button-outline:active,.skp-button-root.skp-button-outline.skp-button-loading{background-color:var(--skp-color-primary-500)}.skp-button-root.skp-button-outline:active .skp-text-root,.skp-button-root.skp-button-outline.skp-button-loading .skp-text-root{color:var(--skp-color-white) !important}.skp-button-root.skp-button-outline:active .hydrated svg path,.skp-button-root.skp-button-outline.skp-button-loading .hydrated svg path{fill:white}.skp-button-root.skp-button-outline.skp-button-disabled{background-color:var(--skp-color-neutral-100)}.skp-button-root.skp-button-positive{background-color:var(--skp-color-success-50);border:1px solid transparent}.skp-button-root.skp-button-positive:hover{background-color:var(--skp-color-success-100)}.skp-button-root.skp-button-positive:focus-visible{outline:solid 4px var(--skp-color-success-200)}.skp-button-root.skp-button-positive:active,.skp-button-root.skp-button-positive.skp-button-loading{background-color:var(--skp-color-success-500)}.skp-button-root.skp-button-positive:active .skp-text-root,.skp-button-root.skp-button-positive.skp-button-loading .skp-text-root{color:var(--skp-color-white) !important}.skp-button-root.skp-button-positive:active .hydrated svg path,.skp-button-root.skp-button-positive.skp-button-loading .hydrated svg path{fill:var(--skp-color-success-500)}.skp-button-root.skp-button-positive.skp-button-disabled{background-color:var(--skp-color-neutral-100)}.skp-button-root.skp-button-negative{background-color:var(--skp-color-error-50);border:1px solid transparent}.skp-button-root.skp-button-negative:hover{background-color:var(--skp-color-error-100)}.skp-button-root.skp-button-negative:focus-visible{outline:solid 4px var(--skp-color-error-200)}.skp-button-root.skp-button-negative:active,.skp-button-root.skp-button-negative.skp-button-loading{background-color:var(--skp-color-error-500)}.skp-button-root.skp-button-negative:active .skp-text-root,.skp-button-root.skp-button-negative.skp-button-loading .skp-text-root{color:var(--skp-color-white) !important}.skp-button-root.skp-button-negative:active .hydrated svg path,.skp-button-root.skp-button-negative.skp-button-loading .hydrated svg path{fill:var(--skp-color-error-500)}.skp-button-root.skp-button-negative.skp-button-disabled{background-color:var(--skp-color-neutral-100)}.skp-button-root.skp-button-icon{background-color:transparent}.skp-button-root.skp-button-icon:hover:not(:disabled){background-color:var(--skp-color-neutral-50)}.skp-button-root.skp-button-icon:focus-visible:not(:disabled){outline:solid 4px var(--skp-color-neutral-100);background-color:var(--skp-color-neutral-50)}.skp-button-root.skp-button-icon:active:not(:disabled){background-color:var(--skp-color-neutral-200)}.skp-button-root.skp-button-icon:disabled{cursor:not-allowed}.skp-button-root.skp-button-loading{cursor:not-allowed}.skp-button-root .skp-text-root{white-space:nowrap}.skp-button-root .skp-button-content{display:flex;align-items:center;justify-content:center;gap:var(--skp-size-2)}.skp-button-root .skp-button-content.skp-button-content-hidden{visibility:hidden}.skp-button-root .skp-button-content.skp-button-icon-right{flex-direction:row-reverse}.skp-button-root .skp-button-loader-container{position:absolute}.skp-button-root.skp-button-disabled{background-color:var(--skp-color-neutral-100);border:solid 1px var(--skp-color-neutral-100);cursor:not-allowed}.skp-button-root.skp-button-disabled .skp-text-root{color:var(--skp-color-neutral-500)}.skp-button-root.skp-button-disabled:hover,.skp-button-root.skp-button-disabled:active{background-color:var(--skp-color-neutral-100);border:solid 1px var(--skp-color-neutral-100)}.skp-button-root.skp-button-disabled:hover .skp-text-root,.skp-button-root.skp-button-disabled:active .skp-text-root{color:var(--skp-color-neutral-500) !important}.skp-button-root.skp-button-disabled:hover .hydrated svg path,.skp-button-root.skp-button-disabled:active .hydrated svg path{fill:var(--skp-color-neutral-500)}', v3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.skpClick = sr(this, "skpClick", 7), this.color = "#000", this.disabled = !1, this.icon = void 0, this.loading = !1, this.name = `button-${Math.ceil(Date.now() * Math.random())}`, this.size = "medium", this.skpClass = "", this.text = void 0, this.type = "primary", this.width = "auto";
  }
  handleClick() {
    this.skpClick.emit();
  }
  render() {
    var e, t, s;
    const a = {
      primary: "--skp-color-white",
      tertiary: "--skp-color-white",
      secondary: "--skp-color-neutral-700",
      outline: "--skp-color-primary-500",
      positive: "--skp-color-success-500",
      negative: "--skp-color-error-500",
      icon: this.color
    }, i = a[this.type] || "--skp-color-white", o = {
      positive: ta.faCheck,
      negative: Ho.faXmark
    };
    return U("button", { type: "button", "aria-label": this.name, class: Me("skp-button", this.skpClass)("root", this.size, this.type, {
      squared: this.icon && !this.text,
      loading: this.loading,
      disabled: this.disabled && this.type !== "icon"
    }), disabled: this.disabled || this.loading, "aria-disabled": (e = this.disabled || this.loading) === null || e === void 0 ? void 0 : e.toString(), style: {
      width: this.width === "auto" ? "fit-content" : "100%",
      color: i
    }, onClick: this.handleClick.bind(this) }, U("div", { class: Me("skp-button")("content", `icon-${(s = (t = this.icon) === null || t === void 0 ? void 0 : t.position) !== null && s !== void 0 ? s : "left"}`, { "content-hidden": this.loading }) }, !!this.icon && U("skp-icon", { icon: o[this.type] || this.icon, size: this.size, color: this.disabled ? "--skp-color-neutral-500" : this.type === "icon" ? this.color : i, cursor: this.disabled ? "not-allowed" : "pointer" }), !!this.text && this.type !== "icon" && U("skp-text", { size: this.size === "small" ? "xsmall" : this.size, text: this.text, bold: !0, color: this.disabled ? "--skp-color-neutral-500" : a[this.type] })), this.loading && U("div", { class: "skp-button-loader-container" }, U("skp-loader", { type: ["secondary", "icon"].includes(this.type) ? "secondary" : "tertiary", size: this.size })));
  }
  static get style() {
    return g3;
  }
}, [0, "skp-button", {
  color: [1],
  disabled: [4],
  icon: [16],
  loading: [4],
  name: [513],
  size: [1],
  skpClass: [1, "skp-class"],
  text: [1],
  type: [1],
  width: [1]
}]);
function h3() {
  if (typeof customElements > "u")
    return;
  ["skp-button", "skp-icon", "skp-loader", "skp-text"].forEach((e) => {
    switch (e) {
      case "skp-button":
        customElements.get(e) || customElements.define(e, v3);
        break;
      case "skp-icon":
        customElements.get(e) || ar();
        break;
      case "skp-loader":
        customElements.get(e) || qo();
        break;
      case "skp-text":
        customElements.get(e) || $r();
        break;
    }
  });
}
const x3 = h3, b3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-button-icon-small{height:var(--skp-button-small-height);width:var(--skp-button-small-height)}.skp-button-icon-medium{width:var(--skp-button-medium-height);height:var(--skp-button-medium-height)}.skp-button-icon-large{height:var(--skp-button-large-height);width:var(--skp-button-large-height)}.skp-button-icon-xlarge{height:var(--skp-button-xlarge-height);width:var(--skp-button-xlarge-height)}.skp-button-icon-xxlarge{height:var(--skp-button-xxlarge-height);width:var(--skp-button-xxlarge-height)}.skp-button-icon-root{border:1px solid transparent;background-color:unset;outline:none;transition:var(--skp-transition);cursor:pointer;border-radius:var(--skp-small-radius);display:flex;align-items:center;justify-content:center;position:relative}.skp-button-icon-root:active,.skp-button-icon-root:focus{outline:none;border:1px solid var(--skp-color-neutral-100)}.skp-button-icon-root:hover{background-color:var(--skp-color-neutral-100)}.skp-button-icon-root.skp-button-icon-disabled{cursor:not-allowed}.skp-button-icon-root.skp-button-icon-disabled svg path{fill:var(--skp-color-neutral-500)}.skp-button-icon-root.skp-button-icon-positive{background-color:var(--skp-color-success-50);border:1px solid transparent}.skp-button-icon-root.skp-button-icon-positive:hover{background-color:var(--skp-color-success-100)}.skp-button-icon-root.skp-button-icon-positive:active{border:1px solid var(--skp-color-success-500)}.skp-button-icon-root.skp-button-icon-positive svg path{fill:var(--skp-color-success-500)}.skp-button-icon-root.skp-button-icon-positive.skp-button-icon-disabled{cursor:not-allowed;background-color:var(--skp-color-neutral-100);border:none}.skp-button-icon-root.skp-button-icon-positive.skp-button-icon-disabled svg path{fill:var(--skp-color-neutral-500)}.skp-button-icon-root.skp-button-icon-negative{background-color:var(--skp-color-error-50);border:1px solid transparent}.skp-button-icon-root.skp-button-icon-negative:hover{background-color:var(--skp-color-error-100)}.skp-button-icon-root.skp-button-icon-negative:active{border:1px solid var(--skp-color-error-500)}.skp-button-icon-root.skp-button-icon-negative svg path{fill:var(--skp-color-error-500)}.skp-button-icon-root.skp-button-icon-negative.skp-button-icon-disabled{cursor:not-allowed;background-color:var(--skp-color-neutral-100);border:none}.skp-button-icon-root.skp-button-icon-negative.skp-button-icon-disabled svg path{fill:var(--skp-color-neutral-500)}', y3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.skpClick = sr(this, "skpClick", 7), this.color = "#000", this.disabled = !1, this.icon = void 0, this.loading = !1, this.name = `button-icon-${Math.ceil(Date.now() * Math.random())}`, this.size = "medium", this.skpClass = "", this.type = void 0;
  }
  handleClick(e) {
    e.stopPropagation(), this.skpClick.emit();
  }
  render() {
    const e = {
      positive: ta.faCheck,
      negative: Ho.faXmark
    };
    return !!this.icon && U("button", { type: "button", "aria-label": this.name, class: Me("skp-button-icon", this.skpClass)("root", this.size, this.type, {
      disabled: this.disabled || this.loading
    }), disabled: this.disabled || this.loading, onClick: this.disabled || this.loading ? () => {
    } : this.handleClick.bind(this) }, U("skp-icon", { color: this.color, icon: e[this.type] || this.icon, size: this.size, cursor: this.disabled ? "not-allowed" : "pointer" }));
  }
  static get style() {
    return b3;
  }
}, [0, "skp-button-icon", {
  color: [1],
  disabled: [4],
  icon: [16],
  loading: [4],
  name: [513],
  size: [1],
  skpClass: [1, "skp-class"],
  type: [1]
}]);
function w3() {
  if (typeof customElements > "u")
    return;
  ["skp-button-icon", "skp-icon"].forEach((e) => {
    switch (e) {
      case "skp-button-icon":
        customElements.get(e) || customElements.define(e, y3);
        break;
      case "skp-icon":
        customElements.get(e) || ar();
        break;
    }
  });
}
const z3 = w3;
var F3 = ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fal", s = "check", a = 448, i = 512, o = [10004, 10003], l = "f00c", p = "M443.3 100.7C449.6 106.9 449.6 117.1 443.3 123.3L171.3 395.3C165.1 401.6 154.9 401.6 148.7 395.3L4.686 251.3C-1.562 245.1-1.562 234.9 4.686 228.7C10.93 222.4 21.06 222.4 27.31 228.7L160 361.4L420.7 100.7C426.9 94.44 437.1 94.44 443.3 100.7H443.3z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faCheck = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
}), E3 = ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fal", s = "minus", a = 448, i = 512, o = [8722, 10134, 8211, "subtract"], l = "f068", p = "M432 256C432 264.8 424.8 272 416 272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h384C424.8 240 432 247.2 432 256z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faMinus = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
const j3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-checkbox-root{position:relative;display:flex;justify-content:flex-start;align-items:flex-start;outline:none}.skp-checkbox-root:hover .skp-checkbox-element{border-color:var(--skp-color-primary-500);cursor:pointer}.skp-checkbox-root:hover .skp-checkbox-label{color:var(--skp-color-primary-500);cursor:pointer}.skp-checkbox-root:not([data-disabled]):focus-visible .skp-checkbox-element{outline:2px solid var(--skp-color-primary-100);border-color:var(--skp-color-primary-500)}.skp-checkbox-root .skp-checkbox-input{position:absolute;opacity:0;visibility:hidden;width:1px;height:1px}.skp-checkbox-root .skp-checkbox-input:checked~.skp-checkbox-element{background:var(--skp-color-primary-500);border-color:var(--skp-color-primary-500)}.skp-checkbox-root .skp-checkbox-input-indeterminate~.skp-checkbox-element{background:var(--skp-color-primary-500);border-color:var(--skp-color-primary-500)}.skp-checkbox-root .skp-checkbox-input:disabled~.skp-checkbox-element{background:var(--skp-color-neutral-50);border-color:var(--skp-color-neutral-200);pointer-events:none}.skp-checkbox-root .skp-checkbox-input:disabled~.skp-checkbox-label{color:black;cursor:not-allowed}.skp-checkbox-root .skp-checkbox-input:disabled~.skp-checkbox-element path{stroke:var(--skp-color-neutral-200)}.skp-checkbox-root .skp-checkbox-element{display:inline-flex;justify-content:center;align-items:center;border:2px solid var(--skp-color-neutral-400);border-radius:2px}.skp-checkbox-root .skp-checkbox-element path{stroke-width:60;stroke:var(--skp-color-white)}.skp-checkbox-root .skp-checkbox-element:active,.skp-checkbox-root .skp-checkbox-element:focus{outline:2px solid var(--skp-color-primary-100)}.skp-checkbox-root .skp-checkbox-element-small{min-width:14px;width:14px;height:14px}.skp-checkbox-root .skp-checkbox-element-large{min-width:18px;width:18px;height:18px}.skp-checkbox-root .skp-checkbox-label{margin-left:var(--skp-size-2)}.skp-checkbox-root.skp-checkbox-outlined{align-items:center;justify-content:center;width:100%;background:var(--skp-color-white);border:1px solid var(--skp-color-neutral-400);border-radius:var(--skp-small-radius);outline:none;cursor:pointer;width:max-content}.skp-checkbox-root.skp-checkbox-outlined .skp-checkbox-label{margin:0;padding:8px 12px}.skp-checkbox-root.skp-checkbox-outlined .skp-checkbox-input{display:none}.skp-checkbox-root.skp-checkbox-outlined .skp-checkbox-element{display:none}.skp-checkbox-root.skp-checkbox-outlined:hover{border-color:var(--skp-color-primary-500);background-color:var(--skp-color-white)}.skp-checkbox-root.skp-checkbox-outlined:hover .skp-text-root{color:var(--skp-color-primary-500)}.skp-checkbox-root.skp-checkbox-outlined:hover[data-disabled]{outline:none}.skp-checkbox-root.skp-checkbox-outlined[data-checked]{border-color:var(--skp-color-primary-500);background-color:var(--skp-color-primary-50)}.skp-checkbox-root.skp-checkbox-outlined[data-checked] .skp-text-root{color:var(--skp-color-primary-500)}.skp-checkbox-root.skp-checkbox-outlined:focus-visible{border-color:var(--skp-color-primary-500);outline:4px solid var(--skp-color-primary-100)}.skp-checkbox-root.skp-checkbox-outlined:focus-visible .skp-text-root{color:var(--skp-color-primary-500)}.skp-checkbox-root.skp-checkbox-outlined[data-disabled]{background-color:var(--skp-color-neutral-50);border-color:var(--skp-color-neutral-200);color:var(--skp-color-neutral-200);outline-color:var(--skp-color-neutral-200);cursor:not-allowed}.skp-checkbox-root.skp-checkbox-outlined[data-disabled] .skp-text-root{color:var(--skp-color-neutral-200)}.skp-checkbox-root.skp-checkbox-outlined-small{height:33px}.skp-checkbox-root.skp-checkbox-outlined-large{height:42px}', C3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.skpCheck = sr(this, "skpCheck", 7), this.checked = !1, this.disabled = !1, this.indeterminate = !1, this.isGroup = !1, this.label = void 0, this.size = "small", this.value = void 0;
  }
  onIndeterminate(e) {
    this.handleIndeterminate(e);
  }
  componentWillLoad() {
    this.handleIndeterminate(this.indeterminate);
  }
  handleChange() {
    this.disabled || (this.indeterminate && (this.indeterminate = !1), this.isGroup || (this.checked = !this.checked), this.skpCheck.emit({ value: this.value, checked: this.checked }));
  }
  handleIndeterminate(e) {
    e && this.checked && (this.checked = !1);
  }
  handleKeyDown(e) {
    e.code === "Space" && (e.preventDefault(), this.handleChange());
  }
  render() {
    const e = this.disabled ? "--skp-color-neutral-200" : "--skp-color-white", t = this.disabled ? "not-allowed" : "pointer", s = Lt("skp-checkbox");
    return U("label", { class: s()("root"), "data-checked": this.checked, "data-disabled": this.disabled, tabIndex: this.disabled ? -1 : 0, onKeyDown: this.handleKeyDown.bind(this) }, U("input", { type: "checkbox", class: s()("input", {
      "input-indeterminate": this.indeterminate
    }), disabled: this.disabled, checked: this.checked, value: this.value, onChange: this.handleChange.bind(this) }), U("div", { class: s()("element", `element-${this.size}`) }, this.checked && U("skp-icon", { color: e, size: "small", icon: F3.faCheck, cursor: t }), this.indeterminate && U("skp-icon", { color: e, size: "small", icon: E3.faMinus, cursor: t })), U("div", { class: "skp-checkbox-label" }, U("skp-text", { size: this.size === "large" ? "medium" : "small", text: this.label })));
  }
  static get watchers() {
    return {
      indeterminate: ["onIndeterminate"]
    };
  }
  static get style() {
    return j3;
  }
}, [0, "skp-checkbox", {
  checked: [1540],
  disabled: [4],
  indeterminate: [1540],
  isGroup: [4, "is-group"],
  label: [1],
  size: [1],
  value: [513]
}, void 0, {
  indeterminate: ["onIndeterminate"]
}]);
function sa() {
  if (typeof customElements > "u")
    return;
  ["skp-checkbox", "skp-icon", "skp-text"].forEach((e) => {
    switch (e) {
      case "skp-checkbox":
        customElements.get(e) || customElements.define(e, C3);
        break;
      case "skp-icon":
        customElements.get(e) || ar();
        break;
      case "skp-text":
        customElements.get(e) || $r();
        break;
    }
  });
}
var S3 = ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "angle-down", a = 384, i = 512, o = [8964], l = "f107", p = "M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faAngleDown = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
const A3 = {
  small: 186,
  medium: 228,
  large: 268
}, D3 = (r, e) => window.innerHeight - r < A3[e] ? "up" : "down", _3 = (r) => {
  if (typeof window < "u" && window.__SKP_ASSET_PATH__) {
    let e = r;
    return r.startsWith("./") && (e = r.substring(2)), window.__SKP_ASSET_PATH__.endsWith("/") || (e = "/" + e), window.__SKP_ASSET_PATH__ + e;
  }
  return gx(r);
}, O3 = ["AC", "AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "EU", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TA", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "XK", "YE", "YT", "ZA", "ZM", "ZW"];
var $3 = ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fal", s = "globe", a = 512, i = 512, o = [127760], l = "f0ac", p = "M256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM256 480C272.7 480 296.4 465.6 317.9 422.7C327.8 402.9 336.1 378.1 341.1 352H170C175.9 378.1 184.2 402.9 194.1 422.7C215.6 465.6 239.3 480 256 480V480zM164.3 320H347.7C350.5 299.8 352 278.3 352 256C352 233.7 350.5 212.2 347.7 192H164.3C161.5 212.2 160 233.7 160 256C160 278.3 161.5 299.8 164.3 320V320zM341.1 160C336.1 133 327.8 109.1 317.9 89.29C296.4 46.37 272.7 32 256 32C239.3 32 215.6 46.37 194.1 89.29C184.2 109.1 175.9 133 170 160H341.1zM379.1 192C382.6 212.5 384 233.9 384 256C384 278.1 382.6 299.5 379.1 320H470.7C476.8 299.7 480 278.2 480 256C480 233.8 476.8 212.3 470.7 192H379.1zM327.5 43.66C348.5 71.99 365.1 112.4 374.7 160H458.4C432.6 105.5 385.3 63.12 327.5 43.66V43.66zM184.5 43.66C126.7 63.12 79.44 105.5 53.56 160H137.3C146.9 112.4 163.5 71.99 184.5 43.66V43.66zM32 256C32 278.2 35.24 299.7 41.28 320H132C129.4 299.5 128 278.1 128 256C128 233.9 129.4 212.5 132 192H41.28C35.24 212.3 32 233.8 32 256V256zM458.4 352H374.7C365.1 399.6 348.5 440 327.5 468.3C385.3 448.9 432.6 406.5 458.4 352zM137.3 352H53.56C79.44 406.5 126.7 448.9 184.5 468.3C163.5 440 146.9 399.6 137.3 352V352z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faGlobe = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
const M3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-flag-root{display:flex;justify-content:center;align-items:center;border-radius:50%;overflow:hidden}.skp-flag-root img{width:100%}.skp-flag-root.skp-flag-xsmall,.skp-flag-root.skp-flag-xsmall .skp-icon-root{width:var(--skp-size-4);height:var(--skp-size-4)}.skp-flag-root.skp-flag-small,.skp-flag-root.skp-flag-small .skp-icon-root{width:var(--skp-size-6);height:var(--skp-size-6)}.skp-flag-root.skp-flag-medium,.skp-flag-root.skp-flag-medium .skp-icon-root{width:var(--skp-size-9);height:var(--skp-size-9)}.skp-flag-root.skp-flag-large,.skp-flag-root.skp-flag-large .skp-icon-root{width:42px;height:42px}.skp-flag-root.skp-flag-xlarge,.skp-flag-root.skp-flag-xlarge .skp-icon-root{width:52px;height:52px}', B3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.country = void 0, this.size = "medium", this.skpClass = "";
  }
  render() {
    const e = this.country && O3.includes(this.country) ? _3(`./assets/${this.country.toLowerCase()}.svg`) : null;
    return U("div", { class: Me("skp-flag", this.skpClass)("root", this.size) }, e ? U("img", { alt: `${this.country}-flag`, src: e, loading: "lazy" }) : U("skp-icon", { icon: $3.faGlobe, skpClass: `skp-flag-${this.size}`, color: "--skp-color-neutral-200" }));
  }
  static get assetsDirs() {
    return ["assets"];
  }
  static get style() {
    return M3;
  }
}, [0, "skp-flag", {
  country: [513],
  size: [1],
  skpClass: [1, "skp-class"]
}]);
function aa() {
  if (typeof customElements > "u")
    return;
  ["skp-flag", "skp-icon"].forEach((e) => {
    switch (e) {
      case "skp-flag":
        customElements.get(e) || customElements.define(e, B3);
        break;
      case "skp-icon":
        customElements.get(e) || ar();
        break;
    }
  });
}
var Ko = ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "camera-slash", a = 640, i = 512, o = [], l = "e0d9", p = "M154.8 96H202.7L213.1 64.82C219.6 45.22 237.9 32 258.6 32H381.4C402.1 32 420.4 45.22 426.9 64.82L437.3 96H512C547.3 96 576 124.7 576 160V416C576 419.3 575.8 422.5 575.3 425.6L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L154.8 96zM285.4 198.4L415.2 300.2C415.7 296.2 416 292.1 416 288C416 234.1 373 192 320 192C307.8 192 296.2 194.3 285.4 198.4V198.4zM320 384C332.9 384 345.2 381.5 356.4 376.8L487.4 480H128C92.66 480 64 451.3 64 416V160C64 155.7 64.43 151.5 65.24 147.4L225.1 273.4C224.4 278.1 224 283 224 288C224 341 266.1 384 320 384V384z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faCameraSlash = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
const T3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-dropdown-list-item-root{position:relative;display:flex;justify-content:space-between;align-items:center;list-style:none;padding-left:12px;padding-right:12px}.skp-dropdown-list-item-root.skp-dropdown-list-item-small{height:var(--skp-size-9)}.skp-dropdown-list-item-root.skp-dropdown-list-item-medium{height:var(--skp-size-11)}.skp-dropdown-list-item-root.skp-dropdown-list-item-large{height:var(--skp-size-13)}.skp-dropdown-list-item-root:hover{background:var(--skp-color-neutral-50);cursor:pointer}.skp-dropdown-list-item-root:hover .skp-dropdown-list-item-image{outline:4px solid var(--skp-color-neutral-100)}.skp-dropdown-list-item-root:hover .skp-checkbox-root .skp-checkbox-element{border-color:var(--skp-color-primary-500)}.skp-dropdown-list-item-root:active,.skp-dropdown-list-item-root:focus{outline:none;background:var(--skp-color-neutral-50)}.skp-dropdown-list-item-root:active .skp-checkbox-root .skp-checkbox-element,.skp-dropdown-list-item-root:focus .skp-checkbox-root .skp-checkbox-element{border-color:var(--skp-color-primary-500);outline:2px solid var(--skp-color-primary-100)}.skp-dropdown-list-item-root.skp-dropdown-list-item-disabled{pointer-events:none}.skp-dropdown-list-item-root.skp-dropdown-list-item-disabled .skp-dropdown-list-item-image{opacity:0.4}.skp-dropdown-list-item-root .skp-dropdown-list-item-container{display:flex;align-items:center}.skp-dropdown-list-item-root .skp-dropdown-list-item-container .skp-dropdown-list-item-left-icon{margin-right:var(--skp-size-2)}.skp-dropdown-list-item-root .skp-dropdown-list-item-container .skp-dropdown-list-item-image{margin-right:var(--skp-size-2);width:36px;min-width:36px;height:36px;border-radius:50%;overflow:hidden;background-repeat:no-repeat;background-position:center;background-color:var(--skp-color-white);background-size:cover}.skp-dropdown-list-item-root .skp-dropdown-list-item-container .skp-dropdown-list-item-image.small{min-width:24px;width:24px;height:24px}.skp-dropdown-list-item-root .skp-dropdown-list-item-container .skp-dropdown-list-item-image.empty{display:flex;justify-content:center;align-items:center;background:var(--skp-color-neutral-100)}.skp-dropdown-list-item-root .skp-dropdown-list-item-container .skp-dropdown-list-item-flag{margin-right:8px}.skp-dropdown-list-item-root skp-checkbox{pointer-events:none}', I3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.skpSelect = sr(this, "skpSelect", 7), this.active = !1, this.config = void 0, this.disabled = !1, this.size = "medium", this.skpClass = "", this.text = void 0, this.type = void 0, this.value = void 0;
  }
  handleClick() {
    this.disabled || this.skpSelect.emit(this.value);
  }
  getColor(e) {
    return this.disabled ? "--skp-color-neutral-500" : e;
  }
  render() {
    var e, t, s, a, i, o, l;
    const p = this.size === "small" ? "small" : "medium", g = Lt("skp-dropdown-list-item");
    return U("li", { class: g(this.skpClass)("root", this.size, {
      disabled: this.disabled
    }), role: "option", "aria-selected": this.active, tabIndex: -1, onClick: this.handleClick.bind(this) }, U("div", { class: "skp-dropdown-list-item-container" }, this.type === "icon" && ((e = this.config) === null || e === void 0 ? void 0 : e.icon) && U("skp-icon", Object.assign({ icon: this.config.icon }, (t = this.config) === null || t === void 0 ? void 0 : t.iconProps, { color: this.getColor(), skpClass: "skp-dropdown-list-item-left-icon" })), this.type === "image" && (!((s = this.config) === null || s === void 0) && s.image ? U("div", { class: g()("image", this.size), style: { backgroundImage: `url(${this.config.image})` } }) : U("div", { class: "skp-dropdown-list-item-image empty" }, U("skp-icon", { icon: Ko.faCameraSlash }))), this.type === "checkbox" && U("skp-checkbox", { value: this.value, size: "large", checked: this.active, disabled: this.disabled }), this.type === "flag" && U("skp-flag", Object.assign({}, (a = this.config) === null || a === void 0 ? void 0 : a.flagProps, { size: p, skpClass: "skp-dropdown-list-item-flag" })), U("skp-text", { text: this.text, size: this.size === "large" ? "medium" : "small", color: this.getColor() })), this.active && this.type !== "checkbox" ? U("skp-icon", { icon: ta.faCheck }) : !((i = this.config) === null || i === void 0) && i.rightIcon ? U("skp-icon", Object.assign({ icon: this.config.rightIcon }, this.config.rightIconProps, { color: this.getColor((l = (o = this.config) === null || o === void 0 ? void 0 : o.rightIconProps) === null || l === void 0 ? void 0 : l.color) })) : null);
  }
  static get style() {
    return T3;
  }
}, [0, "skp-dropdown-list-item", {
  active: [4],
  config: [16],
  disabled: [4],
  size: [1],
  skpClass: [1, "skp-class"],
  text: [8],
  type: [1],
  value: [513]
}]);
function Yo() {
  if (typeof customElements > "u")
    return;
  ["skp-dropdown-list-item", "skp-checkbox", "skp-flag", "skp-icon", "skp-text"].forEach((e) => {
    switch (e) {
      case "skp-dropdown-list-item":
        customElements.get(e) || customElements.define(e, I3);
        break;
      case "skp-checkbox":
        customElements.get(e) || sa();
        break;
      case "skp-flag":
        customElements.get(e) || aa();
        break;
      case "skp-icon":
        customElements.get(e) || ar();
        break;
      case "skp-text":
        customElements.get(e) || $r();
        break;
    }
  });
}
const R3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-dropdown-list-root{padding:0;margin:0;background:var(--skp-color-white);box-shadow:0 8px 20px rgba(0, 0, 0, 0.1);border-radius:0 0 4px 4px;overflow:hidden}.skp-dropdown-list-root.skp-dropdown-list-up{box-shadow:0 -6px 15px rgba(0, 0, 0, 0.1);border-radius:4px 4px 0 0}.skp-dropdown-list-root.skp-dropdown-list-down{box-shadow:0 8px 20px rgba(0, 0, 0, 0.1);border-radius:0 0 4px 4px}.skp-dropdown-list-root .skp-dropdown-list-content{overflow:auto}.skp-dropdown-list-root .skp-dropdown-list-content::-webkit-scrollbar{width:10px}.skp-dropdown-list-root .skp-dropdown-list-content::-webkit-scrollbar-track{background:transparent;margin:8px 0}.skp-dropdown-list-root .skp-dropdown-list-content::-webkit-scrollbar-thumb{border-right:4px solid rgba(0, 0, 0, 0);border-left:2px solid rgba(0, 0, 0, 0);background-clip:padding-box;border-radius:999px;background-color:var(--skp-color-neutral-100)}.skp-dropdown-list-root .skp-dropdown-list-content-small{max-height:207px}.skp-dropdown-list-root .skp-dropdown-list-content-medium{max-height:250px}.skp-dropdown-list-root .skp-dropdown-list-content-large{max-height:294px}';
var L3 = function(r, e) {
  var t = {};
  for (var s in r)
    Object.prototype.hasOwnProperty.call(r, s) && e.indexOf(s) < 0 && (t[s] = r[s]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, s = Object.getOwnPropertySymbols(r); a < s.length; a++)
      e.indexOf(s[a]) < 0 && Object.prototype.propertyIsEnumerable.call(r, s[a]) && (t[s[a]] = r[s[a]]);
  return t;
};
const N3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.skpDropdownNavigate = sr(this, "skpDropdownNavigate", 7), this.activeValues = [], this.direction = "down", this.multiselectable = !1, this.name = void 0, this.options = void 0, this.size = "medium", this.skpClass = "";
  }
  handleKeyUp(e) {
    var t, s;
    const a = document.getElementById(this.name);
    switch (e.key) {
      case "ArrowUp":
        const i = e.target.parentElement.previousElementSibling;
        i ? (t = i.querySelector("li")) === null || t === void 0 || t.focus() : a == null || a.focus();
        break;
      case "ArrowDown":
        const o = e.target.parentElement.nextElementSibling;
        o ? (s = o.querySelector("li")) === null || s === void 0 || s.focus() : a == null || a.focus();
        break;
      case "Enter":
      case "Escape":
        this.skpDropdownNavigate.emit(e);
    }
  }
  render() {
    return U("ul", { role: "listbox", "area-multiselectable": this.multiselectable, onKeyUp: this.handleKeyUp.bind(this), class: Me("skp-dropdown-list", this.skpClass)("root", this.direction) }, U("slot", null), U("div", { class: Me("skp-dropdown-list")("content", `content-${this.size}`), style: { paddingTop: this.options.length ? "8px" : "0" } }, this.options.map((e) => {
      var { config: t } = e, s = L3(e, ["config"]);
      return s.value && U("skp-dropdown-list-item", Object.assign({ key: s.value }, s, { size: this.size, config: t, active: this.activeValues.includes(s.value) }));
    })));
  }
  static get style() {
    return R3;
  }
}, [4, "skp-dropdown-list", {
  activeValues: [16],
  direction: [1],
  multiselectable: [4],
  name: [513],
  options: [16],
  size: [1],
  skpClass: [1, "skp-class"]
}]);
function P3() {
  if (typeof customElements > "u")
    return;
  ["skp-dropdown-list", "skp-checkbox", "skp-dropdown-list-item", "skp-flag", "skp-icon", "skp-text"].forEach((e) => {
    switch (e) {
      case "skp-dropdown-list":
        customElements.get(e) || customElements.define(e, N3);
        break;
      case "skp-checkbox":
        customElements.get(e) || sa();
        break;
      case "skp-dropdown-list-item":
        customElements.get(e) || Yo();
        break;
      case "skp-flag":
        customElements.get(e) || aa();
        break;
      case "skp-icon":
        customElements.get(e) || ar();
        break;
      case "skp-text":
        customElements.get(e) || $r();
        break;
    }
  });
}
const U3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-progress-root{background-color:var(--skp-color-neutral-100);overflow:hidden;border-radius:40px;width:100%}.skp-progress-filling{border-radius:40px;height:100%;width:0%;transition:all 0.5s ease-in-out}.skp-progress-filling.skp-progress-indeterminate{animation-name:skp-progress-indeterminate;animation-duration:2.2s;animation-iteration-count:infinite}@keyframes skp-progress-indeterminate{0%{width:75%;margin-left:-90%;margin-right:100%}60%{width:90%;margin-left:-90%;margin-right:100%}100%{width:10%;margin-left:100%;margin-right:-35%}}', G3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.color = "--skp-color-primary-500", this.height = 4, this.indeterminate = !1, this.max = 100, this.value = 0;
  }
  getValue() {
    return this.value >= 0 && this.value <= this.max ? 100 * this.value / this.max : this.value > this.max ? this.max : 0;
  }
  render() {
    const e = Lt("skp-progress");
    return U("div", { class: e()("root"), style: { height: `${this.height}px` } }, U("div", { class: e()("filling", { indeterminate: this.indeterminate }), style: Object.assign(Object.assign({}, !this.indeterminate && { width: `${this.getValue()}%` }), { backgroundColor: this.color && ra(this.color) }) }));
  }
  static get style() {
    return U3;
  }
}, [0, "skp-progress", {
  color: [1],
  height: [2],
  indeterminate: [4],
  max: [2],
  value: [2]
}]);
function Wo() {
  if (typeof customElements > "u")
    return;
  ["skp-progress"].forEach((e) => {
    switch (e) {
      case "skp-progress":
        customElements.get(e) || customElements.define(e, G3);
        break;
    }
  });
}
const H3 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-input-text-root,.skp-input-number-root,.skp-input-password-root,.skp-input-phone-root,.skp-input-search-root,.skp-input-date-root,.skp-input-date-range-root,.skp-input-textarea-root{position:relative}.skp-input-text-root .skp-progress-root,.skp-input-number-root .skp-progress-root,.skp-input-password-root .skp-progress-root,.skp-input-phone-root .skp-progress-root,.skp-input-search-root .skp-progress-root,.skp-input-date-root .skp-progress-root,.skp-input-date-range-root .skp-progress-root,.skp-input-textarea-root .skp-progress-root{height:2px;z-index:100;position:absolute;bottom:0.8px;width:calc(100% - 2px);margin-left:1px;border-radius:0 0 9px 9px}.skp-input-text-icon,.skp-input-number-icon,.skp-input-password-icon,.skp-input-phone-icon,.skp-input-search-icon,.skp-input-date-icon,.skp-input-date-range-icon,.skp-input-textarea-icon{position:absolute;top:50%;transform:translateY(-50%) !important}.skp-input-text-icon-start,.skp-input-number-icon-start,.skp-input-password-icon-start,.skp-input-phone-icon-start,.skp-input-search-icon-start,.skp-input-date-icon-start,.skp-input-date-range-icon-start,.skp-input-textarea-icon-start{left:var(--skp-size-3)}.skp-input-text-icon-end,.skp-input-number-icon-end,.skp-input-password-icon-end,.skp-input-phone-icon-end,.skp-input-search-icon-end,.skp-input-date-icon-end,.skp-input-date-range-icon-end,.skp-input-textarea-icon-end{right:var(--skp-size-3)}.skp-input-text-input,.skp-input-number-input,.skp-input-password-input,.skp-input-phone-input,.skp-input-search-input,.skp-input-date-input,.skp-input-date-range-input,.skp-input-textarea-input{background:var(--skp-color-white);border:1px solid var(--skp-color-neutral-300);border-radius:var(--skp-small-radius);color:var(--skp-color-neutral-900);font-family:var(--skp-main-font);padding-left:var(--skp-size-3);padding-right:var(--skp-size-3);transition:border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;width:100%;box-sizing:border-box}.skp-input-text-input:focus,.skp-input-text-input:active,.skp-input-number-input:focus,.skp-input-number-input:active,.skp-input-password-input:focus,.skp-input-password-input:active,.skp-input-phone-input:focus,.skp-input-phone-input:active,.skp-input-search-input:focus,.skp-input-search-input:active,.skp-input-date-input:focus,.skp-input-date-input:active,.skp-input-date-range-input:focus,.skp-input-date-range-input:active,.skp-input-textarea-input:focus,.skp-input-textarea-input:active{outline:4px solid var(--skp-color-neutral-100)}.skp-input-text-input::placeholder,.skp-input-number-input::placeholder,.skp-input-password-input::placeholder,.skp-input-phone-input::placeholder,.skp-input-search-input::placeholder,.skp-input-date-input::placeholder,.skp-input-date-range-input::placeholder,.skp-input-textarea-input::placeholder{color:var(--skp-color-neutral-400)}.skp-input-text-input:disabled,.skp-input-number-input:disabled,.skp-input-password-input:disabled,.skp-input-phone-input:disabled,.skp-input-search-input:disabled,.skp-input-date-input:disabled,.skp-input-date-range-input:disabled,.skp-input-textarea-input:disabled{background:var(--skp-color-neutral-50);border:1px solid var(--skp-color-neutral-200);color:var(--skp-color-neutral-400);cursor:not-allowed}.skp-input-text-input:disabled:focus,.skp-input-text-input:disabled:active,.skp-input-number-input:disabled:focus,.skp-input-number-input:disabled:active,.skp-input-password-input:disabled:focus,.skp-input-password-input:disabled:active,.skp-input-phone-input:disabled:focus,.skp-input-phone-input:disabled:active,.skp-input-search-input:disabled:focus,.skp-input-search-input:disabled:active,.skp-input-date-input:disabled:focus,.skp-input-date-input:disabled:active,.skp-input-date-range-input:disabled:focus,.skp-input-date-range-input:disabled:active,.skp-input-textarea-input:disabled:focus,.skp-input-textarea-input:disabled:active{outline:none}.skp-input-text-input:-webkit-autofill,.skp-input-number-input:-webkit-autofill,.skp-input-password-input:-webkit-autofill,.skp-input-phone-input:-webkit-autofill,.skp-input-search-input:-webkit-autofill,.skp-input-date-input:-webkit-autofill,.skp-input-date-range-input:-webkit-autofill,.skp-input-textarea-input:-webkit-autofill{background-color:var(--skp-color-white)}.skp-input-text-loading,.skp-input-number-loading,.skp-input-password-loading,.skp-input-phone-loading,.skp-input-search-loading,.skp-input-date-loading,.skp-input-date-range-loading,.skp-input-textarea-loading{border-radius:var(--skp-small-radius) var(--skp-small-radius) 0 0}.skp-input-text-small,.skp-input-number-small,.skp-input-password-small,.skp-input-phone-small,.skp-input-search-small,.skp-input-date-small,.skp-input-date-range-small,.skp-input-textarea-small{height:var(--skp-button-small-height);font-size:14px;line-height:17px}.skp-input-text-small-start,.skp-input-number-small-start,.skp-input-password-small-start,.skp-input-phone-small-start,.skp-input-search-small-start,.skp-input-date-small-start,.skp-input-date-range-small-start,.skp-input-textarea-small-start{padding-left:30px}.skp-input-text-small-end,.skp-input-number-small-end,.skp-input-password-small-end,.skp-input-phone-small-end,.skp-input-search-small-end,.skp-input-date-small-end,.skp-input-date-range-small-end,.skp-input-textarea-small-end{padding-right:30px}.skp-input-text-medium,.skp-input-number-medium,.skp-input-password-medium,.skp-input-phone-medium,.skp-input-search-medium,.skp-input-date-medium,.skp-input-date-range-medium,.skp-input-textarea-medium{height:var(--skp-button-medium-height);font-size:var(--skp-size-4);line-height:19px}.skp-input-text-medium-start,.skp-input-number-medium-start,.skp-input-password-medium-start,.skp-input-phone-medium-start,.skp-input-search-medium-start,.skp-input-date-medium-start,.skp-input-date-range-medium-start,.skp-input-textarea-medium-start{padding-left:36px}.skp-input-text-medium-end,.skp-input-number-medium-end,.skp-input-password-medium-end,.skp-input-phone-medium-end,.skp-input-search-medium-end,.skp-input-date-medium-end,.skp-input-date-range-medium-end,.skp-input-textarea-medium-end{padding-right:36px}.skp-input-text-large,.skp-input-number-large,.skp-input-password-large,.skp-input-phone-large,.skp-input-search-large,.skp-input-date-large,.skp-input-date-range-large,.skp-input-textarea-large{height:var(--skp-button-large-height);font-size:18px;line-height:22px}.skp-input-text-large-start,.skp-input-number-large-start,.skp-input-password-large-start,.skp-input-phone-large-start,.skp-input-search-large-start,.skp-input-date-large-start,.skp-input-date-range-large-start,.skp-input-textarea-large-start{padding-left:40px}.skp-input-text-large-end,.skp-input-number-large-end,.skp-input-password-large-end,.skp-input-phone-large-end,.skp-input-search-large-end,.skp-input-date-large-end,.skp-input-date-range-large-end,.skp-input-textarea-large-end{padding-right:40px}.skp-input-text-error,.skp-input-number-error,.skp-input-password-error,.skp-input-phone-error,.skp-input-search-error,.skp-input-date-error,.skp-input-date-range-error,.skp-input-textarea-error{background:var(--skp-color-error-50) !important;border-color:var(--skp-color-error-500) !important}.skp-input-text-error:not(:disabled):focus,.skp-input-text-error:not(:disabled):active,.skp-input-number-error:not(:disabled):focus,.skp-input-number-error:not(:disabled):active,.skp-input-password-error:not(:disabled):focus,.skp-input-password-error:not(:disabled):active,.skp-input-phone-error:not(:disabled):focus,.skp-input-phone-error:not(:disabled):active,.skp-input-search-error:not(:disabled):focus,.skp-input-search-error:not(:disabled):active,.skp-input-date-error:not(:disabled):focus,.skp-input-date-error:not(:disabled):active,.skp-input-date-range-error:not(:disabled):focus,.skp-input-date-range-error:not(:disabled):active,.skp-input-textarea-error:not(:disabled):focus,.skp-input-textarea-error:not(:disabled):active{outline:4px solid var(--skp-color-error-100) !important}.skp-input-text-error-message,.skp-input-number-error-message,.skp-input-password-error-message,.skp-input-phone-error-message,.skp-input-search-error-message,.skp-input-date-error-message,.skp-input-date-range-error-message,.skp-input-textarea-error-message{position:absolute;display:inline-block;margin-top:var(--skp-size-1)}', q3 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.skpChange = sr(this, "skpChange", 7), this.skpInputError = sr(this, "skpInputError", 7), this.autocomplete = void 0, this.disabled = !1, this.email = !1, this.error = void 0, this.errors = void 0, this.icon = void 0, this.iconPosition = "end", this.loading = void 0, this.maxLength = void 0, this.minLength = void 0, this.name = `input-text-${Math.ceil(Date.now() * Math.random())}`, this.placeholder = void 0, this.readOnly = !1, this.required = !1, this.size = "medium", this.skpTabindex = void 0, this.validateOn = "blur", this.value = void 0;
  }
  handleInput(e) {
    this.value = e.target.value, this.skpChange.emit(e.target.value), this.email && this.validateOn === "type" && this.validateEmail(e.target.value);
  }
  handleBlur(e) {
    this.email && (this.validateOn === "blur" || this.validateOn === "submit") && this.validateEmail(e.target.value);
  }
  validateEmail(e) {
    const t = p3.test(e) ? "" : "INVALID_EMAIL";
    this.error = this.validateOn === "submit" ? this.error : t, this.skpInputError.emit(t);
  }
  render() {
    var e;
    const t = this.disabled ? "--skp-color-neutral-400" : "--skp-color-neutral-900";
    return U(it, null, U("div", { class: "skp-input-text-root" }, U("input", Object.assign({ "aria-label": this.name, type: "text", value: this.value, placeholder: this.placeholder, class: Me("skp-input-text")("input", this.size, {
      [`${this.size}-${this.iconPosition}`]: this.icon,
      error: this.error,
      loading: this.loading
    }), readOnly: this.readOnly, disabled: this.disabled, onInput: this.handleInput.bind(this), onBlur: this.handleBlur.bind(this), required: this.required, minLength: this.minLength, maxLength: this.maxLength, tabindex: this.skpTabindex }, this.autocomplete && {
      autocomplete: this.autocomplete === "off" ? l3() : this.autocomplete
    }, this.email && {
      type: "email",
      name: "email"
    })), !!this.icon && U("skp-icon", { icon: this.icon, size: this.size, color: t, skpClass: Me("skp-input-text")("icon", `icon-${this.iconPosition}`) }), U("slot", null), this.loading && U("skp-progress", { height: 2, indeterminate: !0, color: "--skp-color-primary-500" })), !!this.error && U("skp-text", { text: ((e = this.errors) === null || e === void 0 ? void 0 : e[this.error]) || this.error, color: "--skp-color-error-500", size: "xsmall", class: "skp-input-text-error-message" }));
  }
  static get style() {
    return H3;
  }
}, [4, "skp-input-text", {
  autocomplete: [1],
  disabled: [4],
  email: [4],
  error: [1025],
  errors: [16],
  icon: [16],
  iconPosition: [1, "icon-position"],
  loading: [4],
  maxLength: [2, "max-length"],
  minLength: [2, "min-length"],
  name: [1],
  placeholder: [1],
  readOnly: [4, "read-only"],
  required: [4],
  size: [1],
  skpTabindex: [2, "skp-tabindex"],
  validateOn: [1, "validate-on"],
  value: [1537]
}]);
function K3() {
  if (typeof customElements > "u")
    return;
  ["skp-input-text", "skp-icon", "skp-progress", "skp-text"].forEach((e) => {
    switch (e) {
      case "skp-input-text":
        customElements.get(e) || customElements.define(e, q3);
        break;
      case "skp-icon":
        customElements.get(e) || ar();
        break;
      case "skp-progress":
        customElements.get(e) || Wo();
        break;
      case "skp-text":
        customElements.get(e) || $r();
        break;
    }
  });
}
var Y3 = "Expected a function", xi = NaN, W3 = "[object Symbol]", V3 = /^\s+|\s+$/g, Z3 = /^[-+]0x[0-9a-f]+$/i, J3 = /^0b[01]+$/i, Q3 = /^0o[0-7]+$/i, X3 = parseInt, e5 = typeof Ve == "object" && Ve && Ve.Object === Object && Ve, r5 = typeof self == "object" && self && self.Object === Object && self, t5 = e5 || r5 || Function("return this")(), s5 = Object.prototype, a5 = s5.toString, i5 = Math.max, o5 = Math.min, xs = function() {
  return t5.Date.now();
};
function n5(r, e, t) {
  var s, a, i, o, l, p, g = 0, w = !1, k = !1, h = !0;
  if (typeof r != "function")
    throw new TypeError(Y3);
  e = bi(e) || 0, Ts(t) && (w = !!t.leading, k = "maxWait" in t, i = k ? i5(bi(t.maxWait) || 0, e) : i, h = "trailing" in t ? !!t.trailing : h);
  function S(L) {
    var Z = s, c = a;
    return s = a = void 0, g = L, o = r.apply(c, Z), o;
  }
  function _(L) {
    return g = L, l = setTimeout(N, e), w ? S(L) : o;
  }
  function G(L) {
    var Z = L - p, c = L - g, u = e - Z;
    return k ? o5(u, i - c) : u;
  }
  function I(L) {
    var Z = L - p, c = L - g;
    return p === void 0 || Z >= e || Z < 0 || k && c >= i;
  }
  function N() {
    var L = xs();
    if (I(L))
      return C(L);
    l = setTimeout(N, G(L));
  }
  function C(L) {
    return l = void 0, h && s ? S(L) : (s = a = void 0, o);
  }
  function re() {
    l !== void 0 && clearTimeout(l), g = 0, s = p = a = l = void 0;
  }
  function B() {
    return l === void 0 ? o : C(xs());
  }
  function R() {
    var L = xs(), Z = I(L);
    if (s = arguments, a = this, p = L, Z) {
      if (l === void 0)
        return _(p);
      if (k)
        return l = setTimeout(N, e), S(p);
    }
    return l === void 0 && (l = setTimeout(N, e)), o;
  }
  return R.cancel = re, R.flush = B, R;
}
function Ts(r) {
  var e = typeof r;
  return !!r && (e == "object" || e == "function");
}
function l5(r) {
  return !!r && typeof r == "object";
}
function p5(r) {
  return typeof r == "symbol" || l5(r) && a5.call(r) == W3;
}
function bi(r) {
  if (typeof r == "number")
    return r;
  if (p5(r))
    return xi;
  if (Ts(r)) {
    var e = typeof r.valueOf == "function" ? r.valueOf() : r;
    r = Ts(e) ? e + "" : e;
  }
  if (typeof r != "string")
    return r === 0 ? r : +r;
  r = r.replace(V3, "");
  var t = J3.test(r);
  return t || Q3.test(r) ? X3(r.slice(2), t ? 2 : 8) : Z3.test(r) ? xi : +r;
}
var c5 = n5;
const u5 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.observer = new MutationObserver(c5(this.setPosition.bind(this), 200)), this.offsetX = 0, this.offsetY = 0, this.name = `portal-${String(Math.ceil(Date.now() * Math.random()))}`, this.reference = void 0;
  }
  handlePosition() {
    this.setPosition();
  }
  componentWillLoad() {
    const e = document.body.querySelector(`#${this.name}`);
    e && e.remove(), this.createPortal();
  }
  componentDidLoad() {
    this.moveElementToPortal(), this.setPosition(), this.observer.observe(document.body, { childList: !0, subtree: !0 });
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  handleResize() {
    this.setPosition();
  }
  handleScroll() {
    this.setPosition();
  }
  createPortal() {
    this.portal = document.createElement("div"), this.portal.setAttribute("id", this.name), this.portal.style.zIndex = "10000", this.portal.style.position = "absolute", document.body.append(this.portal);
  }
  moveElementToPortal() {
    this.portal.appendChild(this.element);
  }
  setPosition() {
    if (this.reference) {
      const { top: e, left: t, width: s } = this.reference.getBoundingClientRect();
      this.portal.style.top = `${window.scrollY + e + this.offsetY}px`, this.portal.style.left = `${window.scrollX + t + this.offsetX}px`, this.portal.style.width = `${s}px`;
    }
  }
  render() {
    return U(it, null, U("slot", null));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      reference: ["handlePosition"]
    };
  }
}, [4, "skp-portal", {
  offsetX: [2, "offset-x"],
  offsetY: [2, "offset-y"],
  name: [1],
  reference: [16]
}, [[9, "resize", "handleResize"], [11, "scroll", "handleScroll"]], {
  reference: ["handlePosition"]
}]);
function f5() {
  if (typeof customElements > "u")
    return;
  ["skp-portal"].forEach((e) => {
    switch (e) {
      case "skp-portal":
        customElements.get(e) || customElements.define(e, u5);
        break;
    }
  });
}
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "chevron-left", a = 320, i = 512, o = [9001], l = "f053", p = "M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faChevronLeft = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "chevron-right", a = 320, i = 512, o = [9002], l = "f054", p = "M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faChevronRight = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
var Nt = ne(function(r, e) {
  (function(t, s) {
    r.exports = s();
  })(Ve, function() {
    var t = 1e3, s = 6e4, a = 36e5, i = "millisecond", o = "second", l = "minute", p = "hour", g = "day", w = "week", k = "month", h = "quarter", S = "year", _ = "date", G = "Invalid Date", I = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, N = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, C = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(b) {
      var f = ["th", "st", "nd", "rd"], d = b % 100;
      return "[" + b + (f[(d - 20) % 10] || f[d] || f[0]) + "]";
    } }, re = function(b, f, d) {
      var x = String(b);
      return !x || x.length >= f ? b : "" + Array(f + 1 - x.length).join(d) + b;
    }, B = { s: re, z: function(b) {
      var f = -b.utcOffset(), d = Math.abs(f), x = Math.floor(d / 60), v = d % 60;
      return (f <= 0 ? "+" : "-") + re(x, 2, "0") + ":" + re(v, 2, "0");
    }, m: function b(f, d) {
      if (f.date() < d.date())
        return -b(d, f);
      var x = 12 * (d.year() - f.year()) + (d.month() - f.month()), v = f.clone().add(x, k), A = d - v < 0, O = f.clone().add(x + (A ? -1 : 1), k);
      return +(-(x + (d - v) / (A ? v - O : O - v)) || 0);
    }, a: function(b) {
      return b < 0 ? Math.ceil(b) || 0 : Math.floor(b);
    }, p: function(b) {
      return { M: k, y: S, w, d: g, D: _, h: p, m: l, s: o, ms: i, Q: h }[b] || String(b || "").toLowerCase().replace(/s$/, "");
    }, u: function(b) {
      return b === void 0;
    } }, R = "en", L = {};
    L[R] = C;
    var Z = "$isDayjsObject", c = function(b) {
      return b instanceof F || !(!b || !b[Z]);
    }, u = function b(f, d, x) {
      var v;
      if (!f)
        return R;
      if (typeof f == "string") {
        var A = f.toLowerCase();
        L[A] && (v = A), d && (L[A] = d, v = A);
        var O = f.split("-");
        if (!v && O.length > 1)
          return b(O[0]);
      } else {
        var T = f.name;
        L[T] = f, v = T;
      }
      return !x && v && (R = v), v || !x && R;
    }, m = function(b, f) {
      if (c(b))
        return b.clone();
      var d = typeof f == "object" ? f : {};
      return d.date = b, d.args = arguments, new F(d);
    }, j = B;
    j.l = u, j.i = c, j.w = function(b, f) {
      return m(b, { locale: f.$L, utc: f.$u, x: f.$x, $offset: f.$offset });
    };
    var F = function() {
      function b(d) {
        this.$L = u(d.locale, null, !0), this.parse(d), this.$x = this.$x || d.x || {}, this[Z] = !0;
      }
      var f = b.prototype;
      return f.parse = function(d) {
        this.$d = function(x) {
          var v = x.date, A = x.utc;
          if (v === null)
            return /* @__PURE__ */ new Date(NaN);
          if (j.u(v))
            return /* @__PURE__ */ new Date();
          if (v instanceof Date)
            return new Date(v);
          if (typeof v == "string" && !/Z$/i.test(v)) {
            var O = v.match(I);
            if (O) {
              var T = O[2] - 1 || 0, K = (O[7] || "0").substring(0, 3);
              return A ? new Date(Date.UTC(O[1], T, O[3] || 1, O[4] || 0, O[5] || 0, O[6] || 0, K)) : new Date(O[1], T, O[3] || 1, O[4] || 0, O[5] || 0, O[6] || 0, K);
            }
          }
          return new Date(v);
        }(d), this.init();
      }, f.init = function() {
        var d = this.$d;
        this.$y = d.getFullYear(), this.$M = d.getMonth(), this.$D = d.getDate(), this.$W = d.getDay(), this.$H = d.getHours(), this.$m = d.getMinutes(), this.$s = d.getSeconds(), this.$ms = d.getMilliseconds();
      }, f.$utils = function() {
        return j;
      }, f.isValid = function() {
        return this.$d.toString() !== G;
      }, f.isSame = function(d, x) {
        var v = m(d);
        return this.startOf(x) <= v && v <= this.endOf(x);
      }, f.isAfter = function(d, x) {
        return m(d) < this.startOf(x);
      }, f.isBefore = function(d, x) {
        return this.endOf(x) < m(d);
      }, f.$g = function(d, x, v) {
        return j.u(d) ? this[x] : this.set(v, d);
      }, f.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, f.valueOf = function() {
        return this.$d.getTime();
      }, f.startOf = function(d, x) {
        var v = this, A = !!j.u(x) || x, O = j.p(d), T = function(me, oe) {
          var ce = j.w(v.$u ? Date.UTC(v.$y, oe, me) : new Date(v.$y, oe, me), v);
          return A ? ce : ce.endOf(g);
        }, K = function(me, oe) {
          return j.w(v.toDate()[me].apply(v.toDate("s"), (A ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(oe)), v);
        }, V = this.$W, te = this.$M, W = this.$D, J = "set" + (this.$u ? "UTC" : "");
        switch (O) {
          case S:
            return A ? T(1, 0) : T(31, 11);
          case k:
            return A ? T(1, te) : T(0, te + 1);
          case w:
            var se = this.$locale().weekStart || 0, de = (V < se ? V + 7 : V) - se;
            return T(A ? W - de : W + (6 - de), te);
          case g:
          case _:
            return K(J + "Hours", 0);
          case p:
            return K(J + "Minutes", 1);
          case l:
            return K(J + "Seconds", 2);
          case o:
            return K(J + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, f.endOf = function(d) {
        return this.startOf(d, !1);
      }, f.$set = function(d, x) {
        var v, A = j.p(d), O = "set" + (this.$u ? "UTC" : ""), T = (v = {}, v[g] = O + "Date", v[_] = O + "Date", v[k] = O + "Month", v[S] = O + "FullYear", v[p] = O + "Hours", v[l] = O + "Minutes", v[o] = O + "Seconds", v[i] = O + "Milliseconds", v)[A], K = A === g ? this.$D + (x - this.$W) : x;
        if (A === k || A === S) {
          var V = this.clone().set(_, 1);
          V.$d[T](K), V.init(), this.$d = V.set(_, Math.min(this.$D, V.daysInMonth())).$d;
        } else
          T && this.$d[T](K);
        return this.init(), this;
      }, f.set = function(d, x) {
        return this.clone().$set(d, x);
      }, f.get = function(d) {
        return this[j.p(d)]();
      }, f.add = function(d, x) {
        var v, A = this;
        d = Number(d);
        var O = j.p(x), T = function(te) {
          var W = m(A);
          return j.w(W.date(W.date() + Math.round(te * d)), A);
        };
        if (O === k)
          return this.set(k, this.$M + d);
        if (O === S)
          return this.set(S, this.$y + d);
        if (O === g)
          return T(1);
        if (O === w)
          return T(7);
        var K = (v = {}, v[l] = s, v[p] = a, v[o] = t, v)[O] || 1, V = this.$d.getTime() + d * K;
        return j.w(V, this);
      }, f.subtract = function(d, x) {
        return this.add(-1 * d, x);
      }, f.format = function(d) {
        var x = this, v = this.$locale();
        if (!this.isValid())
          return v.invalidDate || G;
        var A = d || "YYYY-MM-DDTHH:mm:ssZ", O = j.z(this), T = this.$H, K = this.$m, V = this.$M, te = v.weekdays, W = v.months, J = v.meridiem, se = function(oe, ce, xe, ke) {
          return oe && (oe[ce] || oe(x, A)) || xe[ce].slice(0, ke);
        }, de = function(oe) {
          return j.s(T % 12 || 12, oe, "0");
        }, me = J || function(oe, ce, xe) {
          var ke = oe < 12 ? "AM" : "PM";
          return xe ? ke.toLowerCase() : ke;
        };
        return A.replace(N, function(oe, ce) {
          return ce || function(xe) {
            switch (xe) {
              case "YY":
                return String(x.$y).slice(-2);
              case "YYYY":
                return j.s(x.$y, 4, "0");
              case "M":
                return V + 1;
              case "MM":
                return j.s(V + 1, 2, "0");
              case "MMM":
                return se(v.monthsShort, V, W, 3);
              case "MMMM":
                return se(W, V);
              case "D":
                return x.$D;
              case "DD":
                return j.s(x.$D, 2, "0");
              case "d":
                return String(x.$W);
              case "dd":
                return se(v.weekdaysMin, x.$W, te, 2);
              case "ddd":
                return se(v.weekdaysShort, x.$W, te, 3);
              case "dddd":
                return te[x.$W];
              case "H":
                return String(T);
              case "HH":
                return j.s(T, 2, "0");
              case "h":
                return de(1);
              case "hh":
                return de(2);
              case "a":
                return me(T, K, !0);
              case "A":
                return me(T, K, !1);
              case "m":
                return String(K);
              case "mm":
                return j.s(K, 2, "0");
              case "s":
                return String(x.$s);
              case "ss":
                return j.s(x.$s, 2, "0");
              case "SSS":
                return j.s(x.$ms, 3, "0");
              case "Z":
                return O;
            }
            return null;
          }(oe) || O.replace(":", "");
        });
      }, f.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, f.diff = function(d, x, v) {
        var A, O = this, T = j.p(x), K = m(d), V = (K.utcOffset() - this.utcOffset()) * s, te = this - K, W = function() {
          return j.m(O, K);
        };
        switch (T) {
          case S:
            A = W() / 12;
            break;
          case k:
            A = W();
            break;
          case h:
            A = W() / 3;
            break;
          case w:
            A = (te - V) / 6048e5;
            break;
          case g:
            A = (te - V) / 864e5;
            break;
          case p:
            A = te / a;
            break;
          case l:
            A = te / s;
            break;
          case o:
            A = te / t;
            break;
          default:
            A = te;
        }
        return v ? A : j.a(A);
      }, f.daysInMonth = function() {
        return this.endOf(k).$D;
      }, f.$locale = function() {
        return L[this.$L];
      }, f.locale = function(d, x) {
        if (!d)
          return this.$L;
        var v = this.clone(), A = u(d, x, !0);
        return A && (v.$L = A), v;
      }, f.clone = function() {
        return j.w(this.$d, this);
      }, f.toDate = function() {
        return new Date(this.valueOf());
      }, f.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, f.toISOString = function() {
        return this.$d.toISOString();
      }, f.toString = function() {
        return this.$d.toUTCString();
      }, b;
    }(), E = F.prototype;
    return m.prototype = E, [["$ms", i], ["$s", o], ["$m", l], ["$H", p], ["$W", g], ["$M", k], ["$y", S], ["$D", _]].forEach(function(b) {
      E[b[1]] = function(f) {
        return this.$g(f, b[0], b[1]);
      };
    }), m.extend = function(b, f) {
      return b.$i || (b(f, F, m), b.$i = !0), m;
    }, m.locale = u, m.isDayjs = c, m.unix = function(b) {
      return m(1e3 * b);
    }, m.en = L[R], m.Ls = L, m.p = {}, m;
  });
});
ne(function(r, e) {
  (function(t, s) {
    r.exports = s(Nt);
  })(Ve, function(t) {
    function s(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var a = s(t), i = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(o) {
      return "" + o + (o === 1 ? "er" : "");
    } };
    return a.default.locale(i, null, !0), i;
  });
});
ne(function(r, e) {
  (function(t, s) {
    r.exports = s(Nt);
  })(Ve, function(t) {
    function s(p) {
      return p && typeof p == "object" && "default" in p ? p : { default: p };
    }
    var a = s(t), i = { s: "ein paar Sekunden", m: ["eine Minute", "einer Minute"], mm: "%d Minuten", h: ["eine Stunde", "einer Stunde"], hh: "%d Stunden", d: ["ein Tag", "einem Tag"], dd: ["%d Tage", "%d Tagen"], M: ["ein Monat", "einem Monat"], MM: ["%d Monate", "%d Monaten"], y: ["ein Jahr", "einem Jahr"], yy: ["%d Jahre", "%d Jahren"] };
    function o(p, g, w) {
      var k = i[w];
      return Array.isArray(k) && (k = k[g ? 0 : 1]), k.replace("%d", p);
    }
    var l = { name: "de", weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"), weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"), weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"), months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"), monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"), ordinal: function(p) {
      return p + ".";
    }, weekStart: 1, yearStart: 4, formats: { LTS: "HH:mm:ss", LT: "HH:mm", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY HH:mm", LLLL: "dddd, D. MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "vor %s", s: o, m: o, mm: o, h: o, hh: o, d: o, dd: o, M: o, MM: o, y: o, yy: o } };
    return a.default.locale(l, null, !0), l;
  });
});
var k5 = ne(function(r, e) {
  (function(t, s) {
    r.exports = s();
  })(Ve, function() {
    return function(t, s, a) {
      var i = s.prototype, o = function(k) {
        return k && (k.indexOf ? k : k.s);
      }, l = function(k, h, S, _, G) {
        var I = k.name ? k : k.$locale(), N = o(I[h]), C = o(I[S]), re = N || C.map(function(R) {
          return R.slice(0, _);
        });
        if (!G)
          return re;
        var B = I.weekStart;
        return re.map(function(R, L) {
          return re[(L + (B || 0)) % 7];
        });
      }, p = function() {
        return a.Ls[a.locale()];
      }, g = function(k, h) {
        return k.formats[h] || function(S) {
          return S.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(_, G, I) {
            return G || I.slice(1);
          });
        }(k.formats[h.toUpperCase()]);
      }, w = function() {
        var k = this;
        return { months: function(h) {
          return h ? h.format("MMMM") : l(k, "months");
        }, monthsShort: function(h) {
          return h ? h.format("MMM") : l(k, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return k.$locale().weekStart || 0;
        }, weekdays: function(h) {
          return h ? h.format("dddd") : l(k, "weekdays");
        }, weekdaysMin: function(h) {
          return h ? h.format("dd") : l(k, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(h) {
          return h ? h.format("ddd") : l(k, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(h) {
          return g(k.$locale(), h);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      i.localeData = function() {
        return w.bind(this)();
      }, a.localeData = function() {
        var k = p();
        return { firstDayOfWeek: function() {
          return k.weekStart || 0;
        }, weekdays: function() {
          return a.weekdays();
        }, weekdaysShort: function() {
          return a.weekdaysShort();
        }, weekdaysMin: function() {
          return a.weekdaysMin();
        }, months: function() {
          return a.months();
        }, monthsShort: function() {
          return a.monthsShort();
        }, longDateFormat: function(h) {
          return g(k, h);
        }, meridiem: k.meridiem, ordinal: k.ordinal };
      }, a.months = function() {
        return l(p(), "months");
      }, a.monthsShort = function() {
        return l(p(), "monthsShort", "months", 3);
      }, a.weekdays = function(k) {
        return l(p(), "weekdays", null, null, k);
      }, a.weekdaysShort = function(k) {
        return l(p(), "weekdaysShort", "weekdays", 3, k);
      }, a.weekdaysMin = function(k) {
        return l(p(), "weekdaysMin", "weekdays", 2, k);
      };
    };
  });
}), d5 = ne(function(r, e) {
  (function(t, s) {
    r.exports = s();
  })(Ve, function() {
    return function(t, s, a) {
      s.prototype.isBetween = function(i, o, l, p) {
        var g = a(i), w = a(o), k = (p = p || "()")[0] === "(", h = p[1] === ")";
        return (k ? this.isAfter(g, l) : !this.isBefore(g, l)) && (h ? this.isBefore(w, l) : !this.isAfter(w, l)) || (k ? this.isBefore(g, l) : !this.isAfter(g, l)) && (h ? this.isAfter(w, l) : !this.isBefore(w, l));
      };
    };
  });
});
Nt.extend(k5);
Nt.extend(d5);
var yi;
(function(r) {
  r.SKEEPERS = "skeepers", r.INFLUENCER_MARKETING = "influencer-marketing", r.LIVE_SHOPPING = "live-shopping", r.CONSUMER_VIDEOS = "consumer-videos", r.CUSTOMER_DATA_ACTIVATION = "customer-data-activation", r.FEEDBACK_MANAGEMENT = "feedback-management", r.RATING_AND_REVIEWS = "rating&reviews";
})(yi || (yi = {}));
var wi;
(function(r) {
  r.AU = "AU", r.BG = "BG", r.CZ = "CZ", r.DE = "DE", r.EN = "EN", r.ES = "ES", r.FR = "FR", r.HU = "HU", r.IT = "IT", r.JP = "JP", r.KR = "KR", r.LT = "LT", r.PL = "PL", r.PT = "PT", r.TH = "TH", r.UK = "UK", r.VI = "VI";
})(wi || (wi = {}));
var zi;
(function(r) {
  r.BLACK = "black", r.BLUE_AND_BLACK = "blue&black", r.BLUE_AND_WHITE = "blue&white", r.WHITE = "white", r.BLUE = "blue";
})(zi || (zi = {}));
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "bars", a = 448, i = 512, o = ["navicon"], l = "f0c9", p = "M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faBars = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fal", s = "calendar", a = 448, i = 512, o = [128198, 128197], l = "f133", p = "M112 0C120.8 0 128 7.164 128 16V64H320V16C320 7.164 327.2 0 336 0C344.8 0 352 7.164 352 16V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H96V16C96 7.164 103.2 0 112 0zM416 192H32V448C32 465.7 46.33 480 64 480H384C401.7 480 416 465.7 416 448V192zM384 96H64C46.33 96 32 110.3 32 128V160H416V128C416 110.3 401.7 96 384 96z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faCalendar = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "magnifying-glass", a = 512, i = 512, o = [128269, "search"], l = "f002", p = "M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faMagnifyingGlass = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
const m5 = [
  [
    "AF",
    "AFG",
    "004",
    "ISO 3166-2:AF"
  ],
  [
    "AL",
    "ALB",
    "008",
    "ISO 3166-2:AL"
  ],
  [
    "DZ",
    "DZA",
    "012",
    "ISO 3166-2:DZ"
  ],
  [
    "AS",
    "ASM",
    "016",
    "ISO 3166-2:AS"
  ],
  [
    "AD",
    "AND",
    "020",
    "ISO 3166-2:AD"
  ],
  [
    "AO",
    "AGO",
    "024",
    "ISO 3166-2:AO"
  ],
  [
    "AI",
    "AIA",
    "660",
    "ISO 3166-2:AI"
  ],
  [
    "AQ",
    "ATA",
    "010",
    "ISO 3166-2:AQ"
  ],
  [
    "AG",
    "ATG",
    "028",
    "ISO 3166-2:AG"
  ],
  [
    "AR",
    "ARG",
    "032",
    "ISO 3166-2:AR"
  ],
  [
    "AM",
    "ARM",
    "051",
    "ISO 3166-2:AM"
  ],
  [
    "AW",
    "ABW",
    "533",
    "ISO 3166-2:AW"
  ],
  [
    "AU",
    "AUS",
    "036",
    "ISO 3166-2:AU"
  ],
  [
    "AT",
    "AUT",
    "040",
    "ISO 3166-2:AT"
  ],
  [
    "AZ",
    "AZE",
    "031",
    "ISO 3166-2:AZ"
  ],
  [
    "BS",
    "BHS",
    "044",
    "ISO 3166-2:BS"
  ],
  [
    "BH",
    "BHR",
    "048",
    "ISO 3166-2:BH"
  ],
  [
    "BD",
    "BGD",
    "050",
    "ISO 3166-2:BD"
  ],
  [
    "BB",
    "BRB",
    "052",
    "ISO 3166-2:BB"
  ],
  [
    "BY",
    "BLR",
    "112",
    "ISO 3166-2:BY"
  ],
  [
    "BE",
    "BEL",
    "056",
    "ISO 3166-2:BE"
  ],
  [
    "BZ",
    "BLZ",
    "084",
    "ISO 3166-2:BZ"
  ],
  [
    "BJ",
    "BEN",
    "204",
    "ISO 3166-2:BJ"
  ],
  [
    "BM",
    "BMU",
    "060",
    "ISO 3166-2:BM"
  ],
  [
    "BT",
    "BTN",
    "064",
    "ISO 3166-2:BT"
  ],
  [
    "BO",
    "BOL",
    "068",
    "ISO 3166-2:BO"
  ],
  [
    "BA",
    "BIH",
    "070",
    "ISO 3166-2:BA"
  ],
  [
    "BW",
    "BWA",
    "072",
    "ISO 3166-2:BW"
  ],
  [
    "BV",
    "BVT",
    "074",
    "ISO 3166-2:BV"
  ],
  [
    "BR",
    "BRA",
    "076",
    "ISO 3166-2:BR"
  ],
  [
    "IO",
    "IOT",
    "086",
    "ISO 3166-2:IO"
  ],
  [
    "BN",
    "BRN",
    "096",
    "ISO 3166-2:BN"
  ],
  [
    "BG",
    "BGR",
    "100",
    "ISO 3166-2:BG"
  ],
  [
    "BF",
    "BFA",
    "854",
    "ISO 3166-2:BF"
  ],
  [
    "BI",
    "BDI",
    "108",
    "ISO 3166-2:BI"
  ],
  [
    "KH",
    "KHM",
    "116",
    "ISO 3166-2:KH"
  ],
  [
    "CM",
    "CMR",
    "120",
    "ISO 3166-2:CM"
  ],
  [
    "CA",
    "CAN",
    "124",
    "ISO 3166-2:CA"
  ],
  [
    "CV",
    "CPV",
    "132",
    "ISO 3166-2:CV"
  ],
  [
    "KY",
    "CYM",
    "136",
    "ISO 3166-2:KY"
  ],
  [
    "CF",
    "CAF",
    "140",
    "ISO 3166-2:CF"
  ],
  [
    "TD",
    "TCD",
    "148",
    "ISO 3166-2:TD"
  ],
  [
    "CL",
    "CHL",
    "152",
    "ISO 3166-2:CL"
  ],
  [
    "CN",
    "CHN",
    "156",
    "ISO 3166-2:CN"
  ],
  [
    "CX",
    "CXR",
    "162",
    "ISO 3166-2:CX"
  ],
  [
    "CC",
    "CCK",
    "166",
    "ISO 3166-2:CC"
  ],
  [
    "CO",
    "COL",
    "170",
    "ISO 3166-2:CO"
  ],
  [
    "KM",
    "COM",
    "174",
    "ISO 3166-2:KM"
  ],
  [
    "CG",
    "COG",
    "178",
    "ISO 3166-2:CG"
  ],
  [
    "CD",
    "COD",
    "180",
    "ISO 3166-2:CD"
  ],
  [
    "CK",
    "COK",
    "184",
    "ISO 3166-2:CK"
  ],
  [
    "CR",
    "CRI",
    "188",
    "ISO 3166-2:CR"
  ],
  [
    "CI",
    "CIV",
    "384",
    "ISO 3166-2:CI"
  ],
  [
    "HR",
    "HRV",
    "191",
    "ISO 3166-2:HR"
  ],
  [
    "CU",
    "CUB",
    "192",
    "ISO 3166-2:CU"
  ],
  [
    "CY",
    "CYP",
    "196",
    "ISO 3166-2:CY"
  ],
  [
    "CZ",
    "CZE",
    "203",
    "ISO 3166-2:CZ"
  ],
  [
    "DK",
    "DNK",
    "208",
    "ISO 3166-2:DK"
  ],
  [
    "DJ",
    "DJI",
    "262",
    "ISO 3166-2:DJ"
  ],
  [
    "DM",
    "DMA",
    "212",
    "ISO 3166-2:DM"
  ],
  [
    "DO",
    "DOM",
    "214",
    "ISO 3166-2:DO"
  ],
  [
    "EC",
    "ECU",
    "218",
    "ISO 3166-2:EC"
  ],
  [
    "EG",
    "EGY",
    "818",
    "ISO 3166-2:EG"
  ],
  [
    "SV",
    "SLV",
    "222",
    "ISO 3166-2:SV"
  ],
  [
    "GQ",
    "GNQ",
    "226",
    "ISO 3166-2:GQ"
  ],
  [
    "ER",
    "ERI",
    "232",
    "ISO 3166-2:ER"
  ],
  [
    "EE",
    "EST",
    "233",
    "ISO 3166-2:EE"
  ],
  [
    "ET",
    "ETH",
    "231",
    "ISO 3166-2:ET"
  ],
  [
    "FK",
    "FLK",
    "238",
    "ISO 3166-2:FK"
  ],
  [
    "FO",
    "FRO",
    "234",
    "ISO 3166-2:FO"
  ],
  [
    "FJ",
    "FJI",
    "242",
    "ISO 3166-2:FJ"
  ],
  [
    "FI",
    "FIN",
    "246",
    "ISO 3166-2:FI"
  ],
  [
    "FR",
    "FRA",
    "250",
    "ISO 3166-2:FR"
  ],
  [
    "GF",
    "GUF",
    "254",
    "ISO 3166-2:GF"
  ],
  [
    "PF",
    "PYF",
    "258",
    "ISO 3166-2:PF"
  ],
  [
    "TF",
    "ATF",
    "260",
    "ISO 3166-2:TF"
  ],
  [
    "GA",
    "GAB",
    "266",
    "ISO 3166-2:GA"
  ],
  [
    "GM",
    "GMB",
    "270",
    "ISO 3166-2:GM"
  ],
  [
    "GE",
    "GEO",
    "268",
    "ISO 3166-2:GE"
  ],
  [
    "DE",
    "DEU",
    "276",
    "ISO 3166-2:DE"
  ],
  [
    "GH",
    "GHA",
    "288",
    "ISO 3166-2:GH"
  ],
  [
    "GI",
    "GIB",
    "292",
    "ISO 3166-2:GI"
  ],
  [
    "GR",
    "GRC",
    "300",
    "ISO 3166-2:GR"
  ],
  [
    "GL",
    "GRL",
    "304",
    "ISO 3166-2:GL"
  ],
  [
    "GD",
    "GRD",
    "308",
    "ISO 3166-2:GD"
  ],
  [
    "GP",
    "GLP",
    "312",
    "ISO 3166-2:GP"
  ],
  [
    "GU",
    "GUM",
    "316",
    "ISO 3166-2:GU"
  ],
  [
    "GT",
    "GTM",
    "320",
    "ISO 3166-2:GT"
  ],
  [
    "GN",
    "GIN",
    "324",
    "ISO 3166-2:GN"
  ],
  [
    "GW",
    "GNB",
    "624",
    "ISO 3166-2:GW"
  ],
  [
    "GY",
    "GUY",
    "328",
    "ISO 3166-2:GY"
  ],
  [
    "HT",
    "HTI",
    "332",
    "ISO 3166-2:HT"
  ],
  [
    "HM",
    "HMD",
    "334",
    "ISO 3166-2:HM"
  ],
  [
    "VA",
    "VAT",
    "336",
    "ISO 3166-2:VA"
  ],
  [
    "HN",
    "HND",
    "340",
    "ISO 3166-2:HN"
  ],
  [
    "HK",
    "HKG",
    "344",
    "ISO 3166-2:HK"
  ],
  [
    "HU",
    "HUN",
    "348",
    "ISO 3166-2:HU"
  ],
  [
    "IS",
    "ISL",
    "352",
    "ISO 3166-2:IS"
  ],
  [
    "IN",
    "IND",
    "356",
    "ISO 3166-2:IN"
  ],
  [
    "ID",
    "IDN",
    "360",
    "ISO 3166-2:ID"
  ],
  [
    "IR",
    "IRN",
    "364",
    "ISO 3166-2:IR"
  ],
  [
    "IQ",
    "IRQ",
    "368",
    "ISO 3166-2:IQ"
  ],
  [
    "IE",
    "IRL",
    "372",
    "ISO 3166-2:IE"
  ],
  [
    "IL",
    "ISR",
    "376",
    "ISO 3166-2:IL"
  ],
  [
    "IT",
    "ITA",
    "380",
    "ISO 3166-2:IT"
  ],
  [
    "JM",
    "JAM",
    "388",
    "ISO 3166-2:JM"
  ],
  [
    "JP",
    "JPN",
    "392",
    "ISO 3166-2:JP"
  ],
  [
    "JO",
    "JOR",
    "400",
    "ISO 3166-2:JO"
  ],
  [
    "KZ",
    "KAZ",
    "398",
    "ISO 3166-2:KZ"
  ],
  [
    "KE",
    "KEN",
    "404",
    "ISO 3166-2:KE"
  ],
  [
    "KI",
    "KIR",
    "296",
    "ISO 3166-2:KI"
  ],
  [
    "KP",
    "PRK",
    "408",
    "ISO 3166-2:KP"
  ],
  [
    "KR",
    "KOR",
    "410",
    "ISO 3166-2:KR"
  ],
  [
    "KW",
    "KWT",
    "414",
    "ISO 3166-2:KW"
  ],
  [
    "KG",
    "KGZ",
    "417",
    "ISO 3166-2:KG"
  ],
  [
    "LA",
    "LAO",
    "418",
    "ISO 3166-2:LA"
  ],
  [
    "LV",
    "LVA",
    "428",
    "ISO 3166-2:LV"
  ],
  [
    "LB",
    "LBN",
    "422",
    "ISO 3166-2:LB"
  ],
  [
    "LS",
    "LSO",
    "426",
    "ISO 3166-2:LS"
  ],
  [
    "LR",
    "LBR",
    "430",
    "ISO 3166-2:LR"
  ],
  [
    "LY",
    "LBY",
    "434",
    "ISO 3166-2:LY"
  ],
  [
    "LI",
    "LIE",
    "438",
    "ISO 3166-2:LI"
  ],
  [
    "LT",
    "LTU",
    "440",
    "ISO 3166-2:LT"
  ],
  [
    "LU",
    "LUX",
    "442",
    "ISO 3166-2:LU"
  ],
  [
    "MO",
    "MAC",
    "446",
    "ISO 3166-2:MO"
  ],
  [
    "MG",
    "MDG",
    "450",
    "ISO 3166-2:MG"
  ],
  [
    "MW",
    "MWI",
    "454",
    "ISO 3166-2:MW"
  ],
  [
    "MY",
    "MYS",
    "458",
    "ISO 3166-2:MY"
  ],
  [
    "MV",
    "MDV",
    "462",
    "ISO 3166-2:MV"
  ],
  [
    "ML",
    "MLI",
    "466",
    "ISO 3166-2:ML"
  ],
  [
    "MT",
    "MLT",
    "470",
    "ISO 3166-2:MT"
  ],
  [
    "MH",
    "MHL",
    "584",
    "ISO 3166-2:MH"
  ],
  [
    "MQ",
    "MTQ",
    "474",
    "ISO 3166-2:MQ"
  ],
  [
    "MR",
    "MRT",
    "478",
    "ISO 3166-2:MR"
  ],
  [
    "MU",
    "MUS",
    "480",
    "ISO 3166-2:MU"
  ],
  [
    "YT",
    "MYT",
    "175",
    "ISO 3166-2:YT"
  ],
  [
    "MX",
    "MEX",
    "484",
    "ISO 3166-2:MX"
  ],
  [
    "FM",
    "FSM",
    "583",
    "ISO 3166-2:FM"
  ],
  [
    "MD",
    "MDA",
    "498",
    "ISO 3166-2:MD"
  ],
  [
    "MC",
    "MCO",
    "492",
    "ISO 3166-2:MC"
  ],
  [
    "MN",
    "MNG",
    "496",
    "ISO 3166-2:MN"
  ],
  [
    "MS",
    "MSR",
    "500",
    "ISO 3166-2:MS"
  ],
  [
    "MA",
    "MAR",
    "504",
    "ISO 3166-2:MA"
  ],
  [
    "MZ",
    "MOZ",
    "508",
    "ISO 3166-2:MZ"
  ],
  [
    "MM",
    "MMR",
    "104",
    "ISO 3166-2:MM"
  ],
  [
    "NA",
    "NAM",
    "516",
    "ISO 3166-2:NA"
  ],
  [
    "NR",
    "NRU",
    "520",
    "ISO 3166-2:NR"
  ],
  [
    "NP",
    "NPL",
    "524",
    "ISO 3166-2:NP"
  ],
  [
    "NL",
    "NLD",
    "528",
    "ISO 3166-2:NL"
  ],
  [
    "NC",
    "NCL",
    "540",
    "ISO 3166-2:NC"
  ],
  [
    "NZ",
    "NZL",
    "554",
    "ISO 3166-2:NZ"
  ],
  [
    "NI",
    "NIC",
    "558",
    "ISO 3166-2:NI"
  ],
  [
    "NE",
    "NER",
    "562",
    "ISO 3166-2:NE"
  ],
  [
    "NG",
    "NGA",
    "566",
    "ISO 3166-2:NG"
  ],
  [
    "NU",
    "NIU",
    "570",
    "ISO 3166-2:NU"
  ],
  [
    "NF",
    "NFK",
    "574",
    "ISO 3166-2:NF"
  ],
  [
    "MP",
    "MNP",
    "580",
    "ISO 3166-2:MP"
  ],
  [
    "MK",
    "MKD",
    "807",
    "ISO 3166-2:MK"
  ],
  [
    "NO",
    "NOR",
    "578",
    "ISO 3166-2:NO"
  ],
  [
    "OM",
    "OMN",
    "512",
    "ISO 3166-2:OM"
  ],
  [
    "PK",
    "PAK",
    "586",
    "ISO 3166-2:PK"
  ],
  [
    "PW",
    "PLW",
    "585",
    "ISO 3166-2:PW"
  ],
  [
    "PS",
    "PSE",
    "275",
    "ISO 3166-2:PS"
  ],
  [
    "PA",
    "PAN",
    "591",
    "ISO 3166-2:PA"
  ],
  [
    "PG",
    "PNG",
    "598",
    "ISO 3166-2:PG"
  ],
  [
    "PY",
    "PRY",
    "600",
    "ISO 3166-2:PY"
  ],
  [
    "PE",
    "PER",
    "604",
    "ISO 3166-2:PE"
  ],
  [
    "PH",
    "PHL",
    "608",
    "ISO 3166-2:PH"
  ],
  [
    "PN",
    "PCN",
    "612",
    "ISO 3166-2:PN"
  ],
  [
    "PL",
    "POL",
    "616",
    "ISO 3166-2:PL"
  ],
  [
    "PT",
    "PRT",
    "620",
    "ISO 3166-2:PT"
  ],
  [
    "PR",
    "PRI",
    "630",
    "ISO 3166-2:PR"
  ],
  [
    "QA",
    "QAT",
    "634",
    "ISO 3166-2:QA"
  ],
  [
    "RE",
    "REU",
    "638",
    "ISO 3166-2:RE"
  ],
  [
    "RO",
    "ROU",
    "642",
    "ISO 3166-2:RO"
  ],
  [
    "RU",
    "RUS",
    "643",
    "ISO 3166-2:RU"
  ],
  [
    "RW",
    "RWA",
    "646",
    "ISO 3166-2:RW"
  ],
  [
    "SH",
    "SHN",
    "654",
    "ISO 3166-2:SH"
  ],
  [
    "KN",
    "KNA",
    "659",
    "ISO 3166-2:KN"
  ],
  [
    "LC",
    "LCA",
    "662",
    "ISO 3166-2:LC"
  ],
  [
    "PM",
    "SPM",
    "666",
    "ISO 3166-2:PM"
  ],
  [
    "VC",
    "VCT",
    "670",
    "ISO 3166-2:VC"
  ],
  [
    "WS",
    "WSM",
    "882",
    "ISO 3166-2:WS"
  ],
  [
    "SM",
    "SMR",
    "674",
    "ISO 3166-2:SM"
  ],
  [
    "ST",
    "STP",
    "678",
    "ISO 3166-2:ST"
  ],
  [
    "SA",
    "SAU",
    "682",
    "ISO 3166-2:SA"
  ],
  [
    "SN",
    "SEN",
    "686",
    "ISO 3166-2:SN"
  ],
  [
    "SC",
    "SYC",
    "690",
    "ISO 3166-2:SC"
  ],
  [
    "SL",
    "SLE",
    "694",
    "ISO 3166-2:SL"
  ],
  [
    "SG",
    "SGP",
    "702",
    "ISO 3166-2:SG"
  ],
  [
    "SK",
    "SVK",
    "703",
    "ISO 3166-2:SK"
  ],
  [
    "SI",
    "SVN",
    "705",
    "ISO 3166-2:SI"
  ],
  [
    "SB",
    "SLB",
    "090",
    "ISO 3166-2:SB"
  ],
  [
    "SO",
    "SOM",
    "706",
    "ISO 3166-2:SO"
  ],
  [
    "ZA",
    "ZAF",
    "710",
    "ISO 3166-2:ZA"
  ],
  [
    "GS",
    "SGS",
    "239",
    "ISO 3166-2:GS"
  ],
  [
    "ES",
    "ESP",
    "724",
    "ISO 3166-2:ES"
  ],
  [
    "LK",
    "LKA",
    "144",
    "ISO 3166-2:LK"
  ],
  [
    "SD",
    "SDN",
    "729",
    "ISO 3166-2:SD"
  ],
  [
    "SR",
    "SUR",
    "740",
    "ISO 3166-2:SR"
  ],
  [
    "SJ",
    "SJM",
    "744",
    "ISO 3166-2:SJ"
  ],
  [
    "SZ",
    "SWZ",
    "748",
    "ISO 3166-2:SZ"
  ],
  [
    "SE",
    "SWE",
    "752",
    "ISO 3166-2:SE"
  ],
  [
    "CH",
    "CHE",
    "756",
    "ISO 3166-2:CH"
  ],
  [
    "SY",
    "SYR",
    "760",
    "ISO 3166-2:SY"
  ],
  [
    "TW",
    "TWN",
    "158",
    "ISO 3166-2:TW"
  ],
  [
    "TJ",
    "TJK",
    "762",
    "ISO 3166-2:TJ"
  ],
  [
    "TZ",
    "TZA",
    "834",
    "ISO 3166-2:TZ"
  ],
  [
    "TH",
    "THA",
    "764",
    "ISO 3166-2:TH"
  ],
  [
    "TL",
    "TLS",
    "626",
    "ISO 3166-2:TL"
  ],
  [
    "TG",
    "TGO",
    "768",
    "ISO 3166-2:TG"
  ],
  [
    "TK",
    "TKL",
    "772",
    "ISO 3166-2:TK"
  ],
  [
    "TO",
    "TON",
    "776",
    "ISO 3166-2:TO"
  ],
  [
    "TT",
    "TTO",
    "780",
    "ISO 3166-2:TT"
  ],
  [
    "TN",
    "TUN",
    "788",
    "ISO 3166-2:TN"
  ],
  [
    "TR",
    "TUR",
    "792",
    "ISO 3166-2:TR"
  ],
  [
    "TM",
    "TKM",
    "795",
    "ISO 3166-2:TM"
  ],
  [
    "TC",
    "TCA",
    "796",
    "ISO 3166-2:TC"
  ],
  [
    "TV",
    "TUV",
    "798",
    "ISO 3166-2:TV"
  ],
  [
    "UG",
    "UGA",
    "800",
    "ISO 3166-2:UG"
  ],
  [
    "UA",
    "UKR",
    "804",
    "ISO 3166-2:UA"
  ],
  [
    "AE",
    "ARE",
    "784",
    "ISO 3166-2:AE"
  ],
  [
    "GB",
    "GBR",
    "826",
    "ISO 3166-2:GB"
  ],
  [
    "US",
    "USA",
    "840",
    "ISO 3166-2:US"
  ],
  [
    "UM",
    "UMI",
    "581",
    "ISO 3166-2:UM"
  ],
  [
    "UY",
    "URY",
    "858",
    "ISO 3166-2:UY"
  ],
  [
    "UZ",
    "UZB",
    "860",
    "ISO 3166-2:UZ"
  ],
  [
    "VU",
    "VUT",
    "548",
    "ISO 3166-2:VU"
  ],
  [
    "VE",
    "VEN",
    "862",
    "ISO 3166-2:VE"
  ],
  [
    "VN",
    "VNM",
    "704",
    "ISO 3166-2:VN"
  ],
  [
    "VG",
    "VGB",
    "092",
    "ISO 3166-2:VG"
  ],
  [
    "VI",
    "VIR",
    "850",
    "ISO 3166-2:VI"
  ],
  [
    "WF",
    "WLF",
    "876",
    "ISO 3166-2:WF"
  ],
  [
    "EH",
    "ESH",
    "732",
    "ISO 3166-2:EH"
  ],
  [
    "YE",
    "YEM",
    "887",
    "ISO 3166-2:YE"
  ],
  [
    "ZM",
    "ZMB",
    "894",
    "ISO 3166-2:ZM"
  ],
  [
    "ZW",
    "ZWE",
    "716",
    "ISO 3166-2:ZW"
  ],
  [
    "AX",
    "ALA",
    "248",
    "ISO 3166-2:AX"
  ],
  [
    "BQ",
    "BES",
    "535",
    "ISO 3166-2:BQ"
  ],
  [
    "CW",
    "CUW",
    "531",
    "ISO 3166-2:CW"
  ],
  [
    "GG",
    "GGY",
    "831",
    "ISO 3166-2:GG"
  ],
  [
    "IM",
    "IMN",
    "833",
    "ISO 3166-2:IM"
  ],
  [
    "JE",
    "JEY",
    "832",
    "ISO 3166-2:JE"
  ],
  [
    "ME",
    "MNE",
    "499",
    "ISO 3166-2:ME"
  ],
  [
    "BL",
    "BLM",
    "652",
    "ISO 3166-2:BL"
  ],
  [
    "MF",
    "MAF",
    "663",
    "ISO 3166-2:MF"
  ],
  [
    "RS",
    "SRB",
    "688",
    "ISO 3166-2:RS"
  ],
  [
    "SX",
    "SXM",
    "534",
    "ISO 3166-2:SX"
  ],
  [
    "SS",
    "SSD",
    "728",
    "ISO 3166-2:SS"
  ],
  [
    "XK",
    "XKX",
    "983",
    "ISO 3166-2:XK"
  ]
], g5 = [
  "br",
  "cy",
  "dv",
  "sw",
  "eu",
  "af",
  "am",
  "ha",
  "ku",
  "ml",
  "no",
  "ps",
  "sd",
  "so",
  "sq",
  "ta",
  "tg",
  "tt",
  "ug",
  "ur",
  "vi",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "gl",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "ka",
  "kk",
  "km",
  "ko",
  "ky",
  "lt",
  "lv",
  "mk",
  "mn",
  "mr",
  "ms",
  "nb",
  "nl",
  "nn",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "th",
  "tr",
  "uk",
  "uz",
  "zh"
];
var v5 = h5, vt = [
  {
    base: " ",
    chars: " "
  },
  {
    base: "0",
    chars: "߀"
  },
  {
    base: "A",
    chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
  },
  {
    base: "AA",
    chars: "Ꜳ"
  },
  {
    base: "AE",
    chars: "ÆǼǢ"
  },
  {
    base: "AO",
    chars: "Ꜵ"
  },
  {
    base: "AU",
    chars: "Ꜷ"
  },
  {
    base: "AV",
    chars: "ꜸꜺ"
  },
  {
    base: "AY",
    chars: "Ꜽ"
  },
  {
    base: "B",
    chars: "ⒷＢḂḄḆɃƁ"
  },
  {
    base: "C",
    chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
  },
  {
    base: "D",
    chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
  },
  {
    base: "Dh",
    chars: "Ð"
  },
  {
    base: "DZ",
    chars: "ǱǄ"
  },
  {
    base: "Dz",
    chars: "ǲǅ"
  },
  {
    base: "E",
    chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
  },
  {
    base: "F",
    chars: "ꝼⒻＦḞƑꝻ"
  },
  {
    base: "G",
    chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
  },
  {
    base: "H",
    chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
  },
  {
    base: "I",
    chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
  },
  {
    base: "J",
    chars: "ⒿＪĴɈȷ"
  },
  {
    base: "K",
    chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
  },
  {
    base: "L",
    chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
  },
  {
    base: "LJ",
    chars: "Ǉ"
  },
  {
    base: "Lj",
    chars: "ǈ"
  },
  {
    base: "M",
    chars: "ⓂＭḾṀṂⱮƜϻ"
  },
  {
    base: "N",
    chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
  },
  {
    base: "NJ",
    chars: "Ǌ"
  },
  {
    base: "Nj",
    chars: "ǋ"
  },
  {
    base: "O",
    chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
  },
  {
    base: "OE",
    chars: "Œ"
  },
  {
    base: "OI",
    chars: "Ƣ"
  },
  {
    base: "OO",
    chars: "Ꝏ"
  },
  {
    base: "OU",
    chars: "Ȣ"
  },
  {
    base: "P",
    chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
  },
  {
    base: "Q",
    chars: "ⓆＱꝖꝘɊ"
  },
  {
    base: "R",
    chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
  },
  {
    base: "S",
    chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
  },
  {
    base: "T",
    chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
  },
  {
    base: "Th",
    chars: "Þ"
  },
  {
    base: "TZ",
    chars: "Ꜩ"
  },
  {
    base: "U",
    chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
  },
  {
    base: "V",
    chars: "ⓋＶṼṾƲꝞɅ"
  },
  {
    base: "VY",
    chars: "Ꝡ"
  },
  {
    base: "W",
    chars: "ⓌＷẀẂŴẆẄẈⱲ"
  },
  {
    base: "X",
    chars: "ⓍＸẊẌ"
  },
  {
    base: "Y",
    chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
  },
  {
    base: "Z",
    chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
  },
  {
    base: "a",
    chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
  },
  {
    base: "aa",
    chars: "ꜳ"
  },
  {
    base: "ae",
    chars: "æǽǣ"
  },
  {
    base: "ao",
    chars: "ꜵ"
  },
  {
    base: "au",
    chars: "ꜷ"
  },
  {
    base: "av",
    chars: "ꜹꜻ"
  },
  {
    base: "ay",
    chars: "ꜽ"
  },
  {
    base: "b",
    chars: "ⓑｂḃḅḇƀƃɓƂ"
  },
  {
    base: "c",
    chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
  },
  {
    base: "d",
    chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
  },
  {
    base: "dh",
    chars: "ð"
  },
  {
    base: "dz",
    chars: "ǳǆ"
  },
  {
    base: "e",
    chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
  },
  {
    base: "f",
    chars: "ⓕｆḟƒ"
  },
  {
    base: "ff",
    chars: "ﬀ"
  },
  {
    base: "fi",
    chars: "ﬁ"
  },
  {
    base: "fl",
    chars: "ﬂ"
  },
  {
    base: "ffi",
    chars: "ﬃ"
  },
  {
    base: "ffl",
    chars: "ﬄ"
  },
  {
    base: "g",
    chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
  },
  {
    base: "h",
    chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
  },
  {
    base: "hv",
    chars: "ƕ"
  },
  {
    base: "i",
    chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
  },
  {
    base: "j",
    chars: "ⓙｊĵǰɉ"
  },
  {
    base: "k",
    chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
  },
  {
    base: "l",
    chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
  },
  {
    base: "lj",
    chars: "ǉ"
  },
  {
    base: "m",
    chars: "ⓜｍḿṁṃɱɯ"
  },
  {
    base: "n",
    chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
  },
  {
    base: "nj",
    chars: "ǌ"
  },
  {
    base: "o",
    chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
  },
  {
    base: "oe",
    chars: "œ"
  },
  {
    base: "oi",
    chars: "ƣ"
  },
  {
    base: "oo",
    chars: "ꝏ"
  },
  {
    base: "ou",
    chars: "ȣ"
  },
  {
    base: "p",
    chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
  },
  {
    base: "q",
    chars: "ⓠｑɋꝗꝙ"
  },
  {
    base: "r",
    chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
  },
  {
    base: "s",
    chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
  },
  {
    base: "ss",
    chars: "ß"
  },
  {
    base: "t",
    chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
  },
  {
    base: "th",
    chars: "þ"
  },
  {
    base: "tz",
    chars: "ꜩ"
  },
  {
    base: "u",
    chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
  },
  {
    base: "v",
    chars: "ⓥｖṽṿʋꝟʌ"
  },
  {
    base: "vy",
    chars: "ꝡ"
  },
  {
    base: "w",
    chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
  },
  {
    base: "x",
    chars: "ⓧｘẋẍ"
  },
  {
    base: "y",
    chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
  },
  {
    base: "z",
    chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
  }
], ia = {};
for (var mt = 0; mt < vt.length; mt += 1)
  for (var Fi = vt[mt].chars, bs = 0; bs < Fi.length; bs += 1)
    ia[Fi[bs]] = vt[mt].base;
function h5(r) {
  return r.replace(/[^\u0000-\u007e]/g, function(e) {
    return ia[e] || e;
  });
}
var x5 = vt, b5 = ia, y5 = {
  remove: v5,
  replacementList: x5,
  diacriticsMap: b5
}, Vo = ne(function(r, e) {
  const t = y5.remove, s = {}, a = {}, i = {}, o = {}, l = {};
  m5.forEach(function(B) {
    const R = B;
    a[R[0]] = R[1], i[R[1]] = R[0], o[R[2]] = R[0], l[R[0]] = R[2];
  });
  function p(B) {
    return ("000" + (B || "")).slice(-3);
  }
  function g(B, R) {
    return Object.prototype.hasOwnProperty.call(B, R);
  }
  function w(B, R) {
    return Object.keys(B).reduce(function(L, Z) {
      const c = B[Z];
      return L[Z] = R(c, Z), L;
    }, {});
  }
  function k(B, R) {
    switch (B) {
      case "official":
        return Array.isArray(R) ? R[0] : R;
      case "all":
        return typeof R == "string" ? [R] : R;
      case "alias":
        return Array.isArray(R) ? R[1] || R[0] : R;
      default:
        throw new TypeError(
          "LocaleNameType must be one of these: all, official, alias!"
        );
    }
  }
  e.registerLocale = function(B) {
    if (!B.locale)
      throw new TypeError("Missing localeData.locale");
    if (!B.countries)
      throw new TypeError("Missing localeData.countries");
    s[B.locale] = B.countries;
  };
  function h(B) {
    return i[B];
  }
  e.alpha3ToAlpha2 = h;
  function S(B) {
    return a[B];
  }
  e.alpha2ToAlpha3 = S;
  function _(B) {
    return l[h(B)];
  }
  e.alpha3ToNumeric = _;
  function G(B) {
    return l[B];
  }
  e.alpha2ToNumeric = G;
  function I(B) {
    const R = p(B);
    return S(o[R]);
  }
  e.numericToAlpha3 = I;
  function N(B) {
    const R = p(B);
    return o[R];
  }
  e.numericToAlpha2 = N;
  function C(B) {
    if (typeof B == "string") {
      if (/^[0-9]*$/.test(B))
        return I(B);
      if (B.length === 2)
        return S(B.toUpperCase());
      if (B.length === 3)
        return B.toUpperCase();
    }
    if (typeof B == "number")
      return I(B);
  }
  e.toAlpha3 = C;
  function re(B) {
    if (typeof B == "string") {
      if (/^[0-9]*$/.test(B))
        return N(B);
      if (B.length === 2)
        return B.toUpperCase();
      if (B.length === 3)
        return h(B.toUpperCase());
    }
    if (typeof B == "number")
      return N(B);
  }
  e.toAlpha2 = re, e.getName = function(B, R, L = {}) {
    "select" in L || (L.select = "official");
    try {
      const c = s[R.toLowerCase()][re(B)];
      return k(L.select, c);
    } catch {
      return;
    }
  }, e.getNames = function(B, R = {}) {
    "select" in R || (R.select = "official");
    const L = s[B.toLowerCase()];
    return L === void 0 ? {} : w(L, function(Z) {
      return k(R.select, Z);
    });
  }, e.getAlpha2Code = function(B, R) {
    const L = (c) => c.toLowerCase(), Z = (c, u) => L(c) === L(u);
    try {
      const c = s[R.toLowerCase()];
      for (const u in c)
        if (g(c, u)) {
          if (typeof c[u] == "string" && Z(c[u], B))
            return u;
          if (Array.isArray(c[u])) {
            for (const m of c[u])
              if (Z(m, B))
                return u;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getSimpleAlpha2Code = function(B, R) {
    const L = (c) => t(c.toLowerCase()), Z = (c, u) => L(c) === L(u);
    try {
      const c = s[R.toLowerCase()];
      for (const u in c)
        if (g(c, u)) {
          if (typeof c[u] == "string" && Z(c[u], B))
            return u;
          if (Array.isArray(c[u])) {
            for (const m of c[u])
              if (Z(m, B))
                return u;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getAlpha2Codes = function() {
    return a;
  }, e.getAlpha3Code = function(B, R) {
    const L = e.getAlpha2Code(B, R);
    if (L)
      return e.toAlpha3(L);
  }, e.getSimpleAlpha3Code = function(B, R) {
    const L = e.getSimpleAlpha2Code(B, R);
    if (L)
      return e.toAlpha3(L);
  }, e.getAlpha3Codes = function() {
    return i;
  }, e.getNumericCodes = function() {
    return o;
  }, e.langs = function() {
    return Object.keys(s);
  }, e.getSupportedLanguages = function() {
    return g5;
  }, e.isValid = function(B) {
    if (!B)
      return !1;
    const R = B.toString().toUpperCase();
    return g(i, R) || g(a, R) || g(o, R);
  };
});
const w5 = "en", z5 = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: [
    "People's Republic of China",
    "China"
  ],
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: [
    "Republic of the Congo",
    "Congo"
  ],
  CD: [
    "Democratic Republic of the Congo",
    "Congo"
  ],
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: [
    "Cote D'Ivoire",
    "Ivory Coast"
  ],
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: [
    "Czech Republic",
    "Czechia"
  ],
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: [
    "Republic of The Gambia",
    "The Gambia",
    "Gambia"
  ],
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: [
    "Islamic Republic of Iran",
    "Iran"
  ],
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "North Korea",
  KR: [
    "South Korea",
    "Korea, Republic of",
    "Republic of Korea"
  ],
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: [
    "The Republic of North Macedonia",
    "North Macedonia"
  ],
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: [
    "State of Palestine",
    "Palestine"
  ],
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: [
    "Russian Federation",
    "Russia"
  ],
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: [
    "Taiwan, Province of China",
    "Taiwan"
  ],
  TJ: "Tajikistan",
  TZ: [
    "United Republic of Tanzania",
    "Tanzania"
  ],
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: [
    "Türkiye",
    "Turkey"
  ],
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: [
    "United Kingdom",
    "UK",
    "Great Britain"
  ],
  US: [
    "United States of America",
    "United States",
    "USA"
  ],
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland Islands",
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (French part)",
  RS: "Serbia",
  SX: "Sint Maarten (Dutch part)",
  SS: "South Sudan",
  XK: "Kosovo"
}, F5 = {
  locale: w5,
  countries: z5
}, E5 = "fr", j5 = {
  AF: "Afghanistan",
  AL: "Albanie",
  DZ: "Algérie",
  AS: "Samoa américaines",
  AD: "Andorre",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctique",
  AG: "Antigua-et-Barbuda",
  AR: "Argentine",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Australie",
  AT: "Autriche",
  AZ: "Azerbaïdjan",
  BS: "Bahamas",
  BH: "Bahreïn",
  BD: "Bangladesh",
  BB: "Barbade",
  BY: "Biélorussie",
  BE: "Belgique",
  BZ: "Belize",
  BJ: "Bénin",
  BM: "Bermudes",
  BT: "Bhoutan",
  BO: "Bolivie",
  BA: "Bosnie-Herzégovine",
  BW: "Botswana",
  BV: "Île Bouvet",
  BR: "Brésil",
  IO: "Océan Indien Britannique",
  BN: "Brunei Darussalam",
  BG: "Bulgarie",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodge",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Cap-Vert",
  KY: "Îles Caïmans",
  CF: "République Centrafricaine",
  TD: "Tchad",
  CL: "Chili",
  CN: "Chine",
  CX: "Île Christmas",
  CC: "Îles Cocos",
  CO: "Colombie",
  KM: "Comores",
  CG: "République du Congo",
  CD: "République démocratique du Congo",
  CK: "Îles Cook",
  CR: "Costa Rica",
  CI: "Côte-d'Ivoire",
  HR: "Croatie",
  CU: "Cuba",
  CY: "Chypre",
  CZ: "République Tchèque",
  DK: "Danemark",
  DJ: "Djibouti",
  DM: "Dominique",
  DO: "République Dominicaine",
  EC: "Équateur",
  EG: "Égypte",
  SV: "El Salvador",
  GQ: "Guinée équatoriale",
  ER: "Érythrée",
  EE: "Estonie",
  ET: "Éthiopie",
  FK: "Îles Malouines",
  FO: "Îles Féroé",
  FJ: "Fidji",
  FI: "Finlande",
  FR: "France",
  GF: "Guyane française",
  PF: "Polynésie française",
  TF: "Terres australes françaises",
  GA: "Gabon",
  GM: "Gambie",
  GE: "Géorgie",
  DE: "Allemagne",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grèce",
  GL: "Groenland",
  GD: "Grenade",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinée",
  GW: "Guinée-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Îles Heard-et-MacDonald",
  VA: "Saint-Siège (Vatican)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongrie",
  IS: "Islande",
  IN: "Inde",
  ID: "Indonésie",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlande",
  IL: "Israël",
  IT: "Italie",
  JM: "Jamaïque",
  JP: "Japon",
  JO: "Jordanie",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Corée du Nord",
  KR: "Corée du Sud",
  KW: "Koweït",
  KG: "Kirghizistan",
  LA: "Laos",
  LV: "Lettonie",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Libye",
  LI: "Liechtenstein",
  LT: "Lituanie",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macédoine du Nord",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaisie",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malte",
  MH: "Îles Marshall",
  MQ: "Martinique",
  MR: "Mauritanie",
  MU: "Maurice",
  YT: "Mayotte",
  MX: "Mexique",
  FM: "Micronésie",
  MD: "Moldavie",
  MC: "Monaco",
  MN: "Mongolie",
  MS: "Montserrat",
  MA: "Maroc",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  NP: "Népal",
  NL: "Pays-Bas",
  NC: "Nouvelle-Calédonie",
  NZ: "Nouvelle-Zélande",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NU: "Niué",
  NF: "Île Norfolk",
  MP: "Îles Mariannes du Nord",
  NO: "Norvège",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palaos",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papouasie-Nouvelle-Guinée",
  PY: "Paraguay",
  PE: "Pérou",
  PH: "Philippines",
  PN: "Îles Pitcairn",
  PL: "Pologne",
  PT: "Portugal",
  PR: "Porto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roumanie",
  RU: "Russie",
  RW: "Rwanda",
  SH: "Sainte-Hélène",
  KN: "Saint-Christophe-et-Niévès",
  LC: "Sainte-Lucie",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "Saint-Vincent-et-les-Grenadines",
  WS: "Samoa",
  SM: "Saint-Marin",
  ST: "São Tomé-et-Principe",
  SA: "Arabie Saoudite",
  SN: "Sénégal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapour",
  SK: "Slovaquie",
  SI: "Slovénie",
  SB: "Îles Salomon",
  SO: "Somalie",
  ZA: "Afrique du Sud",
  GS: "Géorgie du Sud-et-les Îles Sandwich du Sud",
  ES: "Espagne",
  LK: "Sri Lanka",
  SD: "Soudan",
  SR: "Suriname",
  SJ: "Svalbard et Île Jan Mayen",
  SZ: "Royaume d'Eswatini",
  SE: "Suède",
  CH: "Suisse",
  SY: "Syrie",
  TW: "Taïwan",
  TJ: "Tadjikistan",
  TZ: "République unie de Tanzanie",
  TH: "Thaïlande",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinité-et-Tobago",
  TN: "Tunisie",
  TR: "Turquie",
  TM: "Turkménistan",
  TC: "Îles Turques-et-Caïques",
  TV: "Tuvalu",
  UG: "Ouganda",
  UA: "Ukraine",
  AE: "Émirats Arabes Unis",
  GB: "Royaume-Uni",
  US: "États-Unis d'Amérique",
  UM: "Îles mineures éloignées des États-Unis",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Îles vierges britanniques",
  VI: "Îles vierges américaines",
  WF: "Wallis-et-Futuna",
  EH: "Sahara occidental",
  YE: "Yémen",
  ZM: "Zambie",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Bonaire, Saint-Eustache et Saba",
  CW: "Curaçao",
  GG: "Guernesey",
  IM: "Île de Man",
  JE: "Jersey",
  ME: "Monténégro",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin (partie française)",
  RS: "Serbie",
  SX: "Saint-Martin (partie néerlandaise)",
  SS: "Soudan du Sud",
  XK: "Kosovo"
}, C5 = {
  locale: E5,
  countries: j5
};
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fal", s = "chevron-down", a = 448, i = 512, o = [], l = "f078", p = "M4.251 181.1C7.392 177.7 11.69 175.1 16 175.1c3.891 0 7.781 1.406 10.86 4.25l197.1 181.1l197.1-181.1c6.5-6 16.64-5.625 22.61 .9062c6 6.5 5.594 16.59-.8906 22.59l-208 192c-6.156 5.688-15.56 5.688-21.72 0l-208-192C-1.343 197.7-1.749 187.6 4.251 181.1z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faChevronDown = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
Vo.registerLocale(F5);
Vo.registerLocale(C5);
const S5 = qo;
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fal", s = "angle-up", a = 384, i = 512, o = [8963], l = "f106", p = "M363.9 330.7c-6.271 6.918-16.39 6.783-22.62 1.188L192 197.5l-149.3 134.4c-6.594 5.877-16.69 5.361-22.62-1.188C14.2 324.1 14.73 314 21.29 308.1l159.1-144c6.125-5.469 15.31-5.469 21.44 0l159.1 144C369.3 314 369.8 324.1 363.9 330.7z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faAngleUp = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
const A5 = '@charset "UTF-8";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:"roboto", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-select-root,.skp-multiselect-root,.skp-combobox-root,.skp-nav-dropdown-root{position:relative;display:flex;border-radius:var(--skp-size-1)}.skp-select-root:focus-visible,.skp-multiselect-root:focus-visible,.skp-combobox-root:focus-visible,.skp-nav-dropdown-root:focus-visible{outline:4px solid var(--skp-color-neutral-100)}.skp-select-down,.skp-multiselect-down,.skp-combobox-down,.skp-nav-dropdown-down{flex-direction:column}.skp-select-up,.skp-multiselect-up,.skp-combobox-up,.skp-nav-dropdown-up{flex-direction:column-reverse}.skp-select-dropdown-up,.skp-multiselect-dropdown-up,.skp-combobox-dropdown-up,.skp-nav-dropdown-dropdown-up{position:absolute;bottom:-100%;width:100%}.skp-select-error:focus-visible,.skp-multiselect-error:focus-visible,.skp-combobox-error:focus-visible,.skp-nav-dropdown-error:focus-visible{outline:4px solid var(--skp-color-error-100)}.skp-select-root.skp-select-with-media.skp-select-small .skp-input-text-input{text-indent:18px}.skp-select-root.skp-select-with-media.skp-select-medium .skp-input-text-input{text-indent:24px}.skp-select-root.skp-select-with-media.skp-select-large .skp-input-text-input{text-indent:28px}.skp-select-root.skp-select-small .skp-input-text-input{padding-right:30px}.skp-select-root.skp-select-medium .skp-input-text-input{padding-right:36px}.skp-select-root.skp-select-large .skp-input-text-input{padding-right:40px}.skp-select-root .skp-input-text-input:not(:disabled){cursor:pointer}.skp-select-root .skp-select-left-element{position:absolute;top:50%;transform:translateY(-50%) !important;left:var(--skp-size-3)}.skp-select-root .skp-select-left-element-image{border-radius:50%;overflow:hidden;background:var(--skp-color-white) no-repeat center;background-size:cover}.skp-select-root .skp-select-left-element-image.skp-select-left-element-small{width:14px;min-width:14px;height:14px}.skp-select-root .skp-select-left-element-image.skp-select-left-element-medium{width:20px;min-width:20px;height:20px}.skp-select-root .skp-select-left-element-image.skp-select-left-element-large{width:24px;min-width:24px;height:24px}.skp-select-root .skp-select-left-element-image.skp-select-left-element-empty{background:var(--skp-color-neutral-100);display:flex;align-items:center;justify-content:center}.skp-select-root .skp-select-angle-icon{position:absolute;top:50%;transform:translateY(-50%) !important;right:18px;transform-origin:center 25%;transition:transform 0.2s ease-in-out}.skp-select-root .skp-select-angle-icon-small{right:10px}.skp-select-root .skp-select-angle-icon.skp-select-angle-icon-open{transform:rotate(180deg) !important}.skp-select-helper-text{margin-top:var(--skp-size-2) !important}', D5 = /* @__PURE__ */ Ae(class extends De {
  constructor() {
    super(), this.__registerHost(), this.skpSelectChange = sr(this, "skpSelectChange", 7), this.open = !1, this.selectedOption = void 0, this.dropdownDirection = "down", this.disabled = !1, this.error = void 0, this.helperText = void 0, this.icon = void 0, this.name = `select-${String(Math.ceil(Date.now() * Math.random()))}`, this.options = void 0, this.placeholder = void 0, this.size = "medium", this.value = "";
  }
  onValueChange(e) {
    this.skpSelectChange.emit(e);
  }
  onOptionChange() {
    this.value && this.setSelectedOption(this.value);
  }
  componentWillLoad() {
    this.setSelectedOption(this.value);
  }
  disconnectedCallback() {
    var e;
    (e = document.getElementById(`portal-${this.name}`)) === null || e === void 0 || e.remove();
  }
  onBlur(e) {
    var t, s;
    this.open && !(!((t = e.relatedTarget) === null || t === void 0) && t.closest(`#${this.name}`)) && !(!((s = e.relatedTarget) === null || s === void 0) && s.closest("skp-portal")) && this.closeDropdown(!0);
  }
  onKeyUp(e) {
    e.target.name === this.name && (e.detail.key === "Enter" && this.handleSelect(e.detail.target.parentElement.value), e.detail.key === "Escape" && this.closeDropdown(!0));
  }
  onCheck(e) {
    this.name === e.target.closest("skp-dropdown-list").name && this.handleSelect(e.detail);
  }
  // Reset value if user removed readOnly attribute from input in html and typed random value
  onInputChange() {
    this.value = "";
  }
  openDropdown() {
    this.dropdownDirection = D3(this.select.getBoundingClientRect().bottom, this.size), this.open = !0;
  }
  closeDropdown(e) {
    e || this.select.focus(), setTimeout(() => {
      this.open = !1;
    }, 100);
  }
  handleState() {
    if (!this.disabled) {
      if (this.open) {
        this.closeDropdown();
        return;
      }
      this.openDropdown();
    }
  }
  handleSelect(e) {
    this.value !== e && (this.value = e, this.setSelectedOption(e), this.closeDropdown());
  }
  setSelectedOption(e) {
    this.selectedOption = this.options.find((t) => t.value === e) || null;
  }
  handleKeyUp(e) {
    var t, s, a, i, o, l;
    const p = document.getElementById(`portal-${this.name}`), g = (t = p.querySelector(".skp-dropdown-list-root")) === null || t === void 0 ? void 0 : t.querySelector(`[value="${this.value}"]`);
    switch (e.key) {
      case "Enter": {
        this.handleState();
        break;
      }
      case "ArrowDown": {
        if (!this.open) {
          this.openDropdown();
          return;
        }
        if (this.value && g) {
          g.querySelector("li").focus();
          return;
        }
        (a = (s = p.querySelector(".skp-dropdown-list-root")) === null || s === void 0 ? void 0 : s.querySelector("li")) === null || a === void 0 || a.focus();
        break;
      }
      case "ArrowUp": {
        if (!this.open) {
          this.openDropdown();
          return;
        }
        if (this.value && g) {
          g.querySelector("li").focus();
          return;
        }
        (l = (o = (i = p.querySelector(".skp-dropdown-list-content")) === null || i === void 0 ? void 0 : i.lastElementChild) === null || o === void 0 ? void 0 : o.querySelector("li")) === null || l === void 0 || l.focus();
        break;
      }
    }
  }
  render() {
    var e, t, s, a, i, o, l, p, g, w, k, h, S;
    const _ = this.disabled ? "--skp-color-neutral-400" : "--skp-color-neutral-900", G = this.value && ["image", "icon", "flag"].includes((e = this.selectedOption) === null || e === void 0 ? void 0 : e.type), I = Lt("skp-select");
    return U(it, null, U("div", { "aria-label": `select-${this.name}`, "aria-haspopup": "listbox", "aria-expanded": this.open, class: I()("root", this.size, this.dropdownDirection, {
      "with-media": this.icon || G,
      error: this.error
    }), tabIndex: this.disabled ? -1 : 0, id: this.name, onClick: this.handleState.bind(this), onKeyUp: this.handleKeyUp.bind(this), ref: (N) => this.select = N }, U("skp-input-text", { name: `input-${this.name}`, value: (t = this.selectedOption) === null || t === void 0 ? void 0 : t.text, size: this.size, placeholder: this.placeholder, skpTabindex: -1, error: this.error, disabled: this.disabled, readOnly: !0 }, this.icon && !G && U("skp-icon", { icon: this.icon, size: this.size, skpClass: I()("left-element", `left-element-${this.size}`), cursor: this.disabled ? "not-allowed" : "pointer", color: _ }), ((s = this.selectedOption) === null || s === void 0 ? void 0 : s.type) === "icon" && U("skp-icon", { icon: (i = (a = this.selectedOption) === null || a === void 0 ? void 0 : a.config) === null || i === void 0 ? void 0 : i.icon, size: this.size, skpClass: I()("left-element", `left-element-${this.size}`), cursor: this.disabled ? "not-allowed" : "pointer", color: _ }), ((o = this.selectedOption) === null || o === void 0 ? void 0 : o.type) === "image" && this.selectedOption ? !((l = this.selectedOption.config) === null || l === void 0) && l.image ? U("div", { class: I()("left-element", "left-element-image", `left-element-${this.size}`), style: { backgroundImage: `url(${(g = (p = this.selectedOption) === null || p === void 0 ? void 0 : p.config) === null || g === void 0 ? void 0 : g.image})` } }) : U("div", { class: I()("left-element", "left-element-image", "left-element-empty", `left-element-${this.size}`) }, U("skp-icon", { icon: Ko.faCameraSlash })) : null, ((w = this.selectedOption) === null || w === void 0 ? void 0 : w.type) === "flag" && U("skp-flag", { country: (S = (h = (k = this.selectedOption) === null || k === void 0 ? void 0 : k.config) === null || h === void 0 ? void 0 : h.flagProps) === null || S === void 0 ? void 0 : S.country, size: this.size === "large" ? "small" : "xsmall", skpClass: "skp-select-left-element" }), U("skp-icon", { icon: S3.faAngleDown, size: this.size, skpClass: I()("angle-icon", `angle-icon-${this.size}`, { "angle-icon-open": this.open }), cursor: this.disabled ? "not-allowed" : "pointer", color: _ })), U("div", { ref: (N) => this.dropdownListContainer = N }, U("skp-portal", { key: this.dropdownDirection, reference: this.dropdownListContainer, name: `portal-${this.name}` }, this.open && U("skp-dropdown-list", { name: this.name, activeValues: [this.value], options: this.options, direction: this.dropdownDirection, size: this.size, skpClass: I()({
      "dropdown-up": this.dropdownDirection === "up"
    }) })))), this.helperText && !this.error && U("skp-text", { text: this.helperText, color: "--skp-color-neutral-300", size: "xsmall", skpClass: "skp-select-helper-text" }));
  }
  static get watchers() {
    return {
      value: ["onValueChange"],
      options: ["onOptionChange"]
    };
  }
  static get style() {
    return A5;
  }
}, [0, "skp-select", {
  disabled: [4],
  error: [1],
  helperText: [1, "helper-text"],
  icon: [16],
  name: [513],
  options: [16],
  placeholder: [1],
  size: [1],
  value: [1537],
  open: [32],
  selectedOption: [32],
  dropdownDirection: [32]
}, [[10, "blur", "onBlur"], [8, "skpDropdownNavigate", "onKeyUp"], [8, "skpSelect", "onCheck"], [0, "skpChange", "onInputChange"]], {
  value: ["onValueChange"],
  options: ["onOptionChange"]
}]);
function _5() {
  if (typeof customElements > "u")
    return;
  ["skp-select", "skp-checkbox", "skp-dropdown-list", "skp-dropdown-list-item", "skp-flag", "skp-icon", "skp-input-text", "skp-portal", "skp-progress", "skp-text"].forEach((e) => {
    switch (e) {
      case "skp-select":
        customElements.get(e) || customElements.define(e, D5);
        break;
      case "skp-checkbox":
        customElements.get(e) || sa();
        break;
      case "skp-dropdown-list":
        customElements.get(e) || P3();
        break;
      case "skp-dropdown-list-item":
        customElements.get(e) || Yo();
        break;
      case "skp-flag":
        customElements.get(e) || aa();
        break;
      case "skp-icon":
        customElements.get(e) || ar();
        break;
      case "skp-input-text":
        customElements.get(e) || K3();
        break;
      case "skp-portal":
        customElements.get(e) || f5();
        break;
      case "skp-progress":
        customElements.get(e) || Wo();
        break;
      case "skp-text":
        customElements.get(e) || $r();
        break;
    }
  });
}
ne(function(r, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", s = "bell", a = 448, i = 512, o = [61602, 128276], l = "f0f3", p = "M256 32V51.2C329 66.03 384 130.6 384 208V226.8C384 273.9 401.3 319.2 432.5 354.4L439.9 362.7C448.3 372.2 450.4 385.6 445.2 397.1C440 408.6 428.6 416 416 416H32C19.4 416 7.971 408.6 2.809 397.1C-2.353 385.6-.2883 372.2 8.084 362.7L15.5 354.4C46.74 319.2 64 273.9 64 226.8V208C64 130.6 118.1 66.03 192 51.2V32C192 14.33 206.3 0 224 0C241.7 0 256 14.33 256 32H256zM224 512C207 512 190.7 505.3 178.7 493.3C166.7 481.3 160 464.1 160 448H288C288 464.1 281.3 481.3 269.3 493.3C257.3 505.3 240.1 512 224 512z";
  e.definition = {
    prefix: t,
    iconName: s,
    icon: [
      a,
      i,
      o,
      l,
      p
    ]
  }, e.faBell = e.definition, e.prefix = t, e.iconName = s, e.width = a, e.height = i, e.ligatures = o, e.unicode = l, e.svgPathData = p, e.aliases = o;
});
const O5 = _5, $5 = /* @__PURE__ */ Rt("skp-button", void 0, void 0, x3), M5 = /* @__PURE__ */ Rt("skp-button-icon", void 0, void 0, z3), Zo = /* @__PURE__ */ Rt("skp-loader", void 0, void 0, S5), B5 = /* @__PURE__ */ Rt("skp-select", void 0, void 0, O5), T5 = (r) => {
  const {
    message_threads_open_count: e,
    message_threads_unread_count: t,
    message_threads_archived_count: s
  } = r;
  return [
    {
      value: "unread",
      key: "js.inbox.filters.unread",
      numberOfMessages: t
    },
    {
      value: "open",
      key: "js.inbox.filters.open",
      numberOfMessages: e
    },
    {
      value: "archived",
      key: "js.inbox.filters.archived",
      numberOfMessages: s
    }
  ];
}, I5 = ({
  threads: r,
  selected: e,
  onSelect: t
}) => {
  const { i18n: s } = Je(), { state: a, dispatch: i } = Ne(), o = tr(() => T5(r).map(({ value: g, key: w, numberOfMessages: k }) => ({
    text: `${s.t(w)} (${k})`,
    value: g
  })), [r]), l = (g) => {
    const w = g.detail;
    t(w);
  }, p = () => {
    i(jr("create-thread"));
  };
  return /* @__PURE__ */ z.jsxs("ul", { className: "skp-mb-0", children: [
    /* @__PURE__ */ z.jsx("li", { className: "skp-mb-4", children: /* @__PURE__ */ z.jsx(
      $5,
      {
        size: "medium",
        width: "full",
        disabled: a.mode === "create-thread",
        onSkpClick: p,
        text: s.t("js.inbox.new_message")
      }
    ) }),
    /* @__PURE__ */ z.jsx("li", { children: /* @__PURE__ */ z.jsx(
      B5,
      {
        name: "status",
        size: "medium",
        value: e,
        options: o || [],
        placeholder: "Select...",
        onSkpSelectChange: l
      }
    ) })
  ] });
}, Jo = ln(
  ({
    onNext: r,
    children: e,
    offset: t = 50,
    hasMore: s = !0,
    scrollingDirection: a = "bottom"
  }, i) => {
    const o = be(null), l = be(null), p = be(!1), g = be(0), w = be(!0), k = be(!1), h = be(
      null
    ), S = be(null);
    Ge(() => {
      k.current && (G(), k.current = !1);
    }, [k.current]);
    const _ = () => {
      o.current && (g.current = o.current.scrollHeight - o.current.scrollTop);
    }, G = () => {
      o.current && (o.current.scrollTop = o.current.scrollHeight - g.current);
    };
    return Ge(() => {
      var I;
      if (!(!l.current || !o.current))
        return S.current = new MutationObserver(() => {
          !o.current || !o.current || (w.current = o.current.scrollHeight > o.current.clientHeight);
        }), h.current = new IntersectionObserver(
          (N) => {
            const [C] = N;
            C.isIntersecting && w.current && !p.current && s && (p.current = !0, a === "top" && (k.current = !1, _()), r().then(() => {
              p.current = !1, a === "top" && (k.current = !0);
            }));
          },
          {
            root: o.current,
            rootMargin: "0px",
            threshold: 1
          }
        ), S.current.observe(o.current, {
          attributes: !1,
          childList: !0,
          subtree: !0
        }), (I = h.current) == null || I.observe(l.current), () => {
          var N, C;
          (N = h == null ? void 0 : h.current) == null || N.disconnect(), (C = S == null ? void 0 : S.current) == null || C.disconnect();
        };
    }, [r]), pn(i, () => ({
      scrollUp: () => {
        o.current && (o.current.scrollTop = 0);
      },
      scrollDown: () => {
        o.current && (o.current.scrollTop = o.current.scrollHeight);
      }
    })), /* @__PURE__ */ z.jsx(
      "div",
      {
        ref: o,
        "data-testid": "infinite-scroll",
        className: zr(
          "scrollable scrollbar skp-absolute skp-left-0 skp-top-0 skp-h-full skp-w-full skp-overflow-auto"
        ),
        children: /* @__PURE__ */ z.jsxs("div", { className: "content skp-relative", children: [
          e,
          /* @__PURE__ */ z.jsx(
            "div",
            {
              ref: l,
              style: { height: t },
              className: zr(
                "skp-invisible skp-absolute skp-left-0 skp-w-full",
                {
                  "skp-top-0": a === "top",
                  "skp-bottom-0": a === "bottom"
                }
              )
            }
          )
        ] })
      }
    );
  }
);
function Qo({
  queryFn: r,
  hooks: e,
  initialPage: t = 1,
  reverseScrolling: s = !1,
  shouldFetchOnInit: a = !1,
  shouldResetDataWhenQueryKeyChange: i = !1
}, o = []) {
  const l = be(!1), p = be(t), g = be(!1), w = be(!1), [k, h] = Se([]), S = be(!0), [_, G] = Se(!1);
  Ge(() => {
    (l.current || a) && (i && re(), I()), l.current = !0;
  }, o), Ge(() => {
    var R;
    !g.current && ((R = e == null ? void 0 : e.afterUpdate) == null || R.call(e)), g.current = !1;
  }, [k]);
  const I = async () => {
    var R;
    try {
      if (!S.current || w.current)
        return;
      G(!0), w.current = !0;
      const L = await r(p.current);
      if (!L || L.length === 0) {
        S.current = !1;
        return;
      }
      const Z = s ? L.reverse() : [];
      return h(
        (c) => s ? [...Z, ...c] : [...c, ...L]
      ), L;
    } catch {
      S.current = !1, (R = e == null ? void 0 : e.onError) == null || R.call(e);
    } finally {
      w.current = !1, G(!1);
    }
  }, N = async () => {
    if (!w.current)
      return s && (g.current = !0), p.current++, I().then((R) => {
        (!R || R.length === 0) && (g.current = !1);
      });
  }, C = (R) => {
    h(R);
  }, re = () => {
    p.current = 1, h([]), S.current = !0;
  };
  return {
    reset: re,
    data: k,
    onNext: N,
    initData: C,
    fetchData: I,
    isLoading: _,
    setData: h,
    forceToRefresh: () => {
      re(), I();
    },
    page: p.current,
    hasMore: S.current
  };
}
const R5 = (r, e = {}) => {
  try {
    const t = new URL(r);
    return Object.entries(e).forEach(([s, a]) => {
      ["string", "number", "boolean"].includes(typeof a) && t.searchParams.set(s, a.toString());
    }), t.toString();
  } catch {
    return "";
  }
};
var Is = /* @__PURE__ */ ((r) => (r.LOCAL = "local", r.SESSION = "session", r))(Is || {});
const L5 = (r) => {
  try {
    return JSON.parse(r);
  } catch {
    return r;
  }
};
function Ei({
  key: r,
  type: e = "session"
  /* SESSION */
}) {
  try {
    const t = (e === "local" ? window.localStorage : window.sessionStorage).getItem(r);
    return t ? L5(t) : null;
  } catch {
    return console.warn("We can not get the data from storage"), null;
  }
}
const Xe = (r) => ({ ok: !0, val: r }), Le = (r) => ({
  ok: !1,
  error: r
}), N5 = (r) => r instanceof FormData ? r : JSON.stringify(r);
async function ir(r, {
  signal: e,
  body: t = null,
  headers: s = {},
  method: a = "GET",
  keyAccessToken: i,
  keyBecomeToken: o,
  statusCodeToCheck: l,
  onAuthorizationError: p,
  queryParameters: g = {}
} = {
  body: null,
  headers: {},
  queryParameters: {}
}) {
  const w = Ei({
    type: (i == null ? void 0 : i.type) || Is.LOCAL,
    key: (i == null ? void 0 : i.name) || ""
  }) || null, k = Ei({
    type: (o == null ? void 0 : o.type) || Is.LOCAL,
    key: (o == null ? void 0 : o.name) || ""
  }) || null, h = {
    method: a,
    ...t ? { body: N5(t) } : {},
    headers: {
      ...t instanceof FormData ? {} : { "Content-Type": "application/json" },
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
      ...w ? {
        "Access-Token": w
      } : {},
      ...k ? {
        "Become-Creator-Id": k
      } : {},
      ...s
    }
  }, S = R5(r, g);
  try {
    const _ = await fetch(S, {
      ...h,
      ...e ? { signal: e } : {}
    });
    return _.status === 401 ? (p == null || p(), Le({
      url: S,
      request: h,
      status: _.status,
      response: _
    })) : !_.ok || l && l !== _.status ? Le({
      url: S,
      request: h,
      status: _.status,
      response: _
    }) : Xe(_);
  } catch (_) {
    return Le({
      url: S,
      request: h,
      status: 500,
      response: _
    });
  }
}
const P5 = (r) => {
  if (r != null && r.store_id)
    return { queryParameters: { store_id: r.store_id } };
  if (!r)
    return { queryParameters: { unread: !0 } };
  const { status: e, page: t } = r, s = (i) => ({
    unread: { unread: !0, status: void 0 },
    archived: { status: "archived", unread: void 0 },
    open: { status: "open", unread: void 0 },
    all: { status: void 0, unread: void 0 }
  })[i], a = s(e || "unread");
  return {
    queryParameters: {
      ...t ? { page: t } : {},
      ...a
    }
  };
}, U5 = async ({ baseUrl: r, tokenKey: e, becomeKey: t }, s) => {
  const a = `${r}/api/v2/inbox/message_threads`, i = P5(s), o = await ir(a, {
    ...i,
    keyAccessToken: {
      name: e
    },
    keyBecomeToken: {
      name: t
    }
  });
  return o.ok ? Xe(await o.val.json()) : Le(o.error);
}, oa = async ({ baseUrl: r, tokenKey: e, becomeKey: t }, s) => {
  const a = `${r}/api/v2/inbox/message_threads`, i = await ir(a, {
    queryParameters: {
      store_id: s
    },
    keyAccessToken: {
      name: e
    },
    keyBecomeToken: {
      name: t
    }
  });
  return i.ok ? Xe(await i.val.json()) : Le(i.error);
}, G5 = async ({ baseUrl: r, tokenKey: e, becomeKey: t }, s) => {
  const a = `${r}/api/v2/inbox/message_threads`, i = await ir(a, {
    body: s,
    method: "POST",
    statusCodeToCheck: 201,
    keyAccessToken: {
      name: e
    },
    keyBecomeToken: {
      name: t
    }
  });
  return i.ok ? Xe(await i.val.json()) : Le(i.error);
}, H5 = async ({ baseUrl: r, tokenKey: e, becomeKey: t }, s, a) => {
  const i = `${r}/api/v2/inbox/message_threads/${s}/${a}`, o = await ir(i, {
    statusCodeToCheck: 200,
    method: "PUT",
    keyAccessToken: {
      name: e
    },
    keyBecomeToken: {
      name: t
    }
  });
  return o.ok ? Xe(await o.val.json()) : Le(o.error);
}, q5 = we(() => {
  const { i18n: r } = Je();
  return /* @__PURE__ */ z.jsxs("div", { className: "skp-px-4 skp-py-6 skp-text-center skp-text-gray-400", children: [
    /* @__PURE__ */ z.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        className: "skp-m-auto skp-mb-2 skp-h-12 skp-w-12",
        children: /* @__PURE__ */ z.jsx(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
          }
        )
      }
    ),
    /* @__PURE__ */ z.jsx("p", { className: "skp-text-lg skp-text-gray-600", children: r.t("js.inbox.threads.empty.title") })
  ] });
}), K5 = () => {
  const [r, e] = Se(null), { state: t, dispatch: s } = Ne(), a = async (h) => {
    var _;
    const S = await U5(t.settings, {
      status: t.filters.status,
      page: h
    });
    return S.ok ? (e(S.val), ((_ = S.val) == null ? void 0 : _.message_threads) || []) : [];
  }, { data: i, forceToRefresh: o, isLoading: l, hasMore: p, onNext: g } = Qo(
    {
      queryFn: a,
      shouldFetchOnInit: !0,
      shouldResetDataWhenQueryKeyChange: !0
    },
    [t.filters.status]
  );
  Ge(() => {
    const h = t.observer.subscribe(({ status: S }) => {
      S === t.filters.status ? o() : s(pa({ status: S }));
    });
    return () => h();
  }, [t.filters.status]);
  const w = (h) => {
    s(Ct(h));
  }, k = (h) => {
    s(pa({ status: h }));
  };
  return /* @__PURE__ */ z.jsxs("div", { className: "skp-flex skp-h-full skp-flex-col", children: [
    /* @__PURE__ */ z.jsx("div", { className: "skp-h-w-80 skp-border-b skp-border-gray-200 skp-px-2 skp-py-4", children: r && /* @__PURE__ */ z.jsx(
      I5,
      {
        threads: r,
        selected: t.filters.status,
        onSelect: k
      }
    ) }),
    /* @__PURE__ */ z.jsx("div", { className: "skp-relative skp-flex-1", children: l && i.length === 0 ? /* @__PURE__ */ z.jsx("div", { className: "skp-flex skp-w-full skp-items-center skp-justify-center skp-p-4", children: /* @__PURE__ */ z.jsx(Zo, {}) }) : /* @__PURE__ */ z.jsx(z.Fragment, { children: i.length === 0 ? /* @__PURE__ */ z.jsx(q5, {}) : /* @__PURE__ */ z.jsx(z.Fragment, { children: /* @__PURE__ */ z.jsx(
      Jo,
      {
        onNext: g,
        hasMore: p,
        children: /* @__PURE__ */ z.jsx("ul", { className: "scrollable skp-mb-0", children: i == null ? void 0 : i.map((h) => {
          var S;
          return /* @__PURE__ */ z.jsx(
            "li",
            {
              className: zr(
                "skp-cursor-pointer skp-border-b skp-border-gray-200 skp-transition-all hover:skp-bg-gray-100",
                {
                  "skp-bg-gray-100": h.id === ((S = t.thread) == null ? void 0 : S.id)
                }
              ),
              children: /* @__PURE__ */ z.jsx(
                ox,
                {
                  thread: h,
                  type: t.type,
                  onClick: w
                }
              )
            },
            h.id
          );
        }) })
      }
    ) }) }) })
  ] });
};
var Xo = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  var e = "fas", t = "chevron-left", s = 320, a = 512, i = [9001], o = "f053", l = "M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z";
  r.definition = {
    prefix: e,
    iconName: t,
    icon: [
      s,
      a,
      i,
      o,
      l
    ]
  }, r.faChevronLeft = r.definition, r.prefix = e, r.iconName = t, r.width = s, r.height = a, r.ligatures = i, r.unicode = o, r.svgPathData = l, r.aliases = i;
})(Xo);
const en = we(({ onClick: r }) => /* @__PURE__ */ z.jsx(
  "div",
  {
    "data-testid": "back-button",
    className: "skp-border-r skp-border-gray-100",
    children: /* @__PURE__ */ z.jsx(
      M5,
      {
        size: "medium",
        onSkpClick: r,
        icon: Xo.faChevronLeft
      }
    )
  }
)), rn = ({
  onBack: r,
  children: e,
  avatar: t,
  name: s
}) => /* @__PURE__ */ z.jsx("header", { className: "skp-flex skp-min-h-16 skp-items-center skp-border-b skp-border-gray-200 skp-bg-white skp-px-2 md:skp-px-4 skp-py-2", children: /* @__PURE__ */ z.jsxs("div", { className: "skp-flex skp-w-full skp-justify-between skp-items-center", children: [
  /* @__PURE__ */ z.jsx("span", { className: "skp-mr-2 md:skp-hidden", children: /* @__PURE__ */ z.jsx(en, { onClick: r }) }),
  /* @__PURE__ */ z.jsxs("ul", { className: "skp-flex skp-min-w-0 skp-flex-1 skp-items-center skp-mb-0", children: [
    /* @__PURE__ */ z.jsx("li", { children: /* @__PURE__ */ z.jsx(
      Fr,
      {
        src: t,
        legend: s
      }
    ) }),
    /* @__PURE__ */ z.jsx("li", { className: "skp-min-w-0 skp-px-2 skp-flex-1", children: /* @__PURE__ */ z.jsx(
      "h3",
      {
        "data-testid": "header-title",
        className: "skp-skp-ml-2 skp-whitespace-nowrap skp-text-ellipsis skp-overflow-hidden skp-skp-text-lg skp-skp-text-gray-800 skp-my-0",
        children: s
      }
    ) })
  ] }),
  e && /* @__PURE__ */ z.jsx("div", { className: "skp-flex-shrink-0", children: e })
] }) }), yr = (r) => r.when && r.children, Y5 = ({ message: r }) => {
  const { i18n: e } = Je(), t = tr(() => {
    const s = St(r.sent_at);
    return At(s);
  }, [r]);
  return /* @__PURE__ */ z.jsx(
    "div",
    {
      "data-testid": "sender-message",
      className: "skp-mb-5 skp-flex skp-justify-end",
      children: /* @__PURE__ */ z.jsxs("div", { className: "skp-w-[85%]", children: [
        /* @__PURE__ */ z.jsx(
          "p",
          {
            "data-testid": "sender-message-text",
            className: "skp-mb-1 skp-w-full skp-whitespace-pre-wrap skp-break-words skp-rounded-lg skp-bg-blue-500 skp-p-2 skp-text-sm skp-text-white",
            dangerouslySetInnerHTML: { __html: r.text }
          }
        ),
        /* @__PURE__ */ z.jsx("span", { className: "skp-block skp-text-right skp-text-xs skp-text-gray-400", children: e.t(t.key, { count: t.count }) })
      ] })
    }
  );
}, W5 = (r, e) => r === "pro" && !e || r === "creator" && e === "creator", Rs = (r) => "type" in r, V5 = ({ message: r }) => {
  const { i18n: e } = Je(), { sender: t } = r, { state: s } = Ne(), a = tr(() => {
    const i = St(r.sent_at);
    return At(i);
  }, [r]);
  return /* @__PURE__ */ z.jsxs(
    "div",
    {
      "data-testid": "receiver-message",
      className: "skp-mb-5 skp-flex",
      children: [
        /* @__PURE__ */ z.jsx(
          Fr,
          {
            legend: Rs(t) ? t.username : t.logo,
            src: Rs(t) ? `${s.settings.assetBaseUrl}/${t.avatar}` : `${s.settings.assetBaseUrl}/${t.title}`
          }
        ),
        /* @__PURE__ */ z.jsxs("div", { className: "skp-px-2", children: [
          /* @__PURE__ */ z.jsx(
            "p",
            {
              "data-testid": "receiver-message-text",
              className: "skp-mb-1 skp-whitespace-pre-wrap skp-break-words skp-text-sm skp-text-gray-600",
              dangerouslySetInnerHTML: { __html: r.text }
            }
          ),
          /* @__PURE__ */ z.jsx("span", { className: "skp-text-xs skp-text-gray-400", children: e.t(a.key, { count: a.count }) })
        ] })
      ]
    }
  );
}, tn = (r) => r === "creator" ? "creators" : "pro", Z5 = ({ status: r, platform: e }) => {
  switch (r) {
    case "review":
      switch (e) {
        case "youtube":
          return /* @__PURE__ */ z.jsx(
            ix,
            {
              height: 16,
              width: 16
            }
          );
        case "instagram":
          return /* @__PURE__ */ z.jsx(
            Qh,
            {
              height: 16,
              width: 16
            }
          );
        case "instagram_stories":
          return /* @__PURE__ */ z.jsx(
            Xh,
            {
              height: 16,
              width: 16
            }
          );
        case "tiktok":
          return /* @__PURE__ */ z.jsx(
            sx,
            {
              height: 16,
              width: 16
            }
          );
        case "twitch":
          return /* @__PURE__ */ z.jsx(
            ax,
            {
              height: 16,
              width: 16
            }
          );
        case "instagram_reels":
          return /* @__PURE__ */ z.jsx(
            ex,
            {
              height: 16,
              width: 16
            }
          );
        default:
          return /* @__PURE__ */ z.jsx(
            Zh,
            {
              height: 16,
              width: 16
            }
          );
      }
    case "cancel":
      return /* @__PURE__ */ z.jsx(
        Vh,
        {
          height: 16,
          width: 16
        }
      );
    case "approve":
      return /* @__PURE__ */ z.jsx(
        ii,
        {
          height: 16,
          width: 16
        }
      );
    case "auto_approve":
      return /* @__PURE__ */ z.jsx(
        ii,
        {
          height: 16,
          width: 16
        }
      );
    case "decline":
      return /* @__PURE__ */ z.jsx(
        Jh,
        {
          height: 16,
          width: 16
        }
      );
    case "order":
      return /* @__PURE__ */ z.jsx(
        rx,
        {
          height: 16,
          width: 16
        }
      );
    default:
      return /* @__PURE__ */ z.jsx(
        tx,
        {
          height: 16,
          width: 16
        }
      );
  }
}, J5 = ({ type: r, message: e }) => {
  const { i18n: t } = Je(), { event: s } = e.order_transition, a = tr(() => {
    const l = St(e.sent_at);
    return At(l);
  }, [e]), i = tr(() => {
    const {
      event: l,
      order: { campaign: p }
    } = e.order_transition;
    return {
      parameters: {
        product: `<strong>${p.title}</strong>`,
        store: `<strong>${p.store.title}</strong>`
      },
      key: `js.inbox.thread.messages.message.order.${tn(
        r
      )}.${l}_text`
    };
  }, [e]), o = tr(() => {
    const { order_transition: l } = e;
    switch (s) {
      case "order":
        return l.order.message;
      case "decline":
        return l.order.decline_message;
      case "ship":
        return l.order.shipping_info;
      default:
        return null;
    }
  }, [e]);
  return /* @__PURE__ */ z.jsx(z.Fragment, { children: /* @__PURE__ */ z.jsxs("div", { className: "skp-mb-5 skp-flex skp-items-start skp-gap-2", children: [
    e.order_transition.order.platforms.map((l) => /* @__PURE__ */ z.jsx(
      "span",
      {
        "data-testid": l,
        className: "skp-relative skp-top-1",
        children: /* @__PURE__ */ z.jsx(
          Z5,
          {
            status: s,
            platform: l
          }
        )
      },
      l
    )),
    /* @__PURE__ */ z.jsxs("div", { className: "skp-flex-1 skp-text-sm skp-text-gray-400", children: [
      /* @__PURE__ */ z.jsxs("p", { className: "skp-flex", children: [
        /* @__PURE__ */ z.jsx("strong", { className: "after:skp-mx-1 after:skp-inline-block after:skp-content-['•']", children: t.t(`js.inbox.thread.messages.message.order.status.${s}`) }),
        /* @__PURE__ */ z.jsx("span", { children: t.t(a.key, { count: a.count }) })
      ] }),
      /* @__PURE__ */ z.jsx(
        "p",
        {
          dangerouslySetInnerHTML: {
            __html: t.t(i.key, i.parameters)
          }
        }
      ),
      o && /* @__PURE__ */ z.jsx(
        "p",
        {
          "data-testid": "order-additional-text",
          className: "skp-mt-1 skp-rounded-lg skp-bg-gray-200 skp-p-2 skp-text-sm skp-text-gray-500",
          children: o
        }
      )
    ] })
  ] }) });
}, Q5 = we(({ type: r, message: e }) => {
  const { sender: t } = e, s = W5(
    r,
    Rs(t) ? t.type : void 0
  );
  return /* @__PURE__ */ z.jsx(z.Fragment, { children: e.order_transition ? /* @__PURE__ */ z.jsx(
    J5,
    {
      type: r,
      message: e
    }
  ) : /* @__PURE__ */ z.jsxs(z.Fragment, { children: [
    /* @__PURE__ */ z.jsx(yr, { when: s, children: /* @__PURE__ */ z.jsx(Y5, { message: e }) }),
    /* @__PURE__ */ z.jsx(yr, { when: !s, children: /* @__PURE__ */ z.jsx(V5, { message: e }) })
  ] }) });
}), X5 = async ({ baseUrl: r, tokenKey: e, becomeKey: t }, s, a) => {
  const i = `${r}/api/v2/inbox/messages/${s}`, o = await ir(i, {
    queryParameters: a ? { page: a } : {},
    keyAccessToken: {
      name: e
    },
    keyBecomeToken: {
      name: t
    }
  });
  return o.ok ? Xe(await o.val.json()) : Le(o.error);
}, e6 = async ({ baseUrl: r, tokenKey: e, becomeKey: t }, s, a) => {
  const i = `${r}/api/v2/inbox/messages/${s}`, o = await ir(i, {
    body: a,
    method: "POST",
    keyAccessToken: {
      name: e
    },
    keyBecomeToken: {
      name: t
    },
    statusCodeToCheck: 201
  });
  return o.ok ? Xe(await o.val.json()) : Le(o.error);
}, r6 = () => {
  const r = be(null), [e, t] = Se("");
  Ge(() => {
    a();
  }, [e]);
  const s = (i) => {
    t(i.currentTarget.value);
  }, a = () => {
    r.current && (r.current.style.height = "0px", r.current.style.height = Math.min(r.current.scrollHeight) + "px");
  };
  return { $ref: r, value: e, setValue: t, resize: a, handleOnChange: s };
}, sn = ({ isBlocked: r, onSubmit: e }) => {
  const { i18n: t } = Je(), { value: s, $ref: a, setValue: i, handleOnChange: o } = r6(), l = async () => {
    try {
      await e(s) && i("");
    } catch {
      console.warn("@error:create-message");
    }
  };
  return /* @__PURE__ */ z.jsxs("div", { className: "skp-flex skp-gap-2", children: [
    /* @__PURE__ */ z.jsx(
      "textarea",
      {
        ref: a,
        value: s,
        disabled: r,
        onChange: o,
        "data-testid": "message-form-textarea",
        placeholder: t.t(
          r ? "js.inbox.thread.messages.new.blocked" : "js.inbox.thread.messages.new.placeholder"
        ),
        className: "scrollbar skp-box-border skp-flex skp-h-[42px] skp-max-h-[300px] skp-min-h-[42px] skp-flex-1 skp-resize-none skp-whitespace-pre-wrap skp-rounded-md skp-border skp-border-gray-200 skp-bg-white skp-p-2 skp-text-sm skp-leading-6 skp-text-gray-600 skp-outline-0 focus:skp-border-blue-600 focus:skp-shadow-none focus:skp-ring-2"
      }
    ),
    /* @__PURE__ */ z.jsx(
      "button",
      {
        disabled: !s,
        onClick: l,
        "data-testid": "message-form-submit",
        className: "skp-h-[42px] skp-rounded-md skp-bg-blue-500 skp-px-4 skp-text-sm skp-text-white skp-transition-all disabled:skp-bg-gray-300 disabled:skp-text-gray-600",
        children: t.t("js.inbox.thread.messages.new.submit")
      }
    )
  ] });
}, t6 = ({ thread: r }) => {
  const { state: e } = Ne(), { i18n: t } = Je(), [s, a] = Se(""), [i, o] = Se(!1), l = vn(() => o(!1));
  Ge(() => {
    a(
      e.type === "creator" ? r.status_for_creator : r.status_for_store
    );
  }, [r]);
  const p = async () => {
    o(!1);
    const w = s === "archived" ? "open" : "archived";
    await H5(
      e.settings,
      r.id,
      s === "archived" ? "open" : "archive"
    ), a(w), e.observer.next({ status: w });
  }, g = () => o(!i);
  return /* @__PURE__ */ z.jsxs(
    "div",
    {
      ref: l,
      className: "skp-relative",
      children: [
        /* @__PURE__ */ z.jsx(
          "button",
          {
            onClick: g,
            "data-testid": "actions-button",
            className: "skp-inline-flex skp-h-10 skp-w-10 skp-items-center skp-justify-center skp-rounded-full skp-text-gray-500 skp-shadow-md skp-transition-all hover:skp-bg-gray-100",
            children: /* @__PURE__ */ z.jsx(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                strokeWidth: "1.5",
                stroke: "currentColor",
                className: "skp-h-6 skp-w-6",
                children: /* @__PURE__ */ z.jsx(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
                  }
                )
              }
            )
          }
        ),
        i && /* @__PURE__ */ z.jsx("ul", { className: "skp-absolute -skp-bottom-1 skp-right-0 skp-z-10 skp-mb-0 skp-translate-y-full skp-rounded-lg skp-border skp-border-gray-100 skp-bg-white skp-p-2 skp-shadow-md", children: /* @__PURE__ */ z.jsx(
          "li",
          {
            tabIndex: 0,
            onClick: p,
            className: "skp-cursor-pointer skp-text-nowrap skp-rounded-lg skp-p-1 skp-text-sm skp-text-gray-600 hover:skp-bg-gray-100",
            children: t.t(
              s === "open" ? "js.inbox.thread.show.actions.archive" : "js.inbox.thread.show.actions.open"
            )
          }
        ) })
      ]
    }
  );
}, s6 = ({ thread: r }) => {
  const { state: e, dispatch: t } = Ne(), s = be(null), a = async (k) => {
    if (!r)
      return [];
    const h = await X5(
      e.settings,
      r.id,
      k
    );
    return h.ok ? h.val : [];
  }, { data: i, hasMore: o, setData: l, onNext: p } = Qo(
    {
      queryFn: a,
      initialPage: 0,
      reverseScrolling: !0,
      shouldResetDataWhenQueryKeyChange: !0,
      hooks: {
        afterUpdate: () => {
          var k;
          (k = s.current) == null || k.scrollDown();
        }
      }
    },
    [r.id]
  ), g = async (k) => {
    try {
      const h = await e6(e.settings, r.id, {
        message_text: k,
        sender_id: e.user.id
      });
      return h.ok ? (l((S) => [...S, h.val]), !0) : !1;
    } catch {
      return console.warn("@error:handleSubmit"), !1;
    }
  }, w = () => t(jr("initial"));
  return /* @__PURE__ */ z.jsxs(
    "div",
    {
      "data-testid": "chat",
      className: "skp-flex skp-w-full skp-flex-col",
      children: [
        /* @__PURE__ */ z.jsx(
          rn,
          {
            avatar: `${e.settings.assetBaseUrl}/${r.store.logo}`,
            onBack: w,
            name: r.store.title,
            children: /* @__PURE__ */ z.jsx(t6, { thread: r })
          }
        ),
        /* @__PURE__ */ z.jsx("div", { className: "skp-relative skp-mb-4 skp-flex-1", children: /* @__PURE__ */ z.jsx(
          Jo,
          {
            ref: s,
            onNext: p,
            hasMore: o,
            scrollingDirection: "top",
            children: /* @__PURE__ */ z.jsx("ul", { className: "skp-mb-0 skp-p-4", children: i.map((k, h) => /* @__PURE__ */ z.jsx(
              "li",
              {
                className: "skp-mb-4",
                children: /* @__PURE__ */ z.jsx(
                  Q5,
                  {
                    type: e.type,
                    message: k
                  }
                )
              },
              h
            )) })
          }
        ) }),
        /* @__PURE__ */ z.jsx("div", { className: "skp-px-2 skp-pb-4 md:skp-px-4", children: /* @__PURE__ */ z.jsx(
          sn,
          {
            onSubmit: g,
            isBlocked: r.blocked_creator
          }
        ) })
      ]
    }
  );
};
function a6({
  onSearch: r,
  onSelectOption: e,
  placeholder: t = "",
  isLoading: s = !1,
  debounceValue: a = 400,
  noResult: i,
  renderOption: o,
  options: l = null
}) {
  const [p, g] = Se(!1), [w, k] = Se(""), h = gn(r, a), S = cn(), _ = () => {
  }, G = () => {
    g(!0);
  }, I = (C) => {
    const re = C.currentTarget.value;
    h(re), k(re);
  }, N = () => {
    r(""), k("");
  };
  return /* @__PURE__ */ z.jsxs(
    "div",
    {
      "data-testid": "autocomplete",
      className: "skp-w-100 skp-relative",
      children: [
        /* @__PURE__ */ z.jsxs(
          "label",
          {
            htmlFor: S,
            className: "skp-relative skp-w-full skp-mb-0",
            children: [
              /* @__PURE__ */ z.jsx(
                "input",
                {
                  id: S,
                  value: w,
                  onBlur: _,
                  onFocus: G,
                  onChange: I,
                  placeholder: t,
                  "data-testid": "autocomplete-field",
                  className: "skp-w-full skp-border-0 skp-py-2 skp-pl-2 skp-pr-8 skp-text-gray-800 skp-leading-4 skp-outline-0 placeholder:skp-text-gray-400"
                }
              ),
              w !== "" && /* @__PURE__ */ z.jsx(
                "button",
                {
                  role: "button",
                  onClick: N,
                  "data-testid": "autocomplete-reset",
                  className: "skp-absolute skp-right-1 skp-top-1/2 -skp-translate-y-1/2 skp-text-gray-400",
                  children: /* @__PURE__ */ z.jsx(
                    "svg",
                    {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      strokeWidth: "1.5",
                      stroke: "currentColor",
                      className: "skp-h-6 skp-w-6",
                      children: /* @__PURE__ */ z.jsx(
                        "path",
                        {
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          d: "M6 18 18 6M6 6l12 12"
                        }
                      )
                    }
                  )
                }
              )
            ]
          }
        ),
        p && (s || l) && /* @__PURE__ */ z.jsx("div", { className: "scrollbar skp-absolute skp-z-10 skp-max-h-[300px] skp-w-full skp-overflow-auto skp-rounded-lg skp-border skp-border-gray-300 skp-bg-white shadow-lg", children: s ? /* @__PURE__ */ z.jsx("div", { className: "skp-align-center skp-flex skp-justify-center skp-py-4", children: /* @__PURE__ */ z.jsx(Zo, {}) }) : /* @__PURE__ */ z.jsx(z.Fragment, { children: l && l.length !== 0 ? /* @__PURE__ */ z.jsx(
          "ul",
          {
            className: "skp-mb-0",
            "data-testid": "autocomplete-options",
            children: l.map(({ value: C, label: re }) => /* @__PURE__ */ z.jsx(
              "li",
              {
                onClick: () => e(C),
                className: "skp-cursor-pointer skp-p-2 skp-transition-all hover:skp-bg-gray-100",
                children: o ? o(C) : /* @__PURE__ */ z.jsx("span", { children: re })
              },
              re
            ))
          }
        ) : /* @__PURE__ */ z.jsx(
          "p",
          {
            "data-testid": "autocomplete-no-results",
            className: "skp-align-center skp-flex skp-justify-center skp-py-4",
            children: i
          }
        ) }) })
      ]
    }
  );
}
const i6 = async ({ baseUrl: r, tokenKey: e, becomeKey: t }, s) => {
  const a = `${r}/api/v3/stores/${s}`, i = await ir(a, {
    keyAccessToken: {
      name: e
    },
    keyBecomeToken: {
      name: t
    }
  });
  return i.ok ? Xe(await i.val.json()) : Le(i.error);
}, o6 = async ({
  baseUrl: r,
  tokenKey: e,
  becomeKey: t
}) => {
  const s = `${r}/api/v3/stores`, a = await ir(s, {
    queryParameters: { format: "attributes" },
    keyAccessToken: {
      name: e
    },
    keyBecomeToken: {
      name: t
    }
  });
  return a.ok ? Xe(await a.val.json()) : Le(a.error);
}, n6 = ({ onSelect: r }) => {
  const { i18n: e } = Je(), { state: t, dispatch: s } = Ne(), [a, i] = Se(null), [o, l] = Se(!1), p = async (k) => {
    if (k === "") {
      l(!1), i(null);
      return;
    }
    l(!0);
    const h = await o6(t.settings);
    if (h.ok) {
      const S = h.val.map((_) => ({ label: _.title, value: _ })).filter(
        (_) => _.label.toLocaleLowerCase().includes(k.toLocaleLowerCase())
      );
      i(S);
    }
    l(!1);
  }, g = async (k) => {
    const h = await oa(t.settings, k.id);
    if (h.ok && h.val) {
      r({ type: "thread", value: h.val });
      return;
    }
    const S = await i6(t.settings, k.id);
    S.ok && r({ type: "store", value: S.val.store });
  }, w = () => s(jr("initial"));
  return /* @__PURE__ */ z.jsxs("header", { className: "skp-align-center skp-flex skp-min-h-16 skp-w-full skp-border-b skp-border-gray-200 skp-bg-white skp-px-2 skp-py-2 md:skp-px-4", children: [
    /* @__PURE__ */ z.jsx("span", { className: "skp-mr-4 md:skp-hidden", children: /* @__PURE__ */ z.jsx(en, { onClick: w }) }),
    /* @__PURE__ */ z.jsxs("div", { className: "skp-flex skp-w-full skp-items-center skp-gap-2", children: [
      /* @__PURE__ */ z.jsx(Fr, { legend: "search store", children: /* @__PURE__ */ z.jsx(
        "svg",
        {
          className: "skp-h-full skp-w-full skp-fill-blue-500",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ z.jsx("path", { d: "M20.2277 20.7348C21.4203 19.6141 22.3704 18.2608 23.0193 16.7584C23.6681 15.256 24.0019 13.6365 24 12C24 5.37231 18.6277 0 12 0C5.37231 0 8.01134e-06 5.37231 8.01134e-06 12C-0.00188553 13.6365 0.331905 15.256 0.980746 16.7584C1.62959 18.2608 2.57969 19.6141 3.77231 20.7348C5.99623 22.8356 8.94073 24.0041 12 24C15.0593 24.0041 18.0038 22.8356 20.2277 20.7348ZM4.79385 19.1532C5.65795 18.0722 6.75448 17.1997 8.00202 16.6005C9.24955 16.0013 10.616 15.6909 12 15.6923C13.384 15.6909 14.7504 16.0013 15.998 16.6005C17.2455 17.1997 18.3421 18.0722 19.2061 19.1532C18.2634 20.1055 17.141 20.861 15.904 21.3761C14.667 21.8912 13.34 22.1556 12 22.1538C10.66 22.1556 9.33305 21.8912 8.09603 21.3761C6.85902 20.861 5.73659 20.1055 4.79385 19.1532ZM16.6154 8.30769C16.6154 9.53176 16.1291 10.7057 15.2636 11.5713C14.398 12.4368 13.2241 12.9231 12 12.9231C10.7759 12.9231 9.60198 12.4368 8.73643 11.5713C7.87088 10.7057 7.38462 9.53176 7.38462 8.30769C7.38462 7.08361 7.87088 5.90967 8.73643 5.04412C9.60198 4.17857 10.7759 3.69231 12 3.69231C13.2241 3.69231 14.398 4.17857 15.2636 5.04412C16.1291 5.90967 16.6154 7.08361 16.6154 8.30769Z" })
        }
      ) }),
      /* @__PURE__ */ z.jsx("div", { className: "skp-flex-1", children: /* @__PURE__ */ z.jsx(
        a6,
        {
          noResult: e.t("js.autocomplete.no_results_found"),
          isLoading: o,
          options: a,
          renderOption: (k) => /* @__PURE__ */ z.jsxs("div", { className: "skp-flex skp-items-center skp-gap-2", children: [
            /* @__PURE__ */ z.jsx(
              Fr,
              {
                legend: k.title,
                src: k.logo_urls.small
              }
            ),
            /* @__PURE__ */ z.jsx("p", { className: "skp-my-0", children: k.title })
          ] }),
          onSearch: p,
          placeholder: e.t(
            `js.inbox.thread.new.autocomplete.placeholder.${tn(
              t.type
            )}`
          ),
          onSelectOption: g
        }
      ) })
    ] })
  ] });
}, l6 = () => /* @__PURE__ */ z.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "216",
    height: "435",
    fill: "none",
    viewBox: "0 0 216 435",
    "data-testid": "empty-message",
    children: [
      /* @__PURE__ */ z.jsx(
        "path",
        {
          fill: "#E1E7F0",
          d: "M115.37 0h91.11c5.393 1.133 8.567 4.34 9.52 9.62V82c-1.44 6.3-5.44 9.443-12 9.43-14.527-.02-28.273.03-41.24.15-4.95.04-9.37 2.29-12.84 6.14a268.616 268.616 0 01-9.44 10.02 5.29 5.29 0 01-2.85 1.48 1.18 1.18 0 01-1.02-.28c-2.58-2.2-2.08-8.78-1.7-11.82.253-2.033-.453-3.463-2.12-4.29-7.86-3.92-20.97 3.09-25.3-7.59-.58-1.433-.87-4.007-.87-7.72V11.75c0-6.447 2.917-10.363 8.75-11.75zm71.93 23.5a6.302 6.302 0 00-6.3-6.3 6.301 6.301 0 106.3 6.3zm-38.86 11.55a.489.489 0 01-.49-.49l.03-14.01a.493.493 0 00-.49-.49l-11.26.02a.489.489 0 00-.49.49l.01 40.96a.49.49 0 00.49.49l11.27-.01a.491.491 0 00.49-.49l-.05-15.16a.49.49 0 01.49-.49l9.06.06a.491.491 0 01.49.49l-.01 15.1a.49.49 0 00.49.49l11.18-.01a.491.491 0 00.49-.49l.06-40.97a.493.493 0 00-.49-.49l-11.24.02a.489.489 0 00-.49.49L158 34.5a.493.493 0 01-.49.49l-9.07.06zm38.06-3.04a.512.512 0 00-.51-.51h-9.98a.512.512 0 00-.51.51v29.48a.512.512 0 00.51.51h9.98a.512.512 0 00.51-.51V32.01z"
        }
      ),
      /* @__PURE__ */ z.jsx(
        "path",
        {
          fill: "#fff",
          d: "M181 29.8a6.3 6.3 0 100-12.6 6.3 6.3 0 000 12.6zM148.44 35.05l9.07-.06a.491.491 0 00.49-.49l-.02-13.94a.49.49 0 01.49-.49l11.24-.02a.491.491 0 01.49.49l-.06 40.97a.489.489 0 01-.49.49l-11.18.01a.489.489 0 01-.49-.49l.01-15.1a.489.489 0 00-.49-.49l-9.06-.06a.489.489 0 00-.49.49l.05 15.16a.49.49 0 01-.49.49l-11.27.01a.486.486 0 01-.452-.302.485.485 0 01-.038-.188l-.01-40.96a.49.49 0 01.49-.49l11.26-.02a.491.491 0 01.49.49l-.03 14.01a.49.49 0 00.49.49zM185.99 31.5h-9.98a.51.51 0 00-.51.51v29.48c0 .282.228.51.51.51h9.98a.51.51 0 00.51-.51V32.01a.51.51 0 00-.51-.51z"
        }
      ),
      /* @__PURE__ */ z.jsx(
        "path",
        {
          fill: "#E1E7F0",
          d: "M88.52 252.98c-.42 4.487-.473 9.383-.16 14.69.24 4.027.37 7.917.39 11.67.03 5.27.1 10.59-.17 15.79a4272.374 4272.374 0 00-2.18 46.38c-.473 11.507-.503 22.577-.09 33.21.67 17.22 3.06 34.71 9.5 50.78 2.82 7.05-7.02 12.21-11.11 5.27-1.72-2.913-3.363-6.797-4.93-11.65-9.27-28.72-9.53-59.04-8.92-89.11.007-.127-.053-.193-.18-.2-.1-.007-.153.037-.16.13A338.05 338.05 0 0068 391c.29 5.88-5.66 9.63-10.38 5.57-1.9-1.63-1.94-3.71-2.12-5.96-1.49-18.84-2-36.71-.25-54.99 1.32-13.71 2.51-27.82 2.2-41.37-.166-7.267-.456-15.463-.87-24.59-.04-.84-.153-.85-.34-.03a74.961 74.961 0 00-1.82 12.26c-1.693 25.753-2.3 53.63-1.82 83.63.054 3.313-1.426 5.32-4.44 6.02-.086.013-.17.02-.25.02-3.12-.133-4.793-1.82-5.02-5.06a767.238 767.238 0 01-1.25-83.65c.38-9.62 2.74-19.16 3.76-28.83.054-.493-.086-.557-.42-.19-8.23 9.09-21.91 14.71-32.48 5.67C-.66 248.24-.94 230.41 2.38 214.73c1.674-7.913 3.847-16.493 6.52-25.74 1.647-5.7 2.747-11.373 3.3-17.02.294-2.967-.02-5.673-.94-8.12-1.25-3.34-.38-7.04 2.98-8.65 4.95-2.37 8.52 1.52 9.88 5.94 2.5 8.22 1.73 17.38 0 25.63a2415.76 2415.76 0 01-5.31 24.7c-1.453 6.607-2.17 12.907-2.15 18.9.02 6.17 1.86 12.17 6.68 16.26a2.051 2.051 0 001.91.4c9.5-2.88 14.59-17.01 16.5-26 .7-3.3 1.207-8.177 1.52-14.63 1.18-24.213 2.22-48.21 3.12-71.99.227-6.107.944-10.973 2.15-14.6 4.67-14.15 17.49-23.12 32.37-23.18 11.994-.053 20.514 5.11 25.56 15.49 3.61 7.41 4.01 15.07 4.29 23.23.88 26.233 1.68 49.797 2.4 70.69.054 1.533.197 3.043.43 4.53.29 1.88-.01 3.7.06 5.58.96 23.49 2.95 43.24 5.44 70.19.634 6.913.797 15.757.49 26.53-.426 14.62-1.306 30.207-2.64 46.76-.22 2.693-1.893 4.26-5.02 4.7a.806.806 0 01-.25 0c-3.14-.647-4.716-2.603-4.73-5.87-.09-22.6-.09-45.79-1.72-68.61 0-.067-.033-.1-.1-.1h-.06c-.04 0-.06.02-.06.06-.68 14.247-1.486 27.81-2.42 40.69-.266 3.727-.37 7.8-.31 12.22.154 10.753.74 22.95 1.76 36.59.18 2.433-.026 4.24-.62 5.42-2.69 5.27-10.77 4.18-11.54-1.93-2.62-20.84-4.45-40.43-3.5-60.84.987-21.293 1.24-37.43.76-48.41-.253-5.747-.42-12.603-.5-20.57a.047.047 0 00-.009-.039.043.043 0 00-.036-.016.062.062 0 00-.041.016.066.066 0 00-.024.039zm9.68-89.14a20.588 20.588 0 00-20.59-20.59 20.588 20.588 0 00-20.59 20.59 20.597 20.597 0 006.03 14.559 20.596 20.596 0 0014.56 6.031 20.594 20.594 0 0020.59-20.59zm-18.25 45.33c5.66-1.17 10.74-6.28 13.75-11.06.427-.673.257-.907-.51-.7-10.46 2.787-21.003 2.863-31.63.23-.58-.147-.633-.037-.16.33.334.26.68.51 1.04.75 2.91 1.97 4.01 6.1 6.76 8.35 2.807 2.3 6.39 3 10.75 2.1z"
        }
      ),
      /* @__PURE__ */ z.jsx(
        "path",
        {
          fill: "#fff",
          d: "M98.2 163.84a20.588 20.588 0 01-20.59 20.59 20.595 20.595 0 01-20.59-20.59 20.588 20.588 0 0120.59-20.59 20.588 20.588 0 0120.59 20.59zm-25.51 4.28c-.01 2.35 2.66 3.65 4.55 2.44a300.696 300.696 0 006.18-4.06c3.093-2.073 3.09-4.14-.01-6.2l-6.12-4.07a2.967 2.967 0 00-3.04-.144 2.965 2.965 0 00-1.56 2.614c.013 2.96.013 6.1 0 9.42z"
        }
      ),
      /* @__PURE__ */ z.jsx(
        "path",
        {
          fill: "#E1E7F0",
          d: "M72.69 168.12c.013-3.32.013-6.46 0-9.42a2.963 2.963 0 013.1-2.963 2.967 2.967 0 011.5.493l6.12 4.07c3.1 2.06 3.103 4.127.01 6.2a301.241 301.241 0 01-6.18 4.06c-1.89 1.21-4.56-.09-4.55-2.44z"
        }
      ),
      /* @__PURE__ */ z.jsx(
        "path",
        {
          fill: "#fff",
          d: "M79.95 209.17c-4.36.9-7.943.2-10.75-2.1-2.75-2.25-3.85-6.38-6.76-8.35-.36-.24-.707-.49-1.04-.75-.473-.367-.42-.477.16-.33 10.627 2.633 21.17 2.557 31.63-.23.767-.207.937.027.51.7-3.01 4.78-8.09 9.89-13.75 11.06zm.31-5.66c-2.17-.9-4.16 2.45-4.78 4.03a.52.52 0 00.49.71c4-.02 7.433-1.197 10.3-3.53a.793.793 0 00.203-.979.784.784 0 00-.233-.271c-1.933-1.4-3.683-1.423-5.25-.07a.655.655 0 01-.73.11z"
        }
      ),
      /* @__PURE__ */ z.jsx(
        "path",
        {
          fill: "#E1E7F0",
          d: "M80.99 203.4c1.567-1.353 3.317-1.33 5.25.07a.794.794 0 01.25.968.793.793 0 01-.22.282c-2.867 2.333-6.3 3.51-10.3 3.53a.522.522 0 01-.49-.71c.62-1.58 2.61-4.93 4.78-4.03.266.113.51.077.73-.11z"
        }
      )
    ]
  }
), p6 = ({ store: r }) => {
  const { state: e, dispatch: t } = Ne(), s = async (i) => {
    try {
      if (!(await G5(e.settings, {
        message_text: i,
        sender_id: r.id
      })).ok)
        return !1;
      const l = await oa(e.settings, r.id);
      return !l.ok || l.val === null ? !1 : (t(Ct(l.val)), e.observer.next({ status: "open" }), !0);
    } catch {
      return console.warn("@error:handleSubmit"), !1;
    }
  }, a = () => t(jr("initial"));
  return /* @__PURE__ */ z.jsxs(
    "div",
    {
      "data-testid": "chat",
      className: "skp-flex skp-w-full skp-flex-col",
      children: [
        /* @__PURE__ */ z.jsx(
          rn,
          {
            name: r.title,
            onBack: a,
            avatar: r.logo_urls.small
          }
        ),
        /* @__PURE__ */ z.jsx("div", { className: "skp-relative skp-mb-4 skp-flex-1" }),
        /* @__PURE__ */ z.jsx("div", { className: "skp-px-2 md:skp-px-4 skp-pb-4", children: /* @__PURE__ */ z.jsx(sn, { onSubmit: s }) })
      ]
    }
  );
}, c6 = () => {
  const { state: r, dispatch: e } = Ne(), [t, s] = Se(null), a = (i) => {
    if (i.type === "store") {
      s(i.value), e(jr("new-thread"));
      return;
    }
    e(Ct(i.value));
  };
  return /* @__PURE__ */ z.jsxs(z.Fragment, { children: [
    /* @__PURE__ */ z.jsx(yr, { when: r.mode === "initial", children: /* @__PURE__ */ z.jsx(
      "div",
      {
        "data-testid": "chat-empty",
        className: "skp-hidden skp-h-full skp-w-full skp-items-center skp-justify-center md:skp-flex",
        children: /* @__PURE__ */ z.jsx(l6, {})
      }
    ) }),
    /* @__PURE__ */ z.jsx(yr, { when: r.mode === "new-thread" && !!t, children: /* @__PURE__ */ z.jsx(p6, { store: t }) }),
    /* @__PURE__ */ z.jsx(yr, { when: r.mode === "create-thread", children: /* @__PURE__ */ z.jsx(
      "div",
      {
        "data-testid": "chat-search",
        className: "skp-flex skp-h-full skp-w-full skp-items-start",
        children: /* @__PURE__ */ z.jsx(n6, { onSelect: a })
      }
    ) }),
    /* @__PURE__ */ z.jsx(yr, { when: r.mode === "read-thread" && !!r.thread, children: /* @__PURE__ */ z.jsx(s6, { thread: r.thread }) })
  ] });
}, u6 = () => {
  const { state: r } = Ne();
  return /* @__PURE__ */ z.jsx(z.Fragment, { children: r.thread && r.mode === "read-thread" ? /* @__PURE__ */ z.jsxs(
    "div",
    {
      "data-testid": "panel",
      className: "skp-items-center skp-flex skp-flex-col skp-gap-2 skp-p-4",
      children: [
        /* @__PURE__ */ z.jsx(
          Fr,
          {
            size: "lg",
            legend: r.thread.store.title,
            src: `${r.settings.assetBaseUrl}/${r.thread.store.logo}`
          }
        ),
        /* @__PURE__ */ z.jsx("h2", { className: "skp-text-center skp-text-lg skp-font-semibold skp-text-gray-700", children: r.thread.store.title })
      ]
    }
  ) : /* @__PURE__ */ z.jsx("div", {}) });
}, f6 = ({ storeId: r }) => {
  const { state: e, dispatch: t } = Ne(), s = [
    "create-thread",
    "new-thread",
    "read-thread"
  ].includes(e.mode);
  return Ge(() => {
    r && oa(e.settings, r).then((a) => {
      a.ok ? t(Ct(a.val)) : t(jr("new-thread"));
    });
  }, [r]), /* @__PURE__ */ z.jsxs(
    "main",
    {
      "data-testid": "inbox",
      className: "skp-relative skp-flex skp-h-full skp-w-full",
      children: [
        /* @__PURE__ */ z.jsx("aside", { className: "skp-w-full md:skp-block md:skp-w-1/4", children: /* @__PURE__ */ z.jsx(K5, {}) }),
        /* @__PURE__ */ z.jsx(
          "section",
          {
            "data-testid": "chat",
            className: zr(
              "skp-left-0 skp-top-0 skp-z-10 skp-h-full skp-w-full skp-flex-1 skp-border-gray-200 skp-bg-gray-50 md:skp-relative md:skp-flex md:skp-border-x",
              s ? "skp-absolute skp-flex" : "skp-hidden"
            ),
            children: /* @__PURE__ */ z.jsx(c6, {})
          }
        ),
        /* @__PURE__ */ z.jsx(
          "section",
          {
            "data-testid": "profile",
            className: "skp-hidden md:skp-block md:skp-w-1/4",
            children: /* @__PURE__ */ z.jsx("div", { children: /* @__PURE__ */ z.jsx(u6, {}) })
          }
        )
      ]
    }
  );
}, k6 = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.skp-invisible{visibility:hidden}.skp-absolute{position:absolute}.skp-relative{position:relative}.-skp-bottom-1{bottom:-.25rem}.skp-bottom-0{bottom:0}.skp-left-0{left:0}.skp-left-2{left:.5rem}.skp-right-0{right:0}.skp-right-1{right:.25rem}.skp-top-0{top:0}.skp-top-1{top:.25rem}.skp-top-1\\/2{top:50%}.skp-top-2{top:.5rem}.skp-z-10{z-index:10}.skp-m-auto{margin:auto}.skp-my-0{margin-top:0;margin-bottom:0}.skp-mb-0{margin-bottom:0}.skp-mb-1{margin-bottom:.25rem}.skp-mb-2{margin-bottom:.5rem}.skp-mb-4{margin-bottom:1rem}.skp-mb-5{margin-bottom:1.25rem}.skp-ml-2{margin-left:.5rem}.skp-mr-2{margin-right:.5rem}.skp-mr-4{margin-right:1rem}.skp-mt-1{margin-top:.25rem}.skp-box-border{box-sizing:border-box}.skp-line-clamp-1{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}.skp-line-clamp-2{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2}.skp-block{display:block}.skp-flex{display:flex}.skp-inline-flex{display:inline-flex}.skp-hidden{display:none}.skp-h-0{height:0px}.skp-h-10{height:2.5rem}.skp-h-12{height:3rem}.skp-h-20{height:5rem}.skp-h-3{height:.75rem}.skp-h-6{height:1.5rem}.skp-h-8{height:2rem}.skp-h-\\[42px\\]{height:42px}.skp-h-full{height:100%}.skp-h-screen{height:100vh}.skp-max-h-\\[300px\\]{max-height:300px}.skp-min-h-16{min-height:4rem}.skp-min-h-24{min-height:6rem}.skp-min-h-\\[42px\\]{min-height:42px}.skp-w-0{width:0px}.skp-w-10{width:2.5rem}.skp-w-12{width:3rem}.skp-w-20{width:5rem}.skp-w-3{width:.75rem}.skp-w-6{width:1.5rem}.skp-w-8{width:2rem}.skp-w-\\[85\\%\\]{width:85%}.skp-w-full{width:100%}.skp-w-screen{width:100vw}.skp-min-w-0{min-width:0px}.skp-flex-1{flex:1 1 0%}.skp-flex-shrink-0{flex-shrink:0}.-skp-translate-y-1\\/2{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.skp-translate-y-full{--tw-translate-y: 100%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.skp-cursor-pointer{cursor:pointer}.skp-resize-none{resize:none}.skp-flex-col{flex-direction:column}.skp-items-start{align-items:flex-start}.skp-items-center{align-items:center}.skp-justify-end{justify-content:flex-end}.skp-justify-center{justify-content:center}.skp-justify-between{justify-content:space-between}.skp-gap-2{gap:.5rem}.skp-overflow-auto{overflow:auto}.skp-overflow-hidden{overflow:hidden}.skp-text-ellipsis{text-overflow:ellipsis}.skp-whitespace-nowrap{white-space:nowrap}.skp-whitespace-pre-wrap{white-space:pre-wrap}.skp-text-nowrap{text-wrap:nowrap}.skp-break-words{overflow-wrap:break-word}.skp-rounded-full{border-radius:9999px}.skp-rounded-lg{border-radius:.5rem}.skp-rounded-md{border-radius:.375rem}.skp-border{border-width:1px}.skp-border-0{border-width:0px}.skp-border-b{border-bottom-width:1px}.skp-border-r{border-right-width:1px}.skp-border-gray-100{--tw-border-opacity: 1;border-color:rgb(243 244 246 / var(--tw-border-opacity))}.skp-border-gray-200{--tw-border-opacity: 1;border-color:rgb(229 231 235 / var(--tw-border-opacity))}.skp-border-gray-300{--tw-border-opacity: 1;border-color:rgb(209 213 219 / var(--tw-border-opacity))}.skp-bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(59 130 246 / var(--tw-bg-opacity))}.skp-bg-gray-100{--tw-bg-opacity: 1;background-color:rgb(243 244 246 / var(--tw-bg-opacity))}.skp-bg-gray-200{--tw-bg-opacity: 1;background-color:rgb(229 231 235 / var(--tw-bg-opacity))}.skp-bg-gray-50{--tw-bg-opacity: 1;background-color:rgb(249 250 251 / var(--tw-bg-opacity))}.skp-bg-slate-200{--tw-bg-opacity: 1;background-color:rgb(226 232 240 / var(--tw-bg-opacity))}.skp-bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity))}.skp-fill-blue-500{fill:#3b82f6}.skp-object-contain{-o-object-fit:contain;object-fit:contain}.skp-p-1{padding:.25rem}.skp-p-2{padding:.5rem}.skp-p-4{padding:1rem}.skp-px-2{padding-left:.5rem;padding-right:.5rem}.skp-px-4{padding-left:1rem;padding-right:1rem}.skp-py-2{padding-top:.5rem;padding-bottom:.5rem}.skp-py-4{padding-top:1rem;padding-bottom:1rem}.skp-py-6{padding-top:1.5rem;padding-bottom:1.5rem}.skp-pb-3{padding-bottom:.75rem}.skp-pb-4{padding-bottom:1rem}.skp-pl-2{padding-left:.5rem}.skp-pl-8{padding-left:2rem}.skp-pr-3{padding-right:.75rem}.skp-pr-8{padding-right:2rem}.skp-pt-3{padding-top:.75rem}.skp-text-center{text-align:center}.skp-text-right{text-align:right}.skp-text-2xl{font-size:1.5rem;line-height:2rem}.skp-text-lg{font-size:1.125rem;line-height:1.75rem}.skp-text-sm{font-size:.875rem;line-height:1.25rem}.skp-text-xs{font-size:.75rem;line-height:1rem}.skp-font-semibold{font-weight:600}.skp-uppercase{text-transform:uppercase}.skp-leading-4{line-height:1rem}.skp-leading-6{line-height:1.5rem}.skp-text-gray-400{--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity))}.skp-text-gray-500{--tw-text-opacity: 1;color:rgb(107 114 128 / var(--tw-text-opacity))}.skp-text-gray-600{--tw-text-opacity: 1;color:rgb(75 85 99 / var(--tw-text-opacity))}.skp-text-gray-700{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity))}.skp-text-gray-800{--tw-text-opacity: 1;color:rgb(31 41 55 / var(--tw-text-opacity))}.skp-text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.skp-shadow-md{--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.skp-outline-0{outline-width:0px}.skp-transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.scrollbar::-webkit-scrollbar{width:.5rem;border-radius:9999px}.scrollbar::-webkit-scrollbar-track{border-radius:9999px;--tw-bg-opacity: 1;background-color:rgb(229 231 235 / var(--tw-bg-opacity))}.scrollbar::-webkit-scrollbar-thumb{border-radius:9999px;--tw-bg-opacity: 1;background-color:rgb(209 213 219 / var(--tw-bg-opacity))}.scrollbar::-webkit-scrollbar-thumb:hover{border-radius:9999px;--tw-bg-opacity: 1;background-color:rgb(156 163 175 / var(--tw-bg-opacity))}.placeholder\\:skp-text-gray-400::-moz-placeholder{--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity))}.placeholder\\:skp-text-gray-400::placeholder{--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity))}.after\\:skp-mx-1:after{content:var(--tw-content);margin-left:.25rem;margin-right:.25rem}.after\\:skp-inline-block:after{content:var(--tw-content);display:inline-block}.after\\:skp-content-\\[\\'•\\'\\]:after{--tw-content: "•";content:var(--tw-content)}.hover\\:skp-bg-gray-100:hover{--tw-bg-opacity: 1;background-color:rgb(243 244 246 / var(--tw-bg-opacity))}.focus\\:skp-border-blue-600:focus{--tw-border-opacity: 1;border-color:rgb(37 99 235 / var(--tw-border-opacity))}.focus\\:skp-shadow-none:focus{--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.focus\\:skp-ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.disabled\\:skp-bg-gray-300:disabled{--tw-bg-opacity: 1;background-color:rgb(209 213 219 / var(--tw-bg-opacity))}.disabled\\:skp-text-gray-600:disabled{--tw-text-opacity: 1;color:rgb(75 85 99 / var(--tw-text-opacity))}@media (min-width: 768px){.md\\:skp-relative{position:relative}.md\\:skp-block{display:block}.md\\:skp-flex{display:flex}.md\\:skp-hidden{display:none}.md\\:skp-w-1\\/4{width:25%}.md\\:skp-border-x{border-left-width:1px;border-right-width:1px}.md\\:skp-px-4{padding-left:1rem;padding-right:1rem}}`, S6 = ({ type: r, settings: e, user: t, ...s }) => /* @__PURE__ */ z.jsxs(z.Fragment, { children: [
  /* @__PURE__ */ z.jsx("style", { children: k6 }),
  /* @__PURE__ */ z.jsx(
    mn,
    {
      type: r,
      user: t,
      settings: e,
      children: /* @__PURE__ */ z.jsx(f6, { ...s })
    }
  )
] });
export {
  S6 as Inbox
};
